/* eslint-disable */
// ASVAB Practice Exams - Professional Full-Length Practice Tests

const exams = [
  {
    id: 1,
    title: "ASVAB Practice Test #1",
    description: "Comprehensive practice exam covering all 10 ASVAB sections with military-standard questions",
    totalQuestions: 50, // Enhanced version for free trial
    timeLimit: 60, // minutes
    sections: [
      {
        id: 1,
        name: "General Science (GS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What is the smallest unit of matter that retains the properties of an element?",
            options: ["Molecule", "Atom", "Electron", "Proton"],
            correctAnswer: 1,
            explanation: "An atom is the smallest unit of an element that retains all the chemical properties of that element."
          },
          {
            id: 2,
            question: "Which organ is primarily responsible for filtering blood in the human body?",
            options: ["Liver", "Heart", "Kidneys", "Lungs"],
            correctAnswer: 2,
            explanation: "The kidneys filter waste products and excess water from the blood to produce urine."
          },
          {
            id: 3,
            question: "What type of rock is formed from cooled magma or lava?",
            options: ["Sedimentary", "Metamorphic", "Igneous", "Limestone"],
            correctAnswer: 2,
            explanation: "Igneous rocks form when molten rock (magma or lava) cools and solidifies."
          },
          {
            id: 4,
            question: "Which of the following is NOT a function of the human skeletal system?",
            options: ["Providing structural support", "Producing blood cells", "Regulating body temperature", "Protecting internal organs"],
            correctAnswer: 2,
            explanation: "The skeletal system provides support, produces blood cells in bone marrow, and protects organs. Temperature regulation is primarily handled by the skin and circulatory system."
          },
          {
            id: 5,
            question: "In the water cycle, what is the process called when water vapor becomes liquid water?",
            options: ["Evaporation", "Condensation", "Precipitation", "Sublimation"],
            correctAnswer: 1,
            explanation: "Condensation is the process where water vapor cools and changes from gas to liquid, forming clouds and dew."
          }
        ]
      },
      {
        id: 2,
        name: "Arithmetic Reasoning (AR)",
        timeLimit: 8,
        questions: [
          {
            id: 1,
            question: "A car rental costs $35 per day plus $0.15 per mile. How much does it cost to rent the car for 3 days and drive 200 miles?",
            options: ["$105", "$125", "$135", "$155"],
            correctAnswer: 2,
            explanation: "Daily cost: $35 × 3 = $105. Mileage cost: $0.15 × 200 = $30. Total: $105 + $30 = $135"
          },
          {
            id: 2,
            question: "If 12 workers can complete a project in 15 days, how many days would it take 9 workers?",
            options: ["18 days", "20 days", "22 days", "24 days"],
            correctAnswer: 1,
            explanation: "Total work = 12 workers × 15 days = 180 worker-days. For 9 workers: 180 ÷ 9 = 20 days"
          },
          {
            id: 3,
            question: "A store is having a 25% off sale. If a jacket originally costs $80, what is the sale price?",
            options: ["$55", "$60", "$65", "$70"],
            correctAnswer: 1,
            explanation: "Discount: 25% of $80 = $20. Sale price: $80 - $20 = $60"
          },
          {
            id: 4,
            question: "A military convoy travels at an average speed of 45 mph for 2.5 hours, then 55 mph for 1.5 hours. What is the total distance traveled?",
            options: ["180 miles", "195 miles", "210 miles", "225 miles"],
            correctAnswer: 2,
            explanation: "First leg: 45 mph × 2.5 hours = 112.5 miles. Second leg: 55 mph × 1.5 hours = 82.5 miles. Total: 112.5 + 82.5 = 195 miles"
          },
          {
            id: 5,
            question: "A supply depot has 1,200 units. If 35% are distributed on Monday and 20% of the remaining units on Tuesday, how many units are left?",
            options: ["624 units", "680 units", "720 units", "780 units"],
            correctAnswer: 0,
            explanation: "Monday: 35% of 1,200 = 420 distributed. Remaining: 1,200 - 420 = 780. Tuesday: 20% of 780 = 156 distributed. Final: 780 - 156 = 624 units"
          }
        ]
      },
      {
        id: 3,
        name: "Word Knowledge (WK)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "Dubious most nearly means:",
            options: ["Certain", "Doubtful", "Happy", "Angry"],
            correctAnswer: 1,
            explanation: "Dubious means feeling doubt or uncertainty about something; questionable."
          },
          {
            id: 2,
            question: "Frugal most nearly means:",
            options: ["Wasteful", "Generous", "Economical", "Expensive"],
            correctAnswer: 2,
            explanation: "Frugal means being careful with money or resources; economical and avoiding waste."
          },
          {
            id: 3,
            question: "Candid most nearly means:",
            options: ["Dishonest", "Frank", "Secretive", "Shy"],
            correctAnswer: 1,
            explanation: "Candid means honest and straightforward in speech; frank and open."
          },
          {
            id: 4,
            question: "Adversary most nearly means:",
            options: ["Ally", "Opponent", "Friend", "Supporter"],
            correctAnswer: 1,
            explanation: "An adversary is an opponent or enemy; someone who opposes or fights against you."
          },
          {
            id: 5,
            question: "Stringent most nearly means:",
            options: ["Lenient", "Flexible", "Strict", "Careless"],
            correctAnswer: 2,
            explanation: "Stringent means strict, precise, and demanding; imposing rigorous standards or requirements."
          }
        ]
      },
      {
        id: 4,
        name: "Paragraph Comprehension (PC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            passage: "The invention of the printing press by Johannes Gutenberg in 1440 revolutionized communication and forever changed the course of human history. Before this groundbreaking invention, books were painstakingly copied by hand by scribes and monks, a labor-intensive process that could take months or even years to complete a single manuscript. This made books extremely expensive luxury items that only the wealthy elite and religious institutions could afford, keeping knowledge confined to a privileged few.\n\nThe printing press allowed for mass production of books at a fraction of the previous cost and time. Using movable metal type, Gutenberg's press could produce multiple copies of a text quickly and consistently, with each page identical to the last. This revolutionary technology made knowledge more accessible to the general population, breaking the monopoly that aristocrats and clergy had held over written information for centuries. Books on science, philosophy, religion, and literature could now reach merchants, artisans, and educated commoners who were eager to learn.\n\nThe widespread availability of printed materials contributed significantly to the spread of literacy throughout Europe and beyond. As books became more affordable and abundant, more people were motivated to learn to read, creating a positive cycle of education and enlightenment. The printing press played a crucial role in major historical movements including the Renaissance, the Protestant Reformation, and the Scientific Revolution. It enabled ideas to spread rapidly across geographical boundaries, fostering intellectual exchange and debate that accelerated human progress in ways that continue to influence our world today.",
            question: "According to the passage, what was the main impact of the printing press?",
            options: [
              "It made Johannes Gutenberg wealthy",
              "It made books more expensive",
              "It made knowledge more accessible",
              "It reduced literacy rates"
            ],
            correctAnswer: 2,
            explanation: "The passage states that the printing press 'made knowledge more accessible to the general population' and contributed to literacy."
          },
          {
            id: 2,
            passage: "Military leadership requires a unique combination of technical expertise, decision-making ability, and interpersonal skills that sets it apart from leadership in civilian contexts. The responsibilities and challenges faced by military leaders are magnified by the high-stakes environment in which they operate, where decisions can have life-or-death consequences. Effective leaders must be able to assess complex situations quickly, processing multiple streams of information while under time pressure and often in chaotic conditions. They must make decisions under extreme pressure, weighing tactical considerations, resource constraints, and the safety of their personnel while maintaining focus on mission objectives.\n\nCommunication skills are absolutely critical for military leaders at all levels. They must be able to communicate clearly with subordinates, ensuring that orders are understood and can be executed even in adverse conditions where communication channels may be compromised. Effective leaders articulate their intent and expectations precisely, leaving no room for dangerous misunderstandings while also empowering subordinates to exercise initiative when circumstances change. They must also communicate effectively upward to superiors and laterally with peer units, maintaining the coordination essential for successful military operations.\n\nBeyond technical competence and communication ability, military leaders must also demonstrate integrity and lead by example, earning the respect and trust of those they command. Soldiers will follow leaders who share their hardships, uphold the same standards they enforce, and make decisions based on principle rather than personal advantage. This moral authority is essential because military service demands extraordinary sacrifices, and personnel must have confidence that their leaders are worthy of their loyalty and dedication. Leaders who embody the values they expect from others create cohesive, motivated units capable of accomplishing difficult missions under the most challenging circumstances.",
            question: "According to the passage, what must military leaders do to earn respect?",
            options: [
              "Make decisions slowly and carefully",
              "Focus only on technical skills",
              "Demonstrate integrity and lead by example",
              "Communicate only with superiors"
            ],
            correctAnswer: 2,
            explanation: "The passage states that effective leaders 'must also demonstrate integrity and lead by example, earning the respect and trust of those they command.'"
          },
          {
            id: 3,
            passage: "Sleep deprivation can have serious consequences for both physical and mental health that extend far beyond simply feeling tired. In our modern society, many people chronically sacrifice sleep due to work demands, social activities, or screen time, often without realizing the cumulative damage this causes to their bodies and minds. Studies show that adults who consistently get less than 7 hours of sleep per night have significantly increased risk of obesity, diabetes, cardiovascular disease, and depression. The relationship between insufficient sleep and these conditions is not merely correlational but involves specific biological mechanisms that become disrupted when sleep is inadequate.\n\nSleep is essential for numerous critical physiological processes that maintain health and wellbeing. Memory consolidation occurs primarily during sleep, as the brain processes and stores information from the day, transferring important memories from short-term to long-term storage. Without adequate sleep, learning and memory formation are impaired, affecting everything from academic performance to job skills. Sleep also plays a vital role in immune function, with the body producing cytokines and other immune factors during sleep that help fight off infections and inflammation. People who are sleep-deprived get sick more frequently and take longer to recover from illnesses.\n\nAdditionally, sleep is the time when tissue repair and cellular maintenance occur throughout the body. Growth hormone is released during deep sleep stages, facilitating muscle repair and bone strengthening. The brain clears out metabolic waste products during sleep through the glymphatic system, a process that may help prevent neurodegenerative diseases. Sleep deprivation disrupts hormones that regulate appetite, leading to increased hunger and cravings for unhealthy foods, which contributes to weight gain. Given these wide-ranging effects, prioritizing adequate sleep is one of the most important things people can do for their overall health and longevity.",
            question: "According to the passage, what is one consequence of sleep deprivation?",
            options: [
              "Improved memory",
              "Increased risk of disease",
              "Better immune function",
              "Enhanced athletic performance"
            ],
            correctAnswer: 1,
            explanation: "The passage lists several health risks including obesity, diabetes, cardiovascular disease, and depression as consequences of insufficient sleep."
          },
          {
            id: 4,
            passage: "The United States Army's core values—Loyalty, Duty, Respect, Selfless Service, Honor, Integrity, and Personal Courage—form the foundation of military conduct and define what it means to be a soldier. These seven values, often abbreviated as LDRSHIP, are not merely abstract ideals but practical principles that must be lived every day. From the first day of basic training through retirement, soldiers are taught that these values represent the ethical framework within which all military activities must occur. They provide clear guidance for behavior and decision-making in situations ranging from routine garrison duties to complex combat operations.\n\nThese values guide soldiers in their daily decisions and actions, both on and off duty, creating a consistent standard of behavior regardless of circumstances. Loyalty means bearing true faith and allegiance to the Constitution, the Army, one's unit, and fellow soldiers. Duty involves fulfilling obligations and taking responsibility for actions and decisions. Respect requires treating all people with dignity regardless of their position or background. Selfless Service means putting the welfare of the nation and the Army before personal interests. Honor involves living up to all the Army values in everything soldiers do. Integrity requires doing what is right legally and morally even when no one is watching. Personal Courage encompasses facing fears, danger, and adversity with both physical bravery and moral strength.\n\nBy adhering to these principles, service members maintain the high standards expected of those who defend the nation and preserve the Army's reputation as an institution of honor and professionalism. These values create trust between soldiers, strengthen unit cohesion, and ensure that the Army operates as an ethical organization worthy of public confidence. When soldiers embody these values, they not only become better service members but also better citizens, carrying these principles into their communities and civilian lives after their military service. The Army's core values thus serve as both a professional code of conduct and a framework for personal character development.",
            question: "What is the main purpose of the Army's core values?",
            options: [
              "To make training more difficult",
              "To guide soldiers in their decisions and actions",
              "To replace military regulations",
              "To separate officers from enlisted personnel"
            ],
            correctAnswer: 1,
            explanation: "The passage states that these values 'guide soldiers in their daily decisions and actions, both on and off duty.'"
          },
          {
            id: 5,
            passage: "Proper maintenance of military equipment is crucial for operational readiness and can mean the difference between mission success and catastrophic failure. Military organizations depend on complex systems ranging from individual weapons and communication devices to vehicles, aircraft, and sophisticated electronic systems. When equipment fails during operations, it can endanger lives, compromise tactical advantages, and jeopardize entire missions. The cost of equipment failure extends beyond the immediate tactical situation, potentially requiring expensive repairs or replacement and reducing the overall capability of military units.\n\nRegular inspections, timely repairs, and adherence to maintenance schedules prevent equipment failures that could compromise mission success and ensure maximum availability of assets. Preventive maintenance involves systematic checking and servicing of equipment according to established timelines, often based on hours of operation or calendar intervals. This proactive approach identifies potential problems before they cause breakdowns, allowing repairs to be made under controlled conditions rather than in the field during critical operations. Proper documentation of maintenance activities creates a history that helps predict when components may need replacement and ensures accountability throughout the equipment lifecycle.\n\nSoldiers responsible for equipment maintenance must be thoroughly trained and follow established procedures to ensure all gear functions reliably when needed. These procedures, developed through years of experience and engineering analysis, represent best practices for maintaining specific equipment types. Deviating from these procedures or taking shortcuts can introduce new problems or mask developing issues that will emerge at the worst possible time. Well-trained maintenance personnel understand not just how to perform tasks but why each step is important, enabling them to diagnose problems effectively and make informed decisions. The discipline of proper maintenance extends to all soldiers, as even operators who are not maintenance specialists must perform basic operator-level maintenance and report problems promptly to maintain the readiness of their units.",
            question: "Why is proper equipment maintenance important?",
            options: [
              "It reduces training requirements",
              "It prevents failures that could compromise missions",
              "It eliminates the need for inspections",
              "It allows soldiers to skip established procedures"
            ],
            correctAnswer: 1,
            explanation: "The passage states that proper maintenance 'prevent equipment failures that could compromise mission success.'"
          }
        ]
      },
      {
        id: 5,
        name: "Mathematics Knowledge (MK)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "If 3x - 5 = 16, what is the value of x?",
            options: ["5", "6", "7", "8"],
            correctAnswer: 2,
            explanation: "Add 5 to both sides: 3x = 21. Divide by 3: x = 7"
          },
          {
            id: 2,
            question: "What is the volume of a cube with side length 4?",
            options: ["12", "16", "48", "64"],
            correctAnswer: 3,
            explanation: "Volume of a cube = side³ = 4³ = 4 × 4 × 4 = 64 cubic units"
          },
          {
            id: 3,
            question: "What is the square root of 144?",
            options: ["10", "11", "12", "13"],
            correctAnswer: 2,
            explanation: "√144 = 12 because 12 × 12 = 144"
          },
          {
            id: 4,
            question: "If a right triangle has legs of length 6 and 8, what is the length of the hypotenuse?",
            options: ["10", "12", "14", "16"],
            correctAnswer: 0,
            explanation: "Use Pythagorean theorem: a² + b² = c². So 6² + 8² = 36 + 64 = 100. Therefore c = √100 = 10"
          },
          {
            id: 5,
            question: "What is 30% of 250?",
            options: ["65", "75", "85", "95"],
            correctAnswer: 1,
            explanation: "Convert 30% to decimal (0.30) and multiply: 0.30 × 250 = 75"
          }
        ]
      },
      {
        id: 6,
        name: "Electronics Information (EI)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "What unit is used to measure electrical resistance?",
            options: ["Volts", "Amperes", "Ohms", "Watts"],
            correctAnswer: 2,
            explanation: "Electrical resistance is measured in Ohms (Ω), named after Georg Ohm."
          },
          {
            id: 2,
            question: "In a series circuit with three resistors of 10Ω, 20Ω, and 30Ω, what is the total resistance?",
            options: ["20Ω", "40Ω", "60Ω", "600Ω"],
            correctAnswer: 2,
            explanation: "In a series circuit, total resistance is the sum: 10 + 20 + 30 = 60Ω"
          },
          {
            id: 3,
            question: "What does a capacitor store?",
            options: ["Current", "Voltage", "Electrical charge", "Power"],
            correctAnswer: 2,
            explanation: "A capacitor stores electrical charge (and energy) in an electric field between two conductive plates."
          },
          {
            id: 4,
            question: "According to Ohm's Law, if voltage increases and resistance stays constant, what happens to current?",
            options: ["Increases", "Decreases", "Stays the same", "Becomes zero"],
            correctAnswer: 0,
            explanation: "Ohm's Law states V = I × R. If V increases and R stays constant, I must increase proportionally (I = V/R)."
          },
          {
            id: 5,
            question: "What type of current does a battery produce?",
            options: ["Alternating Current (AC)", "Direct Current (DC)", "Pulsed Current", "Variable Current"],
            correctAnswer: 1,
            explanation: "A battery produces Direct Current (DC), which flows in one constant direction, unlike AC which periodically reverses direction."
          }
        ]
      },
      {
        id: 7,
        name: "Auto & Shop Information (AS)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "What is the purpose of a car's radiator?",
            options: [
              "Generate power",
              "Cool the engine",
              "Filter air",
              "Charge the battery"
            ],
            correctAnswer: 1,
            explanation: "The radiator cools the engine by transferring heat from the coolant to the air."
          },
          {
            id: 2,
            question: "Which tool would you use to measure the diameter of a bolt?",
            options: ["Ruler", "Caliper", "Level", "Compass"],
            correctAnswer: 1,
            explanation: "A caliper is used to precisely measure the diameter of objects like bolts with accuracy."
          },
          {
            id: 3,
            question: "What type of saw is best for cutting curves in wood?",
            options: ["Circular saw", "Table saw", "Jigsaw", "Miter saw"],
            correctAnswer: 2,
            explanation: "A jigsaw has a narrow blade that can follow curved cutting lines in wood and other materials."
          },
          {
            id: 4,
            question: "What does the alternator in a vehicle do?",
            options: [
              "Start the engine",
              "Cool the transmission",
              "Charge the battery while the engine runs",
              "Control the brakes"
            ],
            correctAnswer: 2,
            explanation: "The alternator converts mechanical energy from the engine into electrical energy to charge the battery and power the vehicle's electrical systems."
          },
          {
            id: 5,
            question: "Which type of wrench automatically adjusts to fit different sized nuts and bolts?",
            options: ["Socket wrench", "Torque wrench", "Adjustable wrench", "Allen wrench"],
            correctAnswer: 2,
            explanation: "An adjustable wrench (also called a crescent wrench) has a movable jaw that can be adjusted to fit various sizes of nuts and bolts."
          }
        ]
      },
      {
        id: 8,
        name: "Mechanical Comprehension (MC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "If you want to lift a heavy object with less force, you should position the fulcrum:",
            options: [
              "In the center",
              "Closer to the load",
              "Closer to where you push",
              "It doesn't matter"
            ],
            correctAnswer: 1,
            explanation: "Positioning the fulcrum closer to the load gives you greater mechanical advantage, requiring less force to lift."
          },
          {
            id: 2,
            question: "If Gear A has 20 teeth and rotates at 100 RPM, and it meshes with Gear B which has 40 teeth, how fast does Gear B rotate?",
            options: ["25 RPM", "50 RPM", "100 RPM", "200 RPM"],
            correctAnswer: 1,
            explanation: "Gear ratio = 20:40 = 1:2. Gear B rotates at half the speed: 100 ÷ 2 = 50 RPM"
          },
          {
            id: 3,
            question: "What happens to pressure as you go deeper underwater?",
            options: [
              "It decreases",
              "It increases",
              "It stays the same",
              "It becomes zero"
            ],
            correctAnswer: 1,
            explanation: "Water pressure increases with depth because there is more water weight above pushing down."
          },
          {
            id: 4,
            question: "A pulley system with 4 supporting ropes can lift a 400-pound load. Approximately how much force is needed to lift the load?",
            options: ["50 pounds", "100 pounds", "200 pounds", "400 pounds"],
            correctAnswer: 1,
            explanation: "In a pulley system, the mechanical advantage equals the number of supporting ropes. With 4 ropes, the required force is 400 ÷ 4 = 100 pounds."
          },
          {
            id: 5,
            question: "If a wheel with a 12-inch diameter makes 10 complete rotations, approximately how far has it traveled?",
            options: ["120 inches", "240 inches", "377 inches", "754 inches"],
            correctAnswer: 2,
            explanation: "Distance = circumference × rotations. Circumference = π × diameter = 3.14 × 12 = 37.7 inches. Total: 37.7 × 10 = 377 inches."
          }
        ]
      },
      {
        id: 9,
        name: "Assembling Objects (AO)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "You have 5 puzzle pieces. Four pieces form the corners and one piece goes in the center. Which piece connects to all others?",
            options: [
              "Top left corner",
              "Top right corner",
              "Center piece",
              "Bottom left corner"
            ],
            correctAnswer: 2,
            explanation: "The center piece must connect to all corner pieces in this configuration."
          },
          {
            id: 2,
            question: "If object A connects to B, and B connects to C, which objects are adjacent to B?",
            options: [
              "Only A",
              "Only C",
              "Both A and C",
              "Neither A nor C"
            ],
            correctAnswer: 2,
            explanation: "If B connects to both A and C, then both A and C are adjacent to B."
          },
          {
            id: 3,
            question: "Two shapes will form a square when properly connected. One is a right triangle, what must the other be?",
            options: [
              "A circle",
              "An identical right triangle",
              "A rectangle",
              "A pentagon"
            ],
            correctAnswer: 1,
            explanation: "Two identical right triangles can be arranged along their hypotenuse to form a square."
          },
          {
            id: 4,
            question: "Four L-shaped pieces can be arranged to form what shape?",
            options: [
              "A triangle",
              "A square",
              "A pentagon",
              "A hexagon"
            ],
            correctAnswer: 1,
            explanation: "Four identical L-shaped pieces can be rotated and arranged to form a complete square."
          },
          {
            id: 5,
            question: "Point A must connect to Point B, which are on opposite sides of a square. What is the shortest connection path?",
            options: [
              "Around the perimeter",
              "Diagonal across the square",
              "Through adjacent corners",
              "Along two adjacent sides"
            ],
            correctAnswer: 1,
            explanation: "A diagonal line across the square provides the shortest distance between two opposite points."
          }
        ]
      },
      {
        id: 10,
        name: "Verbal Expression (VE)",
        timeLimit: 4,
        questions: [
          {
            id: 1,
            question: "Choose the sentence with correct grammar:",
            options: [
              "Me and him went to the store",
              "Him and I went to the store",
              "He and I went to the store",
              "Me and he went to the store"
            ],
            correctAnswer: 2,
            explanation: "Use subject pronouns (he, I) when they are the subject of the sentence. 'He and I' is correct."
          },
          {
            id: 2,
            question: "Which word is spelled correctly?",
            options: ["Occured", "Occured", "Occurred", "Ocurred"],
            correctAnswer: 2,
            explanation: "The correct spelling is 'occurred' with two c's and two r's."
          },
          {
            id: 3,
            question: "Choose the sentence with correct punctuation:",
            options: [
              "The meeting which lasted three hours was exhausting",
              "The meeting, which lasted three hours was exhausting",
              "The meeting which lasted three hours, was exhausting",
              "The meeting, which lasted three hours, was exhausting"
            ],
            correctAnswer: 3,
            explanation: "Non-restrictive clauses (which lasted three hours) need commas before and after."
          },
          {
            id: 4,
            question: "Identify the sentence with correct subject-verb agreement:",
            options: [
              "The team are practicing hard",
              "The team is practicing hard",
              "The team were practicing hard",
              "The team be practicing hard"
            ],
            correctAnswer: 1,
            explanation: "When referring to a team as a single unit, use singular verb form: 'The team is practicing hard.'"
          },
          {
            id: 5,
            question: "Which sentence uses 'their' correctly?",
            options: [
              "Their going to the briefing at 0800",
              "The soldiers left there equipment behind",
              "They're going to need their gear inspected",
              "Its important for their to be accountability"
            ],
            correctAnswer: 2,
            explanation: "'Their' shows possession. The correct sentence is 'They're (they are) going to need their (possessive) gear inspected.'"
          }
        ]
      }
    ]
  },,
  {
    id: 2,
    title: "ASVAB Practice Test #2",
    description: "Comprehensive practice exam covering all 10 ASVAB sections with military-standard questions",
    totalQuestions: 50,
    timeLimit: 60,
    sections: [
      {
        id: 1,
        name: "General Science (GS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What is the function of red blood cells in the human body?",
            options: ["Fight infection", "Transport oxygen", "Clot blood", "Digest food"],
            correctAnswer: 1,
            explanation: "Red blood cells contain hemoglobin, which binds to oxygen in the lungs and transports it throughout the body to tissues and organs."
          },
          {
            id: 2,
            question: "Which law states that energy cannot be created or destroyed, only converted from one form to another?",
            options: ["Law of Gravity", "Law of Motion", "Law of Conservation of Energy", "Law of Thermodynamics"],
            correctAnswer: 2,
            explanation: "The Law of Conservation of Energy states that energy cannot be created or destroyed, only transformed from one form to another."
          },
          {
            id: 3,
            question: "What is the primary gas that plants absorb from the atmosphere during photosynthesis?",
            options: ["Oxygen", "Nitrogen", "Carbon dioxide", "Hydrogen"],
            correctAnswer: 2,
            explanation: "Plants absorb carbon dioxide from the atmosphere and use it with water and sunlight to produce glucose and oxygen through photosynthesis."
          },
          {
            id: 4,
            question: "Which layer of Earth's atmosphere contains the ozone layer?",
            options: ["Troposphere", "Stratosphere", "Mesosphere", "Thermosphere"],
            correctAnswer: 1,
            explanation: "The ozone layer is located in the stratosphere, approximately 15-35 kilometers above Earth's surface, where it absorbs harmful ultraviolet radiation."
          },
          {
            id: 5,
            question: "What type of chemical bond involves the sharing of electrons between atoms?",
            options: ["Ionic bond", "Covalent bond", "Metallic bond", "Hydrogen bond"],
            correctAnswer: 1,
            explanation: "A covalent bond forms when two atoms share one or more pairs of electrons to achieve stable electron configurations."
          }
        ]
      },
      {
        id: 2,
        name: "Arithmetic Reasoning (AR)",
        timeLimit: 8,
        questions: [
          {
            id: 1,
            question: "A military base cafeteria serves 450 meals per day. If 60% are breakfast meals and the rest are split equally between lunch and dinner, how many lunch meals are served daily?",
            options: ["90", "180", "270", "360"],
            correctAnswer: 0,
            explanation: "Breakfast: 60% of 450 = 270 meals. Remaining: 450 - 270 = 180. Lunch and dinner split equally: 180 ÷ 2 = 90 lunch meals."
          },
          {
            id: 2,
            question: "A helicopter flies 240 miles in 2 hours against a headwind. With a tailwind, it can fly the same distance in 1.5 hours. What is its speed with the tailwind?",
            options: ["120 mph", "140 mph", "160 mph", "180 mph"],
            correctAnswer: 2,
            explanation: "Speed with tailwind = Distance ÷ Time = 240 miles ÷ 1.5 hours = 160 mph."
          },
          {
            id: 3,
            question: "If a soldier saves $150 per month, how much will they save in 2.5 years?",
            options: ["$3,600", "$4,200", "$4,500", "$5,000"],
            correctAnswer: 2,
            explanation: "2.5 years = 30 months. Total savings: $150 × 30 = $4,500."
          },
          {
            id: 4,
            question: "A training course costs $1,200. If 8 soldiers split the cost equally, but 2 drop out before payment, how much does each remaining soldier pay?",
            options: ["$150", "$200", "$240", "$300"],
            correctAnswer: 1,
            explanation: "Remaining soldiers: 8 - 2 = 6. Cost per soldier: $1,200 ÷ 6 = $200."
          },
          {
            id: 5,
            question: "A supply truck carries 48 boxes. Each box contains 36 units of equipment. How many units are on the truck?",
            options: ["1,628", "1,728", "1,828", "1,928"],
            correctAnswer: 1,
            explanation: "Total units: 48 boxes × 36 units per box = 1,728 units."
          }
        ]
      },
      {
        id: 3,
        name: "Word Knowledge (WK)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "Obsolete most nearly means:",
            options: ["Modern", "Outdated", "Functional", "Required"],
            correctAnswer: 1,
            explanation: "Obsolete means no longer in use or out of date; outdated and replaced by something newer."
          },
          {
            id: 2,
            question: "Vigilant most nearly means:",
            options: ["Careless", "Sleepy", "Watchful", "Aggressive"],
            correctAnswer: 2,
            explanation: "Vigilant means carefully watching for possible danger or difficulties; alert and watchful."
          },
          {
            id: 3,
            question: "Meticulous most nearly means:",
            options: ["Sloppy", "Careful", "Fast", "Lazy"],
            correctAnswer: 1,
            explanation: "Meticulous means showing great attention to detail; very careful and precise."
          },
          {
            id: 4,
            question: "Tenacious most nearly means:",
            options: ["Weak", "Persistent", "Timid", "Flexible"],
            correctAnswer: 1,
            explanation: "Tenacious means holding firmly to something; persistent and determined, not giving up easily."
          },
          {
            id: 5,
            question: "Eloquent most nearly means:",
            options: ["Silent", "Fluent", "Confused", "Brief"],
            correctAnswer: 1,
            explanation: "Eloquent means fluent and persuasive in speaking or writing; expressive and articulate."
          }
        ]
      },
      {
        id: 4,
        name: "Paragraph Comprehension (PC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            passage: "Physical fitness is a critical component of military readiness that directly impacts a unit's ability to accomplish its mission. Service members must maintain cardiovascular endurance, muscular strength, and flexibility to perform their duties effectively in diverse and demanding environments. The physical demands of military service can range from carrying heavy equipment over long distances to engaging in close combat, from conducting rescue operations to maintaining alertness during extended operations. Without adequate physical fitness, even the best-trained and equipped forces will struggle to execute their missions successfully.\n\nRegular physical training not only improves performance in combat situations but also reduces injury rates and enhances overall health and well-being. Structured PT programs build the physical capacity needed for military tasks while simultaneously strengthening joints, bones, and connective tissues that help prevent injuries during training and operations. Soldiers who maintain high fitness levels recover more quickly from physical exertion, can operate effectively for longer periods without rest, and are better able to handle the stress and sleep deprivation common in military operations. Physical fitness also improves mental resilience and confidence, as service members who know they are physically prepared feel more capable of handling challenging situations.\n\nThe military's emphasis on physical fitness extends beyond immediate operational needs to long-term health and readiness. Regular exercise reduces the risk of chronic diseases such as heart disease, diabetes, and obesity, helping service members remain deployable throughout their careers. PT programs foster discipline, team cohesion, and competitive spirit, with unit training sessions building camaraderie alongside fitness. Many military fitness standards are age and gender-normed to ensure fair assessment while maintaining the absolute performance levels required for combat effectiveness. By prioritizing physical fitness, the military ensures its personnel are prepared to meet the rigorous physical demands of defending the nation.",
            question: "According to the passage, what is one benefit of regular physical training?",
            options: [
              "It eliminates the need for medical care",
              "It reduces injury rates",
              "It replaces tactical training",
              "It guarantees promotion"
            ],
            correctAnswer: 1,
            explanation: "The passage states that regular physical training 'reduces injury rates and enhances overall health and well-being.'"
          },
          {
            id: 2,
            passage: "Cybersecurity has become increasingly important in modern military operations as armed forces worldwide have become dependent on networked digital technologies. Today's military forces operate in a highly connected environment where information flows rapidly between sensors, command centers, and weapons platforms. Digital systems control everything from communications to weapons systems, making them potential targets for adversaries who may seek to disrupt, degrade, or manipulate these critical capabilities. A successful cyberattack could compromise classified information, disable weapons systems, or provide enemies with false intelligence that leads to catastrophic tactical decisions.\n\nThe cyber domain represents a new battlefield where conflicts can occur without traditional physical combat. Nation-states and non-state actors have developed sophisticated cyber capabilities that can target military networks from anywhere in the world. Adversaries may attempt to infiltrate networks to steal sensitive data, plant malware that activates during crisis situations, or conduct denial-of-service attacks that overwhelm systems with traffic. The interconnected nature of modern military systems means that a vulnerability in one component can potentially be exploited to compromise an entire network, making comprehensive cybersecurity essential at all levels.\n\nProtecting these systems requires constant vigilance, regular software updates, and trained personnel who understand evolving threats and can respond effectively to incidents. Cybersecurity is not a one-time effort but an ongoing process of identifying vulnerabilities, implementing protective measures, monitoring for intrusions, and responding to incidents. Regular software updates and patches address newly discovered vulnerabilities before adversaries can exploit them. Military personnel at all levels must be trained in cyber hygiene practices such as recognizing phishing attempts, using strong passwords, and properly handling classified information. Specialized cyber warfare units work continuously to defend networks, conduct offensive cyber operations, and stay ahead of emerging threats in this rapidly evolving domain that is now integral to military superiority.",
            question: "Why is cybersecurity important in military operations?",
            options: [
              "It saves money on equipment",
              "It eliminates the need for physical security",
              "Digital systems control critical military functions",
              "It reduces the need for training"
            ],
            correctAnswer: 2,
            explanation: "The passage states that 'Digital systems control everything from communications to weapons systems,' making cybersecurity critical."
          },
          {
            id: 3,
            passage: "The scientific method is a systematic approach to investigating phenomena and acquiring new knowledge that has been the foundation of scientific progress for centuries. This rigorous process provides a structured framework that helps researchers minimize bias, ensure reproducibility, and reach reliable conclusions about how the natural world works. It involves making observations, forming hypotheses, conducting experiments, analyzing data, and drawing conclusions in a careful, methodical sequence. Unlike informal observation or speculation, the scientific method requires that ideas be testable and that results be verifiable by other researchers working independently.\n\nThe process typically begins with observation of a phenomenon and questions about why or how it occurs. Scientists then form hypotheses, which are testable explanations that make specific predictions about what will happen under certain conditions. Carefully designed experiments are conducted to test these predictions, with researchers controlling variables to isolate the factor being studied. Data collected during experiments is analyzed using statistical methods to determine whether results support or contradict the hypothesis. If results consistently contradict a hypothesis, it must be revised or rejected. If results support it across multiple experiments, the hypothesis gains credibility and may eventually contribute to broader scientific theories.\n\nThis method allows scientists to test ideas objectively and build upon previous discoveries, creating an ever-expanding body of reliable knowledge. The requirement for reproducibility means that other scientists can verify findings by repeating experiments, which helps identify errors and prevents false claims from becoming accepted as fact. Scientific knowledge is thus self-correcting, with new evidence continually refining or sometimes overturning previous understanding. The scientific method has enabled remarkable advances in technology, medicine, and our understanding of the universe, from developing vaccines that save millions of lives to exploring distant planets. Its systematic approach to investigation provides the most reliable means humanity has developed for understanding the natural world and solving complex problems.",
            question: "What does the scientific method allow scientists to do?",
            options: [
              "Skip the observation phase",
              "Test ideas objectively",
              "Avoid collecting data",
              "Ignore previous research"
            ],
            correctAnswer: 1,
            explanation: "The passage states that the scientific method 'allows scientists to test ideas objectively and build upon previous discoveries.'"
          },
          {
            id: 4,
            passage: "Effective communication is essential in military operations where clarity can mean the difference between success and failure, life and death. Military forces must coordinate complex activities across multiple units, often under extreme time pressure and in chaotic environments filled with noise, confusion, and danger. Orders must be transmitted accurately, without ambiguity, and confirmed by the recipient to ensure everyone understands their role and timing. A misunderstood order can result in friendly fire incidents, units failing to support each other at critical moments, or missions being compromised because forces are not synchronized in their actions.\n\nThe challenges of military communication are compounded by the operating environment and the technical limitations of communication equipment. Radio signals can be disrupted by terrain, weather, or enemy jamming. Background noise from weapons fire, vehicles, and aircraft can make it difficult to hear messages clearly. In combat situations, personnel are under extreme stress and may have difficulty processing complex information. Communication equipment may malfunction or be damaged, requiring backup methods. Despite these challenges, critical information must flow reliably up, down, and across the chain of command to maintain unity of effort and enable commanders to make informed decisions based on current battlefield conditions.\n\nRadio protocols, standard terminology, and brevity codes help ensure messages are understood quickly and correctly even in stressful conditions. Standard formats for reports and requests mean that personnel know what information to provide and in what order, reducing confusion and saving precious time. Phonetic alphabets eliminate confusion between similar-sounding letters. Brevity codes convey complex information in just a few words, reducing transmission time and the opportunity for interception by adversaries. These standardized communication methods are practiced repeatedly during training so that they become automatic, allowing personnel to communicate effectively even when exhausted, frightened, or wounded. Clear, concise, and confirmed communication is thus a fundamental skill that enables military forces to function as a coordinated team rather than a collection of isolated individuals.",
            question: "Why do military personnel use radio protocols and standard terminology?",
            options: [
              "To make communication more complicated",
              "To ensure messages are understood quickly and correctly",
              "To confuse enemy forces",
              "To reduce the need for training"
            ],
            correctAnswer: 1,
            explanation: "The passage states these tools 'help ensure messages are understood quickly and correctly even in stressful conditions.'"
          },
          {
            id: 5,
            passage: "Dehydration occurs when the body loses more fluids than it takes in, disrupting the delicate balance necessary for proper physiological function. The human body is approximately 60% water, and this fluid is essential for regulating body temperature, transporting nutrients, removing waste products, and enabling cellular processes. Symptoms include thirst, dry mouth, fatigue, dizziness, and decreased urine output, though by the time thirst is felt, dehydration has already begun. Other warning signs can include headaches, reduced concentration, irritability, and dark-colored urine. These symptoms significantly impair physical and cognitive performance, which is especially dangerous in military contexts where peak performance is critical.\n\nIn severe cases, dehydration can lead to heat exhaustion or heat stroke, life-threatening conditions that require immediate medical intervention. Heat exhaustion occurs when the body can no longer cool itself effectively, resulting in symptoms such as heavy sweating, rapid pulse, nausea, and weakness. If not treated promptly, it can progress to heat stroke, where body temperature rises above 104°F and the body's cooling mechanisms fail completely. Heat stroke can cause confusion, loss of consciousness, seizures, and permanent organ damage or death. Military personnel wearing heavy protective gear and carrying equipment in hot environments are particularly vulnerable because their gear traps heat and their physical exertion generates additional body heat that must be dissipated.\n\nService members operating in hot climates must drink water regularly, even before feeling thirsty, to maintain proper hydration and prevent these dangerous conditions. Waiting until feeling thirsty means dehydration has already impaired performance. Guidelines typically recommend drinking water at scheduled intervals and monitoring urine color as an indicator of hydration status. Electrolyte replacement may also be necessary during prolonged exertion, as sweating depletes not just water but also essential salts needed for nerve and muscle function. Leaders must enforce hydration discipline within their units, ensuring personnel have access to water and take regular water breaks. Proper hydration is not just about comfort but about maintaining combat effectiveness and preventing casualties from entirely preventable heat-related injuries that can incapacitate soldiers as surely as any weapon.",
            question: "According to the passage, when should service members drink water in hot climates?",
            options: [
              "Only when extremely thirsty",
              "After completing their mission",
              "Regularly, even before feeling thirsty",
              "Only during meal times"
            ],
            correctAnswer: 2,
            explanation: "The passage explicitly states that service members 'must drink water regularly, even before feeling thirsty, to maintain proper hydration.'"
          }
        ]
      },
      {
        id: 5,
        name: "Mathematics Knowledge (MK)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "If 5y + 8 = 33, what is the value of y?",
            options: ["4", "5", "6", "7"],
            correctAnswer: 1,
            explanation: "Subtract 8 from both sides: 5y = 25. Divide by 5: y = 5."
          },
          {
            id: 2,
            question: "What is the area of a rectangle with length 12 and width 8?",
            options: ["20", "40", "96", "192"],
            correctAnswer: 2,
            explanation: "Area of a rectangle = length × width = 12 × 8 = 96 square units."
          },
          {
            id: 3,
            question: "What is 15% of 200?",
            options: ["15", "20", "30", "35"],
            correctAnswer: 2,
            explanation: "Convert 15% to decimal (0.15) and multiply: 0.15 × 200 = 30."
          },
          {
            id: 4,
            question: "If a circle has a diameter of 10, what is its radius?",
            options: ["2.5", "5", "10", "20"],
            correctAnswer: 1,
            explanation: "The radius is half the diameter: 10 ÷ 2 = 5."
          },
          {
            id: 5,
            question: "Solve for x: 2(x + 4) = 20",
            options: ["4", "6", "8", "10"],
            correctAnswer: 1,
            explanation: "Distribute: 2x + 8 = 20. Subtract 8: 2x = 12. Divide by 2: x = 6."
          }
        ]
      },
      {
        id: 6,
        name: "Electronics Information (EI)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "What unit is used to measure electrical current?",
            options: ["Volts", "Amperes", "Ohms", "Watts"],
            correctAnswer: 1,
            explanation: "Electrical current is measured in Amperes (Amps), which represents the flow of electric charge."
          },
          {
            id: 2,
            question: "What device converts AC (Alternating Current) to DC (Direct Current)?",
            options: ["Transformer", "Rectifier", "Amplifier", "Oscillator"],
            correctAnswer: 1,
            explanation: "A rectifier converts alternating current (AC) to direct current (DC) using diodes to allow current flow in only one direction."
          },
          {
            id: 3,
            question: "In a parallel circuit with two resistors of 10Ω each, what is the total resistance?",
            options: ["5Ω", "10Ω", "20Ω", "100Ω"],
            correctAnswer: 0,
            explanation: "In parallel circuits: 1/Total = 1/R1 + 1/R2. So 1/Total = 1/10 + 1/10 = 2/10. Total = 10/2 = 5Ω."
          },
          {
            id: 4,
            question: "What is the primary function of a transistor?",
            options: ["Store energy", "Amplify or switch electronic signals", "Measure voltage", "Generate heat"],
            correctAnswer: 1,
            explanation: "A transistor can amplify electrical signals or act as an electronic switch, controlling current flow in circuits."
          },
          {
            id: 5,
            question: "What does LED stand for?",
            options: ["Light Emitting Diode", "Low Energy Device", "Linear Electric Display", "Laser Emission Detector"],
            correctAnswer: 0,
            explanation: "LED stands for Light Emitting Diode, a semiconductor device that emits light when current flows through it."
          }
        ]
      },
      {
        id: 7,
        name: "Auto & Shop Information (AS)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "What is the primary function of a vehicle's transmission?",
            options: [
              "Cool the engine",
              "Filter oil",
              "Transfer power from engine to wheels",
              "Generate electricity"
            ],
            correctAnswer: 2,
            explanation: "The transmission transfers power from the engine to the wheels while allowing the driver to control speed and direction through different gear ratios."
          },
          {
            id: 2,
            question: "Which tool is used to tighten or loosen nuts and bolts?",
            options: ["Hammer", "Screwdriver", "Wrench", "Pliers"],
            correctAnswer: 2,
            explanation: "A wrench is specifically designed to grip and turn nuts and bolts, providing leverage for tightening or loosening."
          },
          {
            id: 3,
            question: "What type of engine runs on diesel fuel?",
            options: ["Spark ignition engine", "Compression ignition engine", "Electric motor", "Steam engine"],
            correctAnswer: 1,
            explanation: "Diesel engines are compression ignition engines that ignite fuel through high pressure and temperature rather than spark plugs."
          },
          {
            id: 4,
            question: "What tool is used to remove material from wood to make it smooth?",
            options: ["Chisel", "Plane", "Auger", "Rasp"],
            correctAnswer: 1,
            explanation: "A plane is a hand tool or power tool used to shave thin layers from wood surfaces to create smooth, flat finishes."
          },
          {
            id: 5,
            question: "What automotive component provides the initial power to start the engine?",
            options: ["Alternator", "Starter motor", "Fuel pump", "Carburetor"],
            correctAnswer: 1,
            explanation: "The starter motor is an electric motor that turns the engine over when you turn the ignition key, allowing the engine to start."
          }
        ]
      },
      {
        id: 8,
        name: "Mechanical Comprehension (MC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "If two gears of equal size are meshed together and one rotates clockwise, the other will rotate:",
            options: [
              "Clockwise at the same speed",
              "Counterclockwise at the same speed",
              "Clockwise at double speed",
              "Counterclockwise at half speed"
            ],
            correctAnswer: 1,
            explanation: "When two equal gears mesh, they rotate in opposite directions at the same speed. If one goes clockwise, the other goes counterclockwise."
          },
          {
            id: 2,
            question: "What type of simple machine is a ramp?",
            options: ["Lever", "Pulley", "Inclined plane", "Wheel and axle"],
            correctAnswer: 2,
            explanation: "A ramp is an inclined plane, which reduces the force needed to move an object vertically by extending the distance traveled."
          },
          {
            id: 3,
            question: "If you increase the length of a lever arm, what happens to the mechanical advantage?",
            options: ["It decreases", "It increases", "It stays the same", "It becomes zero"],
            correctAnswer: 1,
            explanation: "Increasing the lever arm length increases mechanical advantage, allowing you to lift heavier loads with less effort."
          },
          {
            id: 4,
            question: "Which material would be the best conductor of heat?",
            options: ["Wood", "Plastic", "Copper", "Rubber"],
            correctAnswer: 2,
            explanation: "Copper is an excellent conductor of heat and electricity due to its atomic structure allowing easy energy transfer."
          },
          {
            id: 5,
            question: "If a 150-pound person stands on a board supported at both ends, where is the stress greatest?",
            options: ["At the ends", "In the center", "Evenly distributed", "At the top surface only"],
            correctAnswer: 1,
            explanation: "The greatest stress occurs at the center of the board where the bending moment is highest due to the concentrated load."
          }
        ]
      },
      {
        id: 9,
        name: "Assembling Objects (AO)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "If three pieces form a straight line when assembled, with piece B in the middle, which pieces must touch piece B?",
            options: [
              "Neither A nor C",
              "Only A",
              "Only C",
              "Both A and C"
            ],
            correctAnswer: 3,
            explanation: "If B is in the middle of a straight line formation, it must touch both A and C on either side."
          },
          {
            id: 2,
            question: "Two identical semicircles can be joined to form what shape?",
            options: [
              "A square",
              "A circle",
              "A triangle",
              "An oval"
            ],
            correctAnswer: 1,
            explanation: "Two semicircles joined along their straight edges form a complete circle."
          },
          {
            id: 3,
            question: "If point X connects to point Y, and point Y connects to point Z, how many connection points are needed total?",
            options: ["1", "2", "3", "4"],
            correctAnswer: 1,
            explanation: "There are two connections: X to Y (one connection) and Y to Z (second connection), totaling 2 connections."
          },
          {
            id: 4,
            question: "Three equilateral triangles arranged around a common center point will form what angle between each triangle?",
            options: ["60 degrees", "90 degrees", "120 degrees", "180 degrees"],
            correctAnswer: 2,
            explanation: "360 degrees divided by 3 triangles = 120 degrees between each triangle around the center point."
          },
          {
            id: 5,
            question: "If shape A fits into shape B, and the result fits into shape C, what is the relationship between A and C?",
            options: [
              "A is larger than C",
              "A is smaller than C",
              "A equals C",
              "No relationship exists"
            ],
            correctAnswer: 1,
            explanation: "Since A fits into B, and B fits into C, A must be smaller than C."
          }
        ]
      },
      {
        id: 10,
        name: "Verbal Expression (VE)",
        timeLimit: 4,
        questions: [
          {
            id: 1,
            question: "Choose the sentence with correct grammar:",
            options: [
              "Between you and I, this is difficult",
              "Between you and me, this is difficult",
              "Between you and myself, this is difficult",
              "Between yourself and I, this is difficult"
            ],
            correctAnswer: 1,
            explanation: "After prepositions like 'between,' use object pronouns. 'Between you and me' is correct."
          },
          {
            id: 2,
            question: "Which word is spelled correctly?",
            options: ["Accommodate", "Acommodate", "Accomodate", "Acomodate"],
            correctAnswer: 0,
            explanation: "The correct spelling is 'accommodate' with two c's and two m's."
          },
          {
            id: 3,
            question: "Choose the sentence with correct punctuation:",
            options: [
              "The soldiers gear was inspected thoroughly",
              "The soldiers' gear was inspected thoroughly",
              "The soldier's gear was inspected thoroughly",
              "The soldiers gear, was inspected thoroughly"
            ],
            correctAnswer: 2,
            explanation: "When referring to one soldier's possession, use 'soldier's' with an apostrophe before the s."
          },
          {
            id: 4,
            question: "Identify the sentence with correct verb tense:",
            options: [
              "Yesterday, I go to the training facility",
              "Yesterday, I went to the training facility",
              "Yesterday, I will go to the training facility",
              "Yesterday, I am going to the training facility"
            ],
            correctAnswer: 1,
            explanation: "'Yesterday' indicates past tense, so 'went' is the correct past tense form of 'go.'"
          },
          {
            id: 5,
            question: "Which sentence uses 'its' correctly?",
            options: [
              "Its a challenging assignment",
              "The unit completed it's mission",
              "The vehicle lost its wheel",
              "Its' important to follow orders"
            ],
            correctAnswer: 2,
            explanation: "'Its' (no apostrophe) is possessive, meaning 'belonging to it.' The sentence 'The vehicle lost its wheel' uses it correctly."
          }
        ]
      }
    ]
  },,
  {
    id: 3,
    title: "ASVAB Practice Test #3",
    description: "Comprehensive practice exam covering all 10 ASVAB sections with military-standard questions",
    totalQuestions: 50,
    timeLimit: 60,
    sections: [
      {
        id: 1,
        name: "General Science (GS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Which planet in our solar system has the most moons?",
            options: ["Jupiter", "Saturn", "Neptune", "Uranus"],
            correctAnswer: 1,
            explanation: "Saturn has the most confirmed moons with over 140 discovered satellites, surpassing Jupiter's count."
          },
          {
            id: 2,
            question: "What is the hardest natural substance on Earth?",
            options: ["Steel", "Diamond", "Quartz", "Granite"],
            correctAnswer: 1,
            explanation: "Diamond is the hardest naturally occurring substance, ranking 10 on the Mohs hardness scale due to its strong carbon-carbon bonds."
          },
          {
            id: 3,
            question: "Which part of the human brain controls balance and coordination?",
            options: ["Cerebrum", "Cerebellum", "Medulla", "Hypothalamus"],
            correctAnswer: 1,
            explanation: "The cerebellum, located at the back of the brain, is responsible for coordinating voluntary movements, balance, and posture."
          },
          {
            id: 4,
            question: "What is the pH level of a neutral solution?",
            options: ["0", "5", "7", "14"],
            correctAnswer: 2,
            explanation: "A neutral solution has a pH of 7. Solutions with pH below 7 are acidic, and above 7 are basic or alkaline."
          },
          {
            id: 5,
            question: "Which vitamin is produced when skin is exposed to sunlight?",
            options: ["Vitamin A", "Vitamin C", "Vitamin D", "Vitamin K"],
            correctAnswer: 2,
            explanation: "The skin produces Vitamin D when exposed to ultraviolet B (UVB) rays from sunlight. This vitamin is essential for calcium absorption and bone health."
          }
        ]
      },
      {
        id: 2,
        name: "Arithmetic Reasoning (AR)",
        timeLimit: 8,
        questions: [
          {
            id: 1,
            question: "A military transport plane carries 18 pallets. If each pallet weighs 850 pounds, what is the total cargo weight?",
            options: ["14,300 lbs", "15,300 lbs", "16,200 lbs", "17,100 lbs"],
            correctAnswer: 1,
            explanation: "Total weight = 18 pallets × 850 pounds = 15,300 pounds."
          },
          {
            id: 2,
            question: "If a squad completes a 15-mile march in 5 hours, what is their average speed in miles per hour?",
            options: ["2 mph", "3 mph", "4 mph", "5 mph"],
            correctAnswer: 1,
            explanation: "Average speed = Distance ÷ Time = 15 miles ÷ 5 hours = 3 mph."
          },
          {
            id: 3,
            question: "A base commissary sells items at 20% below retail price. If a laptop's retail price is $800, what is the commissary price?",
            options: ["$600", "$640", "$680", "$720"],
            correctAnswer: 1,
            explanation: "Discount: 20% of $800 = $160. Commissary price: $800 - $160 = $640."
          },
          {
            id: 4,
            question: "If 15 vehicles consume 450 gallons of fuel, how many gallons would 22 vehicles consume at the same rate?",
            options: ["620 gallons", "660 gallons", "700 gallons", "740 gallons"],
            correctAnswer: 1,
            explanation: "Rate per vehicle: 450 ÷ 15 = 30 gallons. For 22 vehicles: 22 × 30 = 660 gallons."
          },
          {
            id: 5,
            question: "A soldier earns $2,400 per month. If 18% is withheld for taxes and 8% for insurance, how much is the take-home pay?",
            options: ["$1,776", "$1,824", "$1,968", "$2,016"],
            correctAnswer: 0,
            explanation: "Total deductions: 18% + 8% = 26%. Deducted amount: 26% of $2,400 = $624. Take-home: $2,400 - $624 = $1,776."
          }
        ]
      },
      {
        id: 3,
        name: "Word Knowledge (WK)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "Inevitable most nearly means:",
            options: ["Avoidable", "Uncertain", "Unavoidable", "Unlikely"],
            correctAnswer: 2,
            explanation: "Inevitable means certain to happen; unavoidable and impossible to prevent."
          },
          {
            id: 2,
            question: "Proficient most nearly means:",
            options: ["Incompetent", "Skilled", "Careless", "Inexperienced"],
            correctAnswer: 1,
            explanation: "Proficient means skilled and competent in a particular area; having expertise or mastery."
          },
          {
            id: 3,
            question: "Authentic most nearly means:",
            options: ["Fake", "Genuine", "Doubtful", "Copied"],
            correctAnswer: 1,
            explanation: "Authentic means genuine, real, and trustworthy; not false or copied."
          },
          {
            id: 4,
            question: "Simultaneously most nearly means:",
            options: ["Separately", "At the same time", "Before", "After"],
            correctAnswer: 1,
            explanation: "Simultaneously means happening at the same time; occurring concurrently."
          },
          {
            id: 5,
            question: "Comprehend most nearly means:",
            options: ["Misunderstand", "Ignore", "Understand", "Confuse"],
            correctAnswer: 2,
            explanation: "Comprehend means to understand or grasp the meaning of something fully."
          }
        ]
      },
      {
        id: 4,
        name: "Paragraph Comprehension (PC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            passage: "Navigation skills have been crucial throughout military history, often determining the outcome of campaigns and battles. The ability to move forces accurately across unfamiliar terrain, especially under adverse conditions or at night, has always been a fundamental military competency. Before GPS technology revolutionized position finding, soldiers relied on map reading, compass use, and terrain association to determine their location and plan routes. These traditional skills required extensive training and practice, as navigators had to interpret topographic maps, understand magnetic declination, and identify terrain features by comparing the ground to map representations.\n\nThe introduction of GPS and other electronic navigation systems has dramatically improved the speed and accuracy of military navigation. Satellites provide precise location data that updates continuously, enabling forces to coordinate movements with unprecedented precision. Electronic systems can calculate optimal routes, track multiple units simultaneously, and integrate navigation with other digital battlefield management tools. This technology has become so reliable and ubiquitous that an entire generation of service members has grown up depending on it for everyday navigation both in military and civilian contexts.\n\nHowever, modern military personnel still learn these traditional navigation methods because electronic systems can fail or become compromised during operations. Batteries die, equipment gets damaged, GPS signals can be jammed by adversaries, and solar storms or other phenomena can disrupt satellite communications. In hostile territory, using electronic emitters may reveal a unit's position to enemy forces with detection equipment. Traditional navigation skills provide essential backup capabilities that ensure forces can continue operating even when technology fails. The most effective military navigators master both modern technology and time-tested techniques, understanding that true proficiency means being able to navigate successfully under any circumstances with whatever tools are available.",
            question: "Why do modern soldiers still learn traditional navigation methods?",
            options: [
              "Electronic systems are never used",
              "Traditional methods are more accurate",
              "Electronic systems can fail during operations",
              "GPS is too expensive for military use"
            ],
            correctAnswer: 2,
            explanation: "The passage states that soldiers learn traditional methods 'because electronic systems can fail or become compromised during operations.'"
          },
          {
            id: 2,
            passage: "Camouflage is a critical military technique that helps personnel and equipment blend into their surroundings and avoid detection by enemy forces. The science of military camouflage has evolved significantly since its systematic use began in World War I, incorporating understanding of human visual perception, color theory, and the specific characteristics of different operational environments. Proper camouflage can mean the difference between a successful mission and deadly exposure, making it an essential element of tactical operations from individual soldier level to large-scale maneuvers involving vehicles and installations.\n\nDifferent environments require different camouflage patterns—woodland, desert, urban, and arctic patterns each serve specific purposes tailored to the predominant colors, textures, and lighting conditions of particular terrain types. Woodland patterns incorporate various shades of green and brown to blend with forests and vegetated areas. Desert patterns use tan, brown, and pale colors to match arid environments. Urban patterns employ gray tones and geometric shapes to blend with buildings and concrete. Arctic patterns utilize white and light gray to disappear against snow and ice. Modern digital camouflage patterns use pixelated designs that break up outlines more effectively at various distances and have been adopted by many military forces worldwide.\n\nEffective camouflage disrupts the human outline and uses colors that match the surrounding environment, making detection by enemy forces more difficult through both visual observation and optical sensors. The human brain is particularly adept at recognizing human shapes and patterns, so disrupting recognizable silhouettes is as important as color matching. Camouflage works in conjunction with other concealment techniques such as using natural cover, minimizing movement, and reducing shine from exposed skin or equipment. Face paint, camouflage netting, and proper positioning of equipment all contribute to the overall concealment. In modern warfare where adversaries may use thermal imaging and other detection technologies, camouflage systems have expanded to address infrared signatures and other detection methods beyond the visible spectrum.",
            question: "What is the purpose of using different camouflage patterns?",
            options: [
              "To look more professional",
              "To identify different military branches",
              "Each pattern serves specific environments",
              "To save money on uniforms"
            ],
            correctAnswer: 2,
            explanation: "The passage explains that 'Different environments require different camouflage patterns' and each serves specific purposes for various terrains."
          },
          {
            id: 3,
            passage: "Climate change refers to long-term shifts in global temperatures and weather patterns that are altering environmental conditions across the planet. These changes manifest in various ways including rising average temperatures, changing precipitation patterns, more frequent extreme weather events, and shifting seasonal patterns. While natural processes can cause climate variations over geological timescales, the current rate and magnitude of change is unprecedented in human history. Scientific evidence shows that human activities, particularly burning fossil fuels, have accelerated warming since the 1800s at a pace that natural climate variation cannot explain.\n\nThe mechanism behind human-caused climate change involves greenhouse gases released into the atmosphere through industrial activities, transportation, agriculture, and deforestation. Carbon dioxide from burning coal, oil, and natural gas accumulates in the atmosphere and traps heat that would otherwise radiate back into space, creating a warming effect similar to a greenhouse. Methane from agriculture and natural gas production, along with other greenhouse gases, contributes additional warming. The atmospheric concentration of carbon dioxide has increased from about 280 parts per million before the Industrial Revolution to over 420 parts per million today, with levels rising faster each decade as global energy consumption increases.\n\nRising temperatures affect sea levels, weather extremes, and ecosystems worldwide in interconnected ways that create cascading impacts. Warming ocean water expands in volume while melting glaciers and ice sheets add additional water, causing sea levels to rise and threatening coastal communities. Higher temperatures increase the energy available in the atmosphere, leading to more intense hurricanes, heavier rainfall events, and more severe droughts in different regions. Ecosystems are disrupted as temperature and precipitation changes occur faster than many species can adapt, forcing migration or causing extinction. These environmental changes have significant implications for agriculture, water resources, infrastructure, and human security, making climate change one of the most pressing challenges facing global society in the coming decades.",
            question: "According to the passage, what has accelerated global warming since the 1800s?",
            options: [
              "Natural weather cycles only",
              "Volcanic activity",
              "Human activities like burning fossil fuels",
              "Solar radiation increases"
            ],
            correctAnswer: 2,
            explanation: "The passage states that 'scientific evidence shows that human activities, particularly burning fossil fuels, have accelerated warming since the 1800s.'"
          },
          {
            id: 4,
            passage: "First aid training teaches service members to respond effectively to medical emergencies when professional medical care is not immediately available. In military contexts, personnel may face traumatic injuries from combat, training accidents, or other hazardous situations where the nearest medical facility is minutes or hours away. The basic principles include ensuring scene safety, calling for professional medical help, and providing immediate care to prevent the victim's condition from worsening. These principles form a logical sequence that protects both the responder and the victim while maximizing the chances of a positive outcome.\n\nEnsuring scene safety is the critical first step because responders cannot help anyone if they become casualties themselves. This means assessing for ongoing threats such as enemy fire, unstable structures, hazardous materials, or electrical dangers before approaching a victim. In combat situations, this may require moving the victim to cover or eliminating immediate threats before rendering aid. Once the scene is safe, calling for professional medical help ensures that trained medical personnel and evacuation resources are en route. Providing immediate care then focuses on life-threatening conditions using the ABCs: Airway, Breathing, and Circulation. Ensuring an open airway, supporting breathing if necessary, and controlling severe bleeding are the priorities that address conditions most likely to cause death within minutes.\n\nQuick action in the first minutes after an injury can mean the difference between life and death, particularly for conditions like severe bleeding, airway obstruction, or cardiac arrest. The \"golden hour\" concept in trauma care recognizes that survival rates are highest when victims receive definitive medical treatment within 60 minutes of injury, making immediate first aid crucial for stabilizing victims until evacuation is possible. Military first aid training includes techniques such as applying tourniquets for extremity bleeding, using hemostatic gauze for wounds that cannot be tourniqueted, performing needle decompression for tension pneumothorax, and administering auto-injector medications for nerve agent exposure. Regular training and periodic refresher courses ensure that service members can perform these life-saving skills automatically under stress, maintaining calm and effective responses when seconds matter most.",
            question: "What is the first principle of first aid mentioned in the passage?",
            options: [
              "Calling for help",
              "Ensuring scene safety",
              "Providing immediate care",
              "Transporting the victim"
            ],
            correctAnswer: 1,
            explanation: "The passage lists 'ensuring scene safety' as the first basic principle of first aid, before calling for help or providing care."
          },
          {
            id: 5,
            passage: "Military rank structure creates a clear chain of command that ensures orders flow efficiently from senior leadership to junior personnel without confusion or conflicting directions. This hierarchical system establishes exactly who reports to whom and who has authority to make different types of decisions. In high-stress situations where rapid coordination is essential, everyone must know their place in the organization and understand the flow of information and authority. Each rank carries specific responsibilities and authority appropriate to the level of experience, training, and scope of leadership required. Junior enlisted personnel focus on mastering individual skills and following orders, while senior enlisted and officers progressively take on broader responsibilities for planning, resource management, and decision-making.\n\nRespecting rank is essential for maintaining discipline and ensuring missions are executed properly according to a unified plan rather than individual interpretations. When personnel follow the chain of command, senior leaders can coordinate complex operations involving multiple units, ensure logistics support reaches where it is needed, and maintain accountability for personnel and equipment. Bypassing the chain of command creates confusion, undermines leaders' authority, and can result in uncoordinated actions that endanger missions and lives. Military courtesy and customs reinforce the rank structure through saluting, proper forms of address, and formal protocols that constantly remind personnel of organizational relationships. This emphasis on hierarchy may seem rigid compared to civilian organizations, but it reflects the reality that military operations cannot tolerate the ambiguity and debate that might be acceptable in other contexts.\n\nThe rank system has evolved over centuries to meet the organizational needs of armed forces as they have grown in size and technical complexity. Ancient armies had simple hierarchies with commanders and followers. Modern militaries have elaborate rank structures with multiple pay grades within enlisted, non-commissioned officer, and commissioned officer categories. This granularity allows for precise placement of personnel based on their experience, specialization, and leadership capacity. Enlisted ranks provide a progression path from entry-level soldier to senior technical expert and unit leader. Non-commissioned officers serve as the backbone of military units, providing day-to-day leadership, technical expertise, and mentorship. Commissioned officers provide strategic direction, mission planning, and resource management at higher organizational levels. This multi-tiered system creates an efficient organization capable of accomplishing diverse missions while developing personnel progressively throughout their careers.",
            question: "According to the passage, why is military rank structure important?",
            options: [
              "It determines salary only",
              "It creates a clear chain of command",
              "It separates different service branches",
              "It makes training easier"
            ],
            correctAnswer: 1,
            explanation: "The passage states that rank structure 'creates a clear chain of command that ensures orders flow efficiently from senior leadership to junior personnel.'"
          }
        ]
      },
      {
        id: 5,
        name: "Mathematics Knowledge (MK)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "If 4x + 12 = 36, what is the value of x?",
            options: ["4", "5", "6", "7"],
            correctAnswer: 2,
            explanation: "Subtract 12 from both sides: 4x = 24. Divide by 4: x = 6."
          },
          {
            id: 2,
            question: "What is the perimeter of a rectangle with length 15 and width 9?",
            options: ["24", "36", "48", "135"],
            correctAnswer: 2,
            explanation: "Perimeter = 2(length + width) = 2(15 + 9) = 2(24) = 48 units."
          },
          {
            id: 3,
            question: "What is 2 to the power of 5?",
            options: ["10", "16", "25", "32"],
            correctAnswer: 3,
            explanation: "2⁵ = 2 × 2 × 2 × 2 × 2 = 32."
          },
          {
            id: 4,
            question: "If a triangle has angles measuring 45° and 60°, what is the measure of the third angle?",
            options: ["65°", "75°", "85°", "95°"],
            correctAnswer: 1,
            explanation: "The sum of angles in a triangle is 180°. Third angle = 180° - 45° - 60° = 75°."
          },
          {
            id: 5,
            question: "What is 40% of 350?",
            options: ["120", "130", "140", "150"],
            correctAnswer: 2,
            explanation: "Convert 40% to decimal (0.40) and multiply: 0.40 × 350 = 140."
          }
        ]
      },
      {
        id: 6,
        name: "Electronics Information (EI)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "What unit is used to measure electrical power?",
            options: ["Volts", "Amperes", "Ohms", "Watts"],
            correctAnswer: 3,
            explanation: "Electrical power is measured in Watts (W), which equals voltage multiplied by current (P = V × I)."
          },
          {
            id: 2,
            question: "What is the primary purpose of a fuse in an electrical circuit?",
            options: [
              "Increase voltage",
              "Store electricity",
              "Protect against overcurrent",
              "Amplify signals"
            ],
            correctAnswer: 2,
            explanation: "A fuse protects electrical circuits by breaking the connection when current exceeds a safe level, preventing damage or fire."
          },
          {
            id: 3,
            question: "In a circuit, what happens to total current when resistors are added in parallel?",
            options: ["Decreases", "Increases", "Stays the same", "Becomes zero"],
            correctAnswer: 1,
            explanation: "Adding resistors in parallel provides additional paths for current flow, decreasing total resistance and increasing total current."
          },
          {
            id: 4,
            question: "What type of material allows electricity to flow through it easily?",
            options: ["Insulator", "Conductor", "Semiconductor", "Resistor"],
            correctAnswer: 1,
            explanation: "A conductor is a material that allows electricity to flow easily through it due to free-moving electrons. Examples include copper and aluminum."
          },
          {
            id: 5,
            question: "What does a voltmeter measure in an electrical circuit?",
            options: [
              "Current flow",
              "Electrical potential difference",
              "Resistance",
              "Power consumption"
            ],
            correctAnswer: 1,
            explanation: "A voltmeter measures voltage, which is the electrical potential difference between two points in a circuit."
          }
        ]
      },
      {
        id: 7,
        name: "Auto & Shop Information (AS)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "What is the primary function of motor oil in an engine?",
            options: [
              "Cool the radiator",
              "Lubricate moving parts",
              "Ignite fuel",
              "Clean exhaust"
            ],
            correctAnswer: 1,
            explanation: "Motor oil lubricates moving engine parts to reduce friction and wear, while also helping to cool and clean the engine."
          },
          {
            id: 2,
            question: "Which tool is used to cut threads into metal to accept a bolt?",
            options: ["Die", "Tap", "Reamer", "Drill bit"],
            correctAnswer: 1,
            explanation: "A tap cuts internal threads inside a hole to accept a bolt, while a die cuts external threads on a rod or bolt."
          },
          {
            id: 3,
            question: "What component in a vehicle's braking system converts kinetic energy into heat?",
            options: ["Master cylinder", "Brake pads", "Brake lines", "Brake fluid"],
            correctAnswer: 1,
            explanation: "Brake pads create friction against rotors or drums, converting the vehicle's kinetic energy into heat energy to slow or stop the vehicle."
          },
          {
            id: 4,
            question: "What is the purpose of a wood chisel?",
            options: [
              "Measure angles",
              "Cut or shape wood by hand",
              "Sand surfaces smooth",
              "Join wood pieces"
            ],
            correctAnswer: 1,
            explanation: "A chisel is a hand tool with a sharp cutting edge used to carve, cut, or shape wood and other materials."
          },
          {
            id: 5,
            question: "What does ABS stand for in automotive braking systems?",
            options: [
              "Automatic Brake System",
              "Anti-lock Braking System",
              "Advanced Brake Safety",
              "Assisted Brake Service"
            ],
            correctAnswer: 1,
            explanation: "ABS stands for Anti-lock Braking System, which prevents wheels from locking during hard braking, maintaining steering control."
          }
        ]
      },
      {
        id: 8,
        name: "Mechanical Comprehension (MC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "If a lever is 8 feet long and the fulcrum is 2 feet from the load, what is the mechanical advantage?",
            options: ["2", "3", "4", "6"],
            correctAnswer: 1,
            explanation: "Mechanical advantage = effort arm ÷ resistance arm = 6 feet ÷ 2 feet = 3."
          },
          {
            id: 2,
            question: "What happens to the volume of a gas when pressure increases and temperature remains constant?",
            options: ["Volume increases", "Volume decreases", "Volume stays the same", "Volume doubles"],
            correctAnswer: 1,
            explanation: "According to Boyle's Law, when pressure increases at constant temperature, volume decreases proportionally."
          },
          {
            id: 3,
            question: "If Gear A has 30 teeth and Gear B has 15 teeth, and Gear A rotates at 60 RPM, how fast does Gear B rotate?",
            options: ["30 RPM", "60 RPM", "90 RPM", "120 RPM"],
            correctAnswer: 3,
            explanation: "Gear ratio = 30:15 = 2:1. Gear B rotates twice as fast: 60 × 2 = 120 RPM."
          },
          {
            id: 4,
            question: "Which of the following would best reduce friction between two metal surfaces?",
            options: ["Adding sand", "Adding lubricant", "Increasing pressure", "Adding heat"],
            correctAnswer: 1,
            explanation: "Lubricant creates a barrier between metal surfaces, reducing direct contact and friction between them."
          },
          {
            id: 5,
            question: "A fixed pulley changes the direction of force but provides what mechanical advantage?",
            options: ["0", "1", "2", "4"],
            correctAnswer: 1,
            explanation: "A fixed pulley has a mechanical advantage of 1, meaning it doesn't reduce force required but changes the direction of the applied force."
          }
        ]
      },
      {
        id: 9,
        name: "Assembling Objects (AO)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "If six identical triangular pieces are arranged around a common center point, what shape is formed?",
            options: ["Pentagon", "Hexagon", "Octagon", "Circle"],
            correctAnswer: 1,
            explanation: "Six identical triangular pieces arranged around a center point form a hexagon with six sides."
          },
          {
            id: 2,
            question: "Two rectangles of equal size can be arranged to form which of the following?",
            options: [
              "A circle",
              "A larger rectangle",
              "A pentagon",
              "A triangle"
            ],
            correctAnswer: 1,
            explanation: "Two equal rectangles can be placed side by side to form a larger rectangle."
          },
          {
            id: 3,
            question: "If object A is larger than B, and B is larger than C, which is the smallest?",
            options: ["Object A", "Object B", "Object C", "All are equal"],
            correctAnswer: 2,
            explanation: "Since A > B and B > C, object C is the smallest in this sequence."
          },
          {
            id: 4,
            question: "Four identical squares can be arranged to form what larger shape?",
            options: [
              "A triangle",
              "A larger square",
              "A pentagon",
              "A circle"
            ],
            correctAnswer: 1,
            explanation: "Four identical squares can be arranged in a 2×2 pattern to form one larger square."
          },
          {
            id: 5,
            question: "If point P must connect to point Q along the edge of a circle, and both points are on the circle's edge, which connection is shortest?",
            options: [
              "Around the circumference",
              "A straight line through the circle",
              "Along a radius",
              "Through the center"
            ],
            correctAnswer: 1,
            explanation: "A chord (straight line through the circle connecting two points on the edge) is always shorter than the arc along the circumference."
          }
        ]
      },
      {
        id: 10,
        name: "Verbal Expression (VE)",
        timeLimit: 4,
        questions: [
          {
            id: 1,
            question: "Choose the sentence with correct grammar:",
            options: [
              "The team have finished their training",
              "The team has finished their training",
              "The team has finished its training",
              "The team have finished its training"
            ],
            correctAnswer: 2,
            explanation: "When referring to a team as a single unit, use singular verb 'has' and singular pronoun 'its': 'The team has finished its training.'"
          },
          {
            id: 2,
            question: "Which word is spelled correctly?",
            options: ["Recieve", "Receeve", "Receive", "Recive"],
            correctAnswer: 2,
            explanation: "The correct spelling is 'receive,' following the rule 'i before e except after c.'"
          },
          {
            id: 3,
            question: "Choose the sentence with correct punctuation:",
            options: [
              "The officer said report to the briefing room at 0700",
              "The officer said, report to the briefing room at 0700",
              "The officer said, 'Report to the briefing room at 0700.'",
              "The officer said: report to the briefing room at 0700"
            ],
            correctAnswer: 2,
            explanation: "Direct quotations require quotation marks around the spoken words, with proper punctuation inside: 'The officer said, \"Report to the briefing room at 0700.\"'"
          },
          {
            id: 4,
            question: "Identify the sentence with correct subject-verb agreement:",
            options: [
              "Each of the soldiers have their own responsibilities",
              "Each of the soldiers has their own responsibilities",
              "Each of the soldiers has his or her own responsibilities",
              "Each of the soldiers have his or her own responsibilities"
            ],
            correctAnswer: 2,
            explanation: "'Each' is singular and requires a singular verb 'has' and singular pronouns 'his or her': 'Each of the soldiers has his or her own responsibilities.'"
          },
          {
            id: 5,
            question: "Which sentence correctly uses 'who' or 'whom'?",
            options: [
              "Who did you report to?",
              "Whom did you report to?",
              "Who did the report go to?",
              "Whom leads the squad?"
            ],
            correctAnswer: 1,
            explanation: "'Whom' is the object form used after prepositions or as direct objects. 'Whom did you report to?' is correct (you reported to him/her)."
          }
        ]
      }
    ]
  },,
  {
    id: 4,
    title: "ASVAB Practice Test #4",
    description: "Comprehensive practice exam covering all 10 ASVAB sections with military-standard questions",
    totalQuestions: 50,
    timeLimit: 60,
    sections: [
      {
        id: 1,
        name: "General Science (GS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What is the name of the process by which plants release water vapor through their leaves?",
            options: ["Photosynthesis", "Respiration", "Transpiration", "Osmosis"],
            correctAnswer: 2,
            explanation: "Transpiration is the process where plants release water vapor through small pores called stomata in their leaves, helping regulate temperature and transport nutrients."
          },
          {
            id: 2,
            question: "Which gas makes up approximately 78% of Earth's atmosphere?",
            options: ["Oxygen", "Carbon dioxide", "Nitrogen", "Argon"],
            correctAnswer: 2,
            explanation: "Nitrogen comprises about 78% of Earth's atmosphere, while oxygen makes up approximately 21%, with other gases making up the remaining 1%."
          },
          {
            id: 3,
            question: "What type of energy is stored in the bonds of chemical compounds?",
            options: ["Kinetic energy", "Potential energy", "Chemical energy", "Thermal energy"],
            correctAnswer: 2,
            explanation: "Chemical energy is potential energy stored in the bonds between atoms in molecules, which is released during chemical reactions."
          },
          {
            id: 4,
            question: "Which organ produces insulin in the human body?",
            options: ["Liver", "Pancreas", "Stomach", "Kidneys"],
            correctAnswer: 1,
            explanation: "The pancreas produces insulin, a hormone that regulates blood sugar levels by helping cells absorb glucose from the bloodstream."
          },
          {
            id: 5,
            question: "What is the speed of light in a vacuum?",
            options: ["186,000 miles per second", "93,000 miles per second", "300,000 miles per second", "500,000 miles per second"],
            correctAnswer: 0,
            explanation: "The speed of light in a vacuum is approximately 186,000 miles per second (or about 300,000 kilometers per second), the universal speed limit."
          }
        ]
      },
      {
        id: 2,
        name: "Arithmetic Reasoning (AR)",
        timeLimit: 8,
        questions: [
          {
            id: 1,
            question: "A military dining facility serves 1,800 meals per day. If breakfast accounts for 35%, lunch for 40%, and dinner for the remainder, how many dinner meals are served?",
            options: ["360", "450", "540", "630"],
            correctAnswer: 1,
            explanation: "Breakfast and lunch total: 35% + 40% = 75%. Dinner: 100% - 75% = 25%. Dinner meals: 25% of 1,800 = 0.25 × 1,800 = 450 meals."
          },
          {
            id: 2,
            question: "A convoy travels 180 miles in 4 hours, then takes a 30-minute break, then travels another 120 miles in 2.5 hours. What was the average speed while actually driving?",
            options: ["42.5 mph", "44.2 mph", "46.2 mph", "48.0 mph"],
            correctAnswer: 2,
            explanation: "Total distance: 180 + 120 = 300 miles. Total driving time: 4 + 2.5 = 6.5 hours (break time excluded). Average speed: 300 ÷ 6.5 = 46.2 mph."
          },
          {
            id: 3,
            question: "If ammunition costs $2.40 per round and a soldier fires 85 rounds during qualification, what is the total ammunition cost?",
            options: ["$186.00", "$196.00", "$204.00", "$214.00"],
            correctAnswer: 2,
            explanation: "Total cost: $2.40 per round × 85 rounds = $204.00."
          },
          {
            id: 4,
            question: "A barracks room is 18 feet long and 12 feet wide. If new flooring costs $4.50 per square foot, what is the total cost?",
            options: ["$864", "$918", "$972", "$1,026"],
            correctAnswer: 2,
            explanation: "Room area: 18 × 12 = 216 square feet. Total cost: 216 × $4.50 = $972."
          },
          {
            id: 5,
            question: "A water tank holds 2,400 gallons when full. If it is currently 65% full, how many more gallons are needed to fill it?",
            options: ["780 gallons", "840 gallons", "900 gallons", "960 gallons"],
            correctAnswer: 1,
            explanation: "Current volume: 65% of 2,400 = 1,560 gallons. Needed: 2,400 - 1,560 = 840 gallons."
          }
        ]
      },
      {
        id: 3,
        name: "Word Knowledge (WK)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "Impede most nearly means:",
            options: ["Assist", "Obstruct", "Improve", "Accelerate"],
            correctAnswer: 1,
            explanation: "Impede means to obstruct, hinder, or slow down progress; to create barriers or obstacles."
          },
          {
            id: 2,
            question: "Mundane most nearly means:",
            options: ["Extraordinary", "Ordinary", "Exciting", "Dangerous"],
            correctAnswer: 1,
            explanation: "Mundane means ordinary, routine, and commonplace; lacking excitement or interest."
          },
          {
            id: 3,
            question: "Cohesive most nearly means:",
            options: ["Divided", "United", "Scattered", "Independent"],
            correctAnswer: 1,
            explanation: "Cohesive means united, unified, and sticking together as a whole; forming a united or integrated group."
          },
          {
            id: 4,
            question: "Brevity most nearly means:",
            options: ["Length", "Shortness", "Complexity", "Clarity"],
            correctAnswer: 1,
            explanation: "Brevity means shortness or conciseness of expression; using few words to convey meaning effectively."
          },
          {
            id: 5,
            question: "Exemplary most nearly means:",
            options: ["Poor", "Average", "Outstanding", "Mediocre"],
            correctAnswer: 2,
            explanation: "Exemplary means outstanding, excellent, and serving as a model or example worthy of imitation."
          }
        ]
      },
      {
        id: 4,
        name: "Paragraph Comprehension (PC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            passage: "Military bearing refers to the professional appearance, conduct, and demeanor expected of service members both on and off duty. It encompasses posture, grooming standards, uniform wear, and the manner in which one carries themselves in all situations. Military bearing is more than just following regulations about haircuts and uniform specifications—it reflects an internalized sense of professionalism and commitment to high standards. Service members with strong military bearing project confidence, competence, and dedication through their physical presence and behavior. This professional demeanor begins from the first day of basic training and is expected to continue throughout one's military career and even into veteran status.\n\nGood military bearing demonstrates self-discipline, pride in service, and respect for the profession of arms that transcends individual preferences or convenience. Maintaining proper posture, keeping uniforms clean and properly fitted, adhering to grooming standards, and conducting oneself with dignity all require consistent effort and attention to detail. These standards exist not as arbitrary restrictions but as visible manifestations of the discipline and attention to standards that military service demands. When service members maintain military bearing even when tired, stressed, or facing challenges, they demonstrate the self-control necessary for military effectiveness. Pride in service shows in how personnel wear the uniform, present themselves, and represent their unit and branch of service. Respect for the profession is evident in taking these standards seriously rather than seeking minimum compliance.\n\nMilitary bearing influences how others perceive both the individual and the military as a whole, shaping public confidence in the armed forces. Civilians form opinions about military professionalism based on how service members appear and conduct themselves in public. Poor military bearing by even a few individuals can undermine public trust and respect earned by the exemplary service of thousands. Within the military community, personnel with strong military bearing earn respect from peers and superiors, enhancing their leadership potential and career prospects. Conversely, those who present a sloppy appearance or unprofessional demeanor lose credibility regardless of their technical skills. Military bearing thus serves as a constant, visible reminder of the high standards expected of those privileged to wear the uniform and defend the nation.",
            question: "According to the passage, what does good military bearing demonstrate?",
            options: [
              "Rank and authority only",
              "Self-discipline and pride in service",
              "Physical strength",
              "Years of experience"
            ],
            correctAnswer: 1,
            explanation: "The passage explicitly states that good military bearing 'demonstrates self-discipline, pride in service, and respect for the profession of arms.'"
          },
          {
            id: 2,
            passage: "Situational awareness is the ability to perceive, understand, and anticipate events in one's environment by maintaining an accurate mental model of what is happening around you. This critical skill involves continuously gathering information from multiple sources, processing that information to understand its meaning and implications, and projecting forward to anticipate how the situation might evolve. In military operations, maintaining situational awareness can prevent accidents, detect threats early, and enable better decision-making before situations become critical. A soldier with good situational awareness notices the vehicle parked in an unusual location, the person exhibiting suspicious behavior, or the change in routine that signals something is wrong. Without this awareness, threats go unnoticed until it is too late to respond effectively.\n\nSoldiers develop this skill through training, experience, and constant vigilance rather than relying on innate ability alone. Training scenarios expose personnel to realistic situations where they must practice observing, interpreting, and responding to environmental cues. After-action reviews help them understand what indicators they missed and how to improve their observation skills. Experience in various environments builds a mental library of normal patterns, making it easier to recognize when something is out of place. Constant vigilance means maintaining focus even during routine tasks or extended operations when fatigue makes it tempting to relax attention. This disciplined awareness must become habitual so that soldiers automatically scan their environment and process information even under stress.\n\nDeveloping strong situational awareness requires actively observing surroundings, understanding their significance, and predicting how situations might develop based on available information. Active observation means deliberately looking at the environment rather than just passively seeing what is directly in front of you. It involves using all senses—hearing unusual sounds, noticing smells that indicate hazards, and feeling environmental changes. Understanding significance requires interpreting observations in context: is that person nervous because they are hiding something dangerous, or simply intimidated by armed military presence? Predicting developments involves thinking through 'what if' scenarios: if that crowd becomes hostile, where are the exits and cover positions? This mental process of continuous assessment enables rapid, informed responses when situations change suddenly, providing the seconds or minutes of advantage that determine outcomes in military operations.",
            question: "How do soldiers develop situational awareness according to the passage?",
            options: [
              "It is an innate ability everyone has",
              "Through training, experience, and vigilance",
              "By reading manuals only",
              "It cannot be developed"
            ],
            correctAnswer: 1,
            explanation: "The passage states that soldiers 'develop this skill through training, experience, and constant vigilance.'"
          },
          {
            id: 3,
            passage: "Renewable energy sources, such as solar, wind, and hydroelectric power, can be replenished naturally over short time periods, providing essentially unlimited energy if properly managed. Solar energy harnesses radiation from the sun using photovoltaic panels or concentrated solar power systems. Wind energy captures the kinetic energy of moving air through turbines. Hydroelectric power converts the energy of flowing or falling water into electricity. Unlike fossil fuels, which take millions of years to form from ancient organic matter and are depleted as they are consumed, renewable sources are sustainable and continuously available. The sun will shine, wind will blow, and water will flow regardless of how much energy we extract from these sources, making them fundamentally different from finite fossil fuel reserves.\n\nRenewable energy sources also produce fewer greenhouse gas emissions during operation compared to burning coal, oil, or natural gas. While manufacturing solar panels, wind turbines, and other renewable energy infrastructure requires energy and resources, the operational phase generates electricity without releasing carbon dioxide or other pollutants into the atmosphere. This cleaner energy production helps mitigate climate change and reduces air pollution that harms human health. Fossil fuel power plants, by contrast, continuously emit greenhouse gases and pollutants throughout their operational lifetime. The environmental benefits of renewable energy extend beyond just climate considerations to include reduced water pollution, less habitat destruction from resource extraction, and decreased health impacts on communities near power generation facilities.\n\nAs technology improves and costs decrease, renewable energy is becoming increasingly viable for both civilian and military applications across a broader range of situations. Advances in solar panel efficiency, wind turbine design, and energy storage systems have dramatically reduced the cost per kilowatt-hour of renewable electricity. In many locations, new renewable energy installations are now cheaper than new fossil fuel plants, driving rapid adoption. For military applications, renewable energy offers strategic advantages including reduced dependence on fuel supply lines that are vulnerable to interdiction, portable power generation for remote bases, and quiet operation that does not reveal positions. Forward operating bases can use solar panels to reduce the number of fuel convoys required, directly saving lives by reducing exposure to attacks. As battery storage technology continues improving, renewable energy systems will become even more practical for military operations requiring reliable, independent power supplies in challenging environments.",
            question: "What advantage do renewable energy sources have over fossil fuels?",
            options: [
              "They are always cheaper",
              "They can be replenished naturally and produce fewer emissions",
              "They produce more power",
              "They require no technology"
            ],
            correctAnswer: 1,
            explanation: "The passage indicates renewable sources 'can be replenished naturally' and 'produce fewer greenhouse gas emissions' compared to fossil fuels."
          },
          {
            id: 4,
            passage: "The buddy system pairs soldiers together to enhance safety, accountability, and mission effectiveness through mutual support and oversight. This fundamental military practice assigns specific individuals to watch out for each other's welfare and maintain constant awareness of their partner's location and condition. Partners monitor each other's well-being, checking for signs of fatigue, heat stress, injury, or mental strain that individuals might not recognize in themselves. They provide assistance when needed, whether helping with heavy loads, providing covering fire during tactical movements, or offering encouragement during difficult training or operations. The buddy system ensures no one is left behind, with each partner responsible for accounting for the other during movements, accountability formations, and especially during chaotic situations like combat or emergency evacuations.\n\nThis system is especially important in hazardous environments where having someone watching your back can make the difference between success and failure, survival and catastrophe. In combat zones, a buddy may spot threats that you miss while focused on other tasks, provide immediate aid if you are wounded, or drag you to safety if you become incapacitated. During water operations, buddies ensure no one drowns unnoticed. In chemical or biological threat environments, buddies check each other's protective equipment for proper sealing and watch for exposure symptoms. Even in training environments, the buddy system prevents accidents by ensuring someone is always positioned to intervene if equipment malfunctions, exercises go wrong, or medical emergencies occur. The psychological benefit of knowing someone is specifically responsible for your welfare reduces stress and increases confidence during dangerous activities.\n\nThe buddy system builds trust and reinforces teamwork by creating personal bonds and mutual dependence between service members. When you know your survival may depend on your buddy's vigilance and your buddy's survival depends on yours, you develop a powerful commitment to each other that extends beyond formal duty. This relationship teaches soldiers to think beyond individual concerns and to prioritize collective welfare. Buddy teams work together repeatedly, learning each other's capabilities, communication styles, and how to coordinate seamlessly under pressure. These partnerships often extend beyond the immediate pair to create cohesive fire teams, squads, and larger units where everyone looks out for each other. The habits of mutual support and collective responsibility fostered by the buddy system are foundational to the teamwork essential for military success, creating units that function as unified teams rather than collections of individuals.",
            question: "What is the main purpose of the buddy system?",
            options: [
              "To reduce the need for supervision",
              "To enhance safety, accountability, and effectiveness",
              "To assign blame when things go wrong",
              "To speed up training"
            ],
            correctAnswer: 1,
            explanation: "The passage states the buddy system is used 'to enhance safety, accountability, and mission effectiveness.'"
          },
          {
            id: 5,
            passage: "Night vision technology amplifies available light, including infrared light invisible to the human eye, allowing military personnel to see in darkness and low-light conditions where the unaided eye would be nearly blind. These devices work by collecting tiny amounts of light from sources such as distant stars, moonlight, or ambient infrared radiation emitted by objects, then amplifying that light tens of thousands of times to create a visible image. Early night vision devices were bulky and had limited capabilities, with Generation 1 systems developed in the 1960s providing grainy images with limited range and requiring some ambient light to function. These early systems were better than nothing but had significant limitations that restricted their tactical utility.\n\nModern systems are lightweight, durable, and provide clear images with impressive range and resolution that have transformed nighttime military operations. Generation 3 and Generation 4 night vision systems use advanced image intensifier tubes with photocathodes made from gallium arsenide, dramatically improving sensitivity and image quality. Modern devices mount on helmets, weapons, or vehicles, freeing hands for other tasks while providing continuous night vision capability. They are ruggedized to withstand harsh military conditions including vibration, moisture, temperature extremes, and rough handling. Battery life has improved to support extended operations, and automatic brightness control prevents the devices from being overwhelmed by sudden light sources. Some systems incorporate thermal imaging that detects heat signatures rather than amplifying light, working even in complete darkness or through obscurants like smoke.\n\nThis technology gives forces operating at night a significant tactical advantage, enabling operations that would otherwise be impossible in low-light conditions and allowing them to dominate the darkness. Military forces with night vision can move, navigate, identify targets, and engage enemies in conditions where adversaries without such technology are effectively blind. Night operations allow forces to exploit the cover of darkness for surprise attacks, infiltration missions, and movements that would be too dangerous in daylight. Many successful military operations have leveraged night vision superiority to overwhelm opponents who could not effectively respond to threats they could not see. The psychological impact of facing an enemy that can see and operate effectively in darkness while you cannot is substantial. As night vision technology has proliferated globally, maintaining technological superiority in night vision capabilities remains a priority for advanced military forces seeking to preserve their advantage in nighttime combat operations.",
            question: "What advantage does night vision technology provide?",
            options: [
              "It eliminates the need for lighting entirely",
              "It enables operations in low-light conditions",
              "It allows seeing through walls",
              "It works only in complete darkness"
            ],
            correctAnswer: 1,
            explanation: "The passage states night vision 'gives forces operating at night a significant tactical advantage, enabling operations that would otherwise be impossible in low-light conditions.'"
          }
        ]
      },
      {
        id: 5,
        name: "Mathematics Knowledge (MK)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "If 7x - 9 = 40, what is the value of x?",
            options: ["5", "6", "7", "8"],
            correctAnswer: 2,
            explanation: "Add 9 to both sides: 7x = 49. Divide by 7: x = 7."
          },
          {
            id: 2,
            question: "What is the area of a triangle with a base of 16 and a height of 9?",
            options: ["72", "108", "144", "288"],
            correctAnswer: 0,
            explanation: "Area of triangle = (base × height) ÷ 2 = (16 × 9) ÷ 2 = 144 ÷ 2 = 72 square units."
          },
          {
            id: 3,
            question: "What is the value of 3³ + 2²?",
            options: ["13", "17", "31", "35"],
            correctAnswer: 2,
            explanation: "3³ = 3 × 3 × 3 = 27. 2² = 2 × 2 = 4. Total: 27 + 4 = 31."
          },
          {
            id: 4,
            question: "A circle has a radius of 7. What is its circumference? (Use π ≈ 3.14)",
            options: ["21.98", "43.96", "153.86", "307.72"],
            correctAnswer: 1,
            explanation: "Circumference = 2πr = 2 × 3.14 × 7 = 43.96 units."
          },
          {
            id: 5,
            question: "Solve for y: 3y + 15 = 48",
            options: ["9", "11", "13", "15"],
            correctAnswer: 1,
            explanation: "Subtract 15 from both sides: 3y = 33. Divide by 3: y = 11."
          }
        ]
      },
      {
        id: 6,
        name: "Electronics Information (EI)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "What happens to resistance when the length of a wire increases?",
            options: ["Resistance decreases", "Resistance increases", "Resistance stays the same", "Resistance becomes zero"],
            correctAnswer: 1,
            explanation: "Resistance is directly proportional to wire length. As length increases, electrons must travel farther, encountering more resistance."
          },
          {
            id: 2,
            question: "What is the main purpose of a circuit breaker?",
            options: [
              "Increase voltage",
              "Store electrical energy",
              "Automatically interrupt current flow during overload",
              "Convert AC to DC"
            ],
            correctAnswer: 2,
            explanation: "A circuit breaker automatically interrupts current flow when it exceeds safe levels, protecting the circuit from damage. Unlike a fuse, it can be reset."
          },
          {
            id: 3,
            question: "Which component in a circuit stores electrical energy in an electric field?",
            options: ["Resistor", "Capacitor", "Inductor", "Diode"],
            correctAnswer: 1,
            explanation: "A capacitor stores electrical energy in an electric field between two conductive plates separated by an insulator."
          },
          {
            id: 4,
            question: "If a circuit has 12 volts and 3 ohms of resistance, what is the current flow? (Use Ohm's Law: V = I × R)",
            options: ["2 amperes", "4 amperes", "9 amperes", "36 amperes"],
            correctAnswer: 1,
            explanation: "Using Ohm's Law: I = V ÷ R = 12 volts ÷ 3 ohms = 4 amperes."
          },
          {
            id: 5,
            question: "What device converts electrical energy into mechanical motion?",
            options: ["Generator", "Transformer", "Motor", "Battery"],
            correctAnswer: 2,
            explanation: "An electric motor converts electrical energy into mechanical motion through electromagnetic interactions, while a generator does the opposite."
          }
        ]
      },
      {
        id: 7,
        name: "Auto & Shop Information (AS)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "What is the primary purpose of a vehicle's suspension system?",
            options: [
              "Generate power",
              "Control emissions",
              "Absorb road shocks and provide smooth ride",
              "Cool the engine"
            ],
            correctAnswer: 2,
            explanation: "The suspension system absorbs shocks from the road surface, providing a smoother ride and helping maintain tire contact with the road for better control."
          },
          {
            id: 2,
            question: "Which tool is used to grip, turn, or hold objects firmly?",
            options: ["Hacksaw", "Pliers", "File", "Punch"],
            correctAnswer: 1,
            explanation: "Pliers are hand tools designed to grip, turn, bend, or hold objects firmly. Different types of pliers serve various specific purposes."
          },
          {
            id: 3,
            question: "What automotive component controls the amount of air-fuel mixture entering the engine?",
            options: ["Carburetor or throttle body", "Radiator", "Muffler", "Oil filter"],
            correctAnswer: 0,
            explanation: "The carburetor (in older vehicles) or throttle body (in modern vehicles) controls the amount of air-fuel mixture entering the engine, regulating power and speed."
          },
          {
            id: 4,
            question: "What is the purpose of a wood rasp?",
            options: [
              "Cut precise straight lines",
              "Shape and smooth wood with rough teeth",
              "Measure wood thickness",
              "Join wood pieces together"
            ],
            correctAnswer: 1,
            explanation: "A rasp is a coarse file with rough teeth used for shaping and smoothing wood, removing material more aggressively than a fine file."
          },
          {
            id: 5,
            question: "What does the thermostat in a vehicle's cooling system do?",
            options: [
              "Measure engine temperature only",
              "Regulate coolant flow to maintain optimal engine temperature",
              "Cool the transmission",
              "Control air conditioning"
            ],
            correctAnswer: 1,
            explanation: "The thermostat regulates coolant flow through the engine, opening when the engine reaches operating temperature and closing when it's cold to help it warm up quickly."
          }
        ]
      },
      {
        id: 8,
        name: "Mechanical Comprehension (MC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "If a wheel has a diameter of 20 inches, how far will it travel in one complete revolution? (Use π ≈ 3.14)",
            options: ["31.4 inches", "62.8 inches", "94.2 inches", "125.6 inches"],
            correctAnswer: 1,
            explanation: "Distance per revolution equals circumference: π × diameter = 3.14 × 20 = 62.8 inches."
          },
          {
            id: 2,
            question: "In a hydraulic system, if a small piston with 2 square inches of area is pushed down with 100 pounds of force, what force is generated at a large piston with 8 square inches?",
            options: ["100 pounds", "200 pounds", "400 pounds", "800 pounds"],
            correctAnswer: 2,
            explanation: "Hydraulic pressure is equal throughout. Pressure = 100 ÷ 2 = 50 psi. Force on large piston = 50 × 8 = 400 pounds."
          },
          {
            id: 3,
            question: "What happens to the mechanical advantage when you increase the number of supporting ropes in a pulley system?",
            options: ["It decreases", "It increases", "It stays the same", "It becomes zero"],
            correctAnswer: 1,
            explanation: "Mechanical advantage in a pulley system equals the number of supporting ropes. More ropes means greater mechanical advantage and less force needed to lift."
          },
          {
            id: 4,
            question: "If two gears are connected by a belt and one gear has twice the diameter of the other, which statement is true?",
            options: [
              "Both gears rotate at the same speed",
              "The larger gear rotates twice as fast",
              "The smaller gear rotates twice as fast",
              "Neither gear will rotate"
            ],
            correctAnswer: 2,
            explanation: "In belt-driven systems, the smaller gear rotates faster. If one gear has twice the diameter, the smaller gear rotates twice as fast as the larger one."
          },
          {
            id: 5,
            question: "What type of simple machine is a doorknob?",
            options: ["Lever", "Inclined plane", "Wheel and axle", "Pulley"],
            correctAnswer: 2,
            explanation: "A doorknob is a wheel and axle. The knob (wheel) has a larger radius than the shaft (axle), providing mechanical advantage to turn the latch mechanism."
          }
        ]
      },
      {
        id: 9,
        name: "Assembling Objects (AO)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "If five identical rectangular pieces are arranged in a cross pattern with one in the center, how many pieces touch the center piece?",
            options: ["2", "3", "4", "5"],
            correctAnswer: 2,
            explanation: "In a cross pattern, the center piece touches all four surrounding pieces (top, bottom, left, and right)."
          },
          {
            id: 2,
            question: "Three identical 120-degree angles arranged around a common point will form what total angle?",
            options: ["180 degrees", "240 degrees", "300 degrees", "360 degrees"],
            correctAnswer: 3,
            explanation: "Three 120-degree angles: 120 × 3 = 360 degrees, forming a complete circle around the point."
          },
          {
            id: 3,
            question: "If shape X fits inside shape Y, and shape Y fits inside shape Z, which is the largest?",
            options: ["Shape X", "Shape Y", "Shape Z", "All are equal"],
            correctAnswer: 2,
            explanation: "Since X fits in Y and Y fits in Z, shape Z must be the largest, followed by Y, then X."
          },
          {
            id: 4,
            question: "Two 45-degree right triangles can be joined along their hypotenuse to form what shape?",
            options: ["A rectangle", "A square", "A larger right triangle", "A pentagon"],
            correctAnswer: 1,
            explanation: "Two 45-45-90 right triangles joined along their hypotenuse form a square, as the two equal legs of each triangle become the sides."
          },
          {
            id: 5,
            question: "If point M connects to point N, and both are endpoints of a line segment, how many connection points are there total?",
            options: ["0", "1", "2", "3"],
            correctAnswer: 1,
            explanation: "A line segment connecting M to N represents one connection between the two endpoints, even though there are two points involved."
          }
        ]
      },
      {
        id: 10,
        name: "Verbal Expression (VE)",
        timeLimit: 4,
        questions: [
          {
            id: 1,
            question: "Choose the sentence with correct grammar:",
            options: [
              "The commander and his staff was present",
              "The commander and his staff were present",
              "The commander and his staff is present",
              "The commander and his staff be present"
            ],
            correctAnswer: 1,
            explanation: "When two or more subjects are joined by 'and,' use a plural verb. 'The commander and his staff were present' is correct."
          },
          {
            id: 2,
            question: "Which word is spelled correctly?",
            options: ["Maintainance", "Maintenence", "Maintenance", "Maintanance"],
            correctAnswer: 2,
            explanation: "The correct spelling is 'maintenance' with 'tenance' at the end, derived from 'maintain.'"
          },
          {
            id: 3,
            question: "Choose the sentence with correct punctuation:",
            options: [
              "The mission objectives are, secure the area establish communications and await orders",
              "The mission objectives are: secure the area, establish communications, and await orders.",
              "The mission objectives are secure the area, establish communications and await orders",
              "The mission objectives are; secure the area, establish communications, and await orders"
            ],
            correctAnswer: 1,
            explanation: "Use a colon to introduce a list and commas to separate items. 'The mission objectives are: secure the area, establish communications, and await orders.' is correct."
          },
          {
            id: 4,
            question: "Identify the sentence with correct pronoun usage:",
            options: [
              "Myself and the sergeant completed the inspection",
              "The sergeant and myself completed the inspection",
              "The sergeant and I completed the inspection",
              "Me and the sergeant completed the inspection"
            ],
            correctAnswer: 2,
            explanation: "Use subject pronouns (I) when they are subjects of the sentence. 'The sergeant and I completed the inspection' is correct. Always put the other person first."
          },
          {
            id: 5,
            question: "Which sentence correctly uses 'affect' or 'effect'?",
            options: [
              "The weather will effect our mission timeline",
              "The new policy had a positive affect on morale",
              "The noise did not effect his concentration",
              "The training had a positive effect on readiness"
            ],
            correctAnswer: 3,
            explanation: "'Effect' as a noun means result or consequence. 'The training had a positive effect on readiness' is correct. 'Affect' is usually a verb meaning to influence."
          }
        ]
      }
    ]
  },,
  {
    id: 5,
    title: "ASVAB Practice Test #5",
    description: "Comprehensive practice exam covering all 10 ASVAB sections with military-standard questions",
    totalQuestions: 50,
    timeLimit: 60,
    sections: [
      {
        id: 1,
        name: "General Science (GS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What is the primary function of white blood cells in the human body?",
            options: ["Transport oxygen", "Fight infection and disease", "Produce hormones", "Digest nutrients"],
            correctAnswer: 1,
            explanation: "White blood cells (leukocytes) are part of the immune system and defend the body against infections, diseases, and foreign invaders."
          },
          {
            id: 2,
            question: "Which force pulls objects toward the center of the Earth?",
            options: ["Magnetism", "Friction", "Gravity", "Momentum"],
            correctAnswer: 2,
            explanation: "Gravity is the fundamental force that attracts all objects with mass toward each other. On Earth, this pulls objects toward the planet's center."
          },
          {
            id: 3,
            question: "What is the chemical symbol for gold?",
            options: ["Go", "Gd", "Au", "Ag"],
            correctAnswer: 2,
            explanation: "The chemical symbol for gold is Au, derived from its Latin name 'aurum.' Ag is silver, Gd is gadolinium."
          },
          {
            id: 4,
            question: "Which type of rock is formed by the accumulation and compression of sediment over time?",
            options: ["Igneous", "Metamorphic", "Sedimentary", "Volcanic"],
            correctAnswer: 2,
            explanation: "Sedimentary rocks form when sediments (sand, mud, organic matter) accumulate in layers and are compressed over millions of years. Examples include limestone and sandstone."
          },
          {
            id: 5,
            question: "What is the largest organ in the human body?",
            options: ["Liver", "Brain", "Skin", "Lungs"],
            correctAnswer: 2,
            explanation: "The skin is the largest organ in the human body, covering approximately 20 square feet in adults and accounting for about 16% of total body weight."
          }
        ]
      },
      {
        id: 2,
        name: "Arithmetic Reasoning (AR)",
        timeLimit: 8,
        questions: [
          {
            id: 1,
            question: "A platoon of 40 soldiers needs to be divided into equal-sized squads. If each squad must have exactly 8 soldiers, how many squads can be formed?",
            options: ["4 squads", "5 squads", "6 squads", "8 squads"],
            correctAnswer: 1,
            explanation: "Number of squads = Total soldiers ÷ Soldiers per squad = 40 ÷ 8 = 5 squads."
          },
          {
            id: 2,
            question: "A military truck travels 65 miles per hour for 3.5 hours. How far does it travel?",
            options: ["195.5 miles", "210.5 miles", "227.5 miles", "245.5 miles"],
            correctAnswer: 2,
            explanation: "Distance = Speed × Time = 65 mph × 3.5 hours = 227.5 miles."
          },
          {
            id: 3,
            question: "If a soldier's monthly housing allowance increases from $1,200 to $1,380, what is the percentage increase?",
            options: ["12%", "15%", "18%", "20%"],
            correctAnswer: 1,
            explanation: "Increase: $1,380 - $1,200 = $180. Percentage: ($180 ÷ $1,200) × 100 = 15%."
          },
          {
            id: 4,
            question: "A warehouse has 2,800 units of supplies. If 40% are distributed on Monday and 30% of the original total on Tuesday, how many units remain?",
            options: ["720 units", "840 units", "960 units", "1,080 units"],
            correctAnswer: 1,
            explanation: "Monday: 40% of 2,800 = 1,120 distributed. Tuesday: 30% of 2,800 = 840 distributed. Remaining: 2,800 - 1,120 - 840 = 840 units."
          },
          {
            id: 5,
            question: "If 6 mechanics can service 18 vehicles in 4 hours, how many vehicles can 10 mechanics service in the same time period?",
            options: ["24 vehicles", "28 vehicles", "30 vehicles", "36 vehicles"],
            correctAnswer: 2,
            explanation: "Rate per mechanic: 18 vehicles ÷ 6 mechanics = 3 vehicles per mechanic. For 10 mechanics: 10 × 3 = 30 vehicles."
          }
        ]
      },
      {
        id: 3,
        name: "Word Knowledge (WK)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "Diligent most nearly means:",
            options: ["Lazy", "Hardworking", "Confused", "Aggressive"],
            correctAnswer: 1,
            explanation: "Diligent means showing careful and persistent effort in one's work or duties; hardworking and dedicated."
          },
          {
            id: 2,
            question: "Fortify most nearly means:",
            options: ["Weaken", "Strengthen", "Abandon", "Ignore"],
            correctAnswer: 1,
            explanation: "Fortify means to strengthen or reinforce, especially in terms of defenses or structures. Also means to invigorate or encourage."
          },
          {
            id: 3,
            question: "Concise most nearly means:",
            options: ["Lengthy", "Brief", "Complex", "Vague"],
            correctAnswer: 1,
            explanation: "Concise means expressing information clearly and in few words; brief and to the point without unnecessary details."
          },
          {
            id: 4,
            question: "Apprehensive most nearly means:",
            options: ["Confident", "Anxious", "Excited", "Indifferent"],
            correctAnswer: 1,
            explanation: "Apprehensive means anxious or fearful about something that might happen; worried or uneasy about the future."
          },
          {
            id: 5,
            question: "Versatile most nearly means:",
            options: ["Specialized", "Adaptable", "Rigid", "Limited"],
            correctAnswer: 1,
            explanation: "Versatile means able to adapt to many different functions or activities; having varied skills and capable in multiple areas."
          }
        ]
      },
      {
        id: 4,
        name: "Paragraph Comprehension (PC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            passage: "Teamwork is fundamental to military success and represents one of the most important factors distinguishing effective fighting forces from collections of individuals. Modern military operations are far too complex for any single person to execute regardless of their individual capabilities. No individual, regardless of skill level, can accomplish complex missions alone when those missions require simultaneous actions across multiple locations, specialized skills from different fields, or sustained efforts beyond the capacity of a single person. Effective teams combine diverse talents, communicate clearly, support each other under pressure, and work toward common goals with unified effort. The synergy created when skilled individuals work together as a cohesive unit multiplies their effectiveness far beyond what the same individuals could achieve working separately.\n\nSuccessful military teams leverage complementary strengths and compensate for individual weaknesses through mutual support. A team might include technical specialists, tactical leaders, communications experts, and support personnel, each bringing essential capabilities. When these diverse talents are coordinated effectively, teams can solve problems that would stump any individual member working alone. Clear communication ensures everyone understands the plan, their role within it, and how to adapt when circumstances change. Under pressure, team members support each other emotionally and practically, maintaining effectiveness when individuals might falter. This support might mean providing covering fire, taking over tasks when someone is injured, or simply encouraging teammates through difficult moments. Working toward common goals rather than individual recognition creates unity of purpose that is essential for mission accomplishment.\n\nTeam members must trust one another and understand that the success of the mission depends on everyone fulfilling their assigned roles and responsibilities without hesitation or deviation. Trust develops through training together, demonstrating competence and reliability, and knowing that teammates will fulfill their commitments even under extreme stress. When team members trust each other, they can focus on their own tasks without constantly worrying about whether others are doing their part. This trust extends to trusting teammates to watch your back, cover your position during tactical movements, and come to your aid if you are in danger. Understanding that mission success depends on everyone doing their part creates accountability and motivation to perform at the highest level. If one team member fails to fulfill their role, the entire mission may be compromised, endangering everyone. This interdependence creates powerful incentives for individual excellence within the context of team success rather than personal glory.",
            question: "According to the passage, what must team members do for mission success?",
            options: [
              "Work independently without communication",
              "Compete with each other for recognition",
              "Trust each other and fulfill their roles",
              "Focus only on individual achievements"
            ],
            correctAnswer: 2,
            explanation: "The passage states that 'Team members must trust one another and understand that the success of the mission depends on everyone fulfilling their assigned roles and responsibilities.'"
          },
          {
            id: 2,
            passage: "Proper hydration is essential for peak physical and mental performance, especially in demanding military environments where personnel operate under challenging conditions. Water comprises a large percentage of body weight and is critical for virtually every bodily function including temperature regulation, nutrient transport, waste removal, joint lubrication, and cellular processes. Even mild dehydration of just 2% body weight loss through fluid can noticeably impair both physical and cognitive performance. Dehydration can impair judgment, reduce physical endurance, and increase the risk of heat-related injuries that can incapacitate service members as effectively as any enemy action. The effects of dehydration are insidious because they develop gradually, and individuals often do not realize their capabilities are degrading until significant impairment has already occurred.\n\nThe cognitive effects of dehydration are particularly concerning in military contexts where sound decision-making can mean the difference between mission success and catastrophic failure. Studies show that even mild dehydration impairs concentration, short-term memory, alertness, and the ability to process information quickly. Service members may make poor tactical decisions, fail to notice important details, or respond more slowly to threats when dehydrated. Physically, dehydration reduces cardiovascular efficiency, forcing the heart to work harder to pump thickened blood through the body. This decreases endurance, strength, and the ability to sustain physical effort. Muscle cramps become more likely, and coordination may suffer. In hot environments, dehydration severely impairs the body's ability to cool itself through sweating, rapidly increasing the risk of heat exhaustion and potentially fatal heat stroke.\n\nService members should drink water regularly throughout the day, not just when thirsty, because thirst is a late indicator that the body is already experiencing fluid deficit. Waiting until feeling thirsty means performance has likely already been compromised. In hot climates or during strenuous activity, fluid requirements increase significantly and must be met to maintain operational effectiveness and prevent heat casualties. Military guidelines typically recommend drinking water at scheduled intervals—often every 15-30 minutes during physical activity—rather than relying on thirst cues. Monitoring urine color provides a practical hydration status check, with pale yellow indicating good hydration and dark yellow suggesting dehydration. Leaders must enforce hydration discipline, ensuring their personnel have access to potable water and are drinking adequate amounts. In some military contexts, forced water consumption at regular intervals becomes a matter of order rather than personal choice, recognizing that dehydrated soldiers endanger themselves, their teammates, and the mission.",
            question: "According to the passage, when should service members drink water?",
            options: [
              "Only when extremely thirsty",
              "Only during meals",
              "Regularly throughout the day",
              "Only after physical training"
            ],
            correctAnswer: 2,
            explanation: "The passage explicitly states that 'Service members should drink water regularly throughout the day, not just when thirsty.'"
          },
          {
            id: 3,
            passage: "Adaptability is a critical skill in military operations where conditions can change rapidly and unexpectedly, often rendering carefully developed plans obsolete within minutes of execution. The battlefield is a dynamic, chaotic environment where friendly forces, enemy forces, civilians, terrain, and weather all interact in complex ways that cannot be perfectly predicted. Plans that seemed perfect during the planning phase may need to be modified or abandoned based on new intelligence, weather changes, or enemy actions that were not anticipated or could not be known in advance. The enemy always has a say in how operations unfold, and their actions force constant adaptation. Equipment malfunctions, logistical delays, or unexpected opportunities also require forces to deviate from original plans while still accomplishing their objectives.\n\nSuccessful leaders and units can assess changing situations quickly, adjust their approach, and continue working toward objectives despite obstacles that would stop less flexible organizations. This adaptability requires several key capabilities: situational awareness to recognize when circumstances have changed significantly, critical thinking to evaluate new information and determine its implications, creativity to develop alternative approaches, and decisiveness to commit to a new course of action without excessive hesitation. Adaptable units practice responding to unexpected situations during training, developing the mental agility to shift approaches smoothly. Leaders who foster adaptability empower subordinates to exercise initiative, trusting them to make on-the-spot adjustments within the commander's overall intent rather than requiring approval for every minor deviation from the plan. This decentralized decision-making allows units to respond rapidly to local conditions while maintaining overall coordination.\n\nRigid thinking can lead to failure when circumstances demand flexibility because continuing to execute a plan after its underlying assumptions have been invalidated is a recipe for disaster. History is full of military failures caused by commanders who could not adapt to changing realities, instead stubbornly adhering to original plans even as those plans led toward certain defeat. Conversely, many military successes have resulted from forces that rapidly adapted to exploit unexpected opportunities or overcome unforeseen obstacles. The key is maintaining focus on the objective while remaining flexible about the methods used to achieve it. Successful military forces internalize the principle that no plan survives first contact with the enemy intact, and they build adaptability into their organizational culture through training, leadership philosophy, and operational procedures. This combination of detailed planning with mental preparation to deviate from those plans enables forces to maintain effectiveness even when operations unfold very differently than anticipated.",
            question: "Why is adaptability important in military operations?",
            options: [
              "It eliminates the need for planning",
              "Conditions can change rapidly and unexpectedly",
              "It makes training unnecessary",
              "It guarantees mission success"
            ],
            correctAnswer: 1,
            explanation: "The passage states that adaptability is critical 'where conditions can change rapidly and unexpectedly' and plans may need to be modified."
          },
          {
            id: 4,
            passage: "Military logistics involves planning and executing the movement and maintenance of forces in support of military operations. This complex discipline encompasses transportation, supply chain management, maintenance, and distribution of equipment and supplies across distances and in challenging environments. Modern military forces require enormous quantities of fuel, ammunition, food, water, medical supplies, spare parts, and countless other items to sustain operations. Military logistics involves planning and executing the movement and maintenance of forces. This includes transportation, supply chain management, maintenance, and distribution of equipment and supplies. Logisticians must coordinate across multiple modes of transportation including ground vehicles, aircraft, ships, and sometimes aerial delivery, ensuring that critical supplies reach forward units despite enemy action, weather, terrain, and other obstacles.\n\nWithout effective logistics, even the best-trained forces cannot sustain operations for more than brief periods before running out of essential supplies. Soldiers cannot fight without ammunition, vehicles cannot move without fuel, and personnel cannot maintain health without food and water. Complex weapons systems require spare parts and maintenance support that must be delivered to the point of use. Medical evacuation capabilities must be in place to treat wounded personnel. History provides numerous examples of military operations that failed not because of tactical defeats but because logistics could not support the forces involved. Conversely, many successful operations succeeded largely because superior logistics enabled sustained operations while denying the same capability to adversaries. In modern warfare, logistics represents a significant vulnerability because supply lines can be targeted, creating cascading effects on combat forces.\n\nLogisticians must anticipate needs, manage resources efficiently, and ensure supplies reach their destinations on time to maintain operational tempo. Anticipating needs requires understanding how different operations consume supplies and planning accordingly, often maintaining reserve stocks for contingencies. Efficient resource management involves balancing competing demands, prioritizing critical items, and minimizing waste while ensuring adequate supplies are available. Ensuring timely delivery requires complex coordination and constant monitoring of supply movements, with backup plans for when primary routes are blocked or assets are unavailable. Poor logistics can undermine entire operations regardless of tactical skill, turning potential victories into defeats simply because forces cannot maintain their effectiveness. Modern militaries invest heavily in logistics capabilities, recognizing that the ability to project and sustain military power over distance and time is as important as the combat capabilities of the forces themselves. Professional logisticians are essential members of the military team whose work, while less visible than combat operations, is absolutely critical to mission success.",
            question: "What can happen without effective logistics according to the passage?",
            options: [
              "Forces become better trained",
              "Operations become easier to execute",
              "Forces cannot sustain operations",
              "Tactical planning improves"
            ],
            correctAnswer: 2,
            explanation: "The passage clearly states that 'Without effective logistics, even the best-trained forces cannot sustain operations.'"
          },
          {
            id: 5,
            passage: "Preventive maintenance involves regularly scheduled inspections, adjustments, cleaning, and parts replacement to prevent equipment failure before problems occur. This systematic approach follows manufacturer recommendations and military technical manuals that specify exactly what maintenance actions should be performed at specific intervals based on operating hours, calendar time, or usage cycles. Preventive maintenance tasks range from simple actions like checking fluid levels and tire pressure to complex procedures like replacing wear-prone components before they fail. This proactive approach is more cost-effective than reactive maintenance, which only addresses problems after breakdowns occur, often resulting in more extensive damage, longer downtime, and higher repair costs than would have been necessary with timely preventive action.\n\nFor military equipment, preventive maintenance is critical because equipment failures during operations can have serious consequences that extend far beyond inconvenience or expense. A vehicle that breaks down during a convoy may block roads, delay missions, or create security vulnerabilities. A weapons system that malfunctions in combat may leave personnel unable to defend themselves or engage threats. Communication equipment failure can disrupt coordination and leave units unable to call for support. Aircraft maintenance is especially critical because failures can cause crashes that kill crew members and destroy expensive assets. Medical equipment must function reliably in field hospitals where lives depend on it. The military cannot afford to adopt a 'run it until it breaks' mentality because the consequences of equipment failure in military contexts are often unacceptable. Preventive maintenance provides the reliability necessary for mission success.\n\nWell-maintained equipment lasts longer, performs better, and is more reliable when needed most, providing better return on the significant investments made in military hardware. Regular maintenance catches small problems before they escalate into major failures, extending equipment service life considerably. Clean, properly lubricated, and correctly adjusted equipment operates more efficiently and effectively than neglected equipment, even if both are technically functional. When military units need to deploy or respond to emergencies, having equipment in ready condition through preventive maintenance means they can move immediately rather than scrambling to fix problems that should have been addressed earlier. The discipline of preventive maintenance also creates a culture of accountability and attention to detail that extends beyond equipment care to other aspects of military professionalism. Units with strong maintenance programs consistently demonstrate better overall readiness and effectiveness than those that neglect this fundamental responsibility.",
            question: "What is the advantage of preventive maintenance over reactive maintenance?",
            options: [
              "It is more expensive in the long run",
              "It only fixes problems after they occur",
              "It is more cost-effective and prevents failures",
              "It eliminates the need for inspections"
            ],
            correctAnswer: 2,
            explanation: "The passage states that preventive maintenance 'is more cost-effective than reactive maintenance' and helps prevent equipment failures before they occur."
          }
        ]
      },
      {
        id: 5,
        name: "Mathematics Knowledge (MK)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "If 6x + 7 = 43, what is the value of x?",
            options: ["5", "6", "7", "8"],
            correctAnswer: 1,
            explanation: "Subtract 7 from both sides: 6x = 36. Divide by 6: x = 6."
          },
          {
            id: 2,
            question: "What is the volume of a rectangular box with length 10, width 6, and height 4?",
            options: ["120", "180", "240", "360"],
            correctAnswer: 2,
            explanation: "Volume of rectangular box = length × width × height = 10 × 6 × 4 = 240 cubic units."
          },
          {
            id: 3,
            question: "What is the square root of 225?",
            options: ["12", "13", "14", "15"],
            correctAnswer: 3,
            explanation: "√225 = 15 because 15 × 15 = 225."
          },
          {
            id: 4,
            question: "If a right triangle has legs of length 5 and 12, what is the length of the hypotenuse?",
            options: ["11", "13", "15", "17"],
            correctAnswer: 1,
            explanation: "Use Pythagorean theorem: a² + b² = c². So 5² + 12² = 25 + 144 = 169. Therefore c = √169 = 13."
          },
          {
            id: 5,
            question: "What is 25% of 480?",
            options: ["100", "110", "120", "130"],
            correctAnswer: 2,
            explanation: "Convert 25% to decimal (0.25) and multiply: 0.25 × 480 = 120."
          }
        ]
      },
      {
        id: 6,
        name: "Electronics Information (EI)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "What is the purpose of a resistor in an electrical circuit?",
            options: [
              "Store electrical charge",
              "Limit or control current flow",
              "Convert AC to DC",
              "Amplify signals"
            ],
            correctAnswer: 1,
            explanation: "A resistor limits or controls the flow of electrical current in a circuit by providing resistance, measured in ohms."
          },
          {
            id: 2,
            question: "In a series circuit with a 24-volt battery and four 6-ohm resistors, what is the total current flow?",
            options: ["1 ampere", "2 amperes", "4 amperes", "6 amperes"],
            correctAnswer: 0,
            explanation: "Total resistance in series: 6 + 6 + 6 + 6 = 24 ohms. Using Ohm's Law: I = V ÷ R = 24V ÷ 24Ω = 1 ampere."
          },
          {
            id: 3,
            question: "What is the primary function of an inductor in a circuit?",
            options: [
              "Store energy in a magnetic field",
              "Block DC current completely",
              "Convert voltage to current",
              "Measure resistance"
            ],
            correctAnswer: 0,
            explanation: "An inductor stores energy in a magnetic field when current flows through it. It resists changes in current flow and is measured in henries."
          },
          {
            id: 4,
            question: "What happens to voltage in a series circuit when more resistors are added?",
            options: [
              "Total voltage increases",
              "Voltage drop across each resistor changes",
              "Voltage remains constant across all components",
              "Voltage becomes zero"
            ],
            correctAnswer: 1,
            explanation: "In a series circuit, the total voltage is divided among all resistors. Adding more resistors changes how the total voltage is distributed (voltage drop) across each component."
          },
          {
            id: 5,
            question: "What component allows current to flow in only one direction?",
            options: ["Resistor", "Capacitor", "Diode", "Transformer"],
            correctAnswer: 2,
            explanation: "A diode is a semiconductor device that allows current to flow in only one direction, blocking reverse current flow. This property is used in rectification and circuit protection."
          }
        ]
      },
      {
        id: 7,
        name: "Auto & Shop Information (AS)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "What is the primary purpose of a vehicle's differential?",
            options: [
              "Cool the transmission",
              "Allow wheels to rotate at different speeds during turns",
              "Generate electrical power",
              "Filter engine oil"
            ],
            correctAnswer: 1,
            explanation: "The differential allows the drive wheels to rotate at different speeds when turning, which is necessary because the outer wheel travels a longer distance than the inner wheel."
          },
          {
            id: 2,
            question: "Which tool is specifically designed to measure angles?",
            options: ["Micrometer", "Protractor", "Caliper", "Square"],
            correctAnswer: 1,
            explanation: "A protractor is a tool specifically designed to measure angles in degrees. It typically has a semicircular or circular shape with degree markings."
          },
          {
            id: 3,
            question: "What is the primary function of spark plugs in a gasoline engine?",
            options: [
              "Cool the engine",
              "Ignite the air-fuel mixture",
              "Filter exhaust gases",
              "Lubricate pistons"
            ],
            correctAnswer: 1,
            explanation: "Spark plugs create an electrical spark that ignites the compressed air-fuel mixture in the combustion chamber, initiating the power stroke in gasoline engines."
          },
          {
            id: 4,
            question: "What type of saw blade has fine teeth and is used for cutting metal?",
            options: ["Circular saw blade", "Hacksaw blade", "Chain saw blade", "Jigsaw blade"],
            correctAnswer: 1,
            explanation: "A hacksaw blade has fine teeth designed specifically for cutting metal and other hard materials. The teeth are hardened and closely spaced."
          },
          {
            id: 5,
            question: "What automotive system converts hydraulic pressure from the master cylinder into stopping force?",
            options: [
              "Fuel injection system",
              "Cooling system",
              "Brake system",
              "Exhaust system"
            ],
            correctAnswer: 2,
            explanation: "The brake system converts hydraulic pressure from the master cylinder into mechanical force at the wheels through brake calipers or wheel cylinders, creating friction to stop the vehicle."
          }
        ]
      },
      {
        id: 8,
        name: "Mechanical Comprehension (MC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "If a lever is 10 feet long with the fulcrum positioned 2 feet from the load, what is the mechanical advantage?",
            options: ["2", "3", "4", "5"],
            correctAnswer: 2,
            explanation: "Mechanical advantage = effort arm ÷ resistance arm. Effort arm = 10 - 2 = 8 feet. MA = 8 ÷ 2 = 4."
          },
          {
            id: 2,
            question: "If Gear A has 40 teeth and rotates at 80 RPM, meshing with Gear B which has 20 teeth, at what speed does Gear B rotate?",
            options: ["40 RPM", "80 RPM", "120 RPM", "160 RPM"],
            correctAnswer: 3,
            explanation: "Gear ratio = 40:20 = 2:1. Gear B (smaller) rotates twice as fast: 80 × 2 = 160 RPM."
          },
          {
            id: 3,
            question: "What happens to water pressure at 30 feet underwater compared to the surface?",
            options: [
              "Pressure is lower",
              "Pressure is higher",
              "Pressure is the same",
              "Pressure is zero"
            ],
            correctAnswer: 1,
            explanation: "Water pressure increases with depth. At 30 feet underwater, pressure is significantly higher than at the surface due to the weight of water above."
          },
          {
            id: 4,
            question: "A pulley system with 6 supporting ropes can lift a 600-pound load. Approximately how much force is needed?",
            options: ["50 pounds", "75 pounds", "100 pounds", "150 pounds"],
            correctAnswer: 2,
            explanation: "In a pulley system, mechanical advantage equals the number of supporting ropes. With 6 ropes: 600 ÷ 6 = 100 pounds of force needed."
          },
          {
            id: 5,
            question: "If a wheel with an 18-inch diameter makes 8 complete rotations, approximately how far has it traveled? (Use π ≈ 3.14)",
            options: ["144 inches", "226 inches", "339 inches", "452 inches"],
            correctAnswer: 3,
            explanation: "Circumference = π × diameter = 3.14 × 18 = 56.52 inches. Distance = 56.52 × 8 rotations = 452.16 inches, approximately 452 inches."
          }
        ]
      },
      {
        id: 9,
        name: "Assembling Objects (AO)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "Eight puzzle pieces form the outer edge of a square, with one piece in the center. Which piece connects to the most other pieces?",
            options: [
              "A corner piece",
              "An edge piece",
              "The center piece",
              "All pieces connect equally"
            ],
            correctAnswer: 2,
            explanation: "The center piece has the potential to connect to all surrounding pieces, making it the piece with the most connections in this configuration."
          },
          {
            id: 2,
            question: "If object A connects to B, B connects to C, and C connects to D in a line, which object is not adjacent to B?",
            options: ["Object A", "Object C", "Object D", "All are adjacent"],
            correctAnswer: 2,
            explanation: "In a linear arrangement A-B-C-D, object B is adjacent only to A and C. Object D is adjacent to C but not to B."
          },
          {
            id: 3,
            question: "Three identical equilateral triangles can be arranged to form what shape?",
            options: [
              "A larger equilateral triangle",
              "A trapezoid",
              "A rectangle",
              "A pentagon"
            ],
            correctAnswer: 1,
            explanation: "Three equilateral triangles can be arranged (one pointing up, two pointing down) to form a trapezoid shape."
          },
          {
            id: 4,
            question: "If five identical rectangular pieces are arranged around a central point like spokes on a wheel, what angle is between adjacent pieces?",
            options: ["60 degrees", "72 degrees", "90 degrees", "108 degrees"],
            correctAnswer: 1,
            explanation: "360 degrees ÷ 5 pieces = 72 degrees between each adjacent piece around the central point."
          },
          {
            id: 5,
            question: "Two identical semicircles are connected at their flat edges at a right angle. What three-dimensional shape does this most resemble?",
            options: [
              "A sphere",
              "A cone",
              "Part of a cylindrical joint",
              "A cube"
            ],
            correctAnswer: 2,
            explanation: "Two semicircles connected at right angles form an L-shaped structure that resembles part of a cylindrical joint or elbow connection."
          }
        ]
      },
      {
        id: 10,
        name: "Verbal Expression (VE)",
        timeLimit: 4,
        questions: [
          {
            id: 1,
            question: "Choose the sentence with correct grammar:",
            options: [
              "Neither the officers nor the sergeant are present",
              "Neither the officers nor the sergeant is present",
              "Neither the officers nor the sergeant were present",
              "Neither the officers nor the sergeant be present"
            ],
            correctAnswer: 1,
            explanation: "With 'neither...nor,' the verb agrees with the subject closest to it. Since 'sergeant' (singular) is closest, use 'is': 'Neither the officers nor the sergeant is present.'"
          },
          {
            id: 2,
            question: "Which word is spelled correctly?",
            options: ["Seperate", "Separete", "Separate", "Seprate"],
            correctAnswer: 2,
            explanation: "The correct spelling is 'separate' with 'par' in the middle. A common memory trick is 'there's a rat in separate.'"
          },
          {
            id: 3,
            question: "Choose the sentence with correct punctuation:",
            options: [
              "The squad leaders briefing will cover three topics equipment maintenance personnel assignments and mission objectives",
              "The squad leaders briefing will cover three topics: equipment maintenance, personnel assignments, and mission objectives.",
              "The squad leaders briefing will cover three topics, equipment maintenance, personnel assignments, and mission objectives",
              "The squad leaders briefing will cover three topics; equipment maintenance personnel assignments and mission objectives"
            ],
            correctAnswer: 1,
            explanation: "Use a colon to introduce a list and commas between items. Also need an apostrophe for possession: 'The squad leader's briefing will cover three topics: equipment maintenance, personnel assignments, and mission objectives.'"
          },
          {
            id: 4,
            question: "Identify the sentence with correct verb tense consistency:",
            options: [
              "The patrol left at dawn and will return by noon",
              "The patrol leaves at dawn and returned by noon",
              "The patrol left at dawn and returns by noon",
              "The patrol left at dawn and returned by noon"
            ],
            correctAnswer: 3,
            explanation: "Both actions occurred in the past, so both verbs should be past tense: 'The patrol left at dawn and returned by noon' maintains consistent past tense."
          },
          {
            id: 5,
            question: "Which sentence correctly uses 'then' or 'than'?",
            options: [
              "The mission took longer then expected",
              "This route is shorter then the alternative",
              "Complete the inspection, than submit the report",
              "The new equipment is more reliable than the old equipment"
            ],
            correctAnswer: 3,
            explanation: "'Than' is used for comparisons. 'Then' refers to time or sequence. 'The new equipment is more reliable than the old equipment' correctly uses 'than' for comparison."
          }
        ]
      }
    ]
  },,
  {
    id: 6,
    title: "ASVAB Practice Test #6",
    description: "Comprehensive practice exam covering all 10 ASVAB sections with military-standard questions",
    totalQuestions: 50,
    timeLimit: 60,
    sections: [
      {
        id: 1,
        name: "General Science (GS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Which part of a plant cell is responsible for photosynthesis?",
            options: ["Nucleus", "Mitochondria", "Chloroplast", "Cell membrane"],
            correctAnswer: 2,
            explanation: "Chloroplasts contain chlorophyll and are the organelles where photosynthesis occurs, converting light energy into chemical energy (glucose) for the plant."
          },
          {
            id: 2,
            question: "What is the pH level of a neutral solution?",
            options: ["0", "7", "14", "10"],
            correctAnswer: 1,
            explanation: "The pH scale ranges from 0-14, with 7 being neutral. Values below 7 are acidic, and values above 7 are basic (alkaline). Pure water has a pH of 7."
          },
          {
            id: 3,
            question: "Which planet in our solar system has the most moons?",
            options: ["Jupiter", "Saturn", "Uranus", "Neptune"],
            correctAnswer: 1,
            explanation: "Saturn has the most confirmed moons with over 140 known satellites, surpassing Jupiter's 95 moons. Many are small irregular moons discovered in recent years."
          },
          {
            id: 4,
            question: "What type of energy is stored in a compressed spring?",
            options: ["Kinetic energy", "Thermal energy", "Potential energy", "Nuclear energy"],
            correctAnswer: 2,
            explanation: "A compressed or stretched spring stores elastic potential energy. When released, this potential energy converts to kinetic energy as the spring returns to its natural length."
          },
          {
            id: 5,
            question: "Which blood type is considered the universal donor?",
            options: ["Type A", "Type B", "Type AB", "Type O"],
            correctAnswer: 3,
            explanation: "Type O negative blood is the universal donor because it lacks A, B, and Rh antigens, making it compatible with all blood types in emergency transfusions."
          }
        ]
      },
      {
        id: 2,
        name: "Arithmetic Reasoning (AR)",
        timeLimit: 8,
        questions: [
          {
            id: 1,
            question: "A military base cafeteria serves 450 meals per day. If 28% are breakfast meals, how many breakfast meals are served daily?",
            options: ["102 meals", "116 meals", "126 meals", "138 meals"],
            correctAnswer: 2,
            explanation: "Number of breakfast meals = 28% of 450 = 0.28 × 450 = 126 meals."
          },
          {
            id: 2,
            question: "A soldier runs 3 miles in 24 minutes. At this pace, how long would it take to run 8 miles?",
            options: ["56 minutes", "60 minutes", "64 minutes", "68 minutes"],
            correctAnswer: 2,
            explanation: "Pace = 24 minutes ÷ 3 miles = 8 minutes per mile. Time for 8 miles = 8 × 8 = 64 minutes."
          },
          {
            id: 3,
            question: "A supply order costs $3,600. If a 15% discount is applied, followed by 8% tax on the discounted price, what is the final cost?",
            options: ["$3,304.80", "$3,326.40", "$3,348.00", "$3,369.60"],
            correctAnswer: 0,
            explanation: "After discount: $3,600 × 0.85 = $3,060. With tax: $3,060 × 1.08 = $3,304.80."
          },
          {
            id: 4,
            question: "A training exercise requires 5 instructors for every 35 recruits. If there are 245 recruits, how many instructors are needed?",
            options: ["30 instructors", "35 instructors", "40 instructors", "45 instructors"],
            correctAnswer: 1,
            explanation: "Ratio: 5 instructors per 35 recruits = 1 instructor per 7 recruits. For 245 recruits: 245 ÷ 7 = 35 instructors."
          },
          {
            id: 5,
            question: "A helicopter flies 280 kilometers in 2 hours, then 315 kilometers in 1.5 hours. What is the average speed for the entire trip?",
            options: ["165 km/h", "170 km/h", "175 km/h", "180 km/h"],
            correctAnswer: 1,
            explanation: "Total distance: 280 + 315 = 595 km. Total time: 2 + 1.5 = 3.5 hours. Average speed: 595 ÷ 3.5 = 170 km/h."
          }
        ]
      },
      {
        id: 3,
        name: "Word Knowledge (WK)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "Adversary most nearly means:",
            options: ["Friend", "Opponent", "Supporter", "Colleague"],
            correctAnswer: 1,
            explanation: "An adversary is an opponent or enemy; someone who actively opposes or is hostile to another person or cause."
          },
          {
            id: 2,
            question: "Meticulous most nearly means:",
            options: ["Careless", "Hasty", "Thorough", "Reckless"],
            correctAnswer: 2,
            explanation: "Meticulous means showing great attention to detail; extremely careful, precise, and thorough in one's work or actions."
          },
          {
            id: 3,
            question: "Impediment most nearly means:",
            options: ["Advantage", "Obstacle", "Solution", "Benefit"],
            correctAnswer: 1,
            explanation: "An impediment is a hindrance or obstruction; something that delays or prevents progress or makes achievement more difficult."
          },
          {
            id: 4,
            question: "Collaborate most nearly means:",
            options: ["Compete", "Work together", "Oppose", "Ignore"],
            correctAnswer: 1,
            explanation: "Collaborate means to work jointly with others on an activity or project; to cooperate and coordinate efforts toward a common goal."
          },
          {
            id: 5,
            question: "Surveillance most nearly means:",
            options: ["Neglect", "Observation", "Abandonment", "Confusion"],
            correctAnswer: 1,
            explanation: "Surveillance means close observation or monitoring, especially of a person or group, often conducted for security or intelligence purposes."
          }
        ]
      },
      {
        id: 4,
        name: "Paragraph Comprehension (PC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            passage: "Military logistics involves the planning and execution of the movement and support of forces across all domains of military operations. This comprehensive discipline requires coordinating countless moving parts including personnel, equipment, supplies, fuel, ammunition, and maintenance assets across vast distances and through challenging conditions. It encompasses everything from transporting personnel and equipment to maintaining supply chains and providing medical support to forward units operating far from established bases. Effective logistics ensures that military units have the right resources in the right place at the right time, enabling combat forces to maintain operational tempo without being constrained by supply shortages or equipment failures that would force them to pause operations.\n\nThe complexity of modern military logistics cannot be overstated, as operations may involve multiple transportation modes including aircraft, ships, trucks, trains, and even pack animals in mountainous terrain. Logisticians must account for consumption rates that vary based on operational intensity, environmental conditions, and the specific equipment being used. They must maintain visibility over supply inventories at multiple echelons from strategic depots to tactical units, forecasting needs days or weeks in advance while remaining flexible enough to respond to urgent demands. Distribution networks must be resilient to disruption, with alternate routes and contingency plans ready when primary supply lines are blocked by enemy action, weather, or infrastructure damage. Medical logistics adds another layer of complexity, requiring evacuation capabilities, field hospitals, and pharmaceutical supply chains that meet strict standards.\n\nWithout proper logistics coordination, even the most well-trained forces cannot sustain operations successfully beyond their immediate supplies, which are typically exhausted within days of intensive operations. Ammunition, fuel, food, and water are consumed continuously, requiring constant replenishment that only effective logistics can provide. Historical examples abound of military operations that failed due to logistics breakdown rather than tactical defeat—armies that outran their supply lines and ground to a halt, forces that could not evacuate their wounded, or units that became immobilized when fuel ran out. Modern militaries recognize logistics as a combat multiplier that directly enables operational success, investing heavily in logistics capabilities, training professional logisticians, and protecting supply lines as critical vulnerabilities. The ability to project and sustain military power over distance and time depends fundamentally on logistics excellence that keeps forces supplied, equipped, and ready to fight regardless of how far from home or how long operations continue.",
            question: "According to the passage, what is essential for sustaining military operations?",
            options: [
              "Advanced weaponry",
              "Proper logistics coordination",
              "Large numbers of personnel",
              "Superior training alone"
            ],
            correctAnswer: 1,
            explanation: "The passage concludes that 'Without proper logistics coordination, even the most well-trained forces cannot sustain operations successfully,' emphasizing logistics as essential."
          },
          {
            id: 2,
            passage: "Radar technology uses radio waves to detect the presence, direction, distance, and speed of objects without requiring physical contact or visible light conditions. The name 'radar' comes from 'Radio Detection and Ranging,' describing its core function of using radio frequency electromagnetic radiation to sense the environment. A radar system transmits electromagnetic waves that bounce off objects and return to a receiver, creating echoes that reveal information about targets. Unlike optical systems that require light, radar can operate in darkness, through clouds, fog, and precipitation, making it invaluable for all-weather operations. The development of radar during World War II revolutionized warfare by enabling detection of aircraft and ships that would otherwise be invisible in darkness or poor weather.\n\nBy analyzing the time delay and frequency shift of the returned signal, the system calculates the object's location and velocity with remarkable precision. The time delay between transmission and reception reveals distance, since electromagnetic waves travel at the speed of light. The direction from which echoes return indicates the bearing to the target. The Doppler effect—the frequency shift that occurs when objects are moving relative to the radar—enables measurement of target velocity. Modern radar systems can track multiple targets simultaneously, distinguish between different types of objects, and even create detailed images of targets using sophisticated signal processing. Phased array radars can electronically steer their beams without mechanical movement, scanning the sky in milliseconds. Synthetic aperture radar can create high-resolution images of ground terrain from aircraft or satellites.\n\nRadar has become crucial for air traffic control, weather forecasting, and military defense systems that depend on its unique capabilities. Air traffic controllers use radar to maintain safe separation between aircraft, especially in poor visibility conditions where visual observation is impossible. Weather radar detects precipitation and can identify severe weather phenomena like tornadoes, helping forecasters issue timely warnings. Military defense systems employ radar for early warning of incoming aircraft or missiles, fire control for engaging targets, and surveillance of air and sea spaces. Naval vessels use radar for navigation and collision avoidance. Ground-based air defense radars provide coverage of national airspace. Airborne early warning aircraft use powerful radars to detect threats at long range. As electronic warfare has advanced, radar technology continues evolving with stealth techniques to reduce radar signatures and counter-stealth techniques to detect stealthy objects, representing an ongoing technological competition.",
            question: "How does radar determine an object's location?",
            options: [
              "By measuring temperature changes",
              "By analyzing sound waves",
              "By analyzing time delay of returned radio waves",
              "By detecting visual light patterns"
            ],
            correctAnswer: 2,
            explanation: "The passage states that radar systems calculate location 'by analyzing the time delay and frequency shift of the returned signal' from radio waves."
          },
          {
            id: 3,
            passage: "Physical fitness is a cornerstone of military readiness that directly impacts every aspect of military effectiveness from individual performance to unit capability. The demands of military service are inherently physical, requiring personnel to perform strenuous tasks while carrying heavy loads, operating in extreme environments, and maintaining effectiveness despite fatigue and stress. Service members must maintain cardiovascular endurance, muscular strength, and flexibility to perform demanding tasks under challenging conditions ranging from combat operations to humanitarian assistance. Cardiovascular fitness enables sustained physical exertion without exhaustion. Muscular strength allows lifting, carrying, and manipulating equipment. Flexibility reduces injury risk and enables full range of motion during complex physical tasks. Together, these components create the physical capacity necessary for mission accomplishment.\n\nRegular physical training not only improves performance but also reduces injury risk, enhances mental resilience, and builds unit cohesion through shared challenge and accomplishment. Systematic PT programs condition the body to handle military demands, strengthening muscles, bones, tendons, and ligaments that might otherwise fail under stress. Studies consistently show that personnel who maintain high fitness levels experience fewer injuries during training and operations, remaining available for duty rather than sidelined by preventable problems. Physical training also provides significant mental health benefits, reducing stress, improving mood, and building confidence. The discipline required to maintain fitness transfers to other areas of military performance. When units train together physically, they develop camaraderie and team spirit that strengthen bonds between service members and enhance unit effectiveness.\n\nFitness standards ensure that all personnel can meet the physical demands of their duties regardless of assignment, maintaining a baseline capability across the force. These standards are periodically tested to verify that service members maintain required fitness levels throughout their careers. Different military specialties may have different physical requirements, with more demanding standards for infantry, special operations, and other physically intensive roles. Age and gender differences are recognized in fitness testing while still ensuring everyone meets the minimum capability needed for military service. Commanders emphasize fitness through dedicated PT time, fitness assessments, and by modeling high fitness standards themselves. The commitment to physical fitness reflects recognition that military effectiveness depends on personnel who are physically capable of executing their mission under conditions that would overwhelm those who are unprepared or out of shape.",
            question: "What does the passage suggest about physical training beyond improving performance?",
            options: [
              "It only benefits cardiovascular health",
              "It has no impact on mental state",
              "It reduces injury risk and builds mental resilience",
              "It is only required for combat personnel"
            ],
            correctAnswer: 2,
            explanation: "The passage explicitly states that regular physical training 'reduces injury risk, enhances mental resilience, and builds unit cohesion.'"
          },
          {
            id: 4,
            passage: "Cryptography is the practice of securing information by transforming it into an unreadable format that only authorized parties can decode using secret keys or passwords. This ancient art has been essential to military operations for thousands of years, from Caesar's simple substitution cipher to today's sophisticated encryption that protects digital communications. Throughout history, military forces have relied on cryptography to protect sensitive communications from enemy interception, knowing that compromised messages could reveal plans, troop movements, and vulnerabilities that would enable adversaries to defeat them. The ability to communicate securely while denying enemies that same capability has often determined the outcomes of battles and wars.\n\nThe ongoing competition between code-makers and code-breakers has driven continuous evolution in cryptographic techniques. Historical examples like the Enigma machine used by German forces in World War II show both the power of encryption and the catastrophic consequences when encryption is broken. The Allied effort to break Enigma shortened the war and saved countless lives by exposing German plans and movements. Modern encryption methods use complex mathematical algorithms that are nearly impossible to break without the proper decryption key, relying on computational difficulty rather than secrecy of the method. Strong encryption algorithms like AES (Advanced Encryption Standard) would require thousands of years to crack by brute force even with powerful supercomputers. Public key cryptography enables secure communication between parties who have never met by using pairs of mathematically related keys—one public for encryption, one private for decryption.\n\nThese advances make secure communication possible even in hostile environments where adversaries control the transmission medium and can intercept every message. Military forces routinely communicate over radio frequencies that anyone can receive, but encryption ensures that intercepted messages appear as meaningless noise without the decryption keys. Secure voice communications, encrypted email and messaging, and protected data networks all depend on modern cryptography to prevent espionage. As military forces become increasingly networked and dependent on digital systems, cryptography becomes even more critical for protecting not just communications but also weapons systems, logistics databases, and command and control networks from cyber attacks. The ongoing evolution of quantum computing threatens current encryption methods while simultaneously promising new forms of quantum cryptography, ensuring that cryptography will remain a crucial technological competition for military superiority in the digital age.",
            question: "What is the primary purpose of cryptography mentioned in the passage?",
            options: [
              "To create complex mathematical problems",
              "To protect sensitive information from unauthorized access",
              "To improve communication speed",
              "To replace traditional communication methods"
            ],
            correctAnswer: 1,
            explanation: "The passage defines cryptography as securing information 'by transforming it into an unreadable format that only authorized parties can decode,' emphasizing protection from unauthorized access."
          },
          {
            id: 5,
            passage: "Night vision technology enables personnel to see in low-light conditions by amplifying available light or detecting infrared radiation invisible to the naked eye. Historically, military forces were severely constrained by darkness, with nighttime operations extremely risky because personnel could not see obstacles, threats, or targets effectively. Traditional solutions like illumination flares revealed friendly positions to enemies as much as they revealed the battlefield. Image intensifier devices revolutionized nighttime operations by collecting tiny amounts of ambient light from stars, moonlight, or infrared illuminators and electronically amplifying them thousands of times to create visible green-tinted images. These systems enable personnel to navigate, identify targets, and conduct operations in conditions that would leave adversaries without similar technology effectively blind.\n\nDifferent night vision technologies serve complementary roles based on environmental conditions and mission requirements. Image intensification requires some ambient light and can be overwhelmed by bright light sources but provides detailed images showing fine detail and depth perception. Thermal imaging systems detect heat signatures emitted by objects, creating images based on temperature differences rather than reflected light. Thermal imagers work in complete darkness, through light fog and smoke, and can detect people and vehicles by their heat signatures even when hidden behind vegetation or other cover. However, thermal imaging provides less detail than image intensification and cannot read text or see through glass. Modern systems often combine both technologies, allowing operators to select the appropriate mode for current conditions. Fused night vision combines image intensification with thermal imaging in a single display, providing the advantages of both simultaneously.\n\nThese technologies provide critical tactical advantages, allowing operations to continue effectively after dark when visibility would otherwise be severely limited, fundamentally changing the nature of military operations. Forces equipped with night vision can move, navigate, acquire targets, and engage enemies during darkness that renders opponents without similar capabilities nearly helpless. Many military operations are specifically planned for nighttime execution to exploit this technological advantage. Night vision enables extended operations around the clock without waiting for daylight, dramatically increasing operational tempo. Helicopter pilots use night vision goggles to fly low-level missions in darkness. Infantry units conduct raids and patrols at night when detection is less likely. The psychological impact of facing enemies who can see you when you cannot see them is substantial. As night vision technology has proliferated globally, the advantage is no longer absolute, driving continued development of more capable systems and tactics that preserve effectiveness even when adversaries have night vision capabilities.",
            question: "According to the passage, what advantage does night vision technology provide?",
            options: [
              "It eliminates the need for training",
              "It allows effective operations in darkness",
              "It replaces all other surveillance methods",
              "It only works in complete darkness"
            ],
            correctAnswer: 1,
            explanation: "The passage concludes that night vision technologies 'provide critical tactical advantages, allowing operations to continue effectively after dark when visibility would otherwise be severely limited.'"
          }
        ]
      },
      {
        id: 5,
        name: "Mathematics Knowledge (MK)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "If 3x + 7 = 28, what is the value of x?",
            options: ["5", "6", "7", "8"],
            correctAnswer: 2,
            explanation: "Subtract 7 from both sides: 3x = 21. Divide both sides by 3: x = 7."
          },
          {
            id: 2,
            question: "What is the area of a triangle with a base of 12 inches and a height of 8 inches?",
            options: ["48 square inches", "52 square inches", "56 square inches", "60 square inches"],
            correctAnswer: 0,
            explanation: "Area of a triangle = (1/2) × base × height = (1/2) × 12 × 8 = 48 square inches."
          },
          {
            id: 3,
            question: "What is the value of √144?",
            options: ["10", "11", "12", "13"],
            correctAnswer: 2,
            explanation: "The square root of 144 is 12, because 12 × 12 = 144."
          },
          {
            id: 4,
            question: "If a circle has a diameter of 14 cm, what is its circumference? (Use π ≈ 3.14)",
            options: ["38.94 cm", "43.96 cm", "47.12 cm", "50.24 cm"],
            correctAnswer: 1,
            explanation: "Circumference = π × diameter = 3.14 × 14 = 43.96 cm."
          },
          {
            id: 5,
            question: "What is 15% of 240?",
            options: ["32", "34", "36", "38"],
            correctAnswer: 2,
            explanation: "15% of 240 = 0.15 × 240 = 36."
          }
        ]
      },
      {
        id: 6,
        name: "Electronics Information (EI)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "What is the unit of measurement for electrical resistance?",
            options: ["Ampere", "Volt", "Ohm", "Watt"],
            correctAnswer: 2,
            explanation: "The ohm (symbol: Ω) is the unit of electrical resistance. Amperes measure current, volts measure voltage, and watts measure power."
          },
          {
            id: 2,
            question: "In a series circuit with three resistors of 10, 20, and 30 ohms, what is the total resistance?",
            options: ["20 ohms", "40 ohms", "60 ohms", "80 ohms"],
            correctAnswer: 2,
            explanation: "In a series circuit, total resistance equals the sum of all resistances: 10 + 20 + 30 = 60 ohms."
          },
          {
            id: 3,
            question: "Which component stores electrical energy in an electric field?",
            options: ["Resistor", "Capacitor", "Inductor", "Transformer"],
            correctAnswer: 1,
            explanation: "A capacitor stores electrical energy in an electric field between two conductive plates. Inductors store energy in magnetic fields."
          },
          {
            id: 4,
            question: "What does AC stand for in electrical terminology?",
            options: ["Automatic Current", "Alternating Current", "Active Circuit", "Amplified Current"],
            correctAnswer: 1,
            explanation: "AC stands for Alternating Current, which periodically reverses direction, unlike DC (Direct Current) which flows in one direction."
          },
          {
            id: 5,
            question: "If a circuit has a voltage of 120 volts and draws 5 amperes of current, what is the power consumption?",
            options: ["500 watts", "600 watts", "700 watts", "800 watts"],
            correctAnswer: 1,
            explanation: "Power (watts) = Voltage × Current = 120 volts × 5 amperes = 600 watts."
          }
        ]
      },
      {
        id: 7,
        name: "Auto & Shop Information (AS)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "What is the primary function of a vehicle's alternator?",
            options: ["Start the engine", "Charge the battery and power electrical systems", "Control transmission shifting", "Regulate fuel injection"],
            correctAnswer: 1,
            explanation: "The alternator generates electricity while the engine runs, charging the battery and powering the vehicle's electrical systems. The starter motor starts the engine."
          },
          {
            id: 2,
            question: "Which tool is specifically designed to remove and install snap rings?",
            options: ["Needle-nose pliers", "Snap ring pliers", "Locking pliers", "Diagonal cutters"],
            correctAnswer: 1,
            explanation: "Snap ring pliers (also called circlip pliers) have special tips designed to fit into the holes of snap rings for safe removal and installation."
          },
          {
            id: 3,
            question: "What does a higher octane rating in gasoline indicate?",
            options: ["More energy content", "Better fuel economy", "Greater resistance to engine knock", "Faster combustion speed"],
            correctAnswer: 2,
            explanation: "Octane rating measures a fuel's resistance to pre-ignition or knocking. Higher octane fuel resists knocking better in high-compression engines."
          },
          {
            id: 4,
            question: "Which type of saw is best suited for cutting curves in wood?",
            options: ["Crosscut saw", "Rip saw", "Coping saw", "Hacksaw"],
            correctAnswer: 2,
            explanation: "A coping saw has a thin, flexible blade mounted in a C-shaped frame, making it ideal for cutting curves and intricate shapes in wood."
          },
          {
            id: 5,
            question: "What automotive component connects the engine to the transmission in a manual transmission vehicle?",
            options: ["Drive shaft", "Clutch", "Universal joint", "Differential"],
            correctAnswer: 1,
            explanation: "The clutch engages and disengages the engine from the transmission, allowing the driver to change gears and control power delivery to the wheels."
          }
        ]
      },
      {
        id: 8,
        name: "Mechanical Comprehension (MC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "A first-class lever has the fulcrum positioned where?",
            options: ["At one end", "Between the effort and load", "At the load end", "Away from both effort and load"],
            correctAnswer: 1,
            explanation: "In a first-class lever, the fulcrum is positioned between the effort (input force) and the load (output force). Examples include seesaws and crowbars."
          },
          {
            id: 2,
            question: "If a gear with 20 teeth drives a gear with 40 teeth, what is the speed ratio?",
            options: ["The driven gear rotates twice as fast", "Both gears rotate at the same speed", "The driven gear rotates half as fast", "The driven gear rotates three times as fast"],
            correctAnswer: 2,
            explanation: "The driven gear (40 teeth) rotates at half the speed of the driving gear (20 teeth). The ratio is 20:40 or 1:2, meaning half the speed but twice the torque."
          },
          {
            id: 3,
            question: "Which simple machine is a ramp or sloped surface?",
            options: ["Lever", "Pulley", "Inclined plane", "Wheel and axle"],
            correctAnswer: 2,
            explanation: "An inclined plane is a flat surface tilted at an angle, used to raise or lower objects with less force over a longer distance. Examples include ramps and wedges."
          },
          {
            id: 4,
            question: "If a hydraulic system has a small piston with 2 square inches of area and a large piston with 20 square inches, what is the mechanical advantage?",
            options: ["5:1", "10:1", "15:1", "20:1"],
            correctAnswer: 1,
            explanation: "Mechanical advantage in hydraulics equals the ratio of output piston area to input piston area: 20 ÷ 2 = 10:1. Force is multiplied by 10."
          },
          {
            id: 5,
            question: "What happens to the pressure in a fluid as it flows through a narrower section of pipe?",
            options: ["Pressure increases, velocity decreases", "Pressure decreases, velocity increases", "Both pressure and velocity increase", "Both pressure and velocity decrease"],
            correctAnswer: 1,
            explanation: "According to Bernoulli's principle, as a fluid flows through a constriction, its velocity increases and pressure decreases. This explains how airplane wings generate lift."
          }
        ]
      },
      {
        id: 9,
        name: "Assembling Objects (AO)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "Which shape can be formed by folding a net consisting of six connected squares?",
            options: ["Pyramid", "Cube", "Cylinder", "Cone"],
            correctAnswer: 1,
            explanation: "A net of six connected squares folds into a cube, which has six square faces. This is a fundamental concept in spatial visualization."
          },
          {
            id: 2,
            question: "If you rotate a square 90 degrees clockwise, which edge that was on top is now on the right?",
            options: ["The left edge", "The bottom edge", "The top edge", "The right edge"],
            correctAnswer: 2,
            explanation: "After a 90-degree clockwise rotation, the top edge moves to the right side, the right edge to the bottom, the bottom edge to the left, and the left edge to the top."
          },
          {
            id: 3,
            question: "Which 3D shape is created by rotating a right triangle around one of its legs?",
            options: ["Sphere", "Cylinder", "Cone", "Pyramid"],
            correctAnswer: 2,
            explanation: "Rotating a right triangle around one of its legs (not the hypotenuse) creates a cone. The leg becomes the cone's height, and the other leg traces the base."
          },
          {
            id: 4,
            question: "If two puzzle pieces with interlocking tabs connect at point A, and point A is in the center of piece 1, where would point A be on piece 2?",
            options: ["At the edge with the matching notch", "In the center", "At the opposite corner", "At any edge"],
            correctAnswer: 0,
            explanation: "Connection points match at corresponding features. If piece 1 has a tab at its center connecting at point A, piece 2 must have a matching notch at its edge at point A."
          },
          {
            id: 5,
            question: "How many edges does a rectangular prism (box shape) have?",
            options: ["8", "10", "12", "16"],
            correctAnswer: 2,
            explanation: "A rectangular prism has 12 edges: 4 on the top face, 4 on the bottom face, and 4 vertical edges connecting the top and bottom faces."
          }
        ]
      },
      {
        id: 10,
        name: "Verbal Expression (VE)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Choose the sentence with correct subject-verb agreement:",
            options: [
              "The team of soldiers are preparing for deployment",
              "The team of soldiers is preparing for deployment",
              "The team of soldiers were preparing for deployment",
              "The team of soldiers have preparing for deployment"
            ],
            correctAnswer: 1,
            explanation: "The subject 'team' is singular (collective noun acting as one unit), so it requires the singular verb 'is.' 'Of soldiers' is a prepositional phrase that doesn't affect the verb."
          },
          {
            id: 2,
            question: "Which sentence uses 'their,' 'there,' or 'they're' correctly?",
            options: [
              "The soldiers left there equipment at the base",
              "Their going to complete the mission tomorrow",
              "The unit set up camp over their by the river",
              "They're scheduled for training at 0600 hours"
            ],
            correctAnswer: 3,
            explanation: "'They're' is a contraction of 'they are,' which fits correctly. Should be 'their equipment' (possession), 'They're going' (they are), and 'over there' (location)."
          },
          {
            id: 3,
            question: "Identify the sentence with correct comma usage:",
            options: [
              "Before the mission began the commander briefed the unit",
              "Before the mission began, the commander briefed the unit",
              "Before, the mission began the commander briefed the unit",
              "Before the mission, began the commander briefed the unit"
            ],
            correctAnswer: 1,
            explanation: "Use a comma after an introductory dependent clause. 'Before the mission began' is the introductory clause, followed by a comma, then the main clause."
          },
          {
            id: 4,
            question: "Which sentence correctly uses the past perfect tense?",
            options: [
              "The troops deployed after they completed training",
              "The troops had deployed after they completed training",
              "The troops deployed after they had completed training",
              "The troops have deployed after they had completed training"
            ],
            correctAnswer: 2,
            explanation: "Past perfect (had + past participle) shows an action completed before another past action. Training was completed before deployment, so 'had completed' is correct."
          },
          {
            id: 5,
            question: "Choose the sentence with correct pronoun-antecedent agreement:",
            options: [
              "Each of the recruits must complete their physical fitness test",
              "Each of the recruits must complete his or her physical fitness test",
              "Each of the recruits must complete our physical fitness test",
              "Each of the recruits must complete its physical fitness test"
            ],
            correctAnswer: 1,
            explanation: "'Each' is singular, requiring a singular pronoun. 'His or her' is grammatically correct. While 'their' is increasingly accepted for singular use, traditional grammar prefers 'his or her.'"
          }
        ]
      }
    ]
  },,
  {
    id: 7,
    title: "ASVAB Practice Test #7",
    description: "Comprehensive practice exam covering all 10 ASVAB sections with military-standard questions",
    totalQuestions: 50,
    timeLimit: 60,
    sections: [
      {
        id: 1,
        name: "General Science (GS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What type of rock is formed when magma cools and solidifies beneath the Earth's surface?",
            options: ["Sedimentary rock", "Intrusive igneous rock", "Metamorphic rock", "Extrusive igneous rock"],
            correctAnswer: 1,
            explanation: "Intrusive igneous rock forms when magma cools slowly beneath the Earth's surface, allowing large crystals to form. Extrusive igneous rock forms from lava on the surface."
          },
          {
            id: 2,
            question: "Which organ in the human body produces insulin?",
            options: ["Liver", "Pancreas", "Kidney", "Gallbladder"],
            correctAnswer: 1,
            explanation: "The pancreas produces insulin, which regulates blood sugar levels. Beta cells in the pancreas secrete this hormone in response to glucose."
          },
          {
            id: 3,
            question: "What is the speed of light in a vacuum?",
            options: ["186,000 miles per second", "93,000 miles per second", "299,000 miles per second", "150,000 miles per second"],
            correctAnswer: 0,
            explanation: "Light travels at approximately 186,000 miles per second (or about 300,000 kilometers per second) in a vacuum, which is the fastest speed possible in the universe."
          },
          {
            id: 4,
            question: "Which gas makes up approximately 78% of Earth's atmosphere?",
            options: ["Oxygen", "Carbon dioxide", "Nitrogen", "Argon"],
            correctAnswer: 2,
            explanation: "Nitrogen makes up about 78% of Earth's atmosphere, while oxygen comprises about 21%, with trace amounts of other gases making up the remainder."
          },
          {
            id: 5,
            question: "What is the process by which plants lose water through their leaves?",
            options: ["Photosynthesis", "Respiration", "Transpiration", "Osmosis"],
            correctAnswer: 2,
            explanation: "Transpiration is the process by which water evaporates from the leaves of plants through small openings called stomata, helping to pull water up from the roots."
          }
        ]
      },
      {
        id: 2,
        name: "Arithmetic Reasoning (AR)",
        timeLimit: 8,
        questions: [
          {
            id: 6,
            question: "A military convoy travels 285 miles in 5 hours. What is the average speed in miles per hour?",
            options: ["52 mph", "55 mph", "57 mph", "60 mph"],
            correctAnswer: 2,
            explanation: "Divide total distance by time: 285 ÷ 5 = 57 miles per hour."
          },
          {
            id: 7,
            question: "A soldier's base pay is $2,400 per month. If he receives a 15% increase, what is his new monthly pay?",
            options: ["$2,560", "$2,640", "$2,760", "$2,880"],
            correctAnswer: 2,
            explanation: "Calculate 15% of $2,400: $2,400 × 0.15 = $360. Add to original pay: $2,400 + $360 = $2,760."
          },
          {
            id: 8,
            question: "A warehouse has 1,250 crates. If 3/5 of them are shipped out, how many crates remain?",
            options: ["400", "450", "500", "550"],
            correctAnswer: 2,
            explanation: "If 3/5 are shipped, then 2/5 remain: 1,250 × 2/5 = 1,250 × 0.4 = 500 crates."
          },
          {
            id: 9,
            question: "A training exercise starts at 0645 hours and lasts for 3 hours and 45 minutes. What time does it end?",
            options: ["1015 hours", "1030 hours", "1045 hours", "1100 hours"],
            correctAnswer: 1,
            explanation: "Add 3 hours 45 minutes to 0645: 0645 + 3:45 = 1030 hours (10:30 AM)."
          },
          {
            id: 10,
            question: "If 8 mechanics can repair 24 vehicles in 6 hours, how many vehicles can 12 mechanics repair in the same time?",
            options: ["30", "32", "36", "40"],
            correctAnswer: 2,
            explanation: "Each mechanic repairs 24 ÷ 8 = 3 vehicles in 6 hours. So 12 mechanics repair 12 × 3 = 36 vehicles."
          }
        ]
      },
      {
        id: 3,
        name: "Word Knowledge (WK)",
        timeLimit: 5,
        questions: [
          {
            id: 11,
            question: "Meticulous most nearly means:",
            options: ["Careless", "Extremely careful and precise", "Quick", "Confused"],
            correctAnswer: 1,
            explanation: "Meticulous means showing great attention to detail and being very careful and precise in one's work."
          },
          {
            id: 12,
            question: "Verify most nearly means:",
            options: ["Deny", "Confirm as true", "Question", "Ignore"],
            correctAnswer: 1,
            explanation: "Verify means to confirm the truth or accuracy of something, often through investigation or evidence."
          },
          {
            id: 13,
            question: "Hostile most nearly means:",
            options: ["Friendly", "Neutral", "Unfriendly or antagonistic", "Cooperative"],
            correctAnswer: 2,
            explanation: "Hostile means showing unfriendly or aggressive opposition, being antagonistic or opposed to something."
          },
          {
            id: 14,
            question: "Consecutive most nearly means:",
            options: ["Random", "Following in order without interruption", "Separated", "Parallel"],
            correctAnswer: 1,
            explanation: "Consecutive means following continuously in unbroken sequence, one after another without gaps."
          },
          {
            id: 15,
            question: "Candid most nearly means:",
            options: ["Dishonest", "Frank and honest", "Shy", "Aggressive"],
            correctAnswer: 1,
            explanation: "Candid means being truthful, straightforward, and frank in expression, not holding back one's opinions."
          }
        ]
      },
      {
        id: 4,
        name: "Paragraph Comprehension (PC)",
        timeLimit: 6,
        questions: [
          {
            id: 16,
            passage: "Military cryptography involves encoding sensitive information to prevent unauthorized access by adversaries who might intercept communications. The need to communicate securely while denying enemies the ability to understand those communications has been essential throughout military history. During World War II, the Navajo Code Talkers used their native language as an unbreakable code that provided the United States Marine Corps with secure communications in the Pacific Theater. The Navajo language, spoken by only a small population primarily in the southwestern United States, was completely unfamiliar to Japanese forces who had successfully broken other American codes. The complexity of the Navajo language, combined with a special military vocabulary created specifically for the code, created a system that enemy forces could never decipher despite intense efforts and the capture of code samples.\n\nThe Navajo Code Talkers developed code words for military terms that did not exist in their traditional language, using creative associations based on Navajo words for familiar objects. For example, different types of aircraft were designated by Navajo words for birds, with a fighter plane called a 'hummingbird' and a bomber called a 'buzzard.' This code was used to transmit tactical messages about troop movements and operations with speed and accuracy that encrypted machine codes could not match. While machine encryption required time to encode and decode messages, Navajo Code Talkers could transmit and receive messages in real time, providing immediate secure communications during fast-moving combat situations. Two Code Talkers could encode, transmit, and decode a three-line English message in 20 seconds, while machines of the era required 30 minutes for the same task.\n\nThe contribution of the Navajo Code Talkers was so significant that military commanders credited them with saving countless lives and contributing substantially to American victories in critical battles including Iwo Jima. The code was never broken by enemy forces during the war, making it the only unbroken code in modern military history. Approximately 400 Navajo men served as Code Talkers, participating in every major Marine operation in the Pacific from 1942 to 1945. Their service remained classified for decades after the war, and their crucial contribution to victory was not publicly recognized until the code was finally declassified in 1968. The legacy of the Navajo Code Talkers demonstrates how cultural and linguistic diversity can provide unexpected strategic advantages and highlights the importance of creative solutions to security challenges.",
            question: "According to the passage, why was the Navajo code effective?",
            options: ["It was written down", "The language was complex and unfamiliar to enemies", "It was used by many nations", "It was computer-generated"],
            correctAnswer: 1,
            explanation: "The passage states that the complexity of the Navajo language, combined with special military vocabulary, made it impossible for enemies to decipher."
          },
          {
            id: 17,
            passage: "Radar technology revolutionized military defense by allowing detection of aircraft and ships at great distances, fundamentally changing warfare by eliminating the element of surprise that attacking forces had previously enjoyed. Before radar, defending forces relied on visual observation and sound detection, which provided very limited warning time—often only minutes before attacking aircraft reached their targets. The development of radar during the 1930s and its rapid advancement during World War II enabled defenders to detect incoming threats while they were still dozens or even hundreds of miles away, providing crucial time to scramble fighters, prepare anti-aircraft defenses, and alert civilian populations. The British Chain Home radar network played a decisive role in the Battle of Britain by detecting German aircraft forming up over France, allowing the Royal Air Force to intercept them efficiently rather than flying constant patrols that would have exhausted pilots and aircraft.\n\nRadar works by emitting radio waves that bounce off objects and return to the receiver, functioning on the same principle as an echo but using electromagnetic radiation instead of sound. The radar transmitter generates pulses of radio frequency energy that propagate outward at the speed of light. When these waves encounter an object, some of the energy reflects back toward the radar antenna, creating a return signal or 'echo.' By measuring the time it takes for the waves to return, the system can calculate the distance, speed, and direction of the target with remarkable precision. The speed of light is constant, so distance equals half the round-trip time multiplied by light speed. The direction is determined by the antenna pointing angle when the echo was received. Speed is calculated using the Doppler effect—the change in frequency of the returned signal caused by target motion toward or away from the radar.\n\nModern radar systems can track hundreds of objects simultaneously using sophisticated signal processing and computer technology that was unimaginable during radar's early development. Phased array radars electronically steer their beams without mechanical movement, allowing them to switch instantly between multiple targets. Automatic tracking algorithms follow targets across successive radar scans, predicting their future positions and alerting operators to threats. Modern military radars can discriminate between different types of aircraft, detect small targets like cruise missiles against ground clutter, and operate in electronic warfare environments where adversaries attempt to jam or deceive them. Air defense networks integrate multiple radars with different capabilities to provide comprehensive coverage, while airborne early warning aircraft extend radar coverage far beyond land-based systems. Despite decades of development in stealth technology designed to evade radar detection, radar remains the primary means of detecting and tracking airborne and maritime threats for military forces worldwide.",
            question: "How does radar determine the distance of an object?",
            options: ["By measuring sound waves", "By visual observation", "By measuring the time for radio waves to return", "By measuring temperature"],
            correctAnswer: 2,
            explanation: "The passage clearly states that radar measures the time it takes for radio waves to bounce back to calculate distance."
          },
          {
            id: 18,
            passage: "Physical fitness is a cornerstone of military readiness that directly enables service members to perform the demanding physical tasks inherent to military service. The requirements of military operations often push personnel to their physical limits and beyond, whether carrying heavy equipment over long distances, conducting combat operations while wearing body armor, engaging in hand-to-hand combat, or performing rescue operations under time pressure. Service members must maintain cardiovascular endurance, muscular strength, and flexibility to perform their duties effectively across the full spectrum of military operations. Without adequate physical fitness, even highly trained and motivated personnel will be unable to execute their missions, as their bodies will simply fail to perform when demanded. The consequences of inadequate fitness can range from mission failure to injury or death.\n\nRegular training not only improves physical capabilities but also builds mental resilience and discipline that transfer to other aspects of military performance. Physical training teaches personnel to push through discomfort and continue functioning when their bodies want to quit—a mental skill directly applicable to combat and other high-stress situations. The discipline required to maintain fitness despite competing demands, fatigue, or lack of motivation builds the same discipline needed to maintain professional standards in all areas. PT also provides stress relief and mental health benefits, helping service members manage the psychological demands of military life. When conducted in unit formations, physical training builds camaraderie and unit cohesion as members encourage each other through shared physical challenges. Leaders who participate in PT with their units build credibility and rapport that strengthen their effectiveness.\n\nThe military requires periodic fitness assessments to ensure all personnel meet established standards appropriate to their age, gender, and military occupational specialty. These assessments typically evaluate cardiovascular endurance through running or other aerobic activities, muscular strength and endurance through exercises like pushups and situps, and sometimes flexibility or body composition. Standards are set to ensure personnel can perform essential military tasks, not simply to enforce arbitrary requirements. Service members who fail to meet standards receive remedial training and support to improve their fitness, but persistent failure to meet standards can result in administrative action including separation from service. Different military specialties may have different fitness requirements, with more demanding standards for infantry, special operations, and other physically intensive roles. By maintaining fitness standards across the force, the military ensures readiness and reduces injuries that result from inadequately conditioned personnel attempting to perform demanding physical tasks.",
            question: "What is the main idea of this passage?",
            options: ["Physical fitness is only about strength", "Military fitness includes physical and mental benefits", "Fitness tests are difficult", "Cardiovascular training is the only requirement"],
            correctAnswer: 1,
            explanation: "The passage emphasizes that physical fitness is essential for military readiness and provides both physical capabilities and mental benefits like resilience and discipline."
          },
          {
            id: 19,
            passage: "Military logistics involves the coordination of moving troops, equipment, and supplies to where they are needed, when they are needed, in the quantities needed to sustain operations. This complex discipline requires managing vast amounts of material across long distances, often through contested territory and harsh environments. Effective logistics can determine the outcome of military operations as surely as tactical skill or technological superiority. History provides numerous examples of military forces that failed not because they were defeated in battle but because they could not sustain their operations due to logistics failures. Conversely, superior logistics has enabled smaller or less technologically advanced forces to prevail by maintaining operational tempo while denying the same capability to adversaries. Napoleon famously stated that 'an army marches on its stomach,' recognizing that even the finest soldiers cannot fight without food, ammunition, and supplies.\n\nDuring major campaigns, logistics officers must plan transportation routes, manage inventory, coordinate timing, and anticipate needs weeks or months in advance while remaining flexible enough to respond to changing circumstances. Planning transportation routes requires understanding the capacity and vulnerabilities of different modes including trucks, trains, ships, and aircraft, selecting optimal combinations for different cargo types and priorities. Managing inventory means tracking thousands of items at multiple locations, knowing what is available, what is in transit, and what needs to be ordered. Coordinating timing ensures that personnel, equipment, and supplies arrive together rather than having forces waiting idly for missing components or having supplies arrive with no one to use them. Anticipating needs requires understanding consumption rates for different operations and planning accordingly, maintaining reserve stocks for contingencies while avoiding wasteful oversupply that strains transportation networks.\n\nA breakdown in the supply chain can leave units without critical resources such as ammunition, fuel, food, water, or spare parts, forcing them to halt operations or operate at reduced effectiveness. Combat operations consume enormous quantities of supplies, with artillery units firing thousands of shells, vehicles consuming thousands of gallons of fuel, and personnel requiring regular resupply of food and water. When logistics fails, units must choose between continuing operations unsupported or pausing to allow supplies to reach them, both undesirable options that may compromise missions. Medical evacuation and treatment capabilities depend on logistics to function, meaning logistics failures can directly cost lives beyond their operational impacts. Modern military forces invest heavily in logistics capabilities including specialized transportation units, advanced tracking systems, and professional logistics officers who understand the critical importance of their mission. The phrase 'amateurs talk tactics, professionals talk logistics' reflects military professionals' recognition that logistics excellence is fundamental to sustained military success.",
            question: "According to the passage, what can happen if logistics fail?",
            options: ["Operations proceed normally", "Units may lack critical resources", "Transportation becomes easier", "Planning is unnecessary"],
            correctAnswer: 1,
            explanation: "The passage explicitly states that a breakdown in the supply chain can leave units without critical resources."
          },
          {
            id: 20,
            passage: "Leadership in the military emphasizes leading by example as the most powerful and authentic form of leadership that commands genuine respect rather than mere compliance. Officers and non-commissioned officers are expected to demonstrate the values they expect from their subordinates rather than simply demanding those values while exempting themselves. This includes integrity, courage, and commitment to the mission demonstrated through daily actions rather than just words. Leaders who share the hardships of their subordinates, maintain the same standards they enforce, and put the welfare of their people before personal comfort earn moral authority that cannot be achieved through rank alone. When leaders demonstrate courage under fire, subordinates are inspired to be courageous. When leaders maintain integrity even when no one is watching, they create a culture of integrity throughout their units.\n\nThe military leadership principle of leading by example is rooted in the understanding that subordinates constantly observe their leaders and model their behavior accordingly. If leaders demand punctuality but arrive late themselves, subordinates learn that standards are negotiable. If leaders require physical fitness but are themselves out of shape, they lose credibility. Conversely, when leaders consistently demonstrate the behavior and values they expect, they create a powerful standard that influences the entire unit's culture. Leading by example is particularly critical in military contexts where leaders may need to ask subordinates to risk their lives. Personnel are far more willing to follow dangerous orders from leaders who share those dangers than from those who remain safely in the rear. The respect earned through leading by example creates cohesive units where personnel trust their leaders and are committed to mission accomplishment.\n\nEffective military leaders inspire their teams through personal conduct rather than relying solely on rank or authority, recognizing that positional power alone is insufficient for building motivated, high-performing units. While rank provides authority to issue orders and expect obedience, it does not create the willing commitment and initiative necessary for excellence. Leaders who inspire through example develop subordinates who exercise initiative, maintain standards even when unsupervised, and go above and beyond minimum requirements because they want to meet the standard their leaders have demonstrated. This approach to leadership creates a self-sustaining culture of excellence where personnel hold themselves and each other accountable because they have internalized the values their leaders exemplify. In contrast, leaders who rely primarily on their rank must constantly monitor and enforce standards because their subordinates lack intrinsic motivation to maintain them. By leading through example rather than authority alone, military leaders multiply their effectiveness and develop the next generation of leaders who will perpetuate the same leadership approach.",
            question: "According to the passage, how should military leaders inspire their teams?",
            options: ["Through rank alone", "Through personal conduct and example", "Through strict punishment", "Through financial incentives"],
            correctAnswer: 1,
            explanation: "The passage states that effective military leaders inspire their teams through personal conduct and by demonstrating values, rather than relying solely on rank."
          }
        ]
      },
      {
        id: 5,
        name: "Mathematics Knowledge (MK)",
        timeLimit: 6,
        questions: [
          {
            id: 21,
            question: "Solve for x: 4x - 7 = 21",
            options: ["x = 5", "x = 6", "x = 7", "x = 8"],
            correctAnswer: 2,
            explanation: "Add 7 to both sides: 4x = 28. Divide both sides by 4: x = 7."
          },
          {
            id: 22,
            question: "What is the area of a triangle with a base of 12 inches and a height of 8 inches?",
            options: ["48 square inches", "96 square inches", "40 square inches", "60 square inches"],
            correctAnswer: 0,
            explanation: "Area of triangle = (1/2) × base × height = (1/2) × 12 × 8 = 48 square inches."
          },
          {
            id: 23,
            question: "What is 15% of 240?",
            options: ["30", "32", "36", "40"],
            correctAnswer: 2,
            explanation: "15% of 240 = 0.15 × 240 = 36."
          },
          {
            id: 24,
            question: "If y = 3x + 5 and x = 4, what is the value of y?",
            options: ["15", "17", "19", "21"],
            correctAnswer: 1,
            explanation: "Substitute x = 4 into the equation: y = 3(4) + 5 = 12 + 5 = 17."
          },
          {
            id: 25,
            question: "What is the volume of a rectangular box with length 6 cm, width 4 cm, and height 5 cm?",
            options: ["100 cubic cm", "110 cubic cm", "120 cubic cm", "130 cubic cm"],
            correctAnswer: 2,
            explanation: "Volume = length × width × height = 6 × 4 × 5 = 120 cubic centimeters."
          }
        ]
      },
      {
        id: 6,
        name: "Electronics Information (EI)",
        timeLimit: 5,
        questions: [
          {
            id: 26,
            question: "What is the purpose of a capacitor in an electrical circuit?",
            options: ["To resist current flow", "To store electrical energy", "To convert AC to DC", "To measure voltage"],
            correctAnswer: 1,
            explanation: "A capacitor stores electrical energy in an electric field between two conductive plates separated by an insulator."
          },
          {
            id: 27,
            question: "In a series circuit with three resistors of 10 ohms, 15 ohms, and 25 ohms, what is the total resistance?",
            options: ["50 ohms", "40 ohms", "30 ohms", "20 ohms"],
            correctAnswer: 0,
            explanation: "In a series circuit, total resistance is the sum of all resistances: 10 + 15 + 25 = 50 ohms."
          },
          {
            id: 28,
            question: "What does DC stand for in electrical terms?",
            options: ["Digital Current", "Direct Current", "Dual Circuit", "Dynamic Charge"],
            correctAnswer: 1,
            explanation: "DC stands for Direct Current, which is electrical current that flows in one constant direction, unlike AC (Alternating Current)."
          },
          {
            id: 29,
            question: "Which component is used to convert AC voltage to DC voltage?",
            options: ["Transformer", "Capacitor", "Rectifier", "Resistor"],
            correctAnswer: 2,
            explanation: "A rectifier converts alternating current (AC) to direct current (DC) by allowing current to flow in only one direction."
          },
          {
            id: 30,
            question: "What is the unit of electrical power?",
            options: ["Volt", "Ampere", "Watt", "Ohm"],
            correctAnswer: 2,
            explanation: "The watt is the unit of electrical power. Power (watts) = Voltage (volts) × Current (amperes)."
          }
        ]
      },
      {
        id: 7,
        name: "Auto & Shop Information (AS)",
        timeLimit: 5,
        questions: [
          {
            id: 31,
            question: "What is the primary function of a vehicle's alternator?",
            options: ["Start the engine", "Charge the battery and power electrical systems", "Control the transmission", "Cool the engine"],
            correctAnswer: 1,
            explanation: "The alternator generates electricity to charge the battery and power the vehicle's electrical systems while the engine is running."
          },
          {
            id: 32,
            question: "Which tool is used to measure the thickness of material with high precision?",
            options: ["Tape measure", "Level", "Micrometer", "Compass"],
            correctAnswer: 2,
            explanation: "A micrometer is a precision measuring instrument that can measure small distances or thicknesses very accurately, typically to 0.001 inch or 0.01 mm."
          },
          {
            id: 33,
            question: "What is the purpose of motor oil in an engine?",
            options: ["Cool the engine and lubricate moving parts", "Increase fuel efficiency only", "Clean the exhaust system", "Power the electrical system"],
            correctAnswer: 0,
            explanation: "Motor oil lubricates moving engine parts to reduce friction and wear, and also helps cool the engine by absorbing and transferring heat."
          },
          {
            id: 34,
            question: "Which saw is best suited for cutting curves in wood?",
            options: ["Circular saw", "Hack saw", "Jigsaw", "Miter saw"],
            correctAnswer: 2,
            explanation: "A jigsaw has a thin, straight blade that moves up and down, making it ideal for cutting curves and irregular shapes in wood and other materials."
          },
          {
            id: 35,
            question: "What does ABS stand for in automotive braking systems?",
            options: ["Advanced Brake System", "Anti-lock Braking System", "Automatic Brake Sensor", "Auxiliary Brake Support"],
            correctAnswer: 1,
            explanation: "ABS stands for Anti-lock Braking System, which prevents wheels from locking up during braking, allowing the driver to maintain steering control."
          }
        ]
      },
      {
        id: 8,
        name: "Mechanical Comprehension (MC)",
        timeLimit: 6,
        questions: [
          {
            id: 36,
            question: "If a gear with 20 teeth drives a gear with 40 teeth, and the smaller gear rotates at 100 RPM, what is the speed of the larger gear?",
            options: ["200 RPM", "100 RPM", "50 RPM", "25 RPM"],
            correctAnswer: 2,
            explanation: "The gear ratio is 20:40 or 1:2. The larger gear rotates at half the speed of the smaller gear: 100 ÷ 2 = 50 RPM."
          },
          {
            id: 37,
            question: "A 150-pound person stands on a lever 3 feet from the fulcrum. How much force is needed 9 feet from the fulcrum on the other side to balance the lever?",
            options: ["50 pounds", "75 pounds", "100 pounds", "150 pounds"],
            correctAnswer: 0,
            explanation: "Using the lever principle: Force₁ × Distance₁ = Force₂ × Distance₂. So 150 × 3 = Force₂ × 9, therefore Force₂ = 450 ÷ 9 = 50 pounds."
          },
          {
            id: 38,
            question: "What type of simple machine is a doorknob?",
            options: ["Lever", "Wheel and axle", "Pulley", "Inclined plane"],
            correctAnswer: 1,
            explanation: "A doorknob is a wheel and axle. The knob (wheel) turns a smaller shaft (axle) inside the door, providing mechanical advantage."
          },
          {
            id: 39,
            question: "If a pulley system has a mechanical advantage of 4, how much force is required to lift a 200-pound load?",
            options: ["25 pounds", "50 pounds", "75 pounds", "100 pounds"],
            correctAnswer: 1,
            explanation: "Mechanical advantage = Load ÷ Effort. So 4 = 200 ÷ Effort, therefore Effort = 200 ÷ 4 = 50 pounds."
          },
          {
            id: 40,
            question: "When a liquid is heated, what happens to its density?",
            options: ["It increases", "It decreases", "It stays the same", "It becomes solid"],
            correctAnswer: 1,
            explanation: "When heated, liquids expand and their molecules move farther apart, causing the density to decrease. The same mass occupies a larger volume."
          }
        ]
      },
      {
        id: 9,
        name: "Assembling Objects (AO)",
        timeLimit: 5,
        questions: [
          {
            id: 41,
            question: "Which object would be formed if the flat pattern is folded along the dotted lines: a square with triangular flaps on all four sides?",
            options: ["A cube", "A pyramid", "A cone", "A cylinder"],
            correctAnswer: 1,
            explanation: "A square base with triangular flaps on all sides folds to form a square pyramid, where the triangles meet at a point above the base."
          },
          {
            id: 42,
            question: "If point A on one shape must connect to point B on another shape, and both shapes need to rotate, which arrangement shows the correct connection?",
            options: ["Shape 1 rotated 90° clockwise", "Shape 1 rotated 180°", "Shape 1 rotated 90° counterclockwise", "No rotation needed"],
            correctAnswer: 1,
            explanation: "When connecting designated points, a 180° rotation aligns the connection points properly while maintaining the correct spatial relationship."
          },
          {
            id: 43,
            question: "Which combination of shapes can be assembled to form a complete rectangle: two right triangles with equal sides?",
            options: ["Place hypotenuses together", "Place right angles together", "Place the two equal sides together", "Cannot form a rectangle"],
            correctAnswer: 0,
            explanation: "Two identical right triangles can form a rectangle when their hypotenuses (longest sides) are placed together, creating a rectangular shape."
          },
          {
            id: 44,
            question: "If you have a circle divided into 4 equal parts, and you need to reassemble them into a different shape, which is possible?",
            options: ["A square", "An approximate parallelogram", "A triangle", "A pentagon"],
            correctAnswer: 1,
            explanation: "Four quarter-circle pieces can be rearranged to approximate a parallelogram shape by alternating their orientations."
          },
          {
            id: 45,
            question: "Which view shows how the 3D object would look from directly above: an L-shaped block?",
            options: ["An L-shape", "A rectangle", "A T-shape", "A cross"],
            correctAnswer: 0,
            explanation: "Looking directly down on an L-shaped block from above, you would see the L-shaped footprint of the object."
          }
        ]
      },
      {
        id: 10,
        name: "Verbal Expression (VE)",
        timeLimit: 6,
        questions: [
          {
            id: 46,
            question: "Choose the sentence with correct grammar and punctuation:",
            options: ["The soldiers equipment was inspected daily.", "The soldiers' equipment was inspected daily.", "The soldier's equipment were inspected daily.", "The soldiers equipment were inspected daily."],
            correctAnswer: 1,
            explanation: "The correct answer uses the plural possessive form 'soldiers'' to show that the equipment belongs to multiple soldiers, and uses the singular verb 'was' to agree with the singular subject 'equipment'."
          },
          {
            id: 47,
            question: "Which word best completes the sentence: 'The commander gave _____ approval for the mission.'",
            options: ["his", "him", "he", "himself"],
            correctAnswer: 0,
            explanation: "'His' is the correct possessive pronoun to show that the approval belongs to the commander."
          },
          {
            id: 48,
            question: "Identify the sentence with correct subject-verb agreement:",
            options: ["Each of the recruits were given a uniform.", "Each of the recruits was given a uniform.", "Each of the recruit were given a uniform.", "Each of the recruit was given a uniform."],
            correctAnswer: 1,
            explanation: "'Each' is singular and requires the singular verb 'was.' The prepositional phrase 'of the recruits' does not affect the verb agreement."
          },
          {
            id: 49,
            question: "Which sentence uses the comma correctly?",
            options: ["After the training exercise the unit returned to base.", "After the training exercise, the unit returned to base.", "After, the training exercise the unit returned to base.", "After the training, exercise the unit returned to base."],
            correctAnswer: 1,
            explanation: "A comma should follow an introductory phrase. 'After the training exercise' is an introductory adverbial phrase, so it should be followed by a comma."
          },
          {
            id: 50,
            question: "Choose the sentence that is NOT a run-on:",
            options: ["The sergeant briefed the team they prepared for deployment.", "The sergeant briefed the team, they prepared for deployment.", "The sergeant briefed the team, and they prepared for deployment.", "The sergeant briefed the team they then prepared for deployment."],
            correctAnswer: 2,
            explanation: "This sentence correctly joins two independent clauses with a comma and coordinating conjunction 'and.' The other options are run-on sentences or comma splices."
          }
        ]
      }
    ]
  },,
  {
    id: 8,
    title: "ASVAB Practice Test #8",
    description: "Comprehensive practice exam covering all 10 ASVAB sections with military-standard questions",
    totalQuestions: 50,
    timeLimit: 60,
    sections: [
      {
        id: 1,
        name: "General Science (GS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Which layer of the atmosphere contains the ozone layer that protects Earth from harmful UV radiation?",
            options: ["Troposphere", "Stratosphere", "Mesosphere", "Thermosphere"],
            correctAnswer: 1,
            explanation: "The stratosphere contains the ozone layer, which absorbs most of the Sun's harmful ultraviolet radiation, located approximately 10-50 km above Earth's surface."
          },
          {
            id: 2,
            question: "What is the primary function of mitochondria in a cell?",
            options: ["Protein synthesis", "Energy production", "Waste removal", "Cell division"],
            correctAnswer: 1,
            explanation: "Mitochondria are known as the 'powerhouses' of the cell because they produce ATP (adenosine triphosphate), which is the main energy currency used by cells."
          },
          {
            id: 3,
            question: "Which chemical element is essential for thyroid hormone production?",
            options: ["Iron", "Calcium", "Iodine", "Zinc"],
            correctAnswer: 2,
            explanation: "Iodine is essential for the production of thyroid hormones (T3 and T4). Iodine deficiency can lead to thyroid disorders such as goiter."
          },
          {
            id: 4,
            question: "What phenomenon causes ocean tides?",
            options: ["Wind patterns", "Earth's rotation", "Gravitational pull of the Moon and Sun", "Ocean currents"],
            correctAnswer: 2,
            explanation: "Tides are caused primarily by the gravitational pull of the Moon, with the Sun having a secondary effect. The Moon's gravity creates bulges in Earth's oceans."
          },
          {
            id: 5,
            question: "Which type of blood cells are responsible for fighting infections?",
            options: ["Red blood cells", "White blood cells", "Platelets", "Plasma cells"],
            correctAnswer: 1,
            explanation: "White blood cells (leukocytes) are the immune system's primary defense against infections and foreign invaders. They identify and destroy pathogens."
          }
        ]
      },
      {
        id: 2,
        name: "Arithmetic Reasoning (AR)",
        timeLimit: 8,
        questions: [
          {
            id: 1,
            question: "A military helicopter flies at 140 mph for 45 minutes, then increases speed to 180 mph for the next 30 minutes. What is the total distance traveled?",
            options: ["175 miles", "195 miles", "210 miles", "225 miles"],
            correctAnswer: 1,
            explanation: "First segment: 140 mph × 0.75 hours = 105 miles. Second segment: 180 mph × 0.5 hours = 90 miles. Total: 105 + 90 = 195 miles."
          },
          {
            id: 2,
            question: "A platoon has 42 soldiers. If they are divided into squads with 7 soldiers each, and each squad needs 3 radios, how many radios are needed total?",
            options: ["12 radios", "15 radios", "18 radios", "21 radios"],
            correctAnswer: 2,
            explanation: "Number of squads: 42 ÷ 7 = 6 squads. Total radios needed: 6 squads × 3 radios = 18 radios."
          },
          {
            id: 3,
            question: "A soldier saves 15% of their monthly salary of $2,800. If they save this amount for 8 months, how much will they have saved?",
            options: ["$2,940", "$3,200", "$3,360", "$3,640"],
            correctAnswer: 2,
            explanation: "Monthly savings: 15% of $2,800 = $420. Total savings: $420 × 8 months = $3,360."
          },
          {
            id: 4,
            question: "A fuel tank can hold 1,500 gallons. If it is currently 2/5 full and fuel costs $3.40 per gallon, how much will it cost to fill the tank completely?",
            options: ["$2,550", "$3,060", "$3,400", "$5,100"],
            correctAnswer: 1,
            explanation: "Current fuel: 2/5 × 1,500 = 600 gallons. Gallons needed: 1,500 - 600 = 900 gallons. Cost: 900 × $3.40 = $3,060."
          },
          {
            id: 5,
            question: "During a training exercise, a unit completes 18 miles in 6 hours. At this rate, how long will it take to complete 30 miles?",
            options: ["8 hours", "9 hours", "10 hours", "12 hours"],
            correctAnswer: 2,
            explanation: "Rate: 18 miles ÷ 6 hours = 3 mph. Time for 30 miles: 30 miles ÷ 3 mph = 10 hours."
          }
        ]
      },
      {
        id: 3,
        name: "Word Knowledge (WK)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "Meticulous most nearly means:",
            options: ["Careless", "Extremely careful and precise", "Quick", "Generous"],
            correctAnswer: 1,
            explanation: "Meticulous means showing great attention to detail; very careful and precise in one's work or actions."
          },
          {
            id: 2,
            question: "Resilient most nearly means:",
            options: ["Fragile", "Able to recover quickly", "Stubborn", "Colorful"],
            correctAnswer: 1,
            explanation: "Resilient means able to withstand or recover quickly from difficult conditions; having elasticity or the ability to bounce back."
          },
          {
            id: 3,
            question: "Obsolete most nearly means:",
            options: ["Modern", "Expensive", "No longer in use", "Complicated"],
            correctAnswer: 2,
            explanation: "Obsolete means no longer produced or used; out of date or outdated due to being replaced by something newer."
          },
          {
            id: 4,
            question: "Covert most nearly means:",
            options: ["Open", "Secret or hidden", "Military", "Expensive"],
            correctAnswer: 1,
            explanation: "Covert means not openly acknowledged or displayed; secret, hidden, or concealed, often used in military or intelligence contexts."
          },
          {
            id: 5,
            question: "Facilitate most nearly means:",
            options: ["To make difficult", "To make easier", "To prevent", "To ignore"],
            correctAnswer: 1,
            explanation: "Facilitate means to make an action or process easier or less difficult; to help bring about or assist in the progress of something."
          }
        ]
      },
      {
        id: 4,
        name: "Paragraph Comprehension (PC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Military leaders must possess strong decision-making skills under pressure as one of their most critical competencies. The fog and friction of war create conditions of uncertainty, confusion, and rapid change that challenge even experienced commanders. During combat operations, commanders often face situations where they must make critical choices with limited information and time constraints that prevent thorough analysis. Intelligence may be incomplete or contradictory, communication with higher headquarters may be disrupted, and enemy actions may unfold faster than anticipated. The ability to assess risks, consider alternatives, and commit to a course of action can mean the difference between mission success and failure, between preserving forces and suffering unnecessary casualties. Indecision or analysis paralysis can be as dangerous as making the wrong decision, as delay allows enemy forces to seize initiative or escape.\n\nThe complexity of modern military operations magnifies the challenges of decision-making under pressure. Commanders must consider multiple factors simultaneously including friendly force capabilities and positions, enemy strength and disposition, terrain and weather effects, logistics constraints, rules of engagement, and potential second and third-order effects of their decisions. They must balance competing priorities such as mission accomplishment versus force protection, speed versus security, and tactical gains versus strategic implications. In joint operations involving multiple services or coalition partners, commanders must coordinate with other organizations while maintaining the tempo necessary for success. The weight of responsibility—knowing that decisions will determine whether subordinates live or die—adds emotional stress to the cognitive challenge of processing information and selecting courses of action.\n\nTraining exercises and simulations help develop these essential skills by exposing leaders to realistic decision-making scenarios in controlled environments where mistakes provide learning opportunities rather than fatal consequences. Tactical exercises without troops allow commanders to practice planning and decision-making at an accelerated tempo. Combat simulations create realistic stress and uncertainty while providing detailed feedback on decisions and outcomes. Field training exercises put leaders in physically demanding situations where they must make decisions while managing fatigue and physical discomfort similar to actual operations. Over time, this training develops judgment, builds confidence, and creates mental models that enable faster, better decisions under pressure. Leaders learn to recognize patterns, rapidly assess situations, and trust their instincts developed through experience. While no training perfectly replicates combat conditions, systematic exposure to decision-making challenges prepares leaders to perform effectively when lives and missions are truly at stake.\n\nWhat is the main point of this passage?",
            options: ["Training exercises are the most important part of military preparation", "Decision-making under pressure is crucial for military leaders", "Combat operations always involve limited information", "Mission success depends solely on leadership"],
            correctAnswer: 1,
            explanation: "The passage primarily focuses on the importance of decision-making skills under pressure for military leaders, explaining why this ability is critical and how it's developed."
          },
          {
            id: 2,
            question: "The maintenance of military equipment requires strict adherence to technical manuals and schedules established through engineering analysis and operational experience. These technical publications provide detailed procedures for inspecting, servicing, and repairing specific equipment types, specifying exactly what actions to perform, what tools and parts to use, and what standards must be met. Schedules dictate maintenance intervals based on operating hours, calendar time, or usage cycles. Regular inspections prevent equipment failures that could compromise missions by identifying wear, damage, or developing problems before they cause breakdowns during operations. Preventive maintenance is far more cost-effective than emergency repairs, and in military contexts, equipment failures can endanger lives and mission success in ways that justify the time and resources invested in systematic maintenance.\n\nTechnicians must document all maintenance activities and report any defects immediately to create accountability, maintain historical records, and ensure problems are addressed before equipment is returned to service. Documentation includes what work was performed, what parts were used, what defects were found, and what tests were conducted to verify proper function after maintenance. This paperwork may seem burdensome, but it serves critical purposes: tracking maintenance history helps predict when components will need replacement, identifying recurring problems reveals design flaws or training gaps, and creating accountability ensures work is actually performed rather than just checked off. Immediate defect reporting ensures that identified problems are fixed rather than being discovered during subsequent operations when repair may be impossible or dangerous. In mishap investigations, maintenance records provide crucial evidence about whether equipment was properly maintained.\n\nThis systematic approach ensures operational readiness and extends the service life of expensive equipment that represents significant investment. Military forces cannot afford to replace equipment frequently, so maximizing service life through proper maintenance is economically essential. Operational readiness depends on having equipment available and functional when needed, which maintenance directly enables by preventing unexpected failures. The discipline of systematic maintenance creates a culture of attention to detail and accountability that extends beyond equipment care to other aspects of military professionalism. Well-maintained equipment performs better, breaks down less frequently, and gives personnel confidence that their tools will function when lives depend on them. In contrast, organizations that neglect maintenance experience declining readiness, higher costs, and potentially catastrophic failures that could have been prevented through routine care.\n\nAccording to the passage, why is maintenance documentation important?",
            options: ["It helps train new technicians", "It ensures accountability and tracking of equipment condition", "It reduces the cost of equipment", "It eliminates the need for inspections"],
            correctAnswer: 1,
            explanation: "The passage emphasizes that documenting maintenance activities is part of a systematic approach to ensure operational readiness, implying accountability and condition tracking."
          },
          {
            id: 3,
            question: "Physical fitness is a cornerstone of military readiness that enables service members to meet the demanding physical requirements inherent to military service. The nature of military operations—carrying heavy loads, operating in extreme environments, maintaining effectiveness despite fatigue and stress—requires physical capabilities that exceed those needed for most civilian occupations. Service members must maintain strength, endurance, and flexibility to perform their duties effectively across the full range of military operations from combat to humanitarian assistance. Without adequate fitness, even highly trained and motivated personnel cannot execute missions because their bodies will fail to perform when demanded. The Army Combat Fitness Test evaluates soldiers' capabilities through exercises that simulate combat-related movements rather than simply testing general fitness, ensuring that standards reflect actual operational requirements.\n\nThe six events of the Army Combat Fitness Test include deadlifts that simulate lifting heavy equipment, standing power throws that replicate explosive movements like throwing grenades, hand-release pushups that test upper body strength for lifting and climbing, sprint-drag-carry that simulates moving wounded soldiers and equipment, leg tucks or planks that test core strength essential for body armor and load carriage, and a two-mile run that evaluates cardiovascular endurance for sustained operations. These events specifically target the physical capabilities that research and combat experience have identified as critical for soldier performance. Regular physical training not only improves individual performance but also builds unit cohesion and morale by creating shared challenges that bring service members together. When units conduct PT in formation, they develop camaraderie and team spirit that strengthen bonds and enhance effectiveness. Leaders who participate in PT with their troops build credibility and rapport that cannot be achieved through rank alone.\n\nThe mental benefits of physical training extend beyond the obvious physical improvements to include stress management, confidence, and discipline that transfer to other areas of military performance. Exercise reduces stress hormones and improves mood, helping personnel manage the psychological demands of military life. Achieving fitness goals builds confidence that personnel can overcome challenges through sustained effort. The discipline required to maintain fitness despite competing demands, fatigue, or lack of motivation develops the same discipline needed for professional military performance. Physical training teaches personnel to push through discomfort and continue functioning when their bodies want to quit—a mental skill directly applicable to combat. The holistic benefits of fitness programs make them force multipliers that improve readiness through multiple mechanisms simultaneously, justifying the significant time military organizations dedicate to physical training.\n\nWhat can be inferred from this passage?",
            options: ["Physical fitness tests are only about individual achievement", "Combat movements require specific physical capabilities", "Unit cohesion is more important than individual fitness", "Physical training is optional for service members"],
            correctAnswer: 1,
            explanation: "The passage states that fitness tests use 'exercises that simulate combat-related movements,' implying that combat requires specific physical capabilities that are being tested."
          },
          {
            id: 4,
            question: "Effective communication is vital in military operations where clarity can mean the difference between mission success and catastrophic failure. Military forces must coordinate complex activities across multiple units, often under extreme time pressure and in chaotic environments filled with noise, confusion, and danger. Clear, concise messages prevent misunderstandings that could endanger lives or compromise missions by ensuring everyone understands the plan, timing, and their specific responsibilities. Ambiguous orders create confusion that can result in friendly fire incidents, units failing to support each other at critical moments, or forces working at cross-purposes rather than in coordination. In combat, there are no opportunities to send follow-up emails clarifying what was meant—communication must be right the first time, or the consequences may be irreversible.\n\nRadio protocols ensure that information is transmitted accurately even in high-stress situations where personnel are fatigued, frightened, or distracted. Standard message formats provide structure that helps recipients capture essential information in the correct sequence. Phonetic alphabets eliminate confusion between similar-sounding letters. Brevity codes convey complex information in just a few words, reducing transmission time and limiting opportunities for enemy interception. Radio procedures like call signs, authentication, and confirmations ensure messages reach intended recipients and are not enemy deception. These protocols are practiced repeatedly during training until they become automatic, allowing personnel to communicate effectively even when exhausted or under fire. The discipline of radio procedures also maintains security by preventing inadvertent transmission of sensitive information that enemies could exploit.\n\nLeaders must verify that their orders are understood by having subordinates repeat back key details, employing a simple but effective technique that catches miscommunication before it causes problems. This backbrief or readback process requires subordinates to paraphrase what they understood, allowing leaders to immediately correct any misunderstandings. Simply asking 'do you understand?' is insufficient because subordinates may think they understand when they actually missed critical details, or may be reluctant to admit confusion. By having subordinates explain their understanding, leaders can assess whether communication was effective and provide clarification if needed. This practice is especially important for complex orders involving coordination between multiple elements, precise timing, or dangerous activities where mistakes could be fatal. The few seconds required for confirmation can prevent hours of confusion or casualties from misunderstood orders, making it an essential leadership practice in all military operations.\n\nWhat is the author's primary purpose?",
            options: ["To explain radio operation procedures", "To emphasize the importance of communication in military settings", "To describe military hierarchy", "To teach stress management techniques"],
            correctAnswer: 1,
            explanation: "The passage focuses on explaining why effective communication is vital in military operations and how various practices ensure clear communication."
          },
          {
            id: 5,
            question: "Cyber security has become a critical concern for modern military forces as operations have become increasingly dependent on networked digital systems. Contemporary military effectiveness relies on command and control networks, precision weapons with digital targeting, communications satellites, logistics databases, intelligence systems, and countless other technologies that function through interconnected computers. As technology advances, adversaries increasingly target digital infrastructure and communication networks, recognizing that cyberattacks can disable or disrupt military capabilities without firing a shot. Nation-states and sophisticated non-state actors have developed cyber capabilities that can penetrate networks to steal classified information, plant malware for later activation, manipulate data to cause confusion, or conduct denial-of-service attacks that overwhelm systems. A successful cyberattack could compromise an entire military operation by revealing plans, disabling communications, or providing false intelligence.\n\nMilitary cyber professionals work to protect sensitive information and maintain operational security against these diverse and evolving threats. This includes monitoring for threats by analyzing network traffic for suspicious patterns, implementing security protocols such as strong encryption and multi-factor authentication, and responding to breaches by isolating affected systems and eliminating malware. Cyber defense requires constant vigilance because adversaries continuously probe for vulnerabilities and adapt their tactics when defenses improve. Military networks face attempted intrusions daily from various sources ranging from opportunistic criminals to sophisticated intelligence services. Cyber professionals must stay current with emerging threats, apply security patches promptly, train personnel in cyber hygiene, and conduct exercises to practice incident response. The challenge is compounded by the need to balance security with operational usability—overly restrictive security measures can hinder mission execution as much as inadequate security.\n\nThe cyber domain is now considered as important as traditional land, sea, and air domains, representing a fundamental shift in military thinking about the nature of warfare. Where military operations were once understood primarily in terms of physical domains, cyber now stands alongside them as a distinct domain where conflicts occur and advantages must be secured. Military forces establish cyber commands with missions to defend networks, conduct offensive cyber operations against adversaries, and integrate cyber capabilities with traditional military operations. Attacks in cyberspace can have effects in physical domains, such as disabling electrical grids or manipulating weapons systems. Conversely, physical operations may target cyber infrastructure such as communications nodes or data centers. This recognition of cyber as a peer domain shapes force structure, resource allocation, professional education, and operational planning across all military services, ensuring that cyber considerations are integrated into all aspects of military operations rather than treated as a technical specialty separate from warfighting.\n\nAccording to the passage, how has military thinking about cyber security changed?",
            options: ["It is no longer a concern", "It is now considered equal to traditional military domains", "It has replaced traditional military operations", "It is only used for communication"],
            correctAnswer: 1,
            explanation: "The passage explicitly states that 'the cyber domain is now considered as important as traditional land, sea, and air domains,' indicating a shift to viewing it as equally important."
          }
        ]
      },
      {
        id: 5,
        name: "Mathematics Knowledge (MK)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "If 3x + 7 = 28, what is the value of x?",
            options: ["5", "7", "9", "11"],
            correctAnswer: 1,
            explanation: "Solve for x: 3x + 7 = 28. Subtract 7 from both sides: 3x = 21. Divide both sides by 3: x = 7."
          },
          {
            id: 2,
            question: "What is the area of a triangle with a base of 12 inches and a height of 8 inches?",
            options: ["48 square inches", "96 square inches", "20 square inches", "40 square inches"],
            correctAnswer: 0,
            explanation: "Area of a triangle = (1/2) × base × height = (1/2) × 12 × 8 = 48 square inches."
          },
          {
            id: 3,
            question: "What is the value of 2³ × 2²?",
            options: ["32", "64", "128", "16"],
            correctAnswer: 0,
            explanation: "When multiplying powers with the same base, add the exponents: 2³ × 2² = 2⁵ = 32."
          },
          {
            id: 4,
            question: "If a circle has a diameter of 14 feet, what is its circumference? (Use π = 3.14)",
            options: ["43.96 feet", "87.92 feet", "153.86 feet", "21.98 feet"],
            correctAnswer: 0,
            explanation: "Circumference = π × diameter = 3.14 × 14 = 43.96 feet."
          },
          {
            id: 5,
            question: "What is the slope of a line passing through points (2, 5) and (6, 13)?",
            options: ["2", "4", "1/2", "8"],
            correctAnswer: 0,
            explanation: "Slope = (y₂ - y₁) / (x₂ - x₁) = (13 - 5) / (6 - 2) = 8 / 4 = 2."
          }
        ]
      },
      {
        id: 6,
        name: "Electronics Information (EI)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "What is the unit of measurement for electrical resistance?",
            options: ["Volts", "Amperes", "Ohms", "Watts"],
            correctAnswer: 2,
            explanation: "Resistance is measured in ohms (Ω). It represents the opposition to current flow in an electrical circuit."
          },
          {
            id: 2,
            question: "In a parallel circuit with two resistors, what happens to the total resistance compared to the individual resistors?",
            options: ["It increases", "It stays the same", "It decreases", "It doubles"],
            correctAnswer: 2,
            explanation: "In a parallel circuit, the total resistance is always less than the smallest individual resistor because current has multiple paths to flow through."
          },
          {
            id: 3,
            question: "What electronic component stores electrical charge?",
            options: ["Resistor", "Capacitor", "Inductor", "Transistor"],
            correctAnswer: 1,
            explanation: "A capacitor stores electrical energy in an electric field between two conductive plates. It can charge and discharge rapidly."
          },
          {
            id: 4,
            question: "If a circuit has 24 volts and 6 ohms of resistance, what is the current flow? (Use Ohm's Law: I = V/R)",
            options: ["2 amperes", "4 amperes", "6 amperes", "144 amperes"],
            correctAnswer: 1,
            explanation: "Using Ohm's Law: I = V/R = 24 volts / 6 ohms = 4 amperes."
          },
          {
            id: 5,
            question: "What does AC stand for in electrical terms?",
            options: ["Additional Current", "Alternating Current", "Active Current", "Automatic Current"],
            correctAnswer: 1,
            explanation: "AC stands for Alternating Current, which is electrical current that reverses direction periodically. This is the type of electricity supplied to homes and buildings."
          }
        ]
      },
      {
        id: 7,
        name: "Auto & Shop Information (AS)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "What is the primary purpose of a vehicle's alternator?",
            options: ["To start the engine", "To charge the battery and power electrical systems", "To cool the engine", "To filter the fuel"],
            correctAnswer: 1,
            explanation: "The alternator converts mechanical energy from the engine into electrical energy to charge the battery and power the vehicle's electrical systems while the engine is running."
          },
          {
            id: 2,
            question: "Which tool is best suited for cutting metal pipes?",
            options: ["Coping saw", "Hacksaw", "Crosscut saw", "Keyhole saw"],
            correctAnswer: 1,
            explanation: "A hacksaw has fine teeth and a rigid blade designed specifically for cutting metal, including pipes, rods, and other metal materials."
          },
          {
            id: 3,
            question: "What does a torque wrench measure?",
            options: ["The length of a bolt", "The rotational force applied to a fastener", "The speed of rotation", "The thread pitch"],
            correctAnswer: 1,
            explanation: "A torque wrench measures and applies a specific amount of rotational force (torque) to fasteners like bolts and nuts, ensuring they are tightened to the correct specification."
          },
          {
            id: 4,
            question: "What is the purpose of engine coolant?",
            options: ["To lubricate engine parts", "To clean the fuel system", "To absorb and transfer heat away from the engine", "To improve fuel efficiency"],
            correctAnswer: 2,
            explanation: "Engine coolant (antifreeze) circulates through the engine to absorb heat and transfer it to the radiator, preventing the engine from overheating and protecting against freezing."
          },
          {
            id: 5,
            question: "Which grade of sandpaper has the finest grit?",
            options: ["40-grit", "80-grit", "120-grit", "220-grit"],
            correctAnswer: 3,
            explanation: "Higher numbers indicate finer grit. 220-grit sandpaper is finer than the other options and is used for finish sanding and smoothing surfaces."
          }
        ]
      },
      {
        id: 8,
        name: "Mechanical Comprehension (MC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "If a lever has a fulcrum closer to the load than to the effort, what is the mechanical advantage?",
            options: ["Less than 1", "Equal to 1", "Greater than 1", "Cannot be determined"],
            correctAnswer: 2,
            explanation: "When the fulcrum is closer to the load (resistance) than to the effort, the effort arm is longer than the load arm, creating a mechanical advantage greater than 1, meaning less force is needed to lift the load."
          },
          {
            id: 2,
            question: "Two gears are meshed together. If gear A has 20 teeth and rotates at 100 RPM, and gear B has 40 teeth, at what speed does gear B rotate?",
            options: ["200 RPM", "100 RPM", "50 RPM", "25 RPM"],
            correctAnswer: 2,
            explanation: "Gear ratio = teeth of driven gear / teeth of driving gear = 40/20 = 2. Speed of gear B = 100 RPM / 2 = 50 RPM. The larger gear rotates slower."
          },
          {
            id: 3,
            question: "What happens to the pressure in a hydraulic system when force is applied to a small piston?",
            options: ["It decreases throughout the system", "It stays constant only at the small piston", "It increases equally throughout the system", "It only affects the large piston"],
            correctAnswer: 2,
            explanation: "According to Pascal's Law, pressure applied to a confined fluid is transmitted equally in all directions throughout the fluid. This principle enables hydraulic systems to multiply force."
          },
          {
            id: 4,
            question: "A wheel and axle system has a wheel diameter of 24 inches and an axle diameter of 4 inches. What is the mechanical advantage?",
            options: ["2", "4", "6", "8"],
            correctAnswer: 2,
            explanation: "Mechanical advantage = radius of wheel / radius of axle = 12 inches / 2 inches = 6. The larger wheel provides 6 times the mechanical advantage."
          },
          {
            id: 5,
            question: "If a block is resting on an inclined plane, what force primarily determines whether it will slide down?",
            options: ["Magnetic force", "Component of gravity parallel to the plane", "Air resistance", "Centripetal force"],
            correctAnswer: 1,
            explanation: "On an inclined plane, gravity can be resolved into two components: one perpendicular to the plane (normal force) and one parallel to the plane. The parallel component is what causes the object to slide down."
          }
        ]
      },
      {
        id: 9,
        name: "Assembling Objects (AO)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "If a rectangular piece of paper is folded in half twice (first horizontally, then vertically), and a corner is cut off, what pattern will appear when unfolded?",
            options: ["One hole", "Two holes", "Four holes in a symmetric pattern", "Eight holes"],
            correctAnswer: 2,
            explanation: "Folding twice creates four layers. Cutting through all layers creates four holes that appear symmetrically when the paper is unfolded."
          },
          {
            id: 2,
            question: "Which three-dimensional shape is formed when a semicircle is rotated 360 degrees around its diameter?",
            options: ["Cylinder", "Sphere", "Cone", "Torus"],
            correctAnswer: 1,
            explanation: "Rotating a semicircle around its diameter (the straight edge) creates a sphere, as every point on the curved edge traces a circular path."
          },
          {
            id: 3,
            question: "If you have a cube and remove a smaller cube from one corner, how many edges does the resulting shape have?",
            options: ["12", "15", "18", "21"],
            correctAnswer: 2,
            explanation: "A cube has 12 edges. Removing a corner cube creates 6 new edges (3 edges for each of the two new corner vertices), resulting in 12 + 6 = 18 edges."
          },
          {
            id: 4,
            question: "Two identical right triangles can be combined to form which shape?",
            options: ["Pentagon", "Hexagon", "Rectangle or parallelogram", "Circle"],
            correctAnswer: 2,
            explanation: "Two identical right triangles can be combined along their hypotenuse to form a rectangle, or along one of their legs to form a parallelogram or larger triangle."
          },
          {
            id: 5,
            question: "If point X on shape A must connect to point Y on shape B, and shape A must be rotated 270 degrees clockwise to align, which direction is that rotation equivalent to?",
            options: ["90 degrees clockwise", "180 degrees", "90 degrees counterclockwise", "360 degrees"],
            correctAnswer: 2,
            explanation: "A 270-degree clockwise rotation is equivalent to a 90-degree counterclockwise rotation, as they result in the same final position (360 - 270 = 90)."
          }
        ]
      },
      {
        id: 10,
        name: "Verbal Expression (VE)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Choose the sentence with correct grammar:",
            options: ["Between you and I, this mission is critical.", "Between you and me, this mission is critical.", "Between yourself and I, this mission is critical.", "Between you and myself, this mission is critical."],
            correctAnswer: 1,
            explanation: "After the preposition 'between,' use object pronouns. 'Me' is the correct object pronoun, not 'I' (which is a subject pronoun)."
          },
          {
            id: 2,
            question: "Which sentence demonstrates correct use of 'who' vs 'whom'?",
            options: ["Who should I report to?", "Whom should I report to?", "Who should report to I?", "Whom is in charge?"],
            correctAnswer: 1,
            explanation: "'Whom' is correct because it is the object of the preposition 'to.' Use 'whom' when it can be replaced by 'him/her' (To whom = to him)."
          },
          {
            id: 3,
            question: "Identify the sentence with correct parallel structure:",
            options: ["The training includes running, to swim, and hiking.", "The training includes running, swimming, and to hike.", "The training includes running, swimming, and hiking.", "The training includes to run, swimming, and hiking."],
            correctAnswer: 2,
            explanation: "Parallel structure requires consistent grammatical form. All three activities should use the -ing form (gerunds): running, swimming, and hiking."
          },
          {
            id: 4,
            question: "Which sentence uses the semicolon correctly?",
            options: ["The mission was successful; because we followed the plan.", "The mission was successful; we followed the plan carefully.", "The mission; was successful we followed the plan.", "The mission was; successful, we followed the plan."],
            correctAnswer: 1,
            explanation: "A semicolon connects two independent clauses that are closely related. Both 'The mission was successful' and 'we followed the plan carefully' are complete sentences that can stand alone."
          },
          {
            id: 5,
            question: "Choose the sentence that correctly uses 'its' vs 'it's':",
            options: ["The unit completed it's training ahead of schedule.", "Its important that the unit completes its training.", "It's important that the unit completes its training.", "Its important that the unit completes it's training."],
            correctAnswer: 2,
            explanation: "'It's' (with apostrophe) means 'it is' or 'it has.' 'Its' (without apostrophe) is the possessive form. The sentence should read: 'It is important that the unit completes its training.'"
          }
        ]
      }
    ]
  },,
  {
    id: 9,
    title: "ASVAB Practice Test #9",
    description: "Comprehensive practice exam covering all 10 ASVAB sections with military-standard questions",
    totalQuestions: 50,
    timeLimit: 60,
    sections: [
      {
        id: 1,
        name: "General Science (GS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What type of celestial body is the Sun classified as?",
            options: ["Planet", "Main sequence star", "Red giant", "White dwarf"],
            correctAnswer: 1,
            explanation: "The Sun is a main sequence star, which means it fuses hydrogen into helium in its core. It's in the middle of its stellar lifecycle."
          },
          {
            id: 2,
            question: "Which vitamin is produced when skin is exposed to sunlight?",
            options: ["Vitamin A", "Vitamin C", "Vitamin D", "Vitamin K"],
            correctAnswer: 2,
            explanation: "Vitamin D is synthesized in the skin when exposed to UVB radiation from sunlight. It's essential for calcium absorption and bone health."
          },
          {
            id: 3,
            question: "What is the term for animals that are active during twilight hours?",
            options: ["Diurnal", "Nocturnal", "Crepuscular", "Cathemeral"],
            correctAnswer: 2,
            explanation: "Crepuscular animals are most active during dawn and dusk. Examples include deer, rabbits, and many species of bats."
          },
          {
            id: 4,
            question: "Which part of the brain controls balance and coordination?",
            options: ["Cerebrum", "Cerebellum", "Medulla oblongata", "Hypothalamus"],
            correctAnswer: 1,
            explanation: "The cerebellum, located at the back of the brain, coordinates voluntary movements, balance, and posture."
          },
          {
            id: 5,
            question: "What happens to air pressure as altitude increases?",
            options: ["It increases", "It decreases", "It stays the same", "It fluctuates randomly"],
            correctAnswer: 1,
            explanation: "Air pressure decreases with altitude because there is less atmosphere above you pressing down. This is why pressurized cabins are needed in aircraft."
          }
        ]
      },
      {
        id: 2,
        name: "Arithmetic Reasoning (AR)",
        timeLimit: 8,
        questions: [
          {
            id: 1,
            question: "A soldier runs 3 miles in 24 minutes. At this pace, how long will it take to run 5 miles?",
            options: ["36 minutes", "40 minutes", "42 minutes", "45 minutes"],
            correctAnswer: 1,
            explanation: "Pace per mile: 24 ÷ 3 = 8 minutes per mile. For 5 miles: 8 × 5 = 40 minutes"
          },
          {
            id: 2,
            question: "A warehouse has 840 boxes. If 30% are shipped on Monday and 40% of the remaining boxes on Tuesday, how many boxes are left?",
            options: ["352 boxes", "420 boxes", "504 boxes", "588 boxes"],
            correctAnswer: 0,
            explanation: "Monday: 30% of 840 = 252 shipped. Remaining: 840 - 252 = 588. Tuesday: 40% of 588 = 235.2 (236) shipped. Final: 588 - 236 = 352 boxes"
          },
          {
            id: 3,
            question: "A military unit needs to divide $4,500 equally among 15 members. How much does each member receive?",
            options: ["$250", "$275", "$300", "$325"],
            correctAnswer: 2,
            explanation: "$4,500 ÷ 15 = $300 per member"
          },
          {
            id: 4,
            question: "If a truck uses 18 gallons of fuel to travel 270 miles, how many gallons are needed for 450 miles?",
            options: ["27 gallons", "30 gallons", "33 gallons", "36 gallons"],
            correctAnswer: 1,
            explanation: "Fuel efficiency: 270 ÷ 18 = 15 miles per gallon. For 450 miles: 450 ÷ 15 = 30 gallons"
          },
          {
            id: 5,
            question: "A training course costs $1,200. If the price increases by 15%, what is the new cost?",
            options: ["$1,320", "$1,350", "$1,380", "$1,400"],
            correctAnswer: 2,
            explanation: "Increase: 15% of $1,200 = $180. New cost: $1,200 + $180 = $1,380"
          }
        ]
      },
      {
        id: 3,
        name: "Word Knowledge (WK)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "Vigilant most nearly means:",
            options: ["Careless", "Watchful", "Aggressive", "Tired"],
            correctAnswer: 1,
            explanation: "Vigilant means being alert and watchful, especially for danger or problems. Essential quality for military personnel on duty."
          },
          {
            id: 2,
            question: "Fortify most nearly means:",
            options: ["Weaken", "Strengthen", "Abandon", "Attack"],
            correctAnswer: 1,
            explanation: "Fortify means to strengthen or reinforce, particularly in military contexts referring to defensive positions."
          },
          {
            id: 3,
            question: "Brevity most nearly means:",
            options: ["Length", "Confusion", "Conciseness", "Complexity"],
            correctAnswer: 2,
            explanation: "Brevity means expressing something in few words; conciseness. Important in military communications."
          },
          {
            id: 4,
            question: "Adversary most nearly means:",
            options: ["Ally", "Opponent", "Supporter", "Neutral party"],
            correctAnswer: 1,
            explanation: "An adversary is an opponent or enemy, someone who opposes or competes against you."
          },
          {
            id: 5,
            question: "Meticulous most nearly means:",
            options: ["Careless", "Fast", "Thorough", "Simple"],
            correctAnswer: 2,
            explanation: "Meticulous means showing great attention to detail; very careful and precise. Critical for technical military tasks."
          }
        ]
      },
      {
        id: 4,
        name: "Paragraph Comprehension (PC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Read the passage: 'Modern military operations rely heavily on satellite communications that have fundamentally transformed how forces coordinate and conduct operations across the globe. These systems provide real-time data transmission across vast distances, enabling coordination between units worldwide regardless of terrain, political boundaries, or atmospheric conditions. Satellites orbiting high above Earth can relay voice, video, and data communications between forces separated by thousands of miles, providing connectivity that would be impossible through terrestrial systems. They enable commanders to communicate directly with deployed forces, intelligence to flow rapidly from collection platforms to analysts to operational units, and precision weapons to receive targeting data from sensors on the other side of the world. The bandwidth and global coverage provided by military satellite communications are essential capabilities that no other technology can replicate.\n\nThe advantages of satellite communications extend beyond simply enabling long-range communications to include mobility, survivability, and flexibility that traditional systems cannot match. Ground-based communication infrastructure requires extensive physical networks that take years to build and can be easily damaged or destroyed. Mobile forces operating in austere environments often have no terrestrial communications available. Satellites provide communications anywhere on Earth, including over oceans, deserts, and mountain ranges where no infrastructure exists. Military satellite terminals can be deployed rapidly with expeditionary forces, providing immediate connectivity without waiting for infrastructure development. The survivability of satellites in space makes them difficult for adversaries to attack compared to vulnerable ground stations and cables. Satellites can be repositioned to provide coverage where needed, and new satellites can be launched to replace damaged ones or provide additional capacity.\n\nWithout satellites, modern warfare would be drastically different, requiring forces to operate with the limitations that constrained earlier generations before space-based systems became available. Long-range communications would be limited by line-of-sight constraints and the availability of relay stations. Commanders would lack the real-time situational awareness that satellites provide, making coordination of widely dispersed forces exponentially more difficult. Precision weapons would be far less effective without satellite guidance and targeting. Intelligence collection would be limited to what aircraft and ground sensors could provide without the persistent overhead coverage that satellites deliver. Navigation would rely on inertial systems without the precision that GPS provides. The modern military concept of network-centric warfare, where information flows freely between interconnected platforms and units, depends fundamentally on satellite communications as the backbone enabling that connectivity. As adversaries develop anti-satellite capabilities that threaten this critical infrastructure, militaries are working to make space systems more resilient and to develop backup capabilities, but satellites will remain essential to military operations for the foreseeable future.' What is the main idea?",
            options: ["Satellites are expensive", "Satellites enable modern military communications", "Warfare has changed over time", "Data transmission is difficult"],
            correctAnswer: 1,
            explanation: "The passage focuses on how satellite communications are essential for modern military operations and coordination."
          },
          {
            id: 2,
            question: "Read the passage: 'Physical fitness standards in the military serve multiple purposes beyond simply promoting general health and wellness. They ensure personnel can handle the demands of combat which often require extraordinary physical exertion while carrying heavy loads, wearing body armor, and operating in extreme environmental conditions. Combat operations may require soldiers to move rapidly across difficult terrain, engage in close combat, evacuate wounded personnel, or perform physically demanding tasks continuously for extended periods. Without adequate fitness, even highly trained and motivated personnel will be unable to execute these missions because their bodies will simply fail to perform when demanded. Fitness standards therefore directly support combat effectiveness by ensuring all personnel maintain the physical capacity necessary for military operations.\n\nPhysical fitness standards also reduce injury rates and maintain operational readiness by conditioning personnel to handle military activities safely. Service members who maintain good fitness levels experience fewer injuries during training and operations because their bodies are better prepared to handle physical stress. Strong muscles, bones, tendons, and ligaments are more resistant to the strains and impacts common in military activities. Good cardiovascular fitness enables personnel to sustain physical effort without exhaustion that can lead to accidents. Flexibility reduces the risk of strains and enables safe execution of complex movements. By preventing injuries that would remove personnel from duty, fitness standards maintain unit strength and readiness. Additionally, physically fit personnel recover more quickly from exertion and injuries when they do occur, returning to duty faster than those in poor condition. This readiness aspect of fitness is as important as the direct performance benefits.\n\nRegular fitness testing helps identify those who need additional training to meet standards before their inadequate fitness compromises missions or causes injuries. Testing provides objective measurement of fitness levels, ensuring accountability and highlighting individuals whose fitness has declined below acceptable levels. Those who fail tests receive focused remedial training programs designed to improve their specific deficiencies, whether cardiovascular endurance, strength, or flexibility. This systematic approach ensures problems are corrected before they impact operations. Testing also motivates personnel to maintain fitness between assessments, creating sustained fitness rather than episodic preparation before tests. The combination of clear standards, regular assessment, and remedial training for those falling short creates an effective system for maintaining force-wide physical readiness that is essential for military effectiveness.' What can be inferred?",
            options: ["Fitness tests are optional", "Only combat roles require fitness", "Fitness directly impacts military effectiveness", "Testing is done annually"],
            correctAnswer: 2,
            explanation: "The passage clearly connects physical fitness to combat capability, injury prevention, and readiness, showing its direct impact on effectiveness."
          },
          {
            id: 3,
            question: "Read the passage: 'Night vision technology has revolutionized military operations after dark by overcoming the fundamental limitation that darkness imposed on military forces throughout history. Before night vision, forces operating at night were severely constrained by their inability to see obstacles, threats, or targets effectively, making nighttime operations extremely risky and often impossible. Traditional solutions like illumination flares revealed friendly positions to enemies as much as they illuminated the battlefield. By amplifying available light or using thermal imaging, soldiers can see clearly in conditions that would otherwise leave them blind, transforming nighttime from a period of reduced activity into an opportunity for operations that exploit darkness while negating its traditional disadvantages.\n\nImage intensifier night vision devices amplify tiny amounts of ambient light from stars, moonlight, or infrared illuminators by tens of thousands of times to create visible green-tinted images. These systems collect photons entering the objective lens, convert them to electrons using a photocathode, multiply those electrons thousands of times through a microchannel plate, and then convert them back to visible light using a phosphor screen. This amplification process allows personnel to see clearly in conditions that appear completely dark to the unaided eye. Thermal imaging systems take a different approach, detecting infrared radiation emitted by objects based on their temperature rather than relying on reflected light. Thermal imagers create images where warmer objects appear brighter than cooler backgrounds, allowing detection of people, vehicles, and equipment by their heat signatures even in complete darkness or through smoke and light fog.\n\nThis advantage is often decisive in combat situations where forces equipped with night vision can operate effectively while adversaries without similar technology are functionally blind. Military operations are frequently planned for nighttime execution specifically to exploit night vision superiority, allowing friendly forces to move, navigate, acquire targets, and engage enemies with significantly reduced risk of detection compared to daylight operations. Many successful military operations have leveraged night vision capabilities to achieve surprise and overwhelm opponents who could not effectively respond to threats they could not see. The psychological impact of facing an enemy that can see you when you cannot see them is substantial, degrading the will to fight. As night vision technology has proliferated globally, maintaining technological superiority in night vision capabilities remains a priority for advanced militaries seeking to preserve their nighttime operational advantages.' According to the passage, night vision:",
            options: ["Creates artificial light", "Amplifies existing light", "Works only in total darkness", "Replaces thermal imaging"],
            correctAnswer: 1,
            explanation: "The passage specifically states that night vision amplifies available light or uses thermal imaging."
          },
          {
            id: 4,
            question: "Read the passage: 'Supply chain management in military logistics requires precise planning to ensure that the right materials arrive at the right place at the right time in the right quantities. The complexity of military supply chains is staggering, with thousands of different items ranging from common consumables like food and fuel to specialized components for complex weapons systems. Each item must be forecasted, procured, stored, transported, and distributed through multiple echelons from strategic depots to forward tactical units. A single missing component can ground an entire aircraft fleet or disable critical vehicles, illustrating the vulnerability created by the interconnected nature of military equipment. If a specific replacement part is unavailable, highly capable systems become inoperable regardless of how many other components function perfectly. This dependency means that logistics failures can negate technological advantages and render expensive equipment useless.\n\nThe consequences of supply chain failures extend beyond inconvenience to directly impact military effectiveness and potentially cause mission failure. Combat operations consume vast quantities of supplies at rates that can quickly exhaust stockpiles if resupply systems fail. Ammunition, fuel, spare parts, food, water, and medical supplies must flow continuously to forward units to sustain operations. When supply chains break down, units face difficult choices between continuing operations unsupported or pausing to await resupply, both potentially compromising missions. Medical evacuation and treatment depend on logistics to function, meaning supply failures can cost lives beyond their operational impacts. Historical examples abound of military forces that failed not because they were defeated tactically but because logistics could not sustain their operations. Napoleon's invasion of Russia failed largely due to overextended supply lines that could not support his army. Modern militaries are even more dependent on complex supply chains that provide the fuel, ammunition, and spare parts that technologically advanced forces require.\n\nRedundancy and careful inventory tracking are essential to maintain operational capability despite the inherent vulnerabilities of supply chains. Redundancy means maintaining multiple sources for critical items, backup transportation modes, and reserve stockpiles that provide buffers against disruptions. If a primary supplier cannot deliver, alternative sources can fill the gap. If one transportation route is blocked, alternatives can be used. Reserve stocks allow operations to continue while supply problems are resolved. Inventory tracking systems provide visibility over what materials are available at each location, what is in transit, and what needs to be ordered, enabling informed decisions about allocation and preventing both shortages and wasteful oversupply. Modern military supply chains use sophisticated information systems that track items from manufacture through distribution to consumption, providing the transparency necessary for effective management of these complex networks. Despite best efforts, supply chains remain vulnerable to disruption from enemy action, weather, accidents, and myriad other causes, making supply chain management a continuous challenge that requires constant attention from professional logisticians.' What is the author's purpose?",
            options: ["To criticize military spending", "To explain the importance of military logistics", "To describe aircraft maintenance", "To compare military and civilian supply chains"],
            correctAnswer: 1,
            explanation: "The author explains how crucial proper logistics and supply chain management are to military operations."
          },
          {
            id: 5,
            question: "Read the passage: 'Leadership in the military goes beyond giving orders and relying on rank authority to compel obedience. While rank provides the legal authority to issue commands and expect compliance, true leadership requires building willing commitment and inspiring personnel to perform at their highest level rather than merely meeting minimum standards. Effective leaders inspire confidence in their subordinates through consistent demonstration of competence, integrity, and commitment to mission accomplishment. When personnel have confidence in their leaders, they follow willingly into difficult and dangerous situations because they trust that their leaders will make sound decisions and not waste their lives carelessly. This confidence is built gradually through leaders' actions over time and can be destroyed instantly by poor decisions or betrayals of trust.\n\nEffective military leaders make sound decisions under pressure despite uncertainty, time constraints, and high stakes that can mean the difference between mission success and failure or between life and death for subordinates. The ability to process complex information rapidly, assess risks, consider alternatives, and commit decisively to a course of action is essential in military contexts where delay can be as dangerous as wrong decisions. Leaders must balance competing priorities such as mission accomplishment versus force protection, speed versus security, and tactical gains versus strategic implications. They must make decisions with imperfect information because waiting for complete information is rarely possible in military operations. The weight of responsibility—knowing that decisions will determine outcomes and casualties—adds emotional stress to the cognitive challenge. Strong leaders develop judgment through training and experience that enables them to make good decisions even under extreme pressure.\n\nEffective leaders also prioritize the welfare of their personnel, recognizing that taking care of subordinates is both a moral obligation and a practical necessity for maintaining unit effectiveness. Leaders who demonstrate genuine concern for their personnel through actions—ensuring they have necessary resources, protecting them from unnecessary risks, supporting their professional development, and caring for their families—earn loyalty that cannot be commanded through rank alone. This does not mean avoiding necessary risks or making decisions based solely on what subordinates want, but rather demonstrating through consistent actions that personnel welfare is a priority consideration in all decisions. These qualities cannot be taught solely through classroom instruction; they develop through experience and mentorship as junior leaders learn from observing senior leaders, receiving feedback on their own leadership attempts, and gradually building the judgment and skills that effective leadership requires. Leadership development is thus a career-long process rather than something achieved through a course or promotion.' Which statement is NOT supported?",
            options: ["Leadership requires more than giving orders", "Classroom training alone is insufficient", "Leaders must care about their personnel", "All leadership qualities are innate"],
            correctAnswer: 3,
            explanation: "The passage states leadership qualities develop through experience and mentorship, not that they are all innate or inborn."
          }
        ]
      },
      {
        id: 5,
        name: "Mathematics Knowledge (MK)",
        timeLimit: 8,
        questions: [
          {
            id: 1,
            question: "Solve for x: 3x - 7 = 20",
            options: ["x = 7", "x = 8", "x = 9", "x = 10"],
            correctAnswer: 2,
            explanation: "3x - 7 = 20. Add 7 to both sides: 3x = 27. Divide by 3: x = 9"
          },
          {
            id: 2,
            question: "What is the area of a circle with radius 6 cm? (Use π ≈ 3.14)",
            options: ["113.04 cm²", "37.68 cm²", "18.84 cm²", "226.08 cm²"],
            correctAnswer: 0,
            explanation: "Area = πr² = 3.14 × 6² = 3.14 × 36 = 113.04 cm²"
          },
          {
            id: 3,
            question: "What is 35% of 240?",
            options: ["78", "84", "90", "96"],
            correctAnswer: 1,
            explanation: "35% of 240 = 0.35 × 240 = 84"
          },
          {
            id: 4,
            question: "If a triangle has angles measuring 45° and 65°, what is the measure of the third angle?",
            options: ["60°", "70°", "80°", "90°"],
            correctAnswer: 1,
            explanation: "The sum of angles in a triangle is 180°. Third angle = 180° - 45° - 65° = 70°"
          },
          {
            id: 5,
            question: "Simplify: (x³)⁴",
            options: ["x⁷", "x¹²", "x⁶⁴", "4x³"],
            correctAnswer: 1,
            explanation: "When raising a power to a power, multiply the exponents: (x³)⁴ = x³ˣ⁴ = x¹²"
          }
        ]
      },
      {
        id: 6,
        name: "Electronics Information (EI)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "What is the purpose of a capacitor in an electronic circuit?",
            options: ["To amplify current", "To store electrical energy", "To convert AC to DC", "To measure voltage"],
            correctAnswer: 1,
            explanation: "A capacitor stores electrical energy in an electric field between two conductive plates separated by an insulating material."
          },
          {
            id: 2,
            question: "In a series circuit with three 60-ohm resistors, what is the total resistance?",
            options: ["20 ohms", "60 ohms", "120 ohms", "180 ohms"],
            correctAnswer: 3,
            explanation: "In a series circuit, total resistance equals the sum of all resistances: 60 + 60 + 60 = 180 ohms"
          },
          {
            id: 3,
            question: "What type of current does a battery produce?",
            options: ["Alternating current (AC)", "Direct current (DC)", "Pulsating current", "Radio frequency current"],
            correctAnswer: 1,
            explanation: "Batteries produce direct current (DC), which flows in one constant direction, unlike alternating current which reverses direction."
          },
          {
            id: 4,
            question: "What happens to current in a circuit if voltage increases and resistance stays constant?",
            options: ["Current decreases", "Current increases", "Current stays the same", "Current becomes zero"],
            correctAnswer: 1,
            explanation: "According to Ohm's Law (V = IR), if voltage increases and resistance is constant, current must increase proportionally."
          },
          {
            id: 5,
            question: "What is the primary function of a transistor?",
            options: ["To store energy", "To amplify or switch electronic signals", "To measure temperature", "To convert light to electricity"],
            correctAnswer: 1,
            explanation: "Transistors are semiconductor devices used to amplify or switch electronic signals and electrical power in circuits."
          }
        ]
      },
      {
        id: 7,
        name: "Auto & Shop Information (AS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What tool would be best for cutting a curved line in a piece of wood?",
            options: ["Circular saw", "Jigsaw", "Table saw", "Hand plane"],
            correctAnswer: 1,
            explanation: "A jigsaw is designed for cutting curves and irregular shapes in wood, metal, and other materials."
          },
          {
            id: 2,
            question: "What is the purpose of engine coolant in a vehicle?",
            options: ["To lubricate the engine", "To clean the fuel system", "To prevent the engine from overheating", "To improve fuel efficiency"],
            correctAnswer: 2,
            explanation: "Engine coolant (antifreeze) circulates through the engine to absorb heat and prevent overheating, while also preventing freezing in cold weather."
          },
          {
            id: 3,
            question: "Which type of screwdriver has a star-shaped tip?",
            options: ["Phillips", "Flathead", "Torx", "Robertson"],
            correctAnswer: 2,
            explanation: "Torx screwdrivers have a 6-point star-shaped tip, designed for high torque applications and commonly used in automotive work."
          },
          {
            id: 4,
            question: "What automotive component converts the engine's mechanical energy into electrical energy?",
            options: ["Battery", "Starter", "Alternator", "Distributor"],
            correctAnswer: 2,
            explanation: "The alternator converts mechanical energy from the engine into electrical energy to charge the battery and power electrical systems while the engine runs."
          },
          {
            id: 5,
            question: "What is the purpose of sandpaper grit numbers?",
            options: ["To indicate the price", "To show the size of abrasive particles", "To identify the manufacturer", "To specify the paper thickness"],
            correctAnswer: 1,
            explanation: "Grit numbers indicate the size of abrasive particles on sandpaper. Lower numbers (coarse) have larger particles; higher numbers (fine) have smaller particles."
          }
        ]
      },
      {
        id: 8,
        name: "Mechanical Comprehension (MC)",
        timeLimit: 10,
        questions: [
          {
            id: 1,
            question: "A wheelbarrow is an example of which class of lever?",
            options: ["First class", "Second class", "Third class", "Not a lever"],
            correctAnswer: 1,
            explanation: "A wheelbarrow is a second-class lever where the load is between the fulcrum (wheel) and the effort (handles)."
          },
          {
            id: 2,
            question: "If two gears are meshed together and the driving gear has 20 teeth while the driven gear has 40 teeth, what is the speed ratio?",
            options: ["1:2 (driven turns slower)", "2:1 (driven turns faster)", "1:1 (same speed)", "3:1 (driven turns faster)"],
            correctAnswer: 0,
            explanation: "The driven gear has twice as many teeth, so it turns at half the speed of the driving gear, giving a 1:2 ratio."
          },
          {
            id: 3,
            question: "What happens to the pressure in a fluid when it flows from a wide pipe into a narrow pipe?",
            options: ["Pressure increases", "Pressure decreases", "Pressure stays the same", "Pressure becomes zero"],
            correctAnswer: 1,
            explanation: "According to Bernoulli's principle, as fluid velocity increases in a narrower pipe, pressure decreases."
          },
          {
            id: 4,
            question: "Which simple machine is a doorknob an example of?",
            options: ["Lever", "Pulley", "Wheel and axle", "Inclined plane"],
            correctAnswer: 2,
            explanation: "A doorknob is a wheel and axle where the knob (wheel) turns a smaller shaft (axle) that retracts the latch."
          },
          {
            id: 5,
            question: "If a 150-pound person stands on a platform 4 feet from the fulcrum, how much weight is needed 6 feet on the other side to balance?",
            options: ["75 pounds", "100 pounds", "150 pounds", "225 pounds"],
            correctAnswer: 1,
            explanation: "For balance, moments must be equal: 150 × 4 = 600. On the other side: 600 ÷ 6 = 100 pounds needed."
          }
        ]
      },
      {
        id: 9,
        name: "Assembling Objects (AO)",
        timeLimit: 5,
        questions: [
          {
            id: 1,
            question: "If a flat pattern shows a rectangle with semicircles attached to two opposite sides, what 3D shape is formed when assembled?",
            options: ["Sphere", "Cylinder", "Cone", "Cube"],
            correctAnswer: 1,
            explanation: "A rectangle with semicircles on opposite sides forms a cylinder when the rectangle is rolled and the semicircles form the circular ends."
          },
          {
            id: 2,
            question: "Which orientation connects point A on shape 1 to point B on shape 2 when shape 2 is rotated 270° clockwise?",
            options: ["Horizontal alignment", "Vertical alignment", "Diagonal alignment", "No connection possible"],
            correctAnswer: 1,
            explanation: "A 270° clockwise rotation (or 90° counterclockwise) typically results in vertical alignment of connection points."
          },
          {
            id: 3,
            question: "Three equilateral triangles can be assembled to form which shape?",
            options: ["Square", "Pentagon", "Trapezoid", "Hexagon"],
            correctAnswer: 2,
            explanation: "Three equilateral triangles arranged properly can form a trapezoid shape."
          },
          {
            id: 4,
            question: "If you unfold a cube, which net pattern is NOT possible?",
            options: ["A cross shape with 4 squares in a row and 1 square on each side", "Six squares in a straight line", "An L-shape pattern", "A T-shape pattern"],
            correctAnswer: 1,
            explanation: "Six squares in a straight line cannot fold into a cube because opposite faces would overlap. A cube net requires proper arrangement."
          },
          {
            id: 5,
            question: "Looking at an object from the side shows a rectangle. From the top it shows a circle. What is the object?",
            options: ["Sphere", "Cube", "Cylinder", "Cone"],
            correctAnswer: 2,
            explanation: "A cylinder appears as a rectangle from the side view and a circle from the top or bottom view."
          }
        ]
      },
      {
        id: 10,
        name: "Verbal Expression (VE)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Choose the sentence with correct grammar:",
            options: ["Between you and I, the mission was challenging.", "Between you and me, the mission was challenging.", "Between you and myself, the mission was challenging.", "Between yourself and I, the mission was challenging."],
            correctAnswer: 1,
            explanation: "After the preposition 'between,' use object pronouns. 'Me' is correct, not the subject pronoun 'I' or reflexive 'myself.'"
          },
          {
            id: 2,
            question: "Which word best completes the sentence: 'The new recruits were _____ to adapt quickly to military life.'",
            options: ["eager", "anxious", "reluctant", "hesitant"],
            correctAnswer: 0,
            explanation: "'Eager' means enthusiastic and willing, which is the most positive and appropriate term for motivated recruits."
          },
          {
            id: 3,
            question: "Identify the sentence with a misplaced modifier:",
            options: ["Walking to the barracks, the sunset was beautiful.", "The soldier saw a beautiful sunset while walking to the barracks.", "While walking to the barracks, the soldier saw a beautiful sunset.", "The soldier, walking to the barracks, saw a beautiful sunset."],
            correctAnswer: 0,
            explanation: "In the first sentence, 'walking to the barracks' incorrectly modifies 'sunset' instead of the soldier. Sunsets don't walk."
          },
          {
            id: 4,
            question: "Which sentence uses parallel structure correctly?",
            options: ["The mission requires planning, execution, and to evaluate results.", "The mission requires planning, executing, and evaluation.", "The mission requires planning, execution, and evaluation.", "The mission requires to plan, execution, and evaluating."],
            correctAnswer: 2,
            explanation: "Parallel structure uses the same grammatical form. All three items should be nouns: planning, execution, and evaluation."
          },
          {
            id: 5,
            question: "Choose the correct use of the semicolon:",
            options: ["The squad trained hard; because they wanted to succeed.", "The squad trained hard; they wanted to succeed.", "The squad trained hard; and they wanted to succeed.", "The squad trained; hard because they wanted to succeed."],
            correctAnswer: 1,
            explanation: "A semicolon joins two independent clauses without a conjunction. 'The squad trained hard' and 'they wanted to succeed' are both complete sentences."
          }
        ]
      }
    ]
  },,
  {
    id: 10,
    title: "ASVAB Practice Test #10",
    description: "Comprehensive practice exam covering all 10 ASVAB sections with military-standard questions",
    totalQuestions: 50,
    timeLimit: 60,
    sections: [
      {
        id: 1,
        name: "General Science (GS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What is the powerhouse of the cell that produces ATP?",
            options: ["Nucleus", "Mitochondria", "Ribosome", "Golgi apparatus"],
            correctAnswer: 1,
            explanation: "Mitochondria are membrane-bound organelles that generate most of the cell's ATP through cellular respiration, earning them the title 'powerhouse of the cell.'"
          },
          {
            id: 2,
            question: "Which layer of Earth's atmosphere contains the ozone layer?",
            options: ["Troposphere", "Stratosphere", "Mesosphere", "Thermosphere"],
            correctAnswer: 1,
            explanation: "The stratosphere contains the ozone layer, which absorbs most of the Sun's harmful ultraviolet radiation and protects life on Earth."
          },
          {
            id: 3,
            question: "What term describes an organism that makes its own food through photosynthesis?",
            options: ["Herbivore", "Carnivore", "Producer", "Decomposer"],
            correctAnswer: 2,
            explanation: "Producers (autotrophs) create their own food through photosynthesis, converting sunlight into chemical energy. Plants, algae, and some bacteria are producers."
          },
          {
            id: 4,
            question: "Which type of energy is stored in a stretched rubber band?",
            options: ["Kinetic energy", "Thermal energy", "Potential energy", "Chemical energy"],
            correctAnswer: 2,
            explanation: "Elastic potential energy is stored in stretched or compressed objects like rubber bands. When released, this stored energy converts to kinetic energy."
          },
          {
            id: 5,
            question: "What is the chemical symbol for gold?",
            options: ["Go", "Gd", "Au", "Ag"],
            correctAnswer: 2,
            explanation: "Gold's chemical symbol is Au, derived from its Latin name 'Aurum.' Silver is Ag, from 'Argentum.'"
          }
        ]
      },
      {
        id: 2,
        name: "Arithmetic Reasoning (AR)",
        timeLimit: 8,
        questions: [
          {
            id: 6,
            question: "A tank holds 240 gallons of fuel. If it uses fuel at a rate of 8 gallons per hour, how many hours can it operate?",
            options: ["28 hours", "30 hours", "32 hours", "35 hours"],
            correctAnswer: 1,
            explanation: "Operating time = Total fuel ÷ Rate of consumption = 240 ÷ 8 = 30 hours."
          },
          {
            id: 7,
            question: "If a military discount gives 30% off an item priced at $150, what is the final price?",
            options: ["$95", "$100", "$105", "$110"],
            correctAnswer: 2,
            explanation: "Discount amount: 30% of $150 = $45. Final price: $150 - $45 = $105."
          },
          {
            id: 8,
            question: "A platoon of 40 soldiers is divided into 4 equal squads. Each squad receives 3 boxes of supplies. How many boxes total?",
            options: ["10 boxes", "12 boxes", "14 boxes", "16 boxes"],
            correctAnswer: 1,
            explanation: "Total boxes = Number of squads × Boxes per squad = 4 squads × 3 boxes = 12 boxes."
          },
          {
            id: 9,
            question: "An aircraft flies 1,200 miles in 3 hours. What is its average speed in miles per hour?",
            options: ["350 mph", "375 mph", "400 mph", "425 mph"],
            correctAnswer: 2,
            explanation: "Average speed = Distance ÷ Time = 1,200 miles ÷ 3 hours = 400 mph."
          },
          {
            id: 10,
            question: "A storage facility has 850 units. After distributing 40% on Monday and 25% of the remainder on Tuesday, how many units are left?",
            options: ["357 units", "383 units", "412 units", "425 units"],
            correctAnswer: 1,
            explanation: "Monday: 40% of 850 = 340 distributed. Remaining: 850 - 340 = 510. Tuesday: 25% of 510 = 127.5 distributed. Final: 510 - 127.5 = 382.5, rounded to 383 units."
          }
        ]
      },
      {
        id: 3,
        name: "Word Knowledge (WK)",
        timeLimit: 5,
        questions: [
          {
            id: 11,
            question: "Vigilant most nearly means:",
            options: ["Careless", "Watchful and alert", "Lazy", "Distracted"],
            correctAnswer: 1,
            explanation: "Vigilant means keeping careful watch for possible danger or difficulties; being alert and attentive."
          },
          {
            id: 12,
            question: "Obsolete most nearly means:",
            options: ["Modern", "Outdated and no longer used", "Popular", "Efficient"],
            correctAnswer: 1,
            explanation: "Obsolete means no longer produced or used; out of date and replaced by something newer."
          },
          {
            id: 13,
            question: "Adhere most nearly means:",
            options: ["Separate", "Stick to or follow closely", "Abandon", "Reject"],
            correctAnswer: 1,
            explanation: "Adhere means to stick firmly to something, or to follow and support a rule, belief, or practice."
          },
          {
            id: 14,
            question: "Concise most nearly means:",
            options: ["Lengthy", "Brief and to the point", "Confusing", "Complicated"],
            correctAnswer: 1,
            explanation: "Concise means giving a lot of information clearly and in few words; brief yet comprehensive."
          },
          {
            id: 15,
            question: "Formidable most nearly means:",
            options: ["Weak", "Inspiring fear or respect through size or power", "Small", "Insignificant"],
            correctAnswer: 1,
            explanation: "Formidable means inspiring fear or respect through being impressively large, powerful, intense, or capable."
          }
        ]
      },
      {
        id: 4,
        name: "Paragraph Comprehension (PC)",
        timeLimit: 6,
        questions: [
          {
            id: 16,
            passage: "Military rank structure establishes a clear chain of command and defines authority within the armed forces, creating an organizational hierarchy that ensures orders flow efficiently from senior leaders to junior personnel. This formal structure eliminates confusion about who reports to whom and who has authority to make different types of decisions. Each branch has its own rank system with distinct insignia, titles, and traditions, though similarities exist across services that allow personnel from different branches to understand relative seniority when working together in joint operations. The Army, Air Force, and Marine Corps share similar rank structures with some nomenclature differences, while the Navy and Coast Guard use different terminology reflecting their maritime traditions.\n\nEnlisted personnel begin at lower ranks such as Private or Airman Basic and can advance through promotions based on time in service, performance, and testing that evaluates their knowledge and readiness for increased responsibility. Time in service requirements ensure personnel gain experience at each level before advancing. Performance evaluations by supervisors assess how well individuals execute their duties and demonstrate the leadership potential and technical proficiency expected at higher ranks. Written tests verify mastery of military knowledge, job-specific skills, and leadership concepts. The promotion system balances recognizing sustained good performance with ensuring personnel are qualified for the increased responsibilities that come with higher ranks. Senior enlisted ranks like Sergeant Major or Master Chief represent decades of experience and serve as technical experts and mentors who bridge the gap between junior enlisted personnel and officers.\n\nOfficers, who hold leadership positions with broader command authority and strategic responsibilities, either enter through commissioning programs such as service academies, ROTC, or Officer Candidate School, or rise from enlisted ranks through programs that recognize exceptional performers who demonstrate officer potential. Most officers commission after college with a bachelor's degree and receive initial training in leadership and military fundamentals before joining their first units. Prior enlisted officers bring valuable experience and credibility from their enlisted service. Officers progress through ranks from Second Lieutenant or Ensign up to General or Admiral, with each rank level carrying expanded scope of responsibility, command of larger organizations, and involvement in increasingly strategic decisions. This rank structure creates a professional military organization where authority is clear, advancement is merit-based, and personnel at all levels understand their roles within the larger institution.",
            question: "According to the passage, how can enlisted personnel advance in rank?",
            options: ["Only through testing", "Through time in service, performance, and testing", "Only officers can advance", "By transferring to another branch"],
            correctAnswer: 1,
            explanation: "The passage states that enlisted personnel 'can advance through promotions based on time in service, performance, and testing.'"
          },
          {
            id: 17,
            passage: "Communication equipment in modern military operations must be secure, reliable, and compatible across different units to enable the coordination essential for mission success. Security prevents adversaries from intercepting sensitive information that could compromise operations, reveal plans, or endanger personnel. Reliability ensures communications function even under adverse conditions including harsh weather, electromagnetic interference, and physical damage from combat. Compatibility allows different units, services, and coalition partners to communicate seamlessly despite using varied equipment from different manufacturers and acquisition programs. Without these qualities, communication systems become liabilities rather than assets.\n\nEncrypted radio systems prevent enemy interception of sensitive information by transforming messages into coded formats that appear as meaningless noise without the proper decryption keys. Modern encryption algorithms are computationally secure, meaning adversaries would require thousands of years to break the encryption through brute force. Frequency-hopping radios further enhance security by rapidly changing transmission frequencies according to patterns known only to friendly forces, making interception and jamming more difficult. Secure voice communications, encrypted data networks, and protected command and control systems all depend on encryption to enable forces to communicate freely over channels that adversaries can monitor but not understand. This allows coordination in hostile electromagnetic environments where enemies control the spectrum.\n\nSatellite communications enable global coordination between deployed forces and command centers regardless of distance or terrain obstacles that would block line-of-sight radio communications. Satellites orbiting thousands of miles above Earth relay signals between widely separated units, enabling real-time voice, video, and data exchange across continents and oceans. This capability transforms how militaries coordinate operations, allowing strategic leaders to communicate directly with tactical units and enabling forces deployed worldwide to share intelligence and coordinate actions. Redundant systems ensure that if one communication method fails due to equipment malfunction, enemy jamming, or physical destruction, alternatives are available to maintain contact during critical missions when loss of communication could prove catastrophic. Multiple radios on different frequencies, satellite backup for terrestrial systems, and emergency signaling methods provide layers of redundancy that keep forces connected even when primary systems fail.",
            question: "Why are redundant communication systems important?",
            options: ["They are cheaper", "They provide alternatives if one method fails", "They are easier to use", "They require less training"],
            correctAnswer: 1,
            explanation: "The passage explains that 'Redundant systems ensure that if one communication method fails, alternatives are available to maintain contact.'"
          },
          {
            id: 18,
            passage: "Military vehicles require regular preventive maintenance to ensure operational readiness and mission capability when forces need to move or engage. Vehicles that break down during operations create cascading problems: missions may be delayed or compromised, units become separated and vulnerable, recovery operations divert resources, and personnel safety is jeopardized. Scheduled inspections identify potential problems before they cause breakdowns during missions by systematically examining components according to established intervals based on operating hours or calendar time. These inspections catch developing issues while they are still minor and can be addressed through routine maintenance rather than waiting for catastrophic failures that require major repairs or vehicle replacement.\n\nMechanics check fluid levels, tire pressure, brake systems, and engine performance along with numerous other systems during these inspections. Engine oil lubricates moving parts and must be changed regularly as it breaks down and accumulates contaminants. Coolant prevents overheating and freezing while protecting against corrosion. Brake fluid transmits hydraulic pressure to stop vehicles safely. Low fluids indicate leaks or consumption problems that need attention. Proper tire pressure ensures safe handling, prevents blowouts, and maximizes tire life. Brake systems must function reliably because brake failure can cause accidents. Engine performance issues like rough running, power loss, or excessive smoke indicate problems requiring diagnosis and repair. Each system serves critical functions, and neglecting any of them risks vehicle failure at the worst possible time.\n\nProper maintenance extends vehicle lifespan and reduces the likelihood of equipment failure in the field, where repairs may be difficult or impossible due to lack of parts, tools, or facilities. Vehicles represent significant investment, and maximizing their service life through systematic care provides better return than premature replacement due to neglect. In field environments, broken vehicles may be far from maintenance facilities, with limited repair capabilities and supply chains that cannot quickly deliver specialized parts. Under combat conditions, stopped vehicles become targets and liabilities. Well-maintained vehicles are more reliable, perform better, and give personnel confidence that their equipment will function when lives depend on it. The discipline of preventive maintenance creates a culture of readiness and attention to detail that extends beyond vehicle care to all aspects of military professionalism.",
            question: "What is the main purpose of preventive maintenance?",
            options: ["To make vehicles look better", "To identify problems before they cause breakdowns", "To increase fuel consumption", "To train new mechanics"],
            correctAnswer: 1,
            explanation: "The passage clearly states that 'Scheduled inspections identify potential problems before they cause breakdowns during missions.'"
          },
          {
            id: 19,
            passage: "Water purification is essential for military units operating in field conditions where clean water sources may not be available and personnel cannot simply turn on a tap to access treated municipal water. Deployed forces may operate in remote locations far from infrastructure, in areas where water systems have been damaged or destroyed, or in regions where local water supplies are naturally contaminated or deliberately poisoned. Contaminated water can cause serious illness that undermines unit effectiveness by incapacitating personnel with diarrhea, vomiting, and dehydration that prevent them from performing their duties. Waterborne diseases like cholera, typhoid, dysentery, and giardiasis have disabled entire armies throughout history, sometimes causing more casualties than combat. Modern militaries recognize that ensuring safe drinking water is as important as providing ammunition and food.\n\nPurification methods include filtration, chemical treatment, and boiling, each with advantages and limitations suited to different situations. Filtration removes particles, sediment, and many pathogens by passing water through membranes with pores small enough to trap bacteria and parasites while allowing water molecules through. Chemical treatment typically uses iodine or chlorine tablets that kill microorganisms through chemical action, requiring waiting periods before water is safe to drink. Boiling kills all pathogens by heating water above temperatures that destroy bacteria, viruses, and parasites, but requires fuel and time. Some modern systems combine multiple methods, such as filters with integrated chemical treatment, providing comprehensive purification. Large units may deploy trailer-mounted reverse osmosis water purification units that can produce thousands of gallons daily from virtually any water source including seawater.\n\nPortable purification systems allow soldiers to safely drink from natural sources like streams, rivers, and lakes, ensuring hydration without compromising health or mission capability. Individual water purification straws and pump filters enable personnel to treat water on the move without waiting or carrying heavy loads of water. This capability is crucial for small unit operations where resupply may be infrequent and carrying enough water for extended periods is impractical. By enabling forces to obtain safe drinking water from local sources, purification systems reduce logistics burdens, increase operational flexibility, and maintain personnel health. Commanders emphasize water discipline—ensuring personnel drink adequate amounts of purified water—because dehydration degrades performance as surely as waterborne illness. The combination of portable purification technology and enforced hydration discipline keeps forces healthy and effective even in challenging field environments where water security cannot be taken for granted.",
            question: "Why is water purification important for military units in the field?",
            options: ["It improves water taste", "Contaminated water can cause illness that affects unit effectiveness", "It's required by regulations", "It saves money"],
            correctAnswer: 1,
            explanation: "The passage states that 'Contaminated water can cause serious illness that undermines unit effectiveness,' making purification essential."
          },
          {
            id: 20,
            passage: "Situational awareness means understanding everything happening around you and how it might affect your mission, maintaining an accurate mental picture of your environment, threats, friendly forces, and how the situation is evolving. This requires continuously gathering information through observation and communication, processing that information to understand its significance, and projecting forward to anticipate how things might develop. Good situational awareness helps soldiers anticipate threats by recognizing indicators and patterns that signal danger before it materializes. It helps them avoid dangers by noticing hazards like unstable structures, improvised explosive devices, or enemy positions before stumbling into them. It enables better decisions by providing the understanding necessary to select appropriate courses of action based on current conditions rather than outdated or incomplete information.\n\nThis skill develops through training, experience, and maintaining focus on the environment rather than becoming distracted by irrelevant stimuli or internal thoughts. Training scenarios expose personnel to situations where they must practice observing their surroundings, identifying relevant information, and responding appropriately. Repetition builds habits of continuously scanning the environment and processing what is observed. Experience in various environments develops mental models of what normal looks like, making it easier to recognize when something is out of place or unusual. Maintaining focus requires discipline to avoid tunnel vision, complacency, or distractions that narrow attention to the exclusion of peripheral awareness. Personnel must consciously maintain broad attention even during routine activities when the temptation to relax vigilance is strong. After-action reviews help personnel understand what indicators they missed and how to improve their observation skills.\n\nLeaders emphasize situational awareness because lapses can have serious consequences in high-risk environments where threats can emerge suddenly and leave no time for belated reaction. Soldiers who lack situational awareness walk into ambushes, overlook improvised explosive devices, or fail to notice threats until it is too late to respond effectively. Vehicle operators without situational awareness cause accidents. Personnel who are not paying attention to their surroundings make poor tactical decisions based on incorrect understanding of the situation. In contrast, forces with strong situational awareness detect threats early when they can be avoided or engaged from positions of advantage, navigate complex environments safely, and maintain coherent understanding of friendly and enemy dispositions that enables coordinated action. Situational awareness is thus a fundamental skill that enables all other military competencies to be applied effectively in the dynamic, dangerous environments where military operations occur.",
            question: "How does good situational awareness help soldiers?",
            options: ["It makes them stronger", "It helps them anticipate threats and make better decisions", "It replaces the need for training", "It guarantees mission success"],
            correctAnswer: 1,
            explanation: "The passage explains that good situational awareness 'helps soldiers anticipate threats, avoid dangers, and make better decisions.'"
          }
        ]
      },
      {
        id: 5,
        name: "Mathematics Knowledge (MK)",
        timeLimit: 6,
        questions: [
          {
            id: 21,
            question: "Solve for x: 3x + 9 = 30",
            options: ["x = 5", "x = 6", "x = 7", "x = 8"],
            correctAnswer: 2,
            explanation: "Subtract 9 from both sides: 3x = 21. Divide both sides by 3: x = 7."
          },
          {
            id: 22,
            question: "What is the perimeter of a rectangle with length 15 feet and width 8 feet?",
            options: ["38 feet", "42 feet", "46 feet", "50 feet"],
            correctAnswer: 2,
            explanation: "Perimeter = 2(length + width) = 2(15 + 8) = 2(23) = 46 feet."
          },
          {
            id: 23,
            question: "If 2^5 = 32, what is 2^6?",
            options: ["48", "56", "64", "72"],
            correctAnswer: 2,
            explanation: "2^6 = 2^5 × 2 = 32 × 2 = 64. Alternatively, 2^6 = 2 × 2 × 2 × 2 × 2 × 2 = 64."
          },
          {
            id: 24,
            question: "What is the value of the expression: 8 + 4 × 3 - 2?",
            options: ["18", "28", "34", "38"],
            correctAnswer: 0,
            explanation: "Following order of operations (PEMDAS): 4 × 3 = 12, then 8 + 12 - 2 = 18."
          },
          {
            id: 25,
            question: "A right triangle has legs of 6 cm and 8 cm. What is the length of the hypotenuse?",
            options: ["9 cm", "10 cm", "12 cm", "14 cm"],
            correctAnswer: 1,
            explanation: "Using Pythagorean theorem: a² + b² = c². So 6² + 8² = c², which gives 36 + 64 = c², therefore c² = 100, and c = 10 cm."
          }
        ]
      },
      {
        id: 6,
        name: "Electronics Information (EI)",
        timeLimit: 5,
        questions: [
          {
            id: 26,
            question: "What is the function of a resistor in an electrical circuit?",
            options: ["To store energy", "To limit or control the flow of electric current", "To convert AC to DC", "To amplify signals"],
            correctAnswer: 1,
            explanation: "A resistor restricts the flow of electric current, controlling how much current passes through a circuit. It converts electrical energy into heat."
          },
          {
            id: 27,
            question: "What does AC stand for in electrical terminology?",
            options: ["Active Current", "Alternating Current", "Automatic Circuit", "Amplified Charge"],
            correctAnswer: 1,
            explanation: "AC stands for Alternating Current, which is electrical current that periodically reverses direction, unlike DC (Direct Current) which flows in one direction."
          },
          {
            id: 28,
            question: "In a parallel circuit with two resistors, what happens to the total resistance?",
            options: ["It increases", "It decreases", "It stays the same", "It becomes zero"],
            correctAnswer: 1,
            explanation: "In a parallel circuit, the total resistance is always less than the smallest individual resistance because current has multiple paths to flow through."
          },
          {
            id: 29,
            question: "What is the purpose of a transistor in electronic circuits?",
            options: ["To resist current", "To store charge", "To amplify or switch electronic signals", "To measure voltage"],
            correctAnswer: 2,
            explanation: "Transistors act as amplifiers or electronic switches, controlling the flow of current in response to an input signal. They are fundamental components in modern electronics."
          },
          {
            id: 30,
            question: "Using Ohm's Law, if voltage is 12 volts and resistance is 4 ohms, what is the current?",
            options: ["2 amperes", "3 amperes", "4 amperes", "8 amperes"],
            correctAnswer: 1,
            explanation: "Ohm's Law: V = I × R, so I = V ÷ R = 12 volts ÷ 4 ohms = 3 amperes."
          }
        ]
      },
      {
        id: 7,
        name: "Auto & Shop Information (AS)",
        timeLimit: 5,
        questions: [
          {
            id: 31,
            question: "What is the primary function of a vehicle's radiator?",
            options: ["Filter air", "Cool the engine", "Store fuel", "Generate electricity"],
            correctAnswer: 1,
            explanation: "The radiator dissipates heat from engine coolant into the air, preventing the engine from overheating. Coolant circulates through the engine, absorbing heat, then flows to the radiator to cool."
          },
          {
            id: 32,
            question: "Which tool would you use to tighten or loosen bolts and nuts?",
            options: ["Screwdriver", "Wrench", "Pliers", "Hammer"],
            correctAnswer: 1,
            explanation: "A wrench (or spanner) is specifically designed to grip and turn bolts and nuts. Different types include box-end, open-end, and socket wrenches."
          },
          {
            id: 33,
            question: "What does a spark plug do in a gasoline engine?",
            options: ["Filters fuel", "Ignites the air-fuel mixture", "Cools the engine", "Stores electricity"],
            correctAnswer: 1,
            explanation: "Spark plugs create an electrical spark that ignites the compressed air-fuel mixture in the combustion chamber, initiating the power stroke of the engine cycle."
          },
          {
            id: 34,
            question: "Which type of screwdriver has a cross-shaped tip?",
            options: ["Flathead", "Phillips", "Torx", "Hex"],
            correctAnswer: 1,
            explanation: "A Phillips screwdriver has a cross-shaped (+) tip designed for Phillips screws, which provide better torque transfer and reduce cam-out compared to flathead screws."
          },
          {
            id: 35,
            question: "What is the purpose of motor oil viscosity ratings like 10W-30?",
            options: ["Color of the oil", "Oil's thickness at different temperatures", "Oil's age", "Oil's chemical composition"],
            correctAnswer: 1,
            explanation: "Viscosity ratings indicate oil thickness at different temperatures. The 'W' stands for winter. 10W-30 flows like 10-weight oil in cold temperatures and like 30-weight oil when hot."
          }
        ]
      },
      {
        id: 8,
        name: "Mechanical Comprehension (MC)",
        timeLimit: 6,
        questions: [
          {
            id: 36,
            question: "A wheel with 30 teeth meshes with a wheel with 60 teeth. If the smaller wheel rotates at 120 RPM, what is the speed of the larger wheel?",
            options: ["30 RPM", "45 RPM", "60 RPM", "90 RPM"],
            correctAnswer: 2,
            explanation: "Gear ratio is 30:60 or 1:2. The larger gear rotates at half the speed: 120 ÷ 2 = 60 RPM."
          },
          {
            id: 37,
            question: "What happens to water pressure as you go deeper underwater?",
            options: ["It decreases", "It increases", "It stays the same", "It becomes zero"],
            correctAnswer: 1,
            explanation: "Water pressure increases with depth because of the weight of the water above. Pressure increases approximately 1 atmosphere (14.7 psi) for every 33 feet of depth."
          },
          {
            id: 38,
            question: "A 120-pound weight is placed 4 feet from the fulcrum of a lever. How far from the fulcrum must a 60-pound weight be placed on the other side to balance?",
            options: ["2 feet", "4 feet", "6 feet", "8 feet"],
            correctAnswer: 3,
            explanation: "Using lever principle: Weight₁ × Distance₁ = Weight₂ × Distance₂. So 120 × 4 = 60 × Distance₂, giving Distance₂ = 480 ÷ 60 = 8 feet."
          },
          {
            id: 39,
            question: "Which simple machine is a screwdriver being used to pry open a paint can lid?",
            options: ["Wheel and axle", "Lever", "Pulley", "Screw"],
            correctAnswer: 1,
            explanation: "When used to pry open a lid, the screwdriver acts as a lever with the edge of the can rim as the fulcrum, providing mechanical advantage to lift the lid."
          },
          {
            id: 40,
            question: "If a pulley system reduces the effort needed to lift an object by half, what is its mechanical advantage?",
            options: ["1", "2", "3", "4"],
            correctAnswer: 1,
            explanation: "Mechanical advantage = Load ÷ Effort. If effort is half the load, then MA = Load ÷ (Load/2) = 2."
          }
        ]
      },
      {
        id: 9,
        name: "Assembling Objects (AO)",
        timeLimit: 5,
        questions: [
          {
            id: 41,
            question: "A rectangular piece of paper is folded in half twice. How many layers thick is the folded paper?",
            options: ["2 layers", "3 layers", "4 layers", "8 layers"],
            correctAnswer: 2,
            explanation: "Each fold doubles the layers. First fold: 2 layers. Second fold: 2 × 2 = 4 layers."
          },
          {
            id: 42,
            question: "Which combination correctly assembles three cubes to form an L-shape?",
            options: ["All cubes in a straight line", "Two cubes in a line, one cube perpendicular", "Three cubes stacked vertically", "Cubes arranged in a triangle"],
            correctAnswer: 1,
            explanation: "An L-shape requires two cubes forming one line and a third cube attached perpendicular to one end, creating the characteristic 90-degree angle."
          },
          {
            id: 43,
            question: "If a circle is divided into 8 equal wedges, what angle does each wedge span?",
            options: ["30 degrees", "45 degrees", "60 degrees", "90 degrees"],
            correctAnswer: 1,
            explanation: "A complete circle is 360 degrees. Dividing by 8 equal parts: 360 ÷ 8 = 45 degrees per wedge."
          },
          {
            id: 44,
            question: "Point X on shape A must connect to point Y on shape B. If shape A is rotated 270° clockwise, which direction is that equivalent to?",
            options: ["90° clockwise", "90° counterclockwise", "180° rotation", "No rotation"],
            correctAnswer: 1,
            explanation: "270° clockwise rotation is equivalent to 90° counterclockwise rotation (360° - 270° = 90°)."
          },
          {
            id: 45,
            question: "A net shows a cross-shaped pattern with a square center and four squares extending from each side. What 3D shape does this form when folded?",
            options: ["Pyramid", "Cube", "Cylinder", "Cone"],
            correctAnswer: 1,
            explanation: "A cross-shaped net with a square center and four surrounding squares folds into a cube, with one face missing from the net."
          }
        ]
      },
      {
        id: 10,
        name: "Verbal Expression (VE)",
        timeLimit: 6,
        questions: [
          {
            id: 46,
            question: "Which sentence correctly uses a semicolon?",
            options: ["The mission was successful; however we lost valuable time.", "The mission was successful; however, we lost valuable time.", "The mission was successful however; we lost valuable time.", "The mission was successful, however; we lost valuable time."],
            correctAnswer: 1,
            explanation: "When using a semicolon with a transitional word like 'however,' place the semicolon before and a comma after the transitional word."
          },
          {
            id: 47,
            question: "Identify the sentence with correct use of 'who' vs. 'whom':",
            options: ["Who did you report to?", "To who did you report?", "Whom did you report to?", "To whom did you report to?"],
            correctAnswer: 2,
            explanation: "'Whom' is the object form of 'who.' Since the person is receiving the action (being reported to), 'whom' is correct: 'Whom did you report to?' or 'To whom did you report?'"
          },
          {
            id: 48,
            question: "Which sentence demonstrates correct parallel structure?",
            options: ["The training includes running, swimming, and to lift weights.", "The training includes running, swimming, and lifting weights.", "The training includes to run, swimming, and lifting weights.", "The training includes running, to swim, and lifting weights."],
            correctAnswer: 1,
            explanation: "Parallel structure requires consistent grammatical form. All three activities should be in the gerund form: 'running, swimming, and lifting weights.'"
          },
          {
            id: 49,
            question: "Choose the sentence with correct use of 'affect' vs. 'effect':",
            options: ["The weather will effect our mission.", "The weather will have an affect on our mission.", "The weather will affect our mission.", "The weather's affect on our mission is significant."],
            correctAnswer: 2,
            explanation: "'Affect' is typically a verb meaning to influence. 'Effect' is typically a noun meaning result. 'The weather will affect (verb) our mission' is correct."
          },
          {
            id: 50,
            question: "Which sentence correctly uses an apostrophe for plural possessive?",
            options: ["The officers orders were clear.", "The officer's orders were clear.", "The officers' orders were clear.", "The officers's orders were clear."],
            correctAnswer: 2,
            explanation: "For plural possessive, add an apostrophe after the s. 'Officers'' indicates the orders belong to multiple officers."
          }
        ]
      }
    ]
  },,
  {
    id: 11,
    title: "ASVAB Practice Test #11",
    description: "Comprehensive practice exam covering all 10 ASVAB sections with military-standard questions",
    totalQuestions: 50,
    timeLimit: 60,
    sections: [
      {
        id: 1,
        name: "General Science (GS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What is the primary gas that makes up Earth's atmosphere?",
            options: ["Oxygen", "Carbon dioxide", "Nitrogen", "Hydrogen"],
            correctAnswer: 2,
            explanation: "Nitrogen makes up approximately 78% of Earth's atmosphere, while oxygen comprises about 21%. The remaining 1% consists of argon, carbon dioxide, and trace gases."
          },
          {
            id: 2,
            question: "Which blood cells are responsible for fighting infections in the human body?",
            options: ["Red blood cells", "White blood cells", "Platelets", "Plasma cells"],
            correctAnswer: 1,
            explanation: "White blood cells (leukocytes) are the primary defense mechanism against infections. They identify and destroy pathogens, produce antibodies, and help coordinate immune responses."
          },
          {
            id: 3,
            question: "What is the process by which plants lose water through their leaves?",
            options: ["Photosynthesis", "Respiration", "Transpiration", "Osmosis"],
            correctAnswer: 2,
            explanation: "Transpiration is the process where water evaporates from plant leaves through small pores called stomata. This helps regulate temperature and draws nutrients up from the roots."
          },
          {
            id: 4,
            question: "Which planet in our solar system has the most moons?",
            options: ["Jupiter", "Saturn", "Uranus", "Neptune"],
            correctAnswer: 1,
            explanation: "Saturn has the most confirmed moons with over 140 natural satellites. Jupiter comes in second with around 95 moons. New moons are still being discovered around both gas giants."
          },
          {
            id: 5,
            question: "What type of simple machine is a doorknob?",
            options: ["Lever", "Pulley", "Wheel and axle", "Inclined plane"],
            correctAnswer: 2,
            explanation: "A doorknob is a wheel and axle simple machine. The knob (wheel) rotates around the shaft (axle), allowing for easier turning and mechanical advantage when opening doors."
          }
        ]
      },
      {
        id: 2,
        name: "Arithmetic Reasoning (AR)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "A military squad of 8 soldiers needs to share 72 ration packs equally. How many packs does each soldier receive?",
            options: ["8 packs", "9 packs", "10 packs", "12 packs"],
            correctAnswer: 1,
            explanation: "Divide the total ration packs by the number of soldiers: 72 ÷ 8 = 9 packs per soldier."
          },
          {
            id: 2,
            question: "If a helicopter travels 180 miles in 2 hours, what is its average speed in miles per hour?",
            options: ["80 mph", "85 mph", "90 mph", "95 mph"],
            correctAnswer: 2,
            explanation: "Speed = Distance ÷ Time. Therefore: 180 miles ÷ 2 hours = 90 mph average speed."
          },
          {
            id: 3,
            question: "A recruit scores 85, 92, 78, and 89 on four fitness tests. What is the average score?",
            options: ["84", "86", "88", "90"],
            correctAnswer: 1,
            explanation: "Add all scores and divide by the number of tests: (85 + 92 + 78 + 89) ÷ 4 = 344 ÷ 4 = 86."
          },
          {
            id: 4,
            question: "A supply truck carries 450 pounds of equipment. If each box weighs 18 pounds, how many boxes are on the truck?",
            options: ["20 boxes", "23 boxes", "25 boxes", "28 boxes"],
            correctAnswer: 2,
            explanation: "Divide total weight by weight per box: 450 ÷ 18 = 25 boxes on the truck."
          },
          {
            id: 5,
            question: "If 5 technicians can repair 15 vehicles in 3 hours, how many vehicles can 8 technicians repair in the same time?",
            options: ["20 vehicles", "22 vehicles", "24 vehicles", "26 vehicles"],
            correctAnswer: 2,
            explanation: "Each technician repairs 15 ÷ 5 = 3 vehicles in 3 hours. With 8 technicians: 8 × 3 = 24 vehicles in 3 hours."
          }
        ]
      },
      {
        id: 3,
        name: "Word Knowledge (WK)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Vigilant most nearly means:",
            options: ["Careless", "Watchful", "Aggressive", "Tired"],
            correctAnswer: 1,
            explanation: "Vigilant means being alert, watchful, and attentive to detect potential danger or problems. This quality is essential for military personnel on duty."
          },
          {
            id: 2,
            question: "Obsolete most nearly means:",
            options: ["Modern", "Outdated", "Functional", "Expensive"],
            correctAnswer: 1,
            explanation: "Obsolete means no longer in use, outdated, or replaced by something newer and more effective. Military equipment can become obsolete as technology advances."
          },
          {
            id: 3,
            question: "Resilient most nearly means:",
            options: ["Fragile", "Flexible", "Able to recover", "Permanent"],
            correctAnswer: 2,
            explanation: "Resilient means having the ability to recover quickly from difficulties or setbacks. It describes both physical materials and mental toughness."
          },
          {
            id: 4,
            question: "Meticulous most nearly means:",
            options: ["Hasty", "Careful", "Reckless", "Simple"],
            correctAnswer: 1,
            explanation: "Meticulous means showing great attention to detail and being very careful and precise. This trait is valued in military operations where accuracy is critical."
          },
          {
            id: 5,
            question: "Expedite most nearly means:",
            options: ["Delay", "Speed up", "Cancel", "Review"],
            correctAnswer: 1,
            explanation: "Expedite means to make something happen more quickly or efficiently. In military contexts, it often refers to accelerating processes or deployments."
          }
        ]
      },
      {
        id: 4,
        name: "Paragraph Comprehension (PC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "The military chain of command is fundamental to operational success and serves as the backbone of all military organizations worldwide. Each level of command has specific responsibilities and authority that are clearly defined and understood by all personnel. Orders flow downward from senior officers to junior personnel, creating a clear hierarchy of leadership and decision-making authority. Simultaneously, information and reports flow upward through the chain, ensuring that commanders at all levels have the situational awareness needed to make informed decisions.\n\nThis structured system ensures accountability at every level of the organization, from the newest recruit to the highest-ranking general. When everyone understands their role and who they report to, it becomes much easier to trace decisions and actions back to their source. The chain of command also enables coordinated action across large organizations, allowing thousands of personnel to work together toward common objectives. Without this clear structure, large military operations would quickly dissolve into chaos and confusion.\n\nMoreover, the chain of command provides a framework for professional development and career progression. Junior personnel learn leadership skills by observing their superiors and gradually taking on more responsibility as they advance through the ranks. This time-tested system has proven essential for maintaining discipline, ensuring effective communication, and accomplishing complex missions under the most challenging conditions.\n\nWhat is the main purpose of the military chain of command?",
            options: ["To create more paperwork", "To ensure accountability and coordination", "To limit communication", "To increase bureaucracy"],
            correctAnswer: 1,
            explanation: "The passage explicitly states that the chain of command 'ensures accountability and enables coordinated action,' which are essential for operational success."
          },
          {
            id: 2,
            question: "Physical fitness is a cornerstone of military readiness and plays a vital role in every aspect of military service. Regular exercise improves cardiovascular health, allowing service members to perform physically demanding tasks for extended periods without fatigue. It also builds muscular strength necessary for carrying heavy equipment, performing rescue operations, and engaging in combat activities. Beyond the physical benefits, exercise enhances mental resilience, helping personnel manage stress and maintain focus during high-pressure situations.\n\nService members must maintain fitness standards throughout their careers, not just during initial training. The military regularly tests personnel to ensure they meet minimum fitness requirements for their age and gender. These standards exist because the demands of military service don't diminish over time. Whether responding to emergencies, deploying to combat zones, or conducting training exercises, service members must be physically prepared for whatever challenges arise.\n\nDaily physical training sessions are a fundamental part of military life and serve multiple purposes beyond simple fitness. These sessions help soldiers stay combat-ready by maintaining the physical conditioning needed for military operations. They also significantly reduce injury risk during demanding operations by strengthening muscles, improving flexibility, and building endurance. Additionally, group physical training builds unit cohesion and camaraderie, as service members push themselves together and support one another through challenging workouts.\n\nAccording to the passage, why is physical fitness important in the military?",
            options: ["It's only for appearance", "It maintains combat readiness and reduces injuries", "It's required only during basic training", "It helps with paperwork"],
            correctAnswer: 1,
            explanation: "The passage states that physical training 'helps soldiers stay combat-ready and reduce injury risk during demanding operations,' emphasizing both readiness and safety."
          },
          {
            id: 3,
            question: "Navigation skills have evolved significantly with modern technology, revolutionizing how military forces move and operate across the globe. While GPS systems provide accurate positioning information that can pinpoint locations within meters, military personnel must still master traditional methods like map reading and compass use. These time-tested techniques have proven reliable for centuries and remain relevant in today's high-tech military environment. Understanding topographic maps, terrain features, and basic navigation principles provides a foundation that technology can enhance but never fully replace.\n\nThe continued emphasis on traditional navigation skills stems from a simple reality: electronic systems can fail or be compromised. Equipment malfunctions, battery failures, and signal interference can render GPS devices useless at critical moments. In combat situations, adversaries may jam or spoof GPS signals to confuse enemy forces. Harsh weather conditions, such as severe storms or extreme cold, can also affect electronic equipment performance. When these failures occur, service members must rely on their fundamental navigation skills to complete missions and return safely.\n\nThis makes backup skills essential for mission success in any environment, from dense jungles to arctic conditions to urban warfare scenarios. A well-trained military professional can navigate using multiple methods, switching seamlessly between modern and traditional techniques as situations demand. This redundancy in navigation capabilities ensures that units can continue operating effectively regardless of technological challenges they may face. The most effective approach combines the precision of modern GPS with the reliability of traditional methods, creating a robust navigation capability.\n\nWhat does the passage suggest about navigation technology?",
            options: ["GPS has made traditional skills obsolete", "Traditional skills remain important as backup", "Maps are more accurate than GPS", "Electronic systems never fail"],
            correctAnswer: 1,
            explanation: "The passage explicitly states that backup skills are essential because 'electronic systems can fail or be compromised,' emphasizing the importance of traditional methods."
          },
          {
            id: 4,
            question: "Military discipline is built on three fundamental pillars: respect, responsibility, and adherence to regulations. Respect encompasses treating fellow service members with dignity, following orders from superiors, and honoring the traditions and values of military service. Responsibility means taking ownership of one's actions, completing assigned duties to the best of one's ability, and being accountable for both successes and failures. Adherence to regulations ensures that all personnel operate according to the same standards and procedures, creating consistency across the entire organization.\n\nThis disciplined approach creates a predictable environment where personnel can trust their teammates and focus on mission objectives rather than worrying about unpredictable behavior. When everyone follows the same rules and standards, service members know what to expect from one another. This trust is absolutely essential in military operations, where personnel must often depend on their comrades for their very survival. The predictability that discipline provides allows leaders to plan complex operations with confidence that their orders will be followed and their units will perform as expected.\n\nWithout discipline, chaos would quickly replace order, and units would be unable to function effectively under stress. In high-pressure combat situations or emergency responses, there's no time for debate or discussion about basic procedures. Disciplined units react quickly and efficiently because everyone knows their role and follows established protocols. This discipline doesn't suppress individual initiative; rather, it provides a framework within which creativity and problem-solving can flourish. The most effective military units balance strict discipline with the flexibility to adapt to changing circumstances.\n\nAccording to the passage, what does military discipline create?",
            options: ["Fear among troops", "A predictable and trustworthy environment", "Unnecessary restrictions", "Confusion in operations"],
            correctAnswer: 1,
            explanation: "The passage states that discipline 'creates a predictable environment where personnel can trust their teammates,' highlighting the positive organizational benefits."
          },
          {
            id: 5,
            question: "Effective communication is critical in military operations and often makes the difference between mission success and failure. Clear, concise messaging prevents misunderstandings that could compromise missions or endanger lives. In the chaos of military operations, where decisions must be made quickly and consequences can be severe, there's no room for ambiguous or unclear communication. Every message must be understood exactly as intended, whether it's transmitted over radio, written in orders, or delivered face-to-face. The stakes are simply too high to rely on unclear communication methods.\n\nMilitary personnel use standardized terminology and protocols to ensure information is transmitted accurately across different units and branches of service. This standardization includes phonetic alphabets for spelling out letters over radio, brevity codes for common situations, and established formats for reports and orders. When a Marine communicates with an Air Force pilot or an Army soldier coordinates with a Navy vessel, they can understand each other because they're using the same communication standards. This common language transcends individual units and service branches, enabling true joint operations.\n\nThe benefits of this standardization extend beyond just understanding words. Standardized communication protocols reduce the time needed to transmit information, eliminate confusion in high-stress situations, and ensure that critical details aren't lost in translation. They also facilitate training, as new personnel can learn a single communication system that will serve them throughout their military career. Whether operating in peacetime training exercises or conducting combat operations in hostile territory, military personnel rely on these standardized communication methods to coordinate their actions and keep everyone informed.\n\nWhat is the main benefit of standardized military communication?",
            options: ["It makes messages longer", "It ensures accurate information transmission", "It confuses enemies", "It reduces the need for training"],
            correctAnswer: 1,
            explanation: "The passage explains that standardized terminology and protocols 'ensure information is transmitted accurately,' which is the key benefit described."
          }
        ]
      },
      {
        id: 5,
        name: "Mathematics Knowledge (MK)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What is the value of 7² - 3²?",
            options: ["16", "32", "40", "52"],
            correctAnswer: 2,
            explanation: "Calculate each square: 7² = 49 and 3² = 9. Then subtract: 49 - 9 = 40."
          },
          {
            id: 2,
            question: "If 3x + 7 = 28, what is the value of x?",
            options: ["5", "6", "7", "8"],
            correctAnswer: 2,
            explanation: "Solve for x: 3x + 7 = 28. Subtract 7 from both sides: 3x = 21. Divide by 3: x = 7."
          },
          {
            id: 3,
            question: "What is the area of a rectangle with length 12 feet and width 8 feet?",
            options: ["40 square feet", "80 square feet", "96 square feet", "120 square feet"],
            correctAnswer: 2,
            explanation: "Area of a rectangle = length × width. Therefore: 12 × 8 = 96 square feet."
          },
          {
            id: 4,
            question: "What is 15% of 240?",
            options: ["30", "32", "36", "40"],
            correctAnswer: 2,
            explanation: "Convert 15% to decimal (0.15) and multiply: 0.15 × 240 = 36."
          },
          {
            id: 5,
            question: "If a triangle has angles measuring 45° and 65°, what is the measure of the third angle?",
            options: ["60°", "65°", "70°", "80°"],
            correctAnswer: 2,
            explanation: "The sum of angles in a triangle equals 180°. Therefore: 180° - 45° - 65° = 70°."
          }
        ]
      },
      {
        id: 6,
        name: "Electronics Information (EI)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What is the unit of measurement for electrical resistance?",
            options: ["Ampere", "Volt", "Ohm", "Watt"],
            correctAnswer: 2,
            explanation: "The ohm (symbol Ω) is the SI unit of electrical resistance, named after German physicist Georg Ohm. It measures how much a material resists the flow of electric current."
          },
          {
            id: 2,
            question: "In a series circuit with two resistors, how does the total resistance compare to individual resistors?",
            options: ["Less than either resistor", "Equal to the larger resistor", "Greater than either resistor", "Always zero"],
            correctAnswer: 2,
            explanation: "In a series circuit, total resistance equals the sum of all resistances. Therefore, it's always greater than any individual resistor: R_total = R1 + R2 + R3..."
          },
          {
            id: 3,
            question: "What component in a circuit is used to store electrical energy temporarily?",
            options: ["Resistor", "Capacitor", "Transistor", "Inductor"],
            correctAnswer: 1,
            explanation: "A capacitor stores electrical energy in an electric field between two conductive plates. It can quickly charge and discharge, making it useful for filtering, timing, and energy storage applications."
          },
          {
            id: 4,
            question: "What does AC stand for in electrical terminology?",
            options: ["Active Current", "Alternating Current", "Applied Current", "Amplified Current"],
            correctAnswer: 1,
            explanation: "AC stands for Alternating Current, where the flow of electric charge periodically reverses direction. This is the type of electricity supplied to homes and buildings."
          },
          {
            id: 5,
            question: "Which material is the best conductor of electricity?",
            options: ["Rubber", "Wood", "Silver", "Plastic"],
            correctAnswer: 2,
            explanation: "Silver is the best conductor of electricity among all metals due to its atomic structure. However, copper is more commonly used in wiring because it's less expensive and nearly as conductive."
          }
        ]
      },
      {
        id: 7,
        name: "Auto & Shop Information (AS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What is the primary function of a vehicle's alternator?",
            options: ["Start the engine", "Charge the battery while driving", "Cool the engine", "Filter the oil"],
            correctAnswer: 1,
            explanation: "The alternator generates electrical power while the engine runs, charging the battery and powering the vehicle's electrical systems. It converts mechanical energy from the engine into electrical energy."
          },
          {
            id: 2,
            question: "Which tool is used to measure the gap between spark plug electrodes?",
            options: ["Micrometer", "Feeler gauge", "Caliper", "Torque wrench"],
            correctAnswer: 1,
            explanation: "A feeler gauge consists of thin metal strips of precise thickness used to measure small gaps, including spark plug gaps. Proper gap spacing is critical for optimal engine performance."
          },
          {
            id: 3,
            question: "What does a higher octane rating in gasoline indicate?",
            options: ["More energy per gallon", "Better fuel economy", "Greater resistance to engine knock", "Lower emissions"],
            correctAnswer: 2,
            explanation: "Octane rating measures a fuel's resistance to premature ignition (knocking). Higher octane fuel resists compression better, making it suitable for high-performance engines with higher compression ratios."
          },
          {
            id: 4,
            question: "What type of joint is created when two pieces of metal are joined at a right angle using a welding technique?",
            options: ["Butt joint", "Lap joint", "T-joint", "Corner joint"],
            correctAnswer: 2,
            explanation: "A T-joint forms when one piece of metal is perpendicular to another, creating a 'T' shape. This joint type is common in frame construction and requires proper welding technique for strength."
          },
          {
            id: 5,
            question: "What automotive fluid is typically red or pink in color?",
            options: ["Engine oil", "Brake fluid", "Transmission fluid", "Coolant"],
            correctAnswer: 2,
            explanation: "Transmission fluid is usually red or pink to distinguish it from other fluids. This color helps mechanics identify leaks and prevents mixing it with other automotive fluids."
          }
        ]
      },
      {
        id: 8,
        name: "Mechanical Comprehension (MC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "If two gears are meshed together and the first gear has 20 teeth while the second has 40 teeth, what happens when the first gear makes one complete rotation?",
            options: ["The second gear makes two rotations", "The second gear makes one rotation", "The second gear makes half a rotation", "The second gear makes four rotations"],
            correctAnswer: 2,
            explanation: "The gear ratio is 20:40 or 1:2. When the smaller gear (20 teeth) makes one complete rotation, the larger gear (40 teeth) makes half a rotation because it has twice as many teeth."
          },
          {
            id: 2,
            question: "A lever is being used to lift a heavy object. To maximize mechanical advantage, where should the fulcrum be positioned?",
            options: ["At the midpoint between effort and load", "Close to the load", "Close to the effort", "At equal distances from both"],
            correctAnswer: 1,
            explanation: "Maximum mechanical advantage occurs when the fulcrum is closest to the load (resistance). This creates a longer effort arm relative to the load arm, multiplying the applied force."
          },
          {
            id: 3,
            question: "Water is flowing through a pipe that narrows in diameter. What happens to the water's velocity as it enters the narrow section?",
            options: ["Velocity decreases", "Velocity increases", "Velocity stays the same", "Velocity becomes zero"],
            correctAnswer: 1,
            explanation: "According to the continuity equation, when pipe diameter decreases, water velocity must increase to maintain constant flow rate. This is why putting your thumb over a garden hose increases water speed."
          },
          {
            id: 4,
            question: "Which of the following would reduce friction between two sliding surfaces?",
            options: ["Increasing surface roughness", "Adding lubricant", "Increasing contact pressure", "Removing any gap between surfaces"],
            correctAnswer: 1,
            explanation: "Lubricants reduce friction by creating a thin film between surfaces, preventing direct contact. This allows surfaces to slide more easily over each other with less resistance and wear."
          },
          {
            id: 5,
            question: "A hydraulic system has a small piston with an area of 2 square inches and a large piston with an area of 10 square inches. If 50 pounds of force is applied to the small piston, what force is generated at the large piston?",
            options: ["100 pounds", "150 pounds", "200 pounds", "250 pounds"],
            correctAnswer: 3,
            explanation: "Hydraulic force multiplication follows Pascal's principle: F1/A1 = F2/A2. Therefore: 50/2 = F2/10, solving gives F2 = 250 pounds. The force is multiplied by the ratio of piston areas (10/2 = 5)."
          }
        ]
      },
      {
        id: 9,
        name: "Assembling Objects (AO)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Which arrangement shows five dots connected in a straight line?",
            options: ["• • • • •", "•  •  •\n     • •", "•    •\n  •\n•    •", "• •\n• •\n  •"],
            correctAnswer: 0,
            explanation: "A straight line arrangement places all five dots in a single horizontal or vertical line with equal spacing, creating the most direct connection between all points."
          },
          {
            id: 2,
            question: "If you have a square piece and a triangular piece, which configuration forms a pentagon?",
            options: ["Square on top of triangle", "Triangle attached to one side of square", "Square inside triangle", "Triangle on top of square"],
            correctAnswer: 1,
            explanation: "When a triangle is properly attached to one side of a square, the combined shape has five sides total, forming a pentagon (penta = five, gon = angles/sides)."
          },
          {
            id: 3,
            question: "Three identical rectangular blocks are arranged end-to-end. What is the resulting shape?",
            options: ["A cube", "A longer rectangle", "A triangle", "A circle"],
            correctAnswer: 1,
            explanation: "When three identical rectangles are placed end-to-end in a line, they form a longer rectangle with three times the length but the same width."
          },
          {
            id: 4,
            question: "Which connection point would create the most stable three-dimensional structure from two L-shaped pieces?",
            options: ["Connecting the ends at right angles", "Overlapping the long sides", "Connecting parallel to each other", "Connecting at opposite angles"],
            correctAnswer: 0,
            explanation: "Connecting L-shaped pieces at right angles through their ends creates a stable three-dimensional corner structure, maximizing rigidity and load-bearing capacity."
          },
          {
            id: 5,
            question: "If four identical triangular pieces are arranged with their bases forming a square, what shape is created?",
            options: ["A cube", "A pyramid", "An octagon", "A larger triangle"],
            correctAnswer: 1,
            explanation: "Four triangular faces meeting at a common apex above a square base creates a square pyramid, a classic three-dimensional geometric shape."
          }
        ]
      },
      {
        id: 10,
        name: "Verbal Expression (VE)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Choose the sentence with correct grammar:",
            options: ["The sergeant along with his squad were deployed overseas.", "The sergeant along with his squad was deployed overseas.", "The sergeant along with his squad are deployed overseas.", "The sergeant along with his squad have deployed overseas."],
            correctAnswer: 1,
            explanation: "When 'along with' is used, the verb agrees with the first subject (sergeant), which is singular. Therefore, 'was deployed' is correct."
          },
          {
            id: 2,
            question: "Identify the sentence with the correct use of punctuation:",
            options: ["The recruits learned: marksmanship tactics and discipline.", "The recruits learned, marksmanship, tactics, and discipline.", "The recruits learned marksmanship, tactics, and discipline.", "The recruits learned; marksmanship, tactics and discipline."],
            correctAnswer: 2,
            explanation: "A simple list of three items should be separated by commas, with no additional punctuation before the list. This follows standard comma usage in series."
          },
          {
            id: 3,
            question: "Which word best completes the sentence: 'The mission was _______ by bad weather conditions.'",
            options: ["affected", "effected", "infected", "deflected"],
            correctAnswer: 0,
            explanation: "'Affected' means influenced or impacted by something. 'Effected' means caused or brought about. Weather conditions affect (influence) missions."
          },
          {
            id: 4,
            question: "Select the sentence with proper subject-verb agreement:",
            options: ["Either the officers or the enlisted soldier are responsible.", "Either the officers or the enlisted soldier is responsible.", "Either the officers or the enlisted soldier were responsible.", "Either the officers or the enlisted soldier have been responsible."],
            correctAnswer: 1,
            explanation: "With 'either...or' constructions, the verb agrees with the subject closest to it. 'Soldier' is singular, so 'is' is correct."
          },
          {
            id: 5,
            question: "Which sentence uses the apostrophe correctly?",
            options: ["The three platoon's equipment was inspected.", "The three platoons equipment was inspected.", "The three platoons' equipment was inspected.", "The three platoon's' equipment was inspected."],
            correctAnswer: 2,
            explanation: "For plural nouns ending in 's', add only an apostrophe after the 's' to show possession. 'Platoons'' (plural possessive) is correct."
          }
        ]
      }
    ]
  },,
  {
    id: 12,
    title: "ASVAB Practice Test #12",
    description: "Comprehensive practice exam covering all 10 ASVAB sections with military-standard questions",
    totalQuestions: 50,
    timeLimit: 60,
    sections: [
      {
        id: 1,
        name: "General Science (GS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What is the largest organ in the human body?",
            options: ["Liver", "Brain", "Skin", "Heart"],
            correctAnswer: 2,
            explanation: "The skin is the largest organ of the human body, covering approximately 20 square feet in adults. It serves as a protective barrier, regulates temperature, and provides sensory information."
          },
          {
            id: 2,
            question: "Which force causes objects to accelerate toward the Earth's center?",
            options: ["Magnetism", "Friction", "Gravity", "Inertia"],
            correctAnswer: 2,
            explanation: "Gravity is the force that attracts all objects with mass toward each other. On Earth, gravity pulls objects toward the planet's center at an acceleration of approximately 9.8 m/s²."
          },
          {
            id: 3,
            question: "What is the chemical symbol for gold?",
            options: ["Go", "Gd", "Au", "Ag"],
            correctAnswer: 2,
            explanation: "The chemical symbol for gold is Au, derived from the Latin word 'aurum'. Gold is a precious metal with atomic number 79 and is highly valued for its resistance to corrosion and malleability."
          },
          {
            id: 4,
            question: "Which organelle is known as the powerhouse of the cell?",
            options: ["Nucleus", "Ribosome", "Mitochondria", "Chloroplast"],
            correctAnswer: 2,
            explanation: "Mitochondria are called the powerhouse of the cell because they generate most of the cell's supply of ATP (adenosine triphosphate), which is used as a source of chemical energy through cellular respiration."
          },
          {
            id: 5,
            question: "What is the term for animals that eat both plants and meat?",
            options: ["Herbivores", "Carnivores", "Omnivores", "Decomposers"],
            correctAnswer: 2,
            explanation: "Omnivores are animals that consume both plant and animal matter as their primary food source. Examples include humans, bears, raccoons, and many birds. This dietary flexibility provides survival advantages."
          }
        ]
      },
      {
        id: 2,
        name: "Arithmetic Reasoning (AR)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "A military warehouse has 2,400 items in stock. If 15% are shipped out on Monday and 25% of what remains is shipped on Tuesday, how many items are left?",
            options: ["1,530 items", "1,620 items", "1,800 items", "1,920 items"],
            correctAnswer: 0,
            explanation: "Monday shipment: 15% of 2,400 = 360 items. Remaining: 2,400 - 360 = 2,040 items. Tuesday shipment: 25% of 2,040 = 510 items. Final remaining: 2,040 - 510 = 1,530 items."
          },
          {
            id: 2,
            question: "A training exercise requires soldiers to march 18 miles in 6 hours. What is their average speed in miles per hour?",
            options: ["2.5 mph", "3 mph", "3.5 mph", "4 mph"],
            correctAnswer: 1,
            explanation: "Average speed = Total distance ÷ Total time. Therefore: 18 miles ÷ 6 hours = 3 mph average marching speed."
          },
          {
            id: 3,
            question: "If a fuel tank holds 240 gallons and is currently 3/8 full, how many gallons are in the tank?",
            options: ["75 gallons", "80 gallons", "90 gallons", "100 gallons"],
            correctAnswer: 2,
            explanation: "To find 3/8 of 240: (3 ÷ 8) × 240 = 0.375 × 240 = 90 gallons currently in the tank."
          },
          {
            id: 4,
            question: "A squad of 12 soldiers shares the cost of a $276 team building event equally. How much does each soldier pay?",
            options: ["$21", "$23", "$25", "$27"],
            correctAnswer: 1,
            explanation: "Divide the total cost by the number of soldiers: $276 ÷ 12 = $23 per soldier."
          },
          {
            id: 5,
            question: "A shipment contains boxes weighing 45 pounds each. If the total weight is 1,350 pounds, how many boxes are in the shipment?",
            options: ["25 boxes", "28 boxes", "30 boxes", "32 boxes"],
            correctAnswer: 2,
            explanation: "Divide total weight by weight per box: 1,350 ÷ 45 = 30 boxes in the shipment."
          }
        ]
      },
      {
        id: 3,
        name: "Word Knowledge (WK)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Arduous most nearly means:",
            options: ["Simple", "Difficult", "Quick", "Pleasant"],
            correctAnswer: 1,
            explanation: "Arduous means requiring great effort, difficult, or strenuous. Military training often involves arduous physical challenges that test endurance and determination."
          },
          {
            id: 2,
            question: "Tangible most nearly means:",
            options: ["Abstract", "Touchable", "Invisible", "Theoretical"],
            correctAnswer: 1,
            explanation: "Tangible means capable of being touched or perceived by the senses, real and concrete rather than imaginary or abstract. Tangible evidence is physical proof that can be examined."
          },
          {
            id: 3,
            question: "Adversary most nearly means:",
            options: ["Ally", "Friend", "Opponent", "Supervisor"],
            correctAnswer: 2,
            explanation: "An adversary is an opponent, enemy, or someone who actively opposes or competes against another. In military contexts, adversary refers to hostile forces or rival nations."
          },
          {
            id: 4,
            question: "Implement most nearly means:",
            options: ["Destroy", "Carry out", "Postpone", "Criticize"],
            correctAnswer: 1,
            explanation: "Implement means to carry out, execute, or put into effect. Military leaders implement strategies, policies, and operational plans to accomplish mission objectives."
          },
          {
            id: 5,
            question: "Coherent most nearly means:",
            options: ["Confused", "Logical", "Scattered", "Emotional"],
            correctAnswer: 1,
            explanation: "Coherent means logical, consistent, and clearly articulated. Coherent communication is essential in military operations to ensure all personnel understand orders and objectives."
          }
        ]
      },
      {
        id: 4,
        name: "Paragraph Comprehension (PC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Logistics is the backbone of military operations and serves as the critical foundation upon which all military activities depend. It encompasses planning, implementing, and controlling the efficient flow of supplies, equipment, and personnel across vast distances and challenging environments. This complex system involves coordinating transportation, managing inventories, maintaining equipment, and ensuring that every unit has what it needs when it needs it. From ammunition and fuel to food and medical supplies, logistics professionals must anticipate requirements and position resources strategically to support mission objectives.\n\nWithout effective logistics, even the most skilled and well-trained forces cannot sustain operations beyond a brief period. History is filled with examples of military campaigns that failed not due to lack of courage or tactical skill, but because supply lines were disrupted or inadequate. A combat unit without ammunition cannot fight, and soldiers without food and water cannot maintain their effectiveness. Modern military operations are particularly dependent on logistics, as sophisticated equipment requires constant maintenance, spare parts, and technical support. The complexity of today's military systems means that logistical planning must be precise and comprehensive.\n\nSupply chains must be maintained under all conditions, from peacetime training exercises to intense combat deployments in hostile territories. This requirement demands flexibility, resourcefulness, and meticulous planning. Logistics personnel must be prepared to overcome obstacles such as damaged infrastructure, adverse weather, and enemy interference. They develop contingency plans, establish multiple supply routes, and maintain reserve stocks to ensure continuity of operations. The ability to sustain forces over extended periods in challenging environments often determines the outcome of military operations, making logistics a decisive factor in military success.\n\nAccording to the passage, what role does logistics play in military operations?",
            options: ["It's only important during combat", "It's the foundation supporting all operations", "It focuses solely on equipment", "It's less important than training"],
            correctAnswer: 1,
            explanation: "The passage states that logistics is 'the backbone of military operations' and notes that forces 'cannot sustain operations' without effective logistics, establishing it as foundational to all military activities."
          },
          {
            id: 2,
            question: "Military rank structure creates a clear hierarchy that defines authority and responsibility throughout the entire organization. Each rank comes with specific duties and expectations that are well-documented and understood by all service members. This clarity eliminates confusion about who is responsible for what and who has the authority to make which decisions. The rank system also provides a visible framework for career progression, showing personnel the path forward and what they must achieve to advance. From the newest private to the most senior general, everyone knows their place in the organization and what is expected of them.\n\nJunior enlisted personnel focus primarily on executing tasks and developing their technical and tactical skills. They learn their jobs, follow orders, and gradually take on more responsibility as they gain experience. As personnel advance through the ranks, their focus shifts toward leadership, management, and strategic thinking. Senior personnel provide leadership and strategic direction to their units, mentor junior members, and make decisions that affect entire organizations. Non-commissioned officers bridge the gap between junior enlisted and officers, serving as the technical experts and day-to-day leaders who ensure missions are executed properly. Officers provide overall direction and are responsible for planning and decision-making at higher organizational levels.\n\nThis structure ensures missions are accomplished efficiently through organized teamwork. Everyone knows their role and how they contribute to the larger mission. The rank structure facilitates efficient communication, as information flows through established channels. It also ensures continuity of operations, as each position can be filled by someone of the appropriate rank and training. Whether in peacetime or combat, the rank structure provides the organizational framework that allows military forces to function as cohesive, effective units capable of accomplishing complex missions under challenging circumstances.\n\nWhat is the primary purpose of military rank structure?",
            options: ["To create social divisions", "To define authority and organize responsibilities", "To limit communication", "To make promotions difficult"],
            correctAnswer: 1,
            explanation: "The passage explicitly states that rank structure 'defines authority and responsibility' and 'ensures missions are accomplished efficiently', highlighting its organizational purpose."
          },
          {
            id: 3,
            question: "Preventive maintenance is crucial for military equipment reliability and represents one of the most cost-effective practices in military operations. Regular inspections and servicing identify potential problems before they cause failures, allowing maintenance personnel to address issues when convenient rather than during critical operations. These scheduled maintenance activities include checking fluid levels, inspecting components for wear, testing systems, and replacing parts that show signs of deterioration. By following manufacturer guidelines and military maintenance standards, units can dramatically extend the service life of their equipment and avoid unexpected breakdowns.\n\nThis proactive approach reduces costly repairs and minimizes the time equipment spends out of service. When minor issues are caught early, they can often be fixed quickly and inexpensively with simple adjustments or part replacements. However, when these same issues are ignored, they can lead to catastrophic failures that require extensive repairs, expensive replacement parts, and lengthy downtime. For example, failing to change oil regularly can eventually destroy an engine, turning a simple maintenance task into a major repair project. Preventive maintenance also ensures equipment is ready when needed, which is absolutely essential in military operations where delays can have serious consequences.\n\nA well-maintained vehicle fleet can mean the difference between mission success and failure. When military units deploy, they need confidence that their vehicles will perform reliably under demanding conditions. Vehicles that break down can strand personnel, delay critical operations, and even endanger lives in combat situations. Regular preventive maintenance builds this reliability by keeping equipment in peak operating condition. It also helps maintenance personnel become familiar with each vehicle's specific characteristics, allowing them to quickly diagnose problems when they do occur. The discipline of preventive maintenance reflects the military's commitment to operational readiness and mission success.\n\nWhat is the main advantage of preventive maintenance?",
            options: ["It eliminates all equipment problems", "It identifies issues before they cause failures", "It's cheaper than buying new equipment", "It requires less training"],
            correctAnswer: 1,
            explanation: "The passage states that preventive maintenance 'identify potential problems before they cause failures', emphasizing the proactive benefit of catching issues early."
          },
          {
            id: 4,
            question: "Military bearing refers to a service member's appearance, conduct, and demeanor in all situations, both on and off duty. It encompasses everything from maintaining a neat, professional appearance in uniform to demonstrating proper military courtesies and maintaining composure under pressure. Military bearing reflects professionalism, self-discipline, and respect for the uniform and what it represents. It includes standing tall, maintaining eye contact when appropriate, speaking clearly and respectfully, and conducting oneself with confidence and dignity. These external manifestations of military bearing reflect the internal character and values that define professional service members.\n\nGood military bearing inspires confidence in subordinates and earns respect from peers and superiors alike. When leaders display strong military bearing, their subordinates feel more secure and confident in following their guidance. They project an image of competence and reliability that makes others want to emulate them. Similarly, peers and superiors recognize and respect service members who consistently demonstrate professional standards in their appearance and conduct. This respect is not given automatically with rank; it must be earned through consistent demonstration of military values and professionalism. Military bearing creates a positive first impression and reinforces the reputation of the entire military organization.\n\nIt demonstrates that a service member takes pride in their role and responsibilities within the armed forces. Someone with good military bearing shows attention to detail in their appearance, suggesting they will bring the same attention to their duties. They show self-discipline by maintaining standards even when not directly supervised. They show respect for tradition and the sacrifices of those who served before them by honoring the uniform and military customs. In essence, military bearing is the outward expression of the commitment, professionalism, and pride that should characterize every service member, regardless of their specific job or rank.\n\nWhat does military bearing demonstrate?",
            options: ["Physical strength only", "Professionalism and self-discipline", "Academic achievement", "Technical expertise"],
            correctAnswer: 1,
            explanation: "The passage defines military bearing as reflecting 'professionalism, self-discipline, and respect' and states it shows a service member 'takes pride in their role', emphasizing these character qualities."
          },
          {
            id: 5,
            question: "Tactical operations require careful planning and adaptation to be successful in complex and unpredictable environments. Commanders analyze multiple factors including terrain, weather conditions, enemy capabilities, and available resources before developing their operational plans. They study maps to understand how terrain features might influence movement and combat, review weather forecasts to anticipate how conditions might affect operations, gather intelligence on enemy strength and tactics, and assess their own unit's capabilities and limitations. This thorough analysis allows commanders to develop plans that maximize their advantages while minimizing vulnerabilities. The planning process also helps identify potential problems and develop contingency plans to address them.\n\nHowever, conditions change rapidly in dynamic military environments, and no plan survives first contact with the enemy unchanged. Unexpected obstacles may appear, weather may shift, enemy forces may behave differently than anticipated, or friendly forces may encounter difficulties. Equipment may malfunction, reinforcements may be delayed, or new opportunities may present themselves. In combat, the situation is constantly evolving, and commanders must be prepared to respond to these changes quickly and effectively. Rigid adherence to a plan when circumstances have changed can lead to failure, while excessive improvisation without regard for objectives can result in wasted effort and confusion.\n\nSuccessful units maintain flexibility to adjust tactics while keeping mission objectives in focus. They understand that tactics are simply the means to achieve objectives, not ends in themselves. When one approach isn't working, they quickly shift to alternatives without losing sight of what they're trying to accomplish. This requires well-trained personnel who understand both the plan and the commander's intent, allowing them to make appropriate decisions when communications are disrupted or situations change faster than orders can be issued. The balance between careful planning and tactical flexibility represents one of the key challenges of military operations and distinguishes effective units from ineffective ones.\n\nAccording to the passage, what is essential for tactical success?",
            options: ["Following rigid plans", "Having superior numbers", "Maintaining flexibility while focused on objectives", "Avoiding all risks"],
            correctAnswer: 2,
            explanation: "The passage emphasizes that 'successful units maintain flexibility to adjust tactics while keeping mission objectives in focus', identifying this balance as key to tactical success."
          }
        ]
      },
      {
        id: 5,
        name: "Mathematics Knowledge (MK)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What is the value of 8³?",
            options: ["24", "64", "256", "512"],
            correctAnswer: 3,
            explanation: "8³ means 8 × 8 × 8. First: 8 × 8 = 64. Then: 64 × 8 = 512."
          },
          {
            id: 2,
            question: "If 5x - 12 = 38, what is the value of x?",
            options: ["8", "10", "12", "14"],
            correctAnswer: 1,
            explanation: "Solve for x: 5x - 12 = 38. Add 12 to both sides: 5x = 50. Divide by 5: x = 10."
          },
          {
            id: 3,
            question: "What is the circumference of a circle with a radius of 7 meters? (Use π ≈ 3.14)",
            options: ["21.98 meters", "38.47 meters", "43.96 meters", "153.86 meters"],
            correctAnswer: 2,
            explanation: "Circumference = 2πr. Therefore: 2 × 3.14 × 7 = 43.96 meters."
          },
          {
            id: 4,
            question: "What is 18% of 350?",
            options: ["54", "58", "63", "68"],
            correctAnswer: 2,
            explanation: "Convert 18% to decimal (0.18) and multiply: 0.18 × 350 = 63."
          },
          {
            id: 5,
            question: "If the perimeter of a square is 64 inches, what is the length of one side?",
            options: ["12 inches", "14 inches", "16 inches", "18 inches"],
            correctAnswer: 2,
            explanation: "A square has 4 equal sides. Perimeter = 4 × side length. Therefore: 64 ÷ 4 = 16 inches per side."
          }
        ]
      },
      {
        id: 6,
        name: "Electronics Information (EI)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What is the unit of measurement for electrical power?",
            options: ["Ampere", "Volt", "Ohm", "Watt"],
            correctAnswer: 3,
            explanation: "The watt (W) is the SI unit of power, measuring the rate of energy transfer or conversion. One watt equals one joule per second. Electrical power = voltage × current (P = V × I)."
          },
          {
            id: 2,
            question: "What device is used to step up or step down AC voltage?",
            options: ["Resistor", "Capacitor", "Transformer", "Diode"],
            correctAnswer: 2,
            explanation: "A transformer changes AC voltage levels using electromagnetic induction between two or more coils. Step-up transformers increase voltage while step-down transformers decrease it, following the turns ratio principle."
          },
          {
            id: 3,
            question: "In a parallel circuit with two resistors, how does the total resistance compare to the individual resistors?",
            options: ["Greater than both resistors", "Equal to the sum of resistors", "Less than the smallest resistor", "Equal to the largest resistor"],
            correctAnswer: 2,
            explanation: "In parallel circuits, total resistance is always less than the smallest individual resistor. The formula is 1/R_total = 1/R1 + 1/R2 + 1/R3... Parallel paths provide multiple routes for current flow."
          },
          {
            id: 4,
            question: "What does DC stand for in electrical terminology?",
            options: ["Direct Current", "Distributed Current", "Dual Current", "Dynamic Current"],
            correctAnswer: 0,
            explanation: "DC stands for Direct Current, where electric charge flows in one constant direction. Batteries and solar cells produce DC power. Many electronic devices use DC internally even when powered by AC outlets."
          },
          {
            id: 5,
            question: "Which component allows current to flow in only one direction?",
            options: ["Resistor", "Capacitor", "Diode", "Inductor"],
            correctAnswer: 2,
            explanation: "A diode is a semiconductor device that permits current flow in one direction while blocking it in the opposite direction. This property makes diodes essential for rectifying AC to DC and protecting circuits."
          }
        ]
      },
      {
        id: 7,
        name: "Auto & Shop Information (AS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What component in a vehicle's braking system multiplies the force applied to the brake pedal?",
            options: ["Brake pads", "Master cylinder", "Brake booster", "Caliper"],
            correctAnswer: 2,
            explanation: "The brake booster uses engine vacuum or hydraulic pressure to multiply the force applied to the brake pedal, making it easier to stop the vehicle. Without it, much greater pedal pressure would be required."
          },
          {
            id: 2,
            question: "What tool is specifically designed to remove rounded or stripped bolt heads?",
            options: ["Allen wrench", "Socket wrench", "Extractor set", "Torque wrench"],
            correctAnswer: 2,
            explanation: "An extractor set (or bolt extractor) is specifically designed to grip and remove damaged, rounded, or stripped bolt heads. They often have reverse threads and bite into the bolt as you turn them counterclockwise."
          },
          {
            id: 3,
            question: "What automotive system is responsible for reducing harmful emissions before they exit the exhaust?",
            options: ["Fuel injection system", "Ignition system", "Catalytic converter", "Cooling system"],
            correctAnswer: 2,
            explanation: "The catalytic converter uses chemical reactions to convert harmful pollutants like carbon monoxide, nitrogen oxides, and hydrocarbons into less harmful substances (water vapor, carbon dioxide, nitrogen) before exhaust gases leave the vehicle."
          },
          {
            id: 4,
            question: "What is the purpose of a pilot hole when drilling?",
            options: ["To weaken the material", "To guide the larger drill bit and prevent wandering", "To create decorative patterns", "To test drill bit sharpness"],
            correctAnswer: 1,
            explanation: "A pilot hole is a small hole drilled first to guide a larger bit and prevent it from wandering off center. It also reduces the chance of splitting wood and makes drilling larger holes easier and more accurate."
          },
          {
            id: 5,
            question: "What does the viscosity rating (such as 10W-30) on motor oil indicate?",
            options: ["The oil's color", "The oil's thickness at different temperatures", "The oil's age", "The oil's brand quality"],
            correctAnswer: 1,
            explanation: "Viscosity ratings indicate oil thickness (flow resistance) at different temperatures. The 'W' stands for winter (cold temperature rating), and the second number represents thickness at operating temperature. 10W-30 flows well when cold but maintains protection when hot."
          }
        ]
      },
      {
        id: 8,
        name: "Mechanical Comprehension (MC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "A pulley system uses 4 supporting ropes. If a load weighs 400 pounds, approximately how much force is needed to lift it (ignoring friction)?",
            options: ["400 pounds", "200 pounds", "100 pounds", "50 pounds"],
            correctAnswer: 2,
            explanation: "In a pulley system, the load is distributed across all supporting ropes. With 4 ropes supporting the load, the force required is approximately 400 ÷ 4 = 100 pounds. This demonstrates mechanical advantage."
          },
          {
            id: 2,
            question: "Two identical containers are filled with water to the same level. One has a rock submerged in it. How do the pressures at the bottom of the containers compare?",
            options: ["The container with the rock has higher pressure", "The container without the rock has higher pressure", "Both have equal pressure", "Pressure cannot be determined"],
            correctAnswer: 2,
            explanation: "Water pressure at a given depth depends only on the height of the water column above that point, not on what's submerged in it. Since water levels are equal, bottom pressures are equal (P = ρgh)."
          },
          {
            id: 3,
            question: "A screwdriver is being used to pry open a paint can lid. What type of simple machine is the screwdriver acting as?",
            options: ["Wheel and axle", "Pulley", "Lever", "Inclined plane"],
            correctAnswer: 2,
            explanation: "When prying with a screwdriver, it acts as a lever. The edge of the can rim serves as the fulcrum, the handle is where effort is applied, and the blade applies force to lift the lid (load)."
          },
          {
            id: 4,
            question: "Why do vehicle tires have treaded patterns instead of smooth surfaces?",
            options: ["To look more attractive", "To increase friction and channel away water", "To reduce fuel efficiency", "To make more noise"],
            correctAnswer: 1,
            explanation: "Tire treads increase traction by providing channels for water, mud, and debris to escape, maintaining contact between rubber and road. Tread patterns also provide biting edges that increase friction, especially on wet or loose surfaces."
          },
          {
            id: 5,
            question: "A 10-foot board is balanced on a fulcrum 4 feet from one end. If a 60-pound weight is placed on the short end, how much weight is needed on the long end to balance it?",
            options: ["30 pounds", "35 pounds", "40 pounds", "45 pounds"],
            correctAnswer: 2,
            explanation: "For balance, torque on both sides must be equal: Force × Distance. Short side: 60 lbs × 4 ft = 240 ft-lbs. Long side: 6 ft from fulcrum, so 240 ÷ 6 = 40 pounds needed for balance."
          }
        ]
      },
      {
        id: 9,
        name: "Assembling Objects (AO)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Which arrangement connects six points to form a hexagon?",
            options: ["Six points in a circle", "Six points in a straight line", "Six points in two parallel rows", "Six points forming a star"],
            correctAnswer: 0,
            explanation: "A hexagon is a six-sided polygon. When six points are arranged in a circular pattern with equal spacing and connected to adjacent points, they form a regular hexagon with six equal sides and six equal angles."
          },
          {
            id: 2,
            question: "If you have two identical semicircles, which configuration creates a complete circle?",
            options: ["Placing them side by side", "Placing curved edges together", "Stacking them vertically", "Overlapping them partially"],
            correctAnswer: 1,
            explanation: "Two semicircles (half circles) create a complete circle when their curved edges are aligned and joined together. The straight edges of each semicircle become the diameter that divides the circle in half."
          },
          {
            id: 3,
            question: "Four identical cubes are stacked in a 2×2 arrangement. What is the resulting shape?",
            options: ["A rectangular prism", "A larger cube", "A cylinder", "A pyramid"],
            correctAnswer: 1,
            explanation: "When four identical cubes are arranged in a 2×2 pattern (two cubes wide, two cubes deep, one cube high), they form a larger cube with dimensions twice that of the individual cubes."
          },
          {
            id: 4,
            question: "Which connection method creates the strongest joint between two flat pieces of wood meeting at their edges?",
            options: ["Butt joint (edges touching)", "Lap joint (pieces overlapping)", "Miter joint (45-degree angles)", "Dovetail joint (interlocking fingers)"],
            correctAnswer: 3,
            explanation: "A dovetail joint, where interlocking wedge-shaped fingers fit together, creates the strongest connection. The interlocking design resists pulling apart and provides large gluing surface area, making it ideal for drawers and fine woodworking."
          },
          {
            id: 5,
            question: "Six identical rectangular panels are arranged to form a closed box. How many panels form the faces of the box?",
            options: ["4 panels", "5 panels", "6 panels", "8 panels"],
            correctAnswer: 2,
            explanation: "A rectangular box (rectangular prism) has exactly 6 faces: top, bottom, front, back, left side, and right side. Six rectangular panels are needed to create a closed box."
          }
        ]
      },
      {
        id: 10,
        name: "Verbal Expression (VE)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Choose the sentence with correct grammar:",
            options: ["Each of the soldiers have completed their training.", "Each of the soldiers has completed their training.", "Each of the soldiers has completed his or her training.", "Each of the soldiers were completing their training."],
            correctAnswer: 2,
            explanation: "The subject 'each' is singular and requires the singular verb 'has'. Additionally, the pronoun must agree with the singular subject, so 'his or her' is correct rather than the plural 'their'."
          },
          {
            id: 2,
            question: "Identify the sentence with correct punctuation:",
            options: ["The equipment includes; rifles, helmets, and vests.", "The equipment includes: rifles helmets and vests.", "The equipment includes rifles, helmets, and vests.", "The equipment includes, rifles helmets, and vests."],
            correctAnswer: 2,
            explanation: "A simple list following a complete independent clause requires commas to separate items, with no additional punctuation before the list begins. Semicolons and colons are unnecessary here."
          },
          {
            id: 3,
            question: "Which word best completes the sentence: 'The commander will _______ a new training protocol next month.'",
            options: ["adapt", "adopt", "adept", "except"],
            correctAnswer: 1,
            explanation: "'Adopt' means to formally accept or put into use. 'Adapt' means to modify or adjust. When implementing a new protocol, you adopt it. Adept means skilled, and except means to exclude."
          },
          {
            id: 4,
            question: "Select the sentence with proper subject-verb agreement:",
            options: ["The team of specialists are arriving tomorrow.", "The team of specialists is arriving tomorrow.", "The team of specialists were arriving tomorrow.", "The team of specialists have arrived tomorrow."],
            correctAnswer: 1,
            explanation: "The subject is 'team' (singular collective noun), not 'specialists'. Singular subjects require singular verbs, so 'is arriving' is correct. The phrase 'of specialists' is a prepositional phrase that doesn't affect verb agreement."
          },
          {
            id: 5,
            question: "Which sentence uses the correct form of 'its' or 'it's'?",
            options: ["The unit completed it's mission successfully.", "The unit completed its mission successfully.", "The unit completed its' mission successfully.", "The unit completed it's' mission successfully."],
            correctAnswer: 1,
            explanation: "'Its' (no apostrophe) is the possessive form meaning 'belonging to it'. 'It's' (with apostrophe) is a contraction of 'it is' or 'it has'. The sentence requires the possessive form: 'its mission'."
          }
        ]
      }
    ]
  },,
  {
    id: 13,
    title: "ASVAB Practice Test #13",
    description: "Comprehensive practice exam covering all 10 ASVAB sections with military-standard questions",
    totalQuestions: 50,
    timeLimit: 60,
    sections: [
      {
        id: 1,
        name: "General Science (GS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Which layer of Earth's atmosphere contains the ozone layer that protects us from ultraviolet radiation?",
            options: ["Troposphere", "Stratosphere", "Mesosphere", "Thermosphere"],
            correctAnswer: 1,
            explanation: "The stratosphere, located approximately 10-50 km above Earth's surface, contains the ozone layer which absorbs most of the Sun's harmful ultraviolet radiation."
          },
          {
            id: 2,
            question: "In Mendelian genetics, if both parents are heterozygous for a trait (Aa), what percentage of offspring will display the recessive phenotype?",
            options: ["0%", "25%", "50%", "75%"],
            correctAnswer: 1,
            explanation: "Using a Punnett square: AA (25%), Aa (50%), aa (25%). Only the aa genotype (25%) displays the recessive phenotype."
          },
          {
            id: 3,
            question: "What type of chemical bond involves the sharing of electron pairs between atoms?",
            options: ["Ionic bond", "Covalent bond", "Metallic bond", "Hydrogen bond"],
            correctAnswer: 1,
            explanation: "Covalent bonds form when atoms share one or more pairs of electrons to achieve stable electron configurations. This is distinct from ionic bonds where electrons are transferred."
          },
          {
            id: 4,
            question: "Which organelle is often called the 'powerhouse of the cell' because it produces ATP through cellular respiration?",
            options: ["Nucleus", "Ribosome", "Mitochondria", "Chloroplast"],
            correctAnswer: 2,
            explanation: "Mitochondria generate most of the cell's supply of ATP (adenosine triphosphate) through aerobic respiration, providing energy for cellular processes."
          },
          {
            id: 5,
            question: "What is the term for the force that opposes the motion of one surface sliding past another?",
            options: ["Gravity", "Friction", "Inertia", "Momentum"],
            correctAnswer: 1,
            explanation: "Friction is the resistive force that occurs when two surfaces move or attempt to move across each other. It converts kinetic energy into thermal energy."
          }
        ]
      },
      {
        id: 2,
        name: "Arithmetic Reasoning (AR)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "A military base cafeteria serves 1,800 meals per day. If 40% are breakfast meals, 35% are lunch meals, and the rest are dinner meals, how many dinner meals are served?",
            options: ["360 meals", "450 meals", "540 meals", "630 meals"],
            correctAnswer: 1,
            explanation: "Breakfast and lunch: 40% + 35% = 75%. Dinner: 100% - 75% = 25%. Calculation: 25% of 1,800 = 0.25 × 1,800 = 450 meals"
          },
          {
            id: 2,
            question: "A soldier runs 3 miles in 24 minutes. At this pace, how long would it take to run 8 miles?",
            options: ["56 minutes", "60 minutes", "64 minutes", "68 minutes"],
            correctAnswer: 2,
            explanation: "Pace: 24 minutes ÷ 3 miles = 8 minutes per mile. For 8 miles: 8 × 8 = 64 minutes"
          },
          {
            id: 3,
            question: "A warehouse has 2,400 supply boxes. If 5/8 of them are shipped out on Monday, how many boxes remain?",
            options: ["900 boxes", "1,000 boxes", "1,200 boxes", "1,500 boxes"],
            correctAnswer: 0,
            explanation: "Shipped: 5/8 × 2,400 = 1,500 boxes. Remaining: 2,400 - 1,500 = 900 boxes"
          },
          {
            id: 4,
            question: "If a jeep's fuel tank holds 18 gallons and it gets 14 miles per gallon, how far can it travel on 3/4 of a tank?",
            options: ["168 miles", "189 miles", "210 miles", "252 miles"],
            correctAnswer: 1,
            explanation: "Fuel available: 3/4 × 18 = 13.5 gallons. Distance: 13.5 × 14 = 189 miles"
          },
          {
            id: 5,
            question: "A training exercise costs $12,500 to conduct. If costs are reduced by 18%, what is the new cost?",
            options: ["$10,000", "$10,250", "$10,500", "$10,750"],
            correctAnswer: 1,
            explanation: "Reduction: 18% of $12,500 = 0.18 × $12,500 = $2,250. New cost: $12,500 - $2,250 = $10,250"
          }
        ]
      },
      {
        id: 3,
        name: "Word Knowledge (WK)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Meticulous most nearly means:",
            options: ["Careless", "Extremely careful and precise", "Average", "Quick"],
            correctAnswer: 1,
            explanation: "Meticulous means showing great attention to detail; very careful and precise in one's work or actions."
          },
          {
            id: 2,
            question: "Adversary most nearly means:",
            options: ["Friend", "Opponent or enemy", "Colleague", "Supervisor"],
            correctAnswer: 1,
            explanation: "An adversary is one's opponent in a contest, conflict, or dispute; an enemy or rival."
          },
          {
            id: 3,
            question: "Illuminate most nearly means:",
            options: ["Darken", "Light up or clarify", "Confuse", "Hide"],
            correctAnswer: 1,
            explanation: "Illuminate means to light up or to make something clearer by explanation. It can be literal (provide light) or figurative (provide understanding)."
          },
          {
            id: 4,
            question: "Fortify most nearly means:",
            options: ["Weaken", "Strengthen or reinforce", "Abandon", "Destroy"],
            correctAnswer: 1,
            explanation: "Fortify means to strengthen or secure a place with defensive works, or to strengthen mentally or physically."
          },
          {
            id: 5,
            question: "Concise most nearly means:",
            options: ["Lengthy", "Brief but comprehensive", "Vague", "Complex"],
            correctAnswer: 1,
            explanation: "Concise means giving a lot of information clearly and in few words; brief yet comprehensive."
          }
        ]
      },
      {
        id: 4,
        name: "Paragraph Comprehension (PC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Military intelligence gathering relies on multiple sources to verify information accuracy and ensure that critical decisions are based on reliable data. Single-source intelligence can be unreliable because it lacks corroboration from other sources and may be affected by bias, deception, or simple error. A single informant might provide false information, a sensor might malfunction, or an intercepted communication might be deliberately misleading. Without additional sources to confirm or contradict the initial intelligence, analysts have no way to assess its reliability. This vulnerability makes single-source intelligence dangerous to rely upon for important military decisions.\n\nAnalysts must cross-reference data from human intelligence, signal intelligence, and imagery intelligence to build a complete picture of the situation. Human intelligence provides insights from sources on the ground, including informants, interrogations, and observations by friendly personnel. Signal intelligence involves intercepting and analyzing enemy communications and electronic emissions. Imagery intelligence uses photographs and video from satellites, aircraft, and drones to provide visual confirmation of activities and capabilities. When information from these different sources aligns and supports the same conclusions, analysts can have much greater confidence in their assessments. Conversely, when sources contradict each other, it alerts analysts that further investigation is needed.\n\nThis multi-source approach reduces the risk of acting on false information and helps military commanders make better-informed decisions. Intelligence failures throughout history have often resulted from relying too heavily on single sources or failing to question information that seemed to confirm existing beliefs. By systematically comparing multiple independent sources, analysts can identify deception, recognize gaps in understanding, and develop more accurate assessments of enemy capabilities and intentions. This thorough approach takes more time and resources than simply accepting information at face value, but the improved accuracy is essential for effective military operations and can prevent costly mistakes.\n\nWhat is the main point of this passage?",
            options: ["Signal intelligence is the most reliable source", "Single sources are always wrong", "Multiple intelligence sources improve accuracy", "Human intelligence is unnecessary"],
            correctAnswer: 2,
            explanation: "The passage emphasizes that using multiple intelligence sources and cross-referencing them reduces unreliability and improves accuracy, making option 2 the main point."
          },
          {
            id: 2,
            question: "The Marine Corps emphasizes physical fitness as a combat multiplier, meaning it enhances every other aspect of combat capability. Studies show that physically fit Marines experience fewer injuries during training and combat operations, reducing casualty rates and keeping more personnel available for duty. When injuries do occur, fit Marines recover faster from wounds due to their stronger cardiovascular systems, better circulation, and overall health. Their bodies are better equipped to heal and bounce back from physical trauma. Additionally, physically fit Marines perform better under stress, maintaining their effectiveness even when fatigued, operating in extreme conditions, or facing the chaos of combat.\n\nThe daily physical training regimen builds not only strength and endurance but also mental resilience that proves invaluable in challenging situations. The discipline required to push through difficult workouts translates directly to the mental toughness needed in combat. Physical training teaches Marines to keep going when everything in their body wants to stop, to push past perceived limitations, and to accomplish missions despite discomfort and exhaustion. This mental conditioning is just as important as the physical conditioning for combat effectiveness.\n\nFurthermore, physical training builds unit cohesion as Marines train together, encourage each other, and share the common experience of challenging workouts. They learn to work as a team, support their fellow Marines, and take pride in their collective accomplishments. This bonding creates the trust and camaraderie essential for effective military units. Group physical training also establishes shared standards and expectations, reinforcing that every Marine must meet the same fitness requirements regardless of their specific job specialty. The Marine Corps' emphasis on fitness reflects its understanding that physical conditioning affects every aspect of combat readiness and mission success.\n\nAccording to the passage, physical fitness benefits Marines in all of the following ways EXCEPT:",
            options: ["Faster wound recovery", "Better stress performance", "Increased academic knowledge", "Improved mental resilience"],
            correctAnswer: 2,
            explanation: "The passage mentions injury reduction, faster recovery, stress performance, mental resilience, and unit cohesion, but does not mention academic knowledge."
          },
          {
            id: 3,
            question: "Navigation by stars has been practiced for thousands of years and enabled ancient mariners to cross vast oceans long before modern technology existed. Sailors identified constellations and their positions to determine direction and latitude with remarkable accuracy. By observing which stars were visible and measuring their angles above the horizon, skilled navigators could calculate their position and plot courses across open waters. This knowledge was passed down through generations and refined over centuries, allowing civilizations to explore, trade, and establish empires across the seas. Different cultures developed their own celestial navigation techniques based on the stars visible from their regions.\n\nPolaris, the North Star, remains nearly fixed in the northern sky due to its alignment with Earth's rotational axis, making it particularly valuable for navigation. While other stars appear to move across the sky throughout the night as Earth rotates, Polaris stays in essentially the same position, always indicating true north. This reliability makes it an ideal reference point for determining direction. Navigators in the Northern Hemisphere can find their latitude by measuring the angle between Polaris and the horizon. The higher Polaris appears in the sky, the farther north the observer is located. This simple yet powerful technique allowed sailors to determine their north-south position with reasonable accuracy.\n\nModern GPS has largely replaced celestial navigation in daily maritime operations, providing instant, precise positioning information at the touch of a button. However, celestial navigation remains a backup skill taught to naval personnel because GPS systems can fail, be jammed, or become unavailable. In the event of equipment failure, electrical problems, or enemy interference with satellite signals, the ability to navigate by stars could mean the difference between safely reaching port and becoming hopelessly lost. This redundancy reflects the military's practical approach to navigation: use the best available technology but maintain traditional skills as insurance against technological failure.\n\nWhat can be inferred from this passage?",
            options: ["GPS is completely unreliable", "Star navigation is no longer taught", "Traditional skills have backup value in modern military", "Polaris moves significantly across the sky"],
            correctAnswer: 2,
            explanation: "The passage states that celestial navigation is still taught as a backup skill despite GPS availability, supporting the inference in option 2."
          },
          {
            id: 4,
            question: "Camouflage patterns disrupt the human outline, making it harder for observers to identify personnel against varied backgrounds. The human form is distinctive and easily recognizable, with straight lines, symmetrical features, and characteristic proportions that stand out in natural environments. Camouflage breaks up these recognizable features using irregular patterns, colors, and textures that blend with the surrounding terrain. When properly applied, camouflage makes the wearer much more difficult to spot, even at relatively close range. This concealment provides a significant tactical advantage by allowing personnel to observe, move, and operate without being detected by enemy forces.\n\nDifferent environments require different patterns to achieve effective concealment: woodland, desert, arctic, and urban. Woodland patterns use greens, browns, and blacks to match forested and vegetated areas. Desert patterns employ tans, browns, and lighter colors to blend with sandy and rocky terrain. Arctic patterns use white and light gray to provide concealment in snow-covered environments. Urban patterns incorporate grays and other colors found in cities and built-up areas. Using the wrong pattern in a given environment defeats the purpose of camouflage, as a desert pattern would stand out obviously in a forest, and a woodland pattern would be equally visible in a desert.\n\nModern digital patterns use pixelated designs that confuse the eye at multiple distances by creating a more effective disruption of the human outline. The small squares or pixels in these patterns work at both close and far ranges, whereas traditional patterns might be effective at one distance but not another. The effectiveness of camouflage depends on matching the pattern to the operational environment and considering factors like lighting conditions, seasons, and vegetation. Even the best camouflage pattern becomes ineffective if used in the wrong setting, which is why military forces maintain multiple camouflage variations and train personnel to select appropriate patterns for their missions.\n\nThe author's main purpose is to:",
            options: ["Argue that digital patterns are superior to all others", "Explain how and why camouflage patterns work", "Criticize old camouflage designs", "Promote a specific camouflage pattern"],
            correctAnswer: 1,
            explanation: "The passage explains the purpose of camouflage (disrupting outline), mentions different types, and describes how they work, making option 1 the main purpose."
          },
          {
            id: 5,
            question: "Leadership in combat differs from peacetime leadership due to the immediate life-or-death stakes that accompany every decision. Combat leaders must make rapid decisions with incomplete information while maintaining unit morale under extreme stress. In peacetime, leaders typically have time to gather information, consult with others, and carefully consider options before making decisions. Combat allows no such luxury. Situations develop rapidly, information is fragmentary and often contradictory, and delays can cost lives. Leaders must act decisively even when uncertain, accepting that some decisions will be made with limited knowledge. The stress of combat also affects everyone differently, and leaders must manage their own fear and stress while projecting confidence and maintaining the fighting spirit of their unit.\n\nTraining exercises simulate combat conditions to prepare leaders for this pressure by exposing them to realistic scenarios, time constraints, and stress. Live-fire exercises, field training exercises, and war games all attempt to replicate the chaos and confusion of actual combat. These training experiences are invaluable for developing leadership skills and identifying potential problems before personnel face real combat. Leaders learn to make quick decisions, communicate under pressure, and manage the challenges of coordinating military operations. They also learn from mistakes in training environments where errors don't result in actual casualties. This preparation significantly improves leader readiness and unit effectiveness.\n\nHowever, actual combat experience reveals each leader's true capabilities in ways that training cannot fully replicate. No matter how realistic training becomes, everyone knows that training exercises eventually end and that the consequences of mistakes are limited. In actual combat, there is no reset button, and poor decisions can result in death and mission failure. Some leaders who excelled in training discover they cannot handle the psychological pressure of real combat, while others who seemed unremarkable in peacetime demonstrate exceptional courage and decision-making ability under fire. Combat tests every aspect of leadership: judgment, courage, decisiveness, communication skills, and the ability to inspire others when lives are on the line.\n\nWhat is implied about combat leadership?",
            options: ["Training fully prepares leaders for combat", "Peacetime and combat leadership are identical", "True leadership ability is tested under actual combat conditions", "Combat leaders never use peacetime skills"],
            correctAnswer: 2,
            explanation: "The passage states that 'actual combat experience reveals each leader's true capabilities,' directly supporting the implication in option 2."
          }
        ]
      },
      {
        id: 5,
        name: "Mathematics Knowledge (MK)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Solve for x: 3x - 7 = 2x + 11",
            options: ["x = 4", "x = 9", "x = 14", "x = 18"],
            correctAnswer: 3,
            explanation: "Subtract 2x from both sides: x - 7 = 11. Add 7 to both sides: x = 18"
          },
          {
            id: 2,
            question: "What is the area of a triangle with a base of 16 inches and a height of 9 inches?",
            options: ["72 square inches", "80 square inches", "96 square inches", "144 square inches"],
            correctAnswer: 0,
            explanation: "Area of a triangle = (1/2) × base × height = (1/2) × 16 × 9 = 72 square inches"
          },
          {
            id: 3,
            question: "If 2^x = 32, what is the value of x?",
            options: ["4", "5", "6", "7"],
            correctAnswer: 1,
            explanation: "2^5 = 2 × 2 × 2 × 2 × 2 = 32, therefore x = 5"
          },
          {
            id: 4,
            question: "What is the perimeter of a rectangle with length 13 meters and width 8 meters?",
            options: ["21 meters", "34 meters", "42 meters", "104 meters"],
            correctAnswer: 2,
            explanation: "Perimeter of rectangle = 2(length + width) = 2(13 + 8) = 2(21) = 42 meters"
          },
          {
            id: 5,
            question: "Simplify: (x^4)(x^3)",
            options: ["x^7", "x^12", "x^1", "2x^7"],
            correctAnswer: 0,
            explanation: "When multiplying powers with the same base, add the exponents: x^4 × x^3 = x^(4+3) = x^7"
          }
        ]
      },
      {
        id: 6,
        name: "Electronics Information (EI)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What is the primary function of a capacitor in an electrical circuit?",
            options: ["Convert AC to DC", "Store electrical energy", "Increase voltage", "Measure current"],
            correctAnswer: 1,
            explanation: "A capacitor stores electrical energy in an electric field between two conductive plates separated by an insulator (dielectric)."
          },
          {
            id: 2,
            question: "In a series circuit with three resistors (R1=10Ω, R2=20Ω, R3=30Ω), what is the total resistance?",
            options: ["20Ω", "30Ω", "60Ω", "6,000Ω"],
            correctAnswer: 2,
            explanation: "In a series circuit, total resistance is the sum of all resistances: R_total = 10 + 20 + 30 = 60Ω"
          },
          {
            id: 3,
            question: "What does LED stand for in electronics?",
            options: ["Light Emitting Diode", "Low Energy Device", "Linear Electronic Display", "Level Energy Detector"],
            correctAnswer: 0,
            explanation: "LED stands for Light Emitting Diode, a semiconductor device that emits light when current flows through it."
          },
          {
            id: 4,
            question: "Using Ohm's Law, if voltage is 24 volts and resistance is 8 ohms, what is the current?",
            options: ["2 amperes", "3 amperes", "16 amperes", "192 amperes"],
            correctAnswer: 1,
            explanation: "Ohm's Law: V = I × R, therefore I = V/R = 24/8 = 3 amperes"
          },
          {
            id: 5,
            question: "What type of current does a standard household outlet in the United States provide?",
            options: ["Direct Current (DC)", "Alternating Current (AC)", "Pulsed Current", "Static Current"],
            correctAnswer: 1,
            explanation: "U.S. household outlets provide Alternating Current (AC) at approximately 120 volts and 60 Hz."
          }
        ]
      },
      {
        id: 7,
        name: "Auto & Shop Information (AS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What is the primary purpose of a vehicle's alternator?",
            options: ["Start the engine", "Generate electrical power while the engine runs", "Cool the engine", "Control fuel injection"],
            correctAnswer: 1,
            explanation: "The alternator generates electrical power while the engine is running, charging the battery and powering electrical systems."
          },
          {
            id: 2,
            question: "Which hand tool is specifically designed for gripping and turning nuts and bolts?",
            options: ["Pliers", "Wrench", "Screwdriver", "Chisel"],
            correctAnswer: 1,
            explanation: "A wrench (or spanner) is specifically designed to provide grip and mechanical advantage for turning nuts, bolts, and other fasteners."
          },
          {
            id: 3,
            question: "What does it mean when a vehicle's engine is 'knocking' or 'pinging'?",
            options: ["Normal combustion", "Premature fuel ignition in the cylinder", "Loose exhaust pipe", "Low oil level"],
            correctAnswer: 1,
            explanation: "Engine knocking occurs when fuel ignites prematurely in the combustion chamber before the spark plug fires, often due to low-octane fuel or excessive heat."
          },
          {
            id: 4,
            question: "What is the purpose of a torque wrench?",
            options: ["Remove rusted bolts", "Tighten fasteners to a specific tension", "Measure bolt diameter", "Cut through metal"],
            correctAnswer: 1,
            explanation: "A torque wrench is used to apply a specific amount of torque (rotational force) to fasteners, ensuring they are tightened to manufacturer specifications."
          },
          {
            id: 5,
            question: "In woodworking, what is the primary use of a plane?",
            options: ["Drill holes", "Smooth and shape wood surfaces", "Cut large boards", "Join pieces together"],
            correctAnswer: 1,
            explanation: "A plane is a hand tool used to shave thin layers from wood surfaces, smoothing them and reducing thickness to desired dimensions."
          }
        ]
      },
      {
        id: 8,
        name: "Mechanical Comprehension (MC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "A first-class lever has the fulcrum between the effort and the load. If the effort arm is 4 feet and the load arm is 2 feet, what is the mechanical advantage?",
            options: ["0.5", "2", "6", "8"],
            correctAnswer: 1,
            explanation: "Mechanical advantage = effort arm ÷ load arm = 4 ÷ 2 = 2. This means the force is multiplied by 2."
          },
          {
            id: 2,
            question: "Two gears are meshed together. If the driver gear has 40 teeth and rotates at 200 RPM, and the driven gear has 20 teeth, at what speed does the driven gear rotate?",
            options: ["100 RPM", "200 RPM", "400 RPM", "800 RPM"],
            correctAnswer: 2,
            explanation: "Gear ratio = 40/20 = 2. The driven gear rotates twice as fast: 200 × 2 = 400 RPM"
          },
          {
            id: 3,
            question: "What happens to the pressure in a closed hydraulic system when force is applied to one piston?",
            options: ["Pressure decreases throughout", "Pressure increases only at that piston", "Pressure increases equally throughout", "Pressure remains unchanged"],
            correctAnswer: 2,
            explanation: "According to Pascal's Law, pressure applied to a confined fluid is transmitted equally in all directions throughout the fluid."
          },
          {
            id: 4,
            question: "A pulley system has 4 supporting ropes. Ignoring friction, how much force is needed to lift a 400-pound load?",
            options: ["50 pounds", "100 pounds", "200 pounds", "400 pounds"],
            correctAnswer: 1,
            explanation: "In an ideal pulley system, mechanical advantage equals the number of supporting ropes. Force needed = 400 ÷ 4 = 100 pounds"
          },
          {
            id: 5,
            question: "If a wheel has a radius of 2 feet and completes 5 full rotations, what distance has it traveled along the ground?",
            options: ["20π feet", "10π feet", "5π feet", "4π feet"],
            correctAnswer: 0,
            explanation: "Circumference = 2πr = 2π(2) = 4π feet per rotation. Distance = 5 rotations × 4π = 20π feet (approximately 62.8 feet)"
          }
        ]
      },
      {
        id: 9,
        name: "Assembling Objects (AO)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Which combination of shapes would create a complete square when assembled?",
            options: ["Two triangles with equal angles", "Three rectangles of different sizes", "Four identical right triangles", "Two circles and one triangle"],
            correctAnswer: 2,
            explanation: "Four identical right triangles (with the right angle at each corner) can be arranged to form a complete square, with their hypotenuses forming the square's diagonals."
          },
          {
            id: 2,
            question: "If piece A connects to piece B at point X, and piece B connects to piece C at point Y, which statement is true?",
            options: ["Point X and Y are the same", "Piece A directly connects to piece C", "Piece B is between A and C", "All pieces connect at one point"],
            correctAnswer: 2,
            explanation: "Since B connects to A at one point and to C at another point, piece B must be positioned between pieces A and C in the assembly."
          },
          {
            id: 3,
            question: "A shape is divided into 5 identical pentagonal sections radiating from a center point. What shape is formed?",
            options: ["Pentagon", "Hexagon", "Circle", "Star"],
            correctAnswer: 0,
            explanation: "Five identical sections arranged around a center point, each being a pentagon, would form a larger pentagon when assembled."
          },
          {
            id: 4,
            question: "Three rectangular pieces (2×4, 2×6, and 2×8 inches) need to be arranged into a single large rectangle. What are the dimensions of the largest possible rectangle?",
            options: ["2 × 18 inches", "4 × 9 inches", "6 × 6 inches", "3 × 12 inches"],
            correctAnswer: 0,
            explanation: "Aligning all pieces along their 2-inch width: total length = 4 + 6 + 8 = 18 inches, creating a 2 × 18 inch rectangle."
          },
          {
            id: 5,
            question: "When two identical L-shaped pieces are rotated and combined, which shape can they NOT form?",
            options: ["Rectangle", "Square", "T-shape", "Perfect circle"],
            correctAnswer: 3,
            explanation: "Two L-shaped pieces can be arranged to form rectangles, squares, or T-shapes depending on orientation, but cannot form a perfect circle due to having straight edges."
          }
        ]
      },
      {
        id: 10,
        name: "Verbal Expression (VE)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Choose the sentence with correct punctuation:",
            options: ["The sergeant reviewed three items: weapons, ammunition and equipment.", "The sergeant reviewed three items: weapons, ammunition, and equipment.", "The sergeant reviewed three items, weapons, ammunition, and equipment.", "The sergeant reviewed three items; weapons ammunition and equipment."],
            correctAnswer: 1,
            explanation: "After a colon introducing a list, items should be separated by commas, including the Oxford comma before 'and' for clarity in military contexts."
          },
          {
            id: 2,
            question: "Which sentence is grammatically correct?",
            options: ["Neither the officers nor the sergeant were present.", "Neither the officers nor the sergeant was present.", "Neither the officers or the sergeant were present.", "Neither the officers or the sergeant was present."],
            correctAnswer: 1,
            explanation: "With 'neither...nor,' the verb agrees with the noun closest to it. 'Sergeant' is singular, requiring 'was.' Also, 'neither' pairs with 'nor,' not 'or.'"
          },
          {
            id: 3,
            question: "Identify the sentence with a misplaced modifier:",
            options: ["The soldier cleaned his rifle thoroughly after the mission.", "After the mission, the soldier thoroughly cleaned his rifle.", "The soldier thoroughly cleaned his rifle after the mission.", "Thoroughly cleaned after the mission, the rifle belonged to the soldier."],
            correctAnswer: 3,
            explanation: "Option 3 incorrectly suggests the rifle was 'thoroughly cleaned after the mission' on its own. The modifier should clearly indicate who performed the action."
          },
          {
            id: 4,
            question: "Select the sentence that uses parallel structure:",
            options: ["The drill instructor emphasized discipline, being punctual, and to show respect.", "The drill instructor emphasized discipline, punctuality, and showing respect.", "The drill instructor emphasized discipline, punctuality, and respect.", "The drill instructor emphasized to be disciplined, punctuality, and respect."],
            correctAnswer: 2,
            explanation: "Parallel structure requires consistent grammatical form. Option 2 uses three nouns (discipline, punctuality, respect), maintaining parallel structure."
          },
          {
            id: 5,
            question: "Which word correctly completes the sentence: 'The new recruits were _______ to follow orders immediately.'",
            options: ["suppose", "supposed", "supposing", "supposes"],
            correctAnswer: 1,
            explanation: "'Supposed to' is the correct phrase meaning expected or required to do something. It's the past participle form used with 'were.'"
          }
        ]
      }
    ]
  },,
  {
    id: 14,
    title: "ASVAB Practice Test #14",
    description: "Comprehensive practice exam covering all 10 ASVAB sections with military-standard questions",
    totalQuestions: 50,
    timeLimit: 60,
    sections: [
      {
        id: 1,
        name: "General Science (GS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Which organelle is known as the 'powerhouse of the cell' because it produces ATP?",
            options: ["Nucleus", "Ribosome", "Mitochondria", "Golgi apparatus"],
            correctAnswer: 2,
            explanation: "Mitochondria are responsible for cellular respiration and produce ATP (adenosine triphosphate), the primary energy currency of cells."
          },
          {
            id: 2,
            question: "What is the boiling point of water at sea level in Celsius?",
            options: ["90°C", "100°C", "110°C", "212°C"],
            correctAnswer: 1,
            explanation: "Water boils at 100°C (or 212°F) at sea level under standard atmospheric pressure."
          },
          {
            id: 3,
            question: "Which vitamin is primarily produced when skin is exposed to sunlight?",
            options: ["Vitamin A", "Vitamin C", "Vitamin D", "Vitamin K"],
            correctAnswer: 2,
            explanation: "Vitamin D is synthesized in the skin when exposed to ultraviolet B (UVB) radiation from sunlight. It's essential for calcium absorption and bone health."
          },
          {
            id: 4,
            question: "What is the most abundant element in the universe?",
            options: ["Oxygen", "Carbon", "Hydrogen", "Helium"],
            correctAnswer: 2,
            explanation: "Hydrogen is the most abundant element in the universe, making up about 75% of all normal matter by mass and over 90% by number of atoms."
          },
          {
            id: 5,
            question: "Which part of the human brain controls balance and coordination?",
            options: ["Cerebrum", "Cerebellum", "Medulla oblongata", "Hypothalamus"],
            correctAnswer: 1,
            explanation: "The cerebellum, located at the back of the brain, is responsible for coordinating voluntary movements, balance, posture, and motor learning."
          }
        ]
      },
      {
        id: 2,
        name: "Arithmetic Reasoning (AR)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "A military transport plane carries 18,000 pounds of cargo. If each supply crate weighs 250 pounds, how many crates can the plane carry?",
            options: ["68 crates", "72 crates", "76 crates", "80 crates"],
            correctAnswer: 1,
            explanation: "Number of crates = 18,000 pounds ÷ 250 pounds per crate = 72 crates."
          },
          {
            id: 2,
            question: "A recruit runs 2 miles in 16 minutes. At this pace, how long would it take to run 5 miles?",
            options: ["35 minutes", "38 minutes", "40 minutes", "42 minutes"],
            correctAnswer: 2,
            explanation: "Pace per mile: 16 minutes ÷ 2 miles = 8 minutes per mile. For 5 miles: 8 × 5 = 40 minutes."
          },
          {
            id: 3,
            question: "A squad of 24 soldiers shares rations equally. If each soldier receives 3 meals, how many total meals were distributed?",
            options: ["64 meals", "68 meals", "72 meals", "76 meals"],
            correctAnswer: 2,
            explanation: "Total meals = 24 soldiers × 3 meals per soldier = 72 meals."
          },
          {
            id: 4,
            question: "Equipment costs $2,400 and depreciates by 15% each year. What is its value after one year?",
            options: ["$2,040", "$2,100", "$2,160", "$2,200"],
            correctAnswer: 0,
            explanation: "Depreciation: 15% of $2,400 = $360. Value after one year: $2,400 - $360 = $2,040."
          },
          {
            id: 5,
            question: "A fuel tank is 3/4 full. After using 1/3 of the fuel, what fraction of the tank remains full?",
            options: ["1/4", "1/3", "1/2", "2/3"],
            correctAnswer: 2,
            explanation: "Fuel used: 1/3 of 3/4 = 1/4. Remaining fuel: 3/4 - 1/4 = 2/4 = 1/2."
          }
        ]
      },
      {
        id: 3,
        name: "Word Knowledge (WK)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Vigilant most nearly means:",
            options: ["Careless", "Watchful", "Aggressive", "Peaceful"],
            correctAnswer: 1,
            explanation: "Vigilant means being alert and watchful, especially for danger or difficulties. It's essential for military personnel on duty."
          },
          {
            id: 2,
            question: "Expedite most nearly means:",
            options: ["Delay", "Prevent", "Accelerate", "Examine"],
            correctAnswer: 2,
            explanation: "Expedite means to make a process happen more quickly or to speed up an action. In military contexts, it often refers to rushing orders or supplies."
          },
          {
            id: 3,
            question: "Cohesive most nearly means:",
            options: ["Divided", "United", "Scattered", "Independent"],
            correctAnswer: 1,
            explanation: "Cohesive means forming a united whole or sticking together. A cohesive unit works well together as a team."
          },
          {
            id: 4,
            question: "Covert most nearly means:",
            options: ["Open", "Secret", "Loud", "Official"],
            correctAnswer: 1,
            explanation: "Covert means concealed, hidden, or secret. Covert operations are conducted in secrecy without being detected."
          },
          {
            id: 5,
            question: "Resilient most nearly means:",
            options: ["Fragile", "Flexible", "Rigid", "Weak"],
            correctAnswer: 1,
            explanation: "Resilient means able to recover quickly from difficulties or able to spring back into shape. It describes both physical materials and mental toughness."
          }
        ]
      },
      {
        id: 4,
        name: "Paragraph Comprehension (PC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Military readiness depends on consistent training and preparation that builds and maintains the skills necessary for effective operations. Units that train regularly perform better in combat situations than those with irregular training schedules because they maintain their proficiency and develop automatic responses to common situations. Regular training reinforces proper procedures, improves coordination between team members, and builds the muscle memory that allows personnel to react quickly and correctly under pressure. When training is irregular or infrequent, skills deteriorate, procedures are forgotten, and personnel become less effective at executing their missions.\n\nStudies show that soldiers who participate in weekly drills demonstrate 40% better response times during emergencies compared to those who train less frequently. This significant improvement reflects how regular practice enhances both individual performance and team coordination. Weekly drills keep skills fresh, allow personnel to practice with their actual equipment and team members, and provide opportunities to identify and correct problems before they become critical in real situations. The repetition builds confidence and competence, allowing soldiers to perform effectively even under the stress and confusion of emergencies or combat.\n\nConsistent training also allows units to progressively increase difficulty and complexity, building toward more challenging scenarios. Units can master basic skills before moving to advanced techniques, ensuring a solid foundation for more complex operations. Regular training schedules also make it easier to maintain equipment, track personnel qualifications, and ensure that everyone meets required standards. The correlation between training frequency and operational performance has been demonstrated repeatedly throughout military history, confirming that consistent preparation is essential for military readiness and effectiveness.\n\nWhat is the main point of this passage?",
            options: ["Combat situations are unpredictable", "Regular training improves military performance", "Weekly drills are mandatory", "Emergency response requires special skills"],
            correctAnswer: 1,
            explanation: "The passage emphasizes that consistent training and regular drills lead to better performance and faster response times, making 'Regular training improves military performance' the main point."
          },
          {
            id: 2,
            question: "The chain of command is fundamental to military organization and serves as the structural framework that enables large, complex organizations to function effectively. It establishes clear lines of authority and ensures orders flow efficiently from top to bottom through designated channels. Each level of command has specific responsibilities and authority, with senior leaders making strategic decisions and junior leaders executing those decisions at the tactical level. This hierarchical structure ensures that everyone knows who they report to, who reports to them, and what decisions they are authorized to make. The clarity provided by the chain of command eliminates confusion about authority and responsibility.\n\nThe chain of command also ensures accountability by creating clear connections between decisions and outcomes. When orders flow through proper channels, leaders at each level can track progress, identify problems, and make necessary adjustments. Information also flows upward through the chain, keeping commanders informed about situations on the ground and allowing them to make better decisions. This two-way flow of information and orders is essential for coordinating the actions of large military units and ensuring that everyone is working toward the same objectives.\n\nBreaking the chain of command can create confusion and undermine unit effectiveness by disrupting this carefully structured system. When personnel bypass their immediate supervisors to communicate with higher-level commanders, it leaves middle-level leaders uninformed and unable to coordinate their subordinates effectively. When orders come from unauthorized sources or skip levels in the hierarchy, it creates questions about legitimacy and priority. Personnel may receive conflicting instructions, become uncertain about which orders to follow, or fail to coordinate properly with their teammates. The resulting confusion can paralyze decision-making, slow operations, and create dangerous situations where personnel don't know who is in charge or what they should be doing.\n\nAccording to the passage, what happens when the chain of command is broken?",
            options: ["Orders are issued more quickly", "Authority becomes clearer", "Confusion and reduced effectiveness result", "Units operate more independently"],
            correctAnswer: 2,
            explanation: "The passage explicitly states that breaking the chain of command 'can create confusion and undermine unit effectiveness.'"
          },
          {
            id: 3,
            question: "Navigation at sea requires understanding multiple systems including GPS, compass bearings, and celestial navigation to safely guide vessels across vast expanses of ocean. GPS provides instant, accurate positioning using satellite signals and has revolutionized maritime navigation with its precision and ease of use. Compass bearings use magnetic or gyroscopic compasses to determine direction and plot courses, providing reliable heading information that doesn't depend on external signals. Celestial navigation uses the positions of stars, planets, the sun, and moon to calculate location through careful observations and mathematical calculations. Each system has its own strengths, limitations, and applications in maritime operations.\n\nWhile modern technology has made navigation easier and more accurate than ever before, traditional methods remain crucial backup systems when electronic equipment fails. GPS receivers can malfunction, lose satellite signals, or be affected by interference. Electronic systems depend on electrical power, which can be lost due to equipment failure, battle damage, or other emergencies. In these situations, knowing how to navigate using traditional methods like compass bearings and celestial navigation can mean the difference between safely reaching port and becoming lost at sea. The ocean is an unforgiving environment where navigation errors can have catastrophic consequences.\n\nExperienced navigators master all three systems to ensure safe passage regardless of conditions or equipment status. They understand when to use each method and how to cross-check results from different systems to verify accuracy. If GPS shows one position but celestial navigation indicates something different, an experienced navigator can identify which is correct and determine why the discrepancy exists. This comprehensive knowledge also allows navigators to choose the most appropriate method for current conditions. For example, celestial navigation becomes difficult during cloudy weather, while GPS may be unreliable in certain situations. The ability to seamlessly transition between navigation methods ensures continuous, accurate positioning in all circumstances.\n\nWhat can be inferred from this passage?",
            options: ["GPS has made traditional navigation obsolete", "Celestial navigation is the most reliable method", "Multiple navigation methods provide redundancy and safety", "Electronic equipment rarely fails at sea"],
            correctAnswer: 2,
            explanation: "The passage emphasizes that mastering multiple navigation systems ensures safe passage 'regardless of conditions,' implying that having multiple methods provides backup and increases safety."
          },
          {
            id: 4,
            question: "Physical fitness standards in the military serve multiple purposes beyond basic health and go far beyond simple exercise requirements. They ensure personnel can handle the physical demands of combat, which can include carrying heavy loads over long distances, evacuating wounded comrades, engaging in hand-to-hand combat, and maintaining effectiveness despite physical exhaustion. Combat situations often require personnel to perform at their physical limits for extended periods, making excellent fitness essential for survival and mission success. Without adequate fitness, even well-trained personnel may fail when faced with the physical rigors of actual combat operations.\n\nPhysical fitness standards also build mental resilience by teaching personnel to push through discomfort and overcome challenges. The mental discipline required to maintain fitness standards translates directly to other aspects of military service. When soldiers learn they can accomplish more than they thought possible physically, it builds confidence that carries over to other challenging situations. The determination to keep going when exhausted during physical training develops the same mental toughness needed to persevere during difficult missions. This psychological benefit is just as valuable as the physical conditioning itself.\n\nAdditionally, fitness standards promote unit cohesion through shared challenges and collective accomplishment. When unit members train together, encourage each other through difficult workouts, and celebrate fitness achievements together, it builds bonds of friendship and mutual respect. Everyone meeting the same standards creates a sense of shared identity and common purpose. Maintaining these standards throughout a military career demonstrates discipline and commitment to professional excellence. Service members who consistently meet or exceed fitness requirements show they take their responsibilities seriously and are willing to put in the work necessary for success. This dedication inspires respect from peers and subordinates alike.\n\nWhat is NOT mentioned as a purpose of fitness standards?",
            options: ["Handling combat demands", "Building mental resilience", "Improving marksmanship skills", "Promoting unit cohesion"],
            correctAnswer: 2,
            explanation: "The passage mentions combat capability, mental resilience, and unit cohesion as purposes of fitness standards, but does not mention marksmanship skills."
          },
          {
            id: 5,
            question: "Logistics planning determines the success or failure of military operations by ensuring that forces have everything they need to accomplish their missions. Without proper supply lines, even the best-trained forces cannot sustain operations beyond a very limited time. Armies need food, water, ammunition, fuel, medical supplies, spare parts, and countless other items to maintain their fighting capability. When these supplies are unavailable or delayed, units quickly lose their effectiveness regardless of how skilled their personnel are or how superior their equipment might be. A tank without fuel cannot move, a rifle without ammunition cannot fire, and soldiers without food and water cannot fight.\n\nHistorical battles have been won and lost based on logistical capabilities rather than combat strength alone, demonstrating that supply management is often more decisive than battlefield tactics. Napoleon's invasion of Russia failed largely due to logistics problems as his supply lines stretched too far and his army couldn't sustain itself. The Allied victory in World War II depended heavily on America's ability to produce and transport massive quantities of supplies across the Atlantic and Pacific oceans. The German Afrika Korps, despite its tactical skill, ultimately failed because it couldn't maintain adequate supply lines across the Mediterranean. These historical examples show that logistical superiority can overcome tactical disadvantages, while logistical failure can doom even the most capable military forces.\n\nModern military operations are even more dependent on logistics than historical campaigns because of the complexity and resource requirements of contemporary equipment. Modern weapons systems require specialized ammunition, sophisticated maintenance, and constant fuel supplies. Communication and computer systems need power and spare parts. Medical care requires extensive supplies and equipment. The challenge of coordinating all these requirements across potentially global operations makes logistics planning increasingly critical. Military strategists recognize that winning battles requires not just tactical brilliance but also the unglamorous work of ensuring supplies reach the right places at the right times. Logistics may not capture the imagination like combat operations, but it often determines who ultimately prevails.\n\nWhat is the author's main argument?",
            options: ["Combat training is less important than supply management", "Historical battles prove logistics superiority", "Supply lines are critical to military success", "Logistics planning is a modern military concept"],
            correctAnswer: 2,
            explanation: "The passage argues that logistics planning 'determines the success or failure of military operations' and that forces 'cannot sustain operations' without proper supply lines, making supply lines critical to success."
          }
        ]
      },
      {
        id: 5,
        name: "Mathematics Knowledge (MK)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Solve for x: 3x + 12 = 27",
            options: ["x = 3", "x = 5", "x = 7", "x = 9"],
            correctAnswer: 1,
            explanation: "Subtract 12 from both sides: 3x = 15. Divide both sides by 3: x = 5."
          },
          {
            id: 2,
            question: "What is the area of a rectangle with length 8 meters and width 5 meters?",
            options: ["26 square meters", "32 square meters", "40 square meters", "48 square meters"],
            correctAnswer: 2,
            explanation: "Area of rectangle = length × width = 8 × 5 = 40 square meters."
          },
          {
            id: 3,
            question: "If a² = 144, what is the value of a? (assume positive value)",
            options: ["10", "11", "12", "14"],
            correctAnswer: 2,
            explanation: "Taking the square root of both sides: a = √144 = 12."
          },
          {
            id: 4,
            question: "What is 15% of 80?",
            options: ["10", "12", "14", "16"],
            correctAnswer: 1,
            explanation: "15% of 80 = 0.15 × 80 = 12."
          },
          {
            id: 5,
            question: "Simplify: (2x³)(4x²)",
            options: ["6x⁵", "8x⁵", "6x⁶", "8x⁶"],
            correctAnswer: 1,
            explanation: "Multiply coefficients and add exponents: (2 × 4)(x³⁺²) = 8x⁵."
          }
        ]
      },
      {
        id: 6,
        name: "Electronics Information (EI)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What does AC stand for in electrical terminology?",
            options: ["Active Current", "Alternating Current", "Automatic Circuit", "Amplified Charge"],
            correctAnswer: 1,
            explanation: "AC stands for Alternating Current, which is electric current that reverses direction periodically, unlike DC (Direct Current) which flows in one direction."
          },
          {
            id: 2,
            question: "Which component stores electrical energy in an electric field?",
            options: ["Resistor", "Capacitor", "Inductor", "Transistor"],
            correctAnswer: 1,
            explanation: "A capacitor stores electrical energy in an electric field between two conductive plates separated by an insulator (dielectric)."
          },
          {
            id: 3,
            question: "What is the unit of electrical resistance?",
            options: ["Ampere", "Volt", "Ohm", "Watt"],
            correctAnswer: 2,
            explanation: "The ohm (Ω) is the SI unit of electrical resistance. It measures how much a component opposes the flow of electric current."
          },
          {
            id: 4,
            question: "In a series circuit with three resistors of 10Ω, 20Ω, and 30Ω, what is the total resistance?",
            options: ["20Ω", "40Ω", "60Ω", "80Ω"],
            correctAnswer: 2,
            explanation: "In a series circuit, total resistance equals the sum of individual resistances: 10Ω + 20Ω + 30Ω = 60Ω."
          },
          {
            id: 5,
            question: "What does a diode primarily do in an electrical circuit?",
            options: ["Amplify signals", "Store charge", "Allow current flow in one direction only", "Regulate voltage"],
            correctAnswer: 2,
            explanation: "A diode allows electric current to flow in only one direction (forward bias) and blocks it in the reverse direction, acting as a one-way valve for electricity."
          }
        ]
      },
      {
        id: 7,
        name: "Auto & Shop Information (AS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What is the primary function of a vehicle's alternator?",
            options: ["Start the engine", "Cool the engine", "Charge the battery while engine runs", "Control transmission shifting"],
            correctAnswer: 2,
            explanation: "The alternator generates electrical power while the engine is running to charge the battery and power the vehicle's electrical systems."
          },
          {
            id: 2,
            question: "Which tool is specifically designed to measure very small distances with high precision?",
            options: ["Caliper", "Micrometer", "Ruler", "Protractor"],
            correctAnswer: 1,
            explanation: "A micrometer can measure dimensions to within 0.001 inch (0.01mm), making it the most precise common measuring tool for small distances."
          },
          {
            id: 3,
            question: "What does SAE stand for in relation to motor oil ratings?",
            options: ["Standard Automotive Engine", "Society of Automotive Engineers", "Synthetic Additive Elements", "System Analysis Equipment"],
            correctAnswer: 1,
            explanation: "SAE (Society of Automotive Engineers) establishes the viscosity grading system for motor oils, such as 5W-30 or 10W-40."
          },
          {
            id: 4,
            question: "Which type of wrench automatically adjusts to fit different sized nuts and bolts?",
            options: ["Box wrench", "Open-end wrench", "Adjustable wrench", "Socket wrench"],
            correctAnswer: 2,
            explanation: "An adjustable wrench (crescent wrench) has a movable jaw that can be adjusted to fit various sizes of nuts and bolts."
          },
          {
            id: 5,
            question: "What is the purpose of engine coolant in a vehicle's cooling system?",
            options: ["Lubricate engine parts", "Transfer heat away from engine", "Clean fuel injectors", "Increase fuel efficiency"],
            correctAnswer: 1,
            explanation: "Engine coolant (antifreeze mixed with water) circulates through the engine to absorb heat and transfer it to the radiator, preventing overheating."
          }
        ]
      },
      {
        id: 8,
        name: "Mechanical Comprehension (MC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "If a lever has the fulcrum closer to the load than to the effort, what is the mechanical advantage?",
            options: ["Less than 1", "Equal to 1", "Greater than 1", "Cannot be determined"],
            correctAnswer: 2,
            explanation: "When the fulcrum is closer to the load (resistance) than to the effort, the effort arm is longer than the resistance arm, creating a mechanical advantage greater than 1, meaning less force is needed to move the load."
          },
          {
            id: 2,
            question: "Two gears are meshed together. If gear A has 40 teeth and rotates clockwise, and gear B has 20 teeth, how does gear B rotate?",
            options: ["Clockwise at the same speed", "Counterclockwise at the same speed", "Clockwise at twice the speed", "Counterclockwise at twice the speed"],
            correctAnswer: 3,
            explanation: "Meshed gears rotate in opposite directions. Since gear A has twice as many teeth as gear B (40 vs 20), gear B rotates twice as fast, counterclockwise."
          },
          {
            id: 3,
            question: "Which simple machine is a ramp an example of?",
            options: ["Lever", "Wheel and axle", "Inclined plane", "Pulley"],
            correctAnswer: 2,
            explanation: "A ramp is an inclined plane, which reduces the force needed to raise an object by increasing the distance over which the force is applied."
          },
          {
            id: 4,
            question: "If water pressure increases with depth, what happens to pressure at twice the depth?",
            options: ["Pressure stays the same", "Pressure doubles", "Pressure quadruples", "Pressure halves"],
            correctAnswer: 1,
            explanation: "Water pressure increases linearly with depth. At twice the depth, the pressure is twice as great because there is twice as much water weight above."
          },
          {
            id: 5,
            question: "A fixed pulley primarily changes which aspect of force application?",
            options: ["Magnitude of force", "Direction of force", "Speed of movement", "Energy required"],
            correctAnswer: 1,
            explanation: "A fixed (single) pulley changes the direction of force application, allowing you to pull down to lift something up, but doesn't provide mechanical advantage."
          }
        ]
      },
      {
        id: 9,
        name: "Assembling Objects (AO)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Which connector piece would join points A and B in a straight line?",
            options: ["L-shaped connector", "Straight connector", "T-shaped connector", "Curved connector"],
            correctAnswer: 1,
            explanation: "A straight connector is needed to join two points that are aligned in a straight line without any angles or curves."
          },
          {
            id: 2,
            question: "If shape A is a square and shape B is a triangle, which combined shape would they form when the triangle's base matches one side of the square?",
            options: ["Rectangle", "Pentagon", "Hexagon", "Octagon"],
            correctAnswer: 1,
            explanation: "When a triangle is attached to one side of a square, the combined shape has five sides (the three sides of the square that aren't shared, plus the two non-base sides of the triangle), forming a pentagon."
          },
          {
            id: 3,
            question: "Three rectangular pieces of equal size need to form a larger rectangle. How should they be arranged?",
            options: ["Stacked vertically", "In a triangular pattern", "Side by side horizontally", "Overlapping diagonally"],
            correctAnswer: 2,
            explanation: "Three rectangular pieces of equal size should be placed side by side horizontally to form a larger rectangle, maintaining the rectangular shape."
          },
          {
            id: 4,
            question: "Which arrangement of four squares would create a larger square?",
            options: ["In a row", "In an L-shape", "In a 2×2 grid", "In a diagonal line"],
            correctAnswer: 2,
            explanation: "Four identical squares arranged in a 2×2 grid (2 rows and 2 columns) create a larger square that is twice as wide and twice as tall as each individual square."
          },
          {
            id: 5,
            question: "If you rotate a right triangle 90 degrees clockwise around its right angle vertex, which edge moves to the position of the base?",
            options: ["The hypotenuse", "The opposite side", "The same base", "No edge moves there"],
            correctAnswer: 0,
            explanation: "When rotating around the right angle vertex by 90 degrees clockwise, the hypotenuse (longest side) rotates to the position where the base was originally."
          }
        ]
      },
      {
        id: 10,
        name: "Verbal Expression (VE)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Which sentence is grammatically correct?",
            options: ["Between you and I, this mission is challenging.", "Between you and me, this mission is challenging.", "Between you and myself, this mission is challenging.", "Between yourself and I, this mission is challenging."],
            correctAnswer: 1,
            explanation: "After the preposition 'between,' use the objective case pronoun 'me' rather than the subjective case 'I.' The correct phrase is 'between you and me.'"
          },
          {
            id: 2,
            question: "Identify the sentence with correct punctuation:",
            options: ["The squad needs: ammunition, water, and rations.", "The squad needs ammunition, water and, rations.", "The squad needs ammunition, water, and rations.", "The squad needs, ammunition, water, and rations."],
            correctAnswer: 2,
            explanation: "In a simple list of three or more items, use commas to separate them with a comma before the conjunction (Oxford comma). No colon is needed without an introductory independent clause."
          },
          {
            id: 3,
            question: "Which word correctly completes the sentence: 'The training had a positive _______ on unit performance.'",
            options: ["affect", "effect", "affection", "effects"],
            correctAnswer: 1,
            explanation: "'Effect' (noun) means a result or consequence. 'Affect' is typically a verb meaning to influence. The training had a positive result/effect."
          },
          {
            id: 4,
            question: "Choose the sentence with proper subject-verb agreement:",
            options: ["Each of the soldiers are prepared for deployment.", "Each of the soldiers is prepared for deployment.", "Each of the soldiers were prepared for deployment.", "Each of the soldiers have been prepared for deployment."],
            correctAnswer: 1,
            explanation: "'Each' is singular and requires a singular verb. Even though 'soldiers' is plural, 'each' is the subject, so the correct verb is 'is.'"
          },
          {
            id: 5,
            question: "Which sentence uses the correct form of 'their/there/they're'?",
            options: ["Their going to the training facility today.", "The soldiers left there equipment in the barracks.", "They're scheduled for deployment next month.", "The unit completed there mission successfully."],
            correctAnswer: 2,
            explanation: "'They're' is a contraction of 'they are.' The other sentences should use 'They're' (they are) for the first, 'their' (possessive) for the second and fourth."
          }
        ]
      }
    ]
  },,
  {
    id: 15,
    title: "ASVAB Practice Test #15",
    description: "Comprehensive practice exam covering all 10 ASVAB sections with military-standard questions",
    totalQuestions: 50,
    timeLimit: 60,
    sections: [
      {
        id: 1,
        name: "General Science (GS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What is the primary function of red blood cells in the human body?",
            options: ["Fighting infection", "Transporting oxygen", "Clotting blood", "Producing antibodies"],
            correctAnswer: 1,
            explanation: "Red blood cells contain hemoglobin, which binds to oxygen in the lungs and transports it throughout the body to tissues and organs."
          },
          {
            id: 2,
            question: "Which layer of Earth's atmosphere contains the ozone layer that protects us from harmful UV radiation?",
            options: ["Troposphere", "Stratosphere", "Mesosphere", "Thermosphere"],
            correctAnswer: 1,
            explanation: "The stratosphere contains the ozone layer, which absorbs most of the Sun's harmful ultraviolet radiation, protecting life on Earth."
          },
          {
            id: 3,
            question: "What type of chemical bond involves the sharing of electrons between atoms?",
            options: ["Ionic bond", "Covalent bond", "Metallic bond", "Hydrogen bond"],
            correctAnswer: 1,
            explanation: "A covalent bond forms when two atoms share one or more pairs of electrons, creating a stable molecule. This is common in organic compounds."
          },
          {
            id: 4,
            question: "Which phase of matter has a definite volume but no definite shape?",
            options: ["Solid", "Liquid", "Gas", "Plasma"],
            correctAnswer: 1,
            explanation: "Liquids have a definite volume but take the shape of their container. Solids have both definite volume and shape, while gases have neither."
          },
          {
            id: 5,
            question: "What is the name of the process by which plants lose water vapor through their leaves?",
            options: ["Photosynthesis", "Respiration", "Transpiration", "Germination"],
            correctAnswer: 2,
            explanation: "Transpiration is the process where water evaporates from plant leaves through small pores called stomata, helping regulate plant temperature and nutrient transport."
          }
        ]
      },
      {
        id: 2,
        name: "Arithmetic Reasoning (AR)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "A naval ship travels 420 nautical miles in 12 hours. What is its average speed in knots (nautical miles per hour)?",
            options: ["30 knots", "35 knots", "40 knots", "45 knots"],
            correctAnswer: 1,
            explanation: "Average speed = Total distance ÷ Total time = 420 nautical miles ÷ 12 hours = 35 knots."
          },
          {
            id: 2,
            question: "A barracks has 144 beds arranged in equal rows. If there are 12 rows, how many beds are in each row?",
            options: ["10 beds", "11 beds", "12 beds", "13 beds"],
            correctAnswer: 2,
            explanation: "Beds per row = Total beds ÷ Number of rows = 144 ÷ 12 = 12 beds per row."
          },
          {
            id: 3,
            question: "A soldier's base pay is $2,400 per month. If 22% is withheld for taxes and deductions, what is the take-home pay?",
            options: ["$1,728", "$1,872", "$1,920", "$2,052"],
            correctAnswer: 1,
            explanation: "Amount withheld: 22% of $2,400 = $528. Take-home pay: $2,400 - $528 = $1,872."
          },
          {
            id: 4,
            question: "If a helicopter uses 45 gallons of fuel per hour and has 270 gallons in its tank, how many hours can it fly?",
            options: ["5 hours", "6 hours", "7 hours", "8 hours"],
            correctAnswer: 1,
            explanation: "Flight time = Total fuel ÷ Fuel consumption rate = 270 gallons ÷ 45 gallons per hour = 6 hours."
          },
          {
            id: 5,
            question: "A training course costs $8,500. If the military covers 85% of the cost, how much does the service member pay?",
            options: ["$1,175", "$1,225", "$1,275", "$1,325"],
            correctAnswer: 2,
            explanation: "Military covers: 85% of $8,500 = $7,225. Service member pays: $8,500 - $7,225 = $1,275."
          }
        ]
      },
      {
        id: 3,
        name: "Word Knowledge (WK)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Meticulous most nearly means:",
            options: ["Careless", "Extremely careful and precise", "Fast", "Simple"],
            correctAnswer: 1,
            explanation: "Meticulous means showing great attention to detail, being very careful and precise in one's work or actions."
          },
          {
            id: 2,
            question: "Ambiguous most nearly means:",
            options: ["Clear", "Uncertain or unclear", "Specific", "Detailed"],
            correctAnswer: 1,
            explanation: "Ambiguous means open to more than one interpretation, not having one clear meaning, or being unclear or vague."
          },
          {
            id: 3,
            question: "Arbitrary most nearly means:",
            options: ["Logical", "Based on random choice rather than reason", "Systematic", "Organized"],
            correctAnswer: 1,
            explanation: "Arbitrary means based on random choice or personal whim rather than any reason or system, often appearing unpredictable or unreasonable."
          },
          {
            id: 4,
            question: "Tenacious most nearly means:",
            options: ["Weak", "Persistent and determined", "Flexible", "Uncertain"],
            correctAnswer: 1,
            explanation: "Tenacious means holding firmly to a purpose or opinion, not giving up easily, being persistent and determined in pursuing goals."
          },
          {
            id: 5,
            question: "Obsolete most nearly means:",
            options: ["Modern", "No longer in use or outdated", "Improved", "Current"],
            correctAnswer: 1,
            explanation: "Obsolete means no longer produced or used, out of date, or replaced by something newer and better."
          }
        ]
      },
      {
        id: 4,
        name: "Paragraph Comprehension (PC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Effective communication is essential in military operations and often determines whether missions succeed or fail. Clear, concise orders prevent misunderstandings that could compromise mission success or endanger lives. In the chaos and confusion of military operations, there is no room for ambiguity or unclear instructions. Every word must convey exactly what is intended, leaving no doubt about what actions should be taken, when they should occur, and who is responsible for them. When orders are vague or poorly communicated, personnel may take incorrect actions, fail to coordinate properly with other units, or miss critical timing windows that affect mission outcomes.\n\nRadio protocols and standardized terminology ensure messages are understood correctly even in high-stress situations where people are frightened, exhausted, or operating under intense time pressure. Standard formats for radio communications eliminate confusion about message priority, sender identity, and intended recipients. Phonetic alphabets prevent confusion between similar-sounding letters. Brevity codes convey complex information quickly. These standardized systems have been refined over decades to maximize clarity and minimize transmission time, which is especially important when radio channels are crowded or when enemy forces might be listening. Personnel from different units or even different services can communicate effectively because they all use the same protocols and terminology.\n\nTraining emphasizes both sending and receiving accurate information because communication is a two-way process that requires skill on both ends. Senders must learn to formulate clear, complete messages that convey all necessary information without unnecessary words. Receivers must learn to listen carefully, acknowledge messages correctly, ask for clarification when needed, and confirm understanding of critical instructions. Both senders and receivers must maintain composure and clarity even under extreme stress. This two-way competency ensures that information flows smoothly throughout military organizations, enabling coordinated action and informed decision-making at all levels. Without effective communication in both directions, even the best plans and most capable personnel cannot function as a cohesive fighting force.\n\nWhat is the main idea of this passage?",
            options: ["Radio equipment is expensive", "Clear communication is critical for mission success", "High-stress situations are common in the military", "Standardized terminology is difficult to learn"],
            correctAnswer: 1,
            explanation: "The passage focuses on how effective communication, clear orders, and standardized protocols are essential for preventing misunderstandings and ensuring mission success."
          },
          {
            id: 2,
            question: "Camouflage patterns disrupt visual recognition by breaking up the outline of personnel and equipment, making them harder to detect against their surroundings. The human eye naturally recognizes familiar shapes and patterns, particularly the distinctive silhouette of the human body and the regular geometric forms of military equipment. Camouflage works by interrupting these recognizable patterns with irregular shapes, colors, and contrasts that blend with the background environment. When properly designed and applied, camouflage makes observers' eyes slide past camouflaged objects without registering them as distinct entities. This concealment provides crucial tactical advantages by allowing military forces to observe, move, and position themselves without being detected by enemy forces.\n\nDifferent environments require different patterns because each terrain type has its own characteristic colors, textures, and visual features. Woodland environments feature various shades of green and brown with irregular patterns of light and shadow created by vegetation. Desert environments display tans, browns, and lighter colors with less vegetation and different lighting conditions. Urban environments incorporate grays, blacks, and earth tones reflecting concrete, asphalt, brick, and metal structures. A camouflage pattern that works perfectly in one environment becomes highly visible in another environment with different colors and features. This is why military forces maintain multiple camouflage systems and select the appropriate one based on their operational environment.\n\nModern digital patterns use pixelated designs that confuse the eye at various distances by creating visual disruption that works at both close and far range. Traditional camouflage patterns sometimes became less effective at certain distances, appearing as solid colors rather than disruptive patterns. Digital patterns with their small, computer-designed pixels maintain their disruptive effect across a wide range of distances. The pixels create a visual noise that makes it difficult for the eye to lock onto and identify the camouflaged object. These advanced patterns represent the evolution of camouflage technology, incorporating scientific understanding of human visual perception to create more effective concealment systems for modern military operations.\n\nAccording to the passage, why are different camouflage patterns needed?",
            options: ["Digital patterns are more fashionable", "Different environments require different color schemes", "Woodland patterns are most effective", "Pixelated designs are cheaper to produce"],
            correctAnswer: 1,
            explanation: "The passage explicitly states that 'different environments require different patterns' with specific color schemes for woodland, desert, and urban settings."
          },
          {
            id: 3,
            question: "Military awards and decorations recognize exceptional service, valor, and achievement, serving as tangible acknowledgment of outstanding performance and sacrifice. These honors boost morale by showing that the organization values and remembers the contributions of its members. Receiving recognition for exceptional work validates the effort and sacrifice that service members put into their duties. It demonstrates that leadership notices and appreciates extraordinary performance. For the recipients, awards provide lasting reminders of their finest moments and proof that their actions made a difference. This recognition helps maintain motivation and commitment even during difficult times when the demands of military service can seem overwhelming.\n\nThese awards also set standards for excellence by defining what exceptional performance looks like in concrete terms. When service members see what actions and achievements merit recognition, it provides a benchmark for their own performance. Award citations describe specific acts of courage, innovation, leadership, or dedication that exemplify military values. While medals acknowledge individual accomplishment and honor the specific actions of particular service members, they also inspire others to perform at higher levels. When personnel see their peers recognized for outstanding work, it motivates them to strive for similar excellence. The awards create a culture that celebrates and encourages exceptional performance throughout the organization.\n\nThe criteria for awards must remain consistent to preserve their meaning and value over time. If awards are given too freely or for insufficient reasons, they lose their significance and fail to motivate. If criteria change arbitrarily or seem unfair, awards breed resentment rather than inspiration. Maintaining consistent, clearly defined standards ensures that receiving an award truly means something and that all recipients have genuinely earned their recognition. This consistency preserves the prestige of military honors and ensures they continue to serve their purposes of acknowledging achievement, boosting morale, and inspiring excellence for future generations of service members.\n\nWhat can be inferred from this passage?",
            options: ["All service members receive medals", "Awards have both individual and collective benefits", "Medals are purely symbolic", "Criteria for awards change frequently"],
            correctAnswer: 1,
            explanation: "The passage indicates awards acknowledge individual achievement while also boosting morale and inspiring others, showing both individual and broader collective benefits."
          },
          {
            id: 4,
            question: "Night vision technology amplifies available light, allowing personnel to see in near-total darkness by collecting and intensifying tiny amounts of ambient light from sources like stars, the moon, or distant artificial lights. Modern devices use infrared sensors that detect heat signatures from living beings and machinery, creating thermal images that show objects based on their temperature rather than visible light reflection. This capability provides enormous tactical advantages by allowing military forces to operate effectively during nighttime when adversaries without such technology are essentially blind. Personnel can navigate, identify targets, and coordinate movements in conditions that would otherwise make these activities impossible. The ability to own the night has become a crucial component of modern military superiority.\n\nWhile highly effective, night vision equipment has limitations that users must understand to employ it properly. It can be affected by fog, which scatters light and reduces visibility even with amplification. Rain impacts effectiveness by creating visual interference and absorbing infrared radiation, making it harder to detect heat signatures. Extreme temperatures cause problems as well: very cold environments reduce thermal contrast between objects and their surroundings, while very hot environments can create so much ambient heat that thermal imaging becomes less useful. Additionally, night vision devices can be overwhelmed by sudden bright lights, temporarily blinding the user. Understanding these limitations helps personnel know when to rely on night vision and when to use alternative methods.\n\nProper training is essential to maximize effectiveness and avoid the pitfalls that inexperienced users often encounter. Personnel must learn how to adjust equipment for different conditions, recognize the difference between real objects and visual artifacts, and understand the limitations of their specific devices. They need to practice moving and operating safely while looking through night vision equipment, which restricts peripheral vision and depth perception. Training also covers care and maintenance of this sensitive equipment, troubleshooting common problems, and integrating night vision into unit tactics. Without adequate training, personnel may misinterpret what they see, damage expensive equipment, or fail to exploit the full capabilities that night vision technology provides.\n\nWhat limitation of night vision is NOT mentioned?",
            options: ["Fog affects performance", "Rain impacts effectiveness", "Battery life is limited", "Extreme temperatures cause problems"],
            correctAnswer: 2,
            explanation: "The passage mentions fog, rain, and extreme temperatures as limitations, but does not discuss battery life."
          },
          {
            id: 5,
            question: "Leadership development programs prepare service members for increasing responsibility by systematically building the skills, knowledge, and experience needed for effective leadership. These programs combine classroom instruction with practical field exercises, creating a comprehensive learning environment that addresses both the theoretical and practical aspects of leadership. Classroom instruction provides the intellectual foundation by teaching leadership principles, organizational management, decision-making frameworks, and historical case studies of successful and failed leadership. Participants learn the why behind effective leadership practices and develop mental models for understanding complex leadership challenges. This theoretical knowledge gives them a framework for analyzing situations and making informed decisions.\n\nThe practical field exercises allow participants to apply theoretical knowledge in realistic scenarios where they face actual leadership challenges. These exercises simulate the stress, complexity, and uncertainty of real military operations, requiring participants to make decisions with incomplete information, manage limited resources, and coordinate the actions of others under pressure. Unlike classroom discussions where mistakes are just talking points, field exercises create consequences for poor decisions and demonstrate the real-world impact of leadership choices. Participants learn from both successes and failures in an environment where mistakes are valuable teaching moments rather than disasters. This experiential learning cements theoretical concepts and builds confidence in applying leadership skills.\n\nMentorship from experienced leaders provides invaluable guidance that cannot be learned from textbooks alone because it offers personalized advice based on real experience. Experienced leaders share insights from their own successes and failures, providing context and nuance that formal instruction cannot capture. They help developing leaders understand the unwritten rules of organizational culture, navigate complex interpersonal dynamics, and develop judgment that comes only from experience. Mentors can tailor their guidance to each individual's specific strengths, weaknesses, and circumstances. This personal relationship allows developing leaders to ask questions, discuss challenges confidentially, and receive honest feedback that accelerates their growth. The combination of classroom instruction, practical exercises, and mentorship creates a comprehensive leadership development approach.\n\nWhat does the passage suggest about effective leadership training?",
            options: ["Classroom instruction is sufficient", "Practical application enhances learning", "Textbooks contain all necessary knowledge", "Mentorship is optional"],
            correctAnswer: 1,
            explanation: "The passage emphasizes that programs 'combine classroom instruction with practical field exercises' and mentions mentorship provides guidance beyond textbooks, indicating practical application enhances learning."
          }
        ]
      },
      {
        id: 5,
        name: "Mathematics Knowledge (MK)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Solve for x: 5x - 18 = 32",
            options: ["x = 8", "x = 10", "x = 12", "x = 14"],
            correctAnswer: 1,
            explanation: "Add 18 to both sides: 5x = 50. Divide both sides by 5: x = 10."
          },
          {
            id: 2,
            question: "What is the perimeter of a square with sides measuring 9 inches?",
            options: ["18 inches", "27 inches", "36 inches", "81 inches"],
            correctAnswer: 2,
            explanation: "Perimeter of a square = 4 × side length = 4 × 9 = 36 inches."
          },
          {
            id: 3,
            question: "What is 35% of 240?",
            options: ["72", "78", "84", "90"],
            correctAnswer: 2,
            explanation: "35% of 240 = 0.35 × 240 = 84."
          },
          {
            id: 4,
            question: "If 4y + 7 = 31, what is the value of y?",
            options: ["y = 5", "y = 6", "y = 7", "y = 8"],
            correctAnswer: 1,
            explanation: "Subtract 7 from both sides: 4y = 24. Divide both sides by 4: y = 6."
          },
          {
            id: 5,
            question: "What is the volume of a rectangular box with length 6 cm, width 4 cm, and height 3 cm?",
            options: ["48 cubic cm", "60 cubic cm", "72 cubic cm", "84 cubic cm"],
            correctAnswer: 2,
            explanation: "Volume = length × width × height = 6 × 4 × 3 = 72 cubic centimeters."
          }
        ]
      },
      {
        id: 6,
        name: "Electronics Information (EI)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What is the unit of measurement for electrical resistance?",
            options: ["Ampere", "Volt", "Ohm", "Watt"],
            correctAnswer: 2,
            explanation: "The ohm (symbol: Ω) is the SI unit of electrical resistance, named after German physicist Georg Ohm."
          },
          {
            id: 2,
            question: "In a parallel circuit, what happens to the total resistance as more resistors are added?",
            options: ["It increases", "It decreases", "It stays the same", "It becomes infinite"],
            correctAnswer: 1,
            explanation: "In a parallel circuit, adding more resistors provides additional paths for current flow, which decreases the total resistance of the circuit."
          },
          {
            id: 3,
            question: "What component stores electrical energy in an electric field?",
            options: ["Resistor", "Capacitor", "Inductor", "Transformer"],
            correctAnswer: 1,
            explanation: "A capacitor stores electrical energy in an electric field between two conducting plates separated by an insulating material (dielectric)."
          },
          {
            id: 4,
            question: "What does AC stand for in electrical terminology?",
            options: ["Active Current", "Alternating Current", "Automatic Circuit", "Amplified Charge"],
            correctAnswer: 1,
            explanation: "AC stands for Alternating Current, which is electric current that periodically reverses direction, unlike DC (Direct Current) which flows in one direction."
          },
          {
            id: 5,
            question: "Which material is commonly used as a conductor in electrical wiring?",
            options: ["Rubber", "Copper", "Plastic", "Wood"],
            correctAnswer: 1,
            explanation: "Copper is an excellent electrical conductor due to its low resistance and high conductivity, making it the most common material for electrical wiring."
          }
        ]
      },
      {
        id: 7,
        name: "Auto & Shop Information (AS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What is the primary function of a vehicle's alternator?",
            options: ["Start the engine", "Charge the battery and power electrical systems", "Control transmission shifting", "Filter engine oil"],
            correctAnswer: 1,
            explanation: "The alternator converts mechanical energy from the engine into electrical energy to charge the battery and power the vehicle's electrical systems while running."
          },
          {
            id: 2,
            question: "Which tool is used to measure the diameter of a cylindrical object with high precision?",
            options: ["Tape measure", "Micrometer", "Level", "Square"],
            correctAnswer: 1,
            explanation: "A micrometer (or micrometer screw gauge) is a precision measuring instrument capable of measuring small distances or thicknesses to within 0.001 inch or 0.01 mm."
          },
          {
            id: 3,
            question: "What does the viscosity rating on motor oil indicate?",
            options: ["Oil color", "Oil thickness or resistance to flow", "Oil age", "Oil brand"],
            correctAnswer: 1,
            explanation: "Viscosity refers to an oil's thickness and resistance to flow. Ratings like 10W-30 indicate how the oil flows at different temperatures, with lower numbers being thinner."
          },
          {
            id: 4,
            question: "What is the purpose of a torque wrench?",
            options: ["Remove stripped bolts", "Tighten fasteners to a specific torque specification", "Measure bolt length", "Cut metal"],
            correctAnswer: 1,
            explanation: "A torque wrench is used to apply a specific amount of rotational force (torque) to fasteners, ensuring they are tightened to manufacturer specifications without over-tightening."
          },
          {
            id: 5,
            question: "Which automotive component connects the engine to the transmission?",
            options: ["Drive shaft", "Clutch or torque converter", "Differential", "Axle"],
            correctAnswer: 1,
            explanation: "In manual transmissions, the clutch connects the engine to the transmission. In automatic transmissions, a torque converter serves this function, allowing the engine to run while the vehicle is stopped."
          }
        ]
      },
      {
        id: 8,
        name: "Mechanical Comprehension (MC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "If gear A has 20 teeth and gear B has 40 teeth, and gear A makes 100 revolutions, how many revolutions does gear B make?",
            options: ["25 revolutions", "50 revolutions", "100 revolutions", "200 revolutions"],
            correctAnswer: 1,
            explanation: "The gear ratio is 20:40 or 1:2. When the smaller gear makes 100 revolutions, the larger gear makes half as many: 100 ÷ 2 = 50 revolutions."
          },
          {
            id: 2,
            question: "A lever is 12 feet long with the fulcrum placed 3 feet from one end. If 40 pounds of force is applied on the short end, approximately how much weight can be lifted on the long end?",
            options: ["10 pounds", "13 pounds", "120 pounds", "160 pounds"],
            correctAnswer: 1,
            explanation: "Using the lever principle: Force × Distance = Weight × Distance. The short end is 3 feet, the long end is 9 feet. 40 × 3 = Weight × 9, so Weight = 120 ÷ 9 = approximately 13 pounds."
          },
          {
            id: 3,
            question: "Which simple machine is a ramp or inclined plane an example of?",
            options: ["Lever", "Wheel and axle", "Inclined plane", "Pulley"],
            correctAnswer: 2,
            explanation: "A ramp is an inclined plane, one of the six classical simple machines. It reduces the force needed to raise an object by increasing the distance over which the force is applied."
          },
          {
            id: 4,
            question: "In a pulley system, if you pull 10 feet of rope to raise a load 2 feet, what is the mechanical advantage?",
            options: ["2", "5", "10", "20"],
            correctAnswer: 1,
            explanation: "Mechanical advantage = Distance of effort ÷ Distance load moves = 10 feet ÷ 2 feet = 5. This means the force required is reduced by a factor of 5."
          },
          {
            id: 5,
            question: "What happens to water pressure as you go deeper underwater?",
            options: ["It decreases", "It stays the same", "It increases", "It becomes zero"],
            correctAnswer: 2,
            explanation: "Water pressure increases with depth because there is more water above pressing down. Pressure increases approximately 1 atmosphere (14.7 psi) for every 33 feet of depth."
          }
        ]
      },
      {
        id: 9,
        name: "Assembling Objects (AO)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Which arrangement correctly assembles the following shapes when the connectors are joined: a circle with point A, and a square with point A?",
            options: ["Circle and square separated", "Circle overlapping square at point A", "Square inside circle", "Circle touching square at point A"],
            correctAnswer: 3,
            explanation: "When shapes with matching connector points (both labeled A) are joined, they touch at that specific point, positioning the circle adjacent to the square at point A."
          },
          {
            id: 2,
            question: "A triangle with connector point B at the top vertex must connect to a rectangle with connector point B on its left side. What is the correct arrangement?",
            options: ["Triangle's top touches rectangle's left side", "Triangle inside rectangle", "Rectangle on top of triangle", "Triangle and rectangle separated"],
            correctAnswer: 0,
            explanation: "Matching connector points B must touch, so the top vertex of the triangle connects to the left side of the rectangle at point B."
          },
          {
            id: 3,
            question: "If five separate pieces form a cross when assembled, which piece would be in the center?",
            options: ["The longest piece", "A square or piece with four connection points", "The smallest piece", "The triangular piece"],
            correctAnswer: 1,
            explanation: "In a cross pattern, the center piece must connect to four other pieces (top, bottom, left, right), so it needs four connection points or edges."
          },
          {
            id: 4,
            question: "Two identical right triangles need to be assembled. Which arrangement creates a rectangle?",
            options: ["Triangles tip to tip", "Hypotenuses joined together", "Right angles touching", "Triangles separated"],
            correctAnswer: 1,
            explanation: "When two identical right triangles have their hypotenuses (longest sides) joined together, they form a rectangle."
          },
          {
            id: 5,
            question: "A hexagon has connector point C on one edge, and a pentagon has connector point C at a vertex. When properly assembled, what is true?",
            options: ["Shapes overlap completely", "The pentagon's vertex C touches the hexagon's edge at point C", "Shapes remain separate", "The hexagon goes inside the pentagon"],
            correctAnswer: 1,
            explanation: "Connector points with the same label must join, so the vertex of the pentagon marked C connects to the edge of the hexagon at its point C."
          }
        ]
      },
      {
        id: 10,
        name: "Verbal Expression (VE)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Which sentence is grammatically correct?",
            options: ["Between you and I, the training was difficult.", "The sergeant gave the orders to him and I.", "She and I completed the course successfully.", "Me and her passed the physical test."],
            correctAnswer: 2,
            explanation: "'She and I' is correct because both pronouns are subjects of the verb 'completed.' Use 'I' (not 'me') as a subject, and put the other person first out of courtesy."
          },
          {
            id: 2,
            question: "Which sentence uses punctuation correctly?",
            options: ["The squad includes: rifles, ammunition and rations.", "The squad includes rifles, ammunition, and rations.", "The squad includes rifles ammunition and rations.", "The squad includes, rifles, ammunition, and rations."],
            correctAnswer: 1,
            explanation: "Items in a list should be separated by commas. The comma before 'and' (Oxford comma) is preferred in military and technical writing for clarity."
          },
          {
            id: 3,
            question: "Choose the sentence with the correct verb tense:",
            options: ["By next week, the unit will completed training.", "By next week, the unit will have completed training.", "By next week, the unit completes training.", "By next week, the unit completing training."],
            correctAnswer: 1,
            explanation: "'Will have completed' is the future perfect tense, correctly indicating an action that will be finished by a specific time in the future."
          },
          {
            id: 4,
            question: "Which sentence is most clear and effective?",
            options: ["The orders that were given by the commander were followed by the soldiers.", "The commander's orders were followed by the soldiers.", "The soldiers followed the orders given by the commander.", "Following the orders, the commander's soldiers obeyed."],
            correctAnswer: 2,
            explanation: "'The soldiers followed the orders given by the commander' is clear, direct, and uses active voice effectively while maintaining proper grammar and logical flow."
          },
          {
            id: 5,
            question: "Which sentence correctly uses 'affect' or 'effect'?",
            options: ["The new policy will effect all personnel.", "The training had a positive affect on performance.", "Weather conditions can affect mission success.", "The affect of the decision was immediate."],
            correctAnswer: 2,
            explanation: "'Affect' is typically a verb meaning to influence. 'Weather conditions can affect mission success' correctly uses 'affect' as a verb. 'Effect' is typically a noun (the result)."
          }
        ]
      }
    ]
  },,
  {
    id: 16,
    title: "ASVAB Practice Test #16",
    description: "Comprehensive practice exam covering all 10 ASVAB sections with military-standard questions",
    totalQuestions: 50,
    timeLimit: 60,
    sections: [
      {
        id: 1,
        name: "General Science (GS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What is the primary function of hemoglobin in red blood cells?",
            options: ["Fighting infection", "Transporting oxygen", "Clotting blood", "Producing antibodies"],
            correctAnswer: 1,
            explanation: "Hemoglobin is an iron-containing protein in red blood cells that binds to oxygen in the lungs and transports it throughout the body to tissues that need it."
          },
          {
            id: 2,
            question: "Which layer of Earth's atmosphere contains the ozone layer?",
            options: ["Troposphere", "Stratosphere", "Mesosphere", "Thermosphere"],
            correctAnswer: 1,
            explanation: "The stratosphere, located approximately 10-50 km above Earth's surface, contains the ozone layer which absorbs most of the sun's harmful ultraviolet radiation."
          },
          {
            id: 3,
            question: "In physics, what is the term for the resistance of an object to changes in its motion?",
            options: ["Momentum", "Inertia", "Velocity", "Acceleration"],
            correctAnswer: 1,
            explanation: "Inertia is the property of matter that causes it to resist changes in its state of motion or rest. Objects with greater mass have greater inertia."
          },
          {
            id: 4,
            question: "What type of chemical bond involves the sharing of electrons between atoms?",
            options: ["Ionic bond", "Metallic bond", "Covalent bond", "Hydrogen bond"],
            correctAnswer: 2,
            explanation: "A covalent bond forms when two atoms share one or more pairs of electrons to achieve stable electron configurations."
          },
          {
            id: 5,
            question: "Which part of a plant cell is responsible for photosynthesis?",
            options: ["Nucleus", "Mitochondria", "Chloroplast", "Ribosome"],
            correctAnswer: 2,
            explanation: "Chloroplasts are organelles found in plant cells that contain chlorophyll and carry out photosynthesis, converting light energy into chemical energy."
          }
        ]
      },
      {
        id: 2,
        name: "Arithmetic Reasoning (AR)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "A military convoy travels 180 miles in 3 hours. What is the average speed in miles per hour?",
            options: ["50 mph", "55 mph", "60 mph", "65 mph"],
            correctAnswer: 2,
            explanation: "Average speed = total distance ÷ total time = 180 miles ÷ 3 hours = 60 miles per hour."
          },
          {
            id: 2,
            question: "A supply depot has 1,440 MREs (Meals Ready to Eat). If each soldier receives 3 MREs per day, how many soldiers can be fed for 4 days?",
            options: ["100 soldiers", "120 soldiers", "140 soldiers", "160 soldiers"],
            correctAnswer: 1,
            explanation: "Each soldier needs 3 × 4 = 12 MREs for 4 days. Total soldiers = 1,440 ÷ 12 = 120 soldiers."
          },
          {
            id: 3,
            question: "If a military discount reduces the price of an item by 15%, what is the sale price of a $240 item?",
            options: ["$200", "$204", "$210", "$216"],
            correctAnswer: 1,
            explanation: "Discount amount = $240 × 0.15 = $36. Sale price = $240 - $36 = $204."
          },
          {
            id: 4,
            question: "A platoon completes a 12-mile march in 3 hours. At the same pace, how long will it take to march 20 miles?",
            options: ["4 hours", "4.5 hours", "5 hours", "5.5 hours"],
            correctAnswer: 2,
            explanation: "Rate = 12 miles ÷ 3 hours = 4 mph. Time for 20 miles = 20 ÷ 4 = 5 hours."
          },
          {
            id: 5,
            question: "In a military training class, the ratio of officers to enlisted personnel is 1:8. If there are 72 enlisted personnel, how many officers are there?",
            options: ["7 officers", "8 officers", "9 officers", "10 officers"],
            correctAnswer: 2,
            explanation: "For every 1 officer there are 8 enlisted. Number of officers = 72 ÷ 8 = 9 officers."
          }
        ]
      },
      {
        id: 3,
        name: "Word Knowledge (WK)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Vigilant most nearly means:",
            options: ["Careless", "Watchful", "Aggressive", "Tired"],
            correctAnswer: 1,
            explanation: "Vigilant means keeping careful watch for possible danger or difficulties; being alert and attentive."
          },
          {
            id: 2,
            question: "Collaborate most nearly means:",
            options: ["Compete", "Work together", "Disagree", "Separate"],
            correctAnswer: 1,
            explanation: "Collaborate means to work jointly with others or together, especially in an intellectual endeavor or on a project."
          },
          {
            id: 3,
            question: "Resilient most nearly means:",
            options: ["Fragile", "Able to recover quickly", "Permanent", "Weak"],
            correctAnswer: 1,
            explanation: "Resilient means able to withstand or recover quickly from difficult conditions; having the ability to bounce back from adversity."
          },
          {
            id: 4,
            question: "Obsolete most nearly means:",
            options: ["Modern", "Out of date", "Functional", "New"],
            correctAnswer: 1,
            explanation: "Obsolete means no longer produced or used; out of date, typically because something newer and better has been invented or developed."
          },
          {
            id: 5,
            question: "Meticulous most nearly means:",
            options: ["Careless", "Quick", "Very careful and precise", "Lazy"],
            correctAnswer: 2,
            explanation: "Meticulous means showing great attention to detail; very careful and precise in one's work or actions."
          }
        ]
      },
      {
        id: 4,
        name: "Paragraph Comprehension (PC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Night vision technology allows military personnel to see in low-light conditions by amplifying available light that would be insufficient for normal human vision. This capability provides enormous tactical advantages during nighttime operations, allowing forces to navigate, identify targets, and coordinate movements in darkness while adversaries without such technology remain effectively blind. Modern night vision devices use image intensifier tubes that collect tiny amounts of light, including infrared light invisible to the human eye, from sources like starlight, moonlight, or distant artificial illumination. Even on the darkest nights, there is usually some ambient light present that these devices can detect and utilize.\n\nThe technology works through a sophisticated process that transforms minimal light into clearly visible images. These photons are converted to electrons when they strike a photocathode plate inside the device. The electrons are then amplified thousands of times as they pass through a microchannel plate, which multiplies them dramatically through a cascading process. Finally, these amplified electrons strike a phosphor screen where they are converted back into visible light and displayed as the characteristic green image associated with night vision. The green color is used because the human eye can distinguish more shades of green than any other color, providing maximum visual detail and reducing eye strain during extended use.\n\nThis amplification process allows military personnel to operate effectively in conditions that would otherwise require artificial lighting that could reveal their positions to enemy forces. Night vision technology has become so integral to modern military operations that owning the night is considered a significant tactical advantage. The devices range from handheld monoculars to weapon-mounted scopes to aviation systems, all employing similar principles of light amplification. Understanding how night vision technology creates visible images from minimal light helps personnel appreciate both the capabilities and limitations of their equipment, enabling them to use it most effectively during operations.\n\nAccording to the passage, how do night vision devices create visible images?",
            options: ["By creating new light", "By amplifying and converting available light into visible images", "By using radar waves", "By thermal imaging only"],
            correctAnswer: 1,
            explanation: "The passage explains that night vision devices collect and amplify available light (including infrared), convert it to electrons, amplify these, and display the result as a visible green image."
          },
          {
            id: 2,
            question: "The chain of command is a fundamental military principle that establishes a hierarchy of authority throughout the entire organization. Orders flow downward from senior officers to subordinates through established channels, ensuring that directives come from authorized sources and are communicated properly. Information and reports flow upward through the same channels, keeping commanders at all levels informed about situations, problems, and progress. This bidirectional flow creates a structured communication system that functions even during the chaos and confusion of combat operations. Each level of the chain has specific responsibilities and authority appropriate to their position, creating a clear organizational structure that everyone understands.\n\nThis system ensures clear communication, accountability, and efficient decision-making by defining roles and responsibilities explicitly. Clear communication results from having established channels and protocols that everyone knows and follows. Accountability is maintained because the chain creates traceable connections between decisions and their outcomes. When everyone knows who gave which orders and who was responsible for executing them, it becomes possible to learn from both successes and failures. Efficient decision-making occurs because the chain of command delegates authority appropriately, allowing decisions to be made at the appropriate level without requiring senior leaders to micromanage every detail. Junior leaders can make tactical decisions while senior leaders focus on strategic planning.\n\nBypassing the chain of command can create confusion and undermine leadership effectiveness by disrupting this carefully structured system. When personnel go around their immediate supervisors, it leaves those supervisors uninformed and unable to coordinate their units effectively. When orders come from outside the proper chain, it creates questions about priority and legitimacy. Personnel may receive conflicting instructions, become uncertain about which orders to follow, or fail to coordinate properly with their teammates. The resulting confusion can paralyze decision-making and create dangerous situations. Respecting the chain of command maintains organizational integrity and ensures that military units can function effectively under all conditions.\n\nWhat is the main purpose of the chain of command?",
            options: ["To create confusion", "To ensure clear communication and accountability", "To limit information flow", "To prevent decision-making"],
            correctAnswer: 1,
            explanation: "The passage clearly states that the chain of command ensures clear communication, accountability, and efficient decision-making."
          },
          {
            id: 3,
            question: "Military aircraft carriers are among the largest warships ever built, serving as mobile airbases that bring formidable air power to any ocean in the world. A single carrier can deploy over 60 aircraft including fighters, attack planes, electronic warfare aircraft, and helicopters, creating a versatile strike force capable of multiple mission types. These massive vessels house more than 5,000 personnel including pilots, maintenance crews, deck personnel, and the ship's company needed to operate such a complex floating city. The sheer size and complexity of carrier operations requires precise organization, constant training, and flawless execution to maintain safety and effectiveness in the demanding maritime environment.\n\nThe flight deck operates 24 hours a day during missions, with precise coordination required between pilots, deck crew, and air traffic controllers to manage the constant cycle of launches and recoveries. Aircraft catapults launch planes from the deck every few minutes, while arresting gear cables catch landing aircraft traveling at high speeds in a controlled crash onto the deck. This dangerous ballet of equipment and personnel takes place on a moving platform subject to weather, sea conditions, and the operational tempo of military missions. The coordination required is extraordinarily complex, with color-coded deck crews performing specific functions, hand signals replacing radio communications in the noisy environment, and split-second timing preventing accidents that could be catastrophic.\n\nCarriers project power across vast ocean distances and can respond rapidly to global crises without requiring permission to use foreign airbases or depending on host nation support. They can position themselves off any coastline in international waters and conduct operations as needed. This mobility and independence makes carriers invaluable strategic assets that provide diplomatic flexibility along with military capability. When crises emerge anywhere in the world's oceans or coastal regions, carriers can arrive quickly and begin operations immediately. They can sustain operations for months with their nuclear power and regular replenishment from support ships, making them the ultimate expression of naval power projection.\n\nBased on the passage, what is a key advantage of aircraft carriers?",
            options: ["They are small and fast", "They can project power and respond rapidly across vast distances", "They only operate during daytime", "They carry no personnel"],
            correctAnswer: 1,
            explanation: "The passage states that carriers project power across vast ocean distances and can respond rapidly to global crises, making them highly mobile and strategically valuable."
          },
          {
            id: 4,
            question: "Camouflage is essential for military operations, allowing personnel and equipment to blend into their surroundings and avoid detection by enemy forces. Different environments require different camouflage patterns to match the specific colors, textures, and lighting conditions found in each terrain type. Woodland environments feature various shades of green and brown with irregular patterns created by vegetation, shadows, and natural features. Desert environments display lighter colors like tans and browns with less vegetation and more uniform terrain. Urban environments incorporate grays, blacks, and earth tones reflecting man-made structures like concrete, asphalt, and brick. Arctic environments require white and light gray patterns to blend with snow and ice.\n\nModern digital camouflage uses pixelated patterns that are more effective at disrupting the human outline at various distances than traditional camouflage designs. The small, computer-generated pixels create visual noise that confuses the eye at both close and far ranges. Traditional patterns sometimes became less effective at certain distances, appearing as solid colors rather than disruptive patterns. Digital patterns maintain their effectiveness across a wide range of viewing distances and lighting conditions. The science behind these patterns draws on research into human visual perception and how the eye recognizes shapes and forms. By understanding how observers process visual information, designers can create patterns that specifically exploit weaknesses in human visual recognition.\n\nEffective camouflage provides tactical advantage by making detection more difficult, allowing military forces to observe enemy positions, move undetected, and achieve surprise in combat operations. When personnel can approach closer to enemy forces without being seen, they gain significant advantages in engagement range and tactical positioning. Camouflage also protects defensive positions by making them harder to identify and target. The psychological effect of not being able to see one's enemy can also demoralize opposing forces. Throughout military history, effective camouflage and concealment have often meant the difference between mission success and failure, making it a critical component of military operations in all environments.\n\nWhy do different environments require different camouflage patterns?",
            options: ["For fashion purposes", "Because each environment has different visual characteristics requiring specific patterns to blend in", "To confuse friendly forces", "To save money"],
            correctAnswer: 1,
            explanation: "The passage indicates that different environments (woodland, desert, urban, arctic) have different characteristics, requiring specific camouflage patterns to blend in effectively."
          },
          {
            id: 5,
            question: "Military medicine has advanced significantly during wartime, with innovations that later benefit civilian healthcare in profound and lasting ways. Triage systems, developed to prioritize treatment of casualties when medical resources are overwhelmed, are now standard in emergency rooms worldwide. This systematic approach to categorizing patients by severity and treatment priority ensures that limited medical resources are used most effectively to save the greatest number of lives. What began as a battlefield necessity has become fundamental to emergency medicine, improving outcomes in disasters, mass casualty events, and even routine emergency department operations. The triage concept represents just one of many military medical innovations that have transformed civilian healthcare.\n\nAdvances in treating traumatic injuries, prosthetics technology, and telemedicine have all emerged from military medical research driven by the unique challenges of battlefield medicine. The need to treat severe wounds in austere environments has led to innovations in hemorrhage control, wound management, and damage control surgery that save civilian trauma patients every day. Modern prosthetics incorporating advanced materials, computer controls, and neural interfaces were developed largely through military research programs serving wounded veterans. Telemedicine systems allowing specialists to guide treatment remotely were pioneered to bring expert medical care to remote military locations, and now serve rural civilian communities and disaster response efforts. These technologies demonstrate how military medical requirements drive innovations with broad civilian applications.\n\nCombat medics receive intensive training to provide life-saving care under extreme conditions, developing protocols and techniques that work in the chaos of combat. They must treat severe injuries with limited equipment, work under fire, and make rapid decisions that determine whether casualties survive. This demanding environment has produced medical advances in areas like tourniquet use, hemostatic agents, and tactical combat casualty care protocols that have revolutionized pre-hospital emergency care. The lessons learned from combat medicine, purchased at tremendous cost, ultimately benefit society broadly as these innovations transfer to civilian emergency medical systems, improving outcomes for accident victims, natural disaster survivors, and others requiring emergency medical care.\n\nWhat does the passage suggest about military medical innovations?",
            options: ["They only benefit military personnel", "They have no impact on civilian medicine", "They later benefit civilian healthcare", "They are kept secret forever"],
            correctAnswer: 2,
            explanation: "The passage explicitly states that military medical innovations 'later benefit civilian healthcare' and provides examples like triage systems now used in emergency rooms."
          }
        ]
      },
      {
        id: 5,
        name: "Mathematics Knowledge (MK)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Simplify: (3x + 4) + (2x - 7)",
            options: ["5x - 3", "5x + 3", "x - 3", "5x - 11"],
            correctAnswer: 0,
            explanation: "Combine like terms: 3x + 2x = 5x and 4 + (-7) = -3, giving us 5x - 3."
          },
          {
            id: 2,
            question: "What is the perimeter of a rectangle with length 15 feet and width 9 feet?",
            options: ["24 feet", "36 feet", "48 feet", "54 feet"],
            correctAnswer: 2,
            explanation: "Perimeter of rectangle = 2(length + width) = 2(15 + 9) = 2(24) = 48 feet."
          },
          {
            id: 3,
            question: "If 3x = 27, what is the value of x?",
            options: ["6", "7", "8", "9"],
            correctAnswer: 3,
            explanation: "Divide both sides by 3: x = 27 ÷ 3 = 9."
          },
          {
            id: 4,
            question: "What is 20% of 350?",
            options: ["60", "65", "70", "75"],
            correctAnswer: 2,
            explanation: "20% of 350 = 0.20 × 350 = 70."
          },
          {
            id: 5,
            question: "What is the value of 4² + 3²?",
            options: ["20", "22", "25", "28"],
            correctAnswer: 2,
            explanation: "4² = 16 and 3² = 9. Therefore, 16 + 9 = 25."
          }
        ]
      },
      {
        id: 6,
        name: "Electronics Information (EI)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What is the unit of measurement for electrical resistance?",
            options: ["Amp", "Volt", "Ohm", "Watt"],
            correctAnswer: 2,
            explanation: "The ohm (symbol: Ω) is the SI unit of electrical resistance, measuring how much a material opposes the flow of electric current."
          },
          {
            id: 2,
            question: "In a series circuit with three resistors, what happens to the total resistance?",
            options: ["It decreases", "It stays the same", "It increases", "It becomes zero"],
            correctAnswer: 2,
            explanation: "In a series circuit, the total resistance is the sum of all individual resistances, so it increases with each added resistor."
          },
          {
            id: 3,
            question: "What type of current does a standard household battery produce?",
            options: ["Alternating current (AC)", "Direct current (DC)", "Pulsed current", "No current"],
            correctAnswer: 1,
            explanation: "Batteries produce direct current (DC), which flows in one constant direction from the negative to positive terminal."
          },
          {
            id: 4,
            question: "What electronic component is used to store electrical energy in an electric field?",
            options: ["Resistor", "Capacitor", "Inductor", "Transistor"],
            correctAnswer: 1,
            explanation: "A capacitor stores electrical energy in an electric field between two conductive plates separated by an insulating material (dielectric)."
          },
          {
            id: 5,
            question: "What does a diode primarily do in an electrical circuit?",
            options: ["Amplify signals", "Allow current to flow in one direction only", "Store energy", "Measure voltage"],
            correctAnswer: 1,
            explanation: "A diode is a semiconductor device that allows current to flow in only one direction, blocking current flow in the opposite direction."
          }
        ]
      },
      {
        id: 7,
        name: "Auto & Shop Information (AS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What is the primary purpose of a vehicle's alternator?",
            options: ["Start the engine", "Charge the battery and power electrical systems", "Cool the engine", "Control transmission shifting"],
            correctAnswer: 1,
            explanation: "The alternator generates electrical power while the engine runs, charging the battery and providing electricity for the vehicle's electrical systems."
          },
          {
            id: 2,
            question: "Which tool is best for cutting metal in a shop environment?",
            options: ["Wood saw", "Hacksaw", "Crosscut saw", "Coping saw"],
            correctAnswer: 1,
            explanation: "A hacksaw has fine-toothed blade specifically designed for cutting metal, plastic, and other hard materials in shop work."
          },
          {
            id: 3,
            question: "What automotive fluid is typically red or pink in color?",
            options: ["Engine oil", "Brake fluid", "Transmission fluid", "Coolant"],
            correctAnswer: 2,
            explanation: "Transmission fluid is typically dyed red or pink to distinguish it from other automotive fluids and to help detect leaks."
          },
          {
            id: 4,
            question: "What is the purpose of a torque wrench?",
            options: ["To remove rounded nuts", "To tighten fasteners to a specific tightness", "To measure angles", "To cut threads"],
            correctAnswer: 1,
            explanation: "A torque wrench is designed to apply a specific amount of torque (rotational force) to a fastener, ensuring it's tightened to manufacturer specifications."
          },
          {
            id: 5,
            question: "In automotive terms, what does ABS stand for?",
            options: ["Automatic Brake System", "Anti-lock Braking System", "Auxiliary Battery System", "Advanced Brake Sensor"],
            correctAnswer: 1,
            explanation: "ABS stands for Anti-lock Braking System, which prevents wheels from locking up during hard braking, maintaining steering control and reducing stopping distance."
          }
        ]
      },
      {
        id: 8,
        name: "Mechanical Comprehension (MC)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "If a gear with 40 teeth drives a gear with 20 teeth, what is the speed ratio?",
            options: ["1:2 (driven gear turns twice as fast)", "2:1 (driven gear turns half as fast)", "1:1 (same speed)", "4:1 (driven gear turns four times as fast)"],
            correctAnswer: 0,
            explanation: "When a larger gear drives a smaller gear, the smaller gear rotates faster. With a 40:20 tooth ratio (2:1), the driven gear turns twice as fast as the driving gear."
          },
          {
            id: 2,
            question: "A first-class lever has the fulcrum between the effort and the load. Which is an example of a first-class lever?",
            options: ["Wheelbarrow", "Nutcracker", "Seesaw", "Door"],
            correctAnswer: 2,
            explanation: "A seesaw is a first-class lever with the fulcrum (pivot point) in the middle, between the effort on one side and the load on the other."
          },
          {
            id: 3,
            question: "What happens to water pressure as you go deeper underwater?",
            options: ["It decreases", "It stays the same", "It increases", "It becomes zero"],
            correctAnswer: 2,
            explanation: "Water pressure increases with depth due to the weight of the water above. Pressure increases approximately 1 atmosphere for every 10 meters of depth."
          },
          {
            id: 4,
            question: "If you apply 50 pounds of force to a lever with a mechanical advantage of 4, what load can you lift?",
            options: ["12.5 pounds", "50 pounds", "100 pounds", "200 pounds"],
            correctAnswer: 3,
            explanation: "Mechanical advantage multiplies the input force. With MA of 4, a 50-pound input force can lift a 200-pound load (50 × 4 = 200)."
          },
          {
            id: 5,
            question: "In a pulley system, what is the primary advantage of using multiple pulleys?",
            options: ["Increases speed", "Reduces the force needed to lift a load", "Makes the load heavier", "Decreases friction"],
            correctAnswer: 1,
            explanation: "Multiple pulleys create a mechanical advantage that reduces the force needed to lift a load, though you must pull more rope to achieve the same lift height."
          }
        ]
      },
      {
        id: 9,
        name: "Assembling Objects (AO)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Which shape is formed when a square is cut diagonally from corner to corner?",
            options: ["Two rectangles", "Two triangles", "Two circles", "Two pentagons"],
            correctAnswer: 1,
            explanation: "Cutting a square diagonally from corner to corner creates two right triangles, each with two equal sides (the square's sides) and a hypotenuse (the diagonal cut)."
          },
          {
            id: 2,
            question: "If you fold a rectangular piece of paper in half twice, creating creases, how many sections are formed when unfolded?",
            options: ["2 sections", "3 sections", "4 sections", "8 sections"],
            correctAnswer: 2,
            explanation: "Folding in half once creates 2 sections. Folding in half again creates 4 sections total when the paper is unfolded (2 × 2 = 4)."
          },
          {
            id: 3,
            question: "Which two shapes can be combined to form a rectangle?",
            options: ["Two circles", "Two triangles of equal size", "Two hexagons", "Two ovals"],
            correctAnswer: 1,
            explanation: "Two identical right triangles can be combined along their hypotenuse to form a rectangle. Two identical triangles can also form a parallelogram or rectangle depending on arrangement."
          },
          {
            id: 4,
            question: "If you rotate a capital letter 'N' 180 degrees, what does it become?",
            options: ["Still looks like 'N'", "Looks like 'Z'", "Looks like 'M'", "Looks upside down"],
            correctAnswer: 0,
            explanation: "The letter 'N' has rotational symmetry at 180 degrees. When rotated 180 degrees, it still appears as the letter 'N'."
          },
          {
            id: 5,
            question: "How many edges does a cube have?",
            options: ["6 edges", "8 edges", "10 edges", "12 edges"],
            correctAnswer: 3,
            explanation: "A cube has 12 edges: 4 on the top face, 4 on the bottom face, and 4 connecting the top and bottom faces."
          }
        ]
      },
      {
        id: 10,
        name: "Verbal Expression (VE)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Which sentence demonstrates correct use of the semicolon?",
            options: ["The mission was successful; however we lost communication.", "The mission was successful; however, we lost communication.", "The mission was successful, however; we lost communication.", "The mission was successful however; we lost communication."],
            correctAnswer: 1,
            explanation: "A semicolon connects two independent clauses. When using a transitional word like 'however,' place a semicolon before it and a comma after it."
          },
          {
            id: 2,
            question: "Identify the sentence with correct parallel structure:",
            options: ["The soldier is strong, brave, and has determination.", "The soldier is strong, brave, and determined.", "The soldier is strong, bravely, and determined.", "The soldier is strength, brave, and determined."],
            correctAnswer: 1,
            explanation: "Parallel structure requires consistent grammatical form. All three descriptors should be adjectives: 'strong, brave, and determined.'"
          },
          {
            id: 3,
            question: "Which sentence uses 'who' correctly?",
            options: ["The officer who's equipment was lost must file a report.", "The officer whom led the mission received a commendation.", "The officer who led the mission received a commendation.", "The officer which led the mission received a commendation."],
            correctAnswer: 2,
            explanation: "'Who' is used as a subject pronoun for people. Since the officer performed the action (led), 'who' is correct. 'Whom' is for objects, and 'which' is for things."
          },
          {
            id: 4,
            question: "Choose the sentence with correct comma usage:",
            options: ["Before deploying soldiers must complete, training.", "Before deploying, soldiers must complete training.", "Before deploying soldiers, must complete training.", "Before, deploying soldiers must complete training."],
            correctAnswer: 1,
            explanation: "When an introductory phrase begins a sentence, place a comma after it and before the main clause. 'Before deploying' is the introductory phrase."
          },
          {
            id: 5,
            question: "Which sentence correctly uses 'fewer' or 'less'?",
            options: ["There are less soldiers in this unit than expected.", "There are fewer soldiers in this unit than expected.", "There are less training days this month.", "The unit has fewer equipment than needed."],
            correctAnswer: 1,
            explanation: "Use 'fewer' for countable items (soldiers, days) and 'less' for uncountable quantities (time, water). Soldiers are countable, so 'fewer' is correct."
          }
        ]
      }
    ]
  },
  {
    id: 17,
    title: "ASVAB Practice Test #17",
    description: "Comprehensive practice exam covering all 10 ASVAB sections with military-standard questions",
    totalQuestions: 50,
    timeLimit: 60,
    sections: [
      {
        id: 1,
        name: "General Science (GS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Which type of rock is formed when magma cools and solidifies beneath the Earth's surface?",
            options: [
              "Sedimentary rock",
              "Intrusive igneous rock",
              "Metamorphic rock",
              "Extrusive igneous rock"
            ],
            correctAnswer: 1,
            explanation: "Intrusive igneous rocks form when magma cools slowly beneath the Earth's surface, allowing large crystals to form. Examples include granite and diorite. Extrusive igneous rocks form when lava cools quickly on the surface."
          },
          {
            id: 2,
            question: "What is the primary function of hemoglobin in red blood cells?",
            options: [
              "Fighting infections",
              "Clotting blood",
              "Transporting oxygen",
              "Digesting nutrients"
            ],
            correctAnswer: 2,
            explanation: "Hemoglobin is an iron-containing protein in red blood cells that binds to oxygen in the lungs and transports it throughout the body to tissues and organs. It also helps transport carbon dioxide back to the lungs for exhalation."
          },
          {
            id: 3,
            question: "Which layer of Earth's atmosphere contains the ozone layer that protects us from harmful UV radiation?",
            options: [
              "Troposphere",
              "Stratosphere",
              "Mesosphere",
              "Thermosphere"
            ],
            correctAnswer: 1,
            explanation: "The stratosphere, located approximately 10-50 km above Earth's surface, contains the ozone layer. This layer absorbs most of the Sun's harmful ultraviolet radiation, protecting life on Earth."
          },
          {
            id: 4,
            question: "In a food chain, organisms that produce their own food through photosynthesis are called:",
            options: [
              "Consumers",
              "Decomposers",
              "Producers",
              "Predators"
            ],
            correctAnswer: 2,
            explanation: "Producers, also called autotrophs, are organisms that create their own food through photosynthesis or chemosynthesis. Plants, algae, and some bacteria are producers and form the base of most food chains."
          },
          {
            id: 5,
            question: "What type of chemical bond involves the sharing of electron pairs between atoms?",
            options: [
              "Ionic bond",
              "Metallic bond",
              "Covalent bond",
              "Hydrogen bond"
            ],
            correctAnswer: 2,
            explanation: "A covalent bond forms when two atoms share one or more pairs of electrons. This type of bonding typically occurs between nonmetal atoms and creates stable molecules like water (H2O) and methane (CH4)."
          }
        ]
      },
      {
        id: 2,
        name: "Arithmetic Reasoning (AR)",
        timeLimit: 6,
        questions: [
          {
            id: 6,
            question: "A military convoy consists of 8 transport trucks. Each truck carries 24 supply crates, and each crate weighs 75 pounds. What is the total weight of supplies in the entire convoy?",
            options: [
              "12,600 pounds",
              "14,400 pounds",
              "16,200 pounds",
              "18,000 pounds"
            ],
            correctAnswer: 1,
            explanation: "First, calculate total crates: 8 trucks × 24 crates = 192 crates. Then multiply by weight per crate: 192 crates × 75 pounds = 14,400 pounds total."
          },
          {
            id: 7,
            question: "A platoon of 45 soldiers needs to be divided into equal-sized fire teams of 9 soldiers each. How many fire teams can be formed?",
            options: [
              "4 fire teams",
              "5 fire teams",
              "6 fire teams",
              "7 fire teams"
            ],
            correctAnswer: 1,
            explanation: "Divide the total number of soldiers by the size of each fire team: 45 ÷ 9 = 5 fire teams."
          },
          {
            id: 8,
            question: "An aircraft flies at 420 miles per hour for 3.5 hours. How many miles does it travel?",
            options: [
              "1,260 miles",
              "1,380 miles",
              "1,470 miles",
              "1,560 miles"
            ],
            correctAnswer: 2,
            explanation: "Use the formula: Distance = Speed × Time. Distance = 420 mph × 3.5 hours = 1,470 miles."
          },
          {
            id: 9,
            question: "A military base cafeteria serves 1,200 meals per day. If 35% of the meals are breakfast, how many breakfast meals are served daily?",
            options: [
              "360 meals",
              "400 meals",
              "420 meals",
              "450 meals"
            ],
            correctAnswer: 2,
            explanation: "Calculate 35% of 1,200: 1,200 × 0.35 = 420 breakfast meals."
          },
          {
            id: 10,
            question: "A soldier earns $2,400 per month. After deductions of 22% for taxes and benefits, what is the soldier's take-home pay?",
            options: [
              "$1,728",
              "$1,824",
              "$1,872",
              "$1,920"
            ],
            correctAnswer: 2,
            explanation: "If 22% is deducted, the soldier keeps 78% of pay. Calculate: $2,400 × 0.78 = $1,872."
          }
        ]
      },
      {
        id: 3,
        name: "Word Knowledge (WK)",
        timeLimit: 6,
        questions: [
          {
            id: 11,
            question: "Meticulous most nearly means:",
            options: [
              "Careless",
              "Extremely careful and precise",
              "Quick",
              "Confused"
            ],
            correctAnswer: 1,
            explanation: "Meticulous means showing great attention to detail and being very careful and precise. A meticulous person is thorough and conscientious in their work."
          },
          {
            id: 12,
            question: "Adversary most nearly means:",
            options: [
              "Friend",
              "Opponent",
              "Advisor",
              "Supporter"
            ],
            correctAnswer: 1,
            explanation: "An adversary is an opponent or enemy, someone who opposes or competes against you. In military contexts, it refers to an opposing force or enemy."
          },
          {
            id: 13,
            question: "Fortify most nearly means:",
            options: [
              "Weaken",
              "Strengthen or reinforce",
              "Abandon",
              "Decorate"
            ],
            correctAnswer: 1,
            explanation: "To fortify means to strengthen or reinforce something, especially a defensive position. In military terms, it often refers to building defenses or making a position stronger against attack."
          },
          {
            id: 14,
            question: "Perimeter most nearly means:",
            options: [
              "Center point",
              "Outer boundary",
              "Interior space",
              "Height measurement"
            ],
            correctAnswer: 1,
            explanation: "A perimeter is the outer boundary or edge of an area. In military operations, perimeter security involves protecting the outer boundaries of a position or base."
          },
          {
            id: 15,
            question: "Expedite most nearly means:",
            options: [
              "Delay",
              "Cancel",
              "Speed up or accelerate",
              "Complicate"
            ],
            correctAnswer: 2,
            explanation: "To expedite means to make something happen more quickly or efficiently, to speed up a process or action. It's commonly used in military logistics and operations."
          }
        ]
      },
      {
        id: 4,
        name: "Paragraph Comprehension (PC)",
        timeLimit: 6,
        questions: [
          {
            id: 16,
            question: "Military leadership requires more than just giving orders and expecting compliance. Effective leaders inspire their troops through personal example, demonstrating the standards and behaviors they expect from others. When leaders personally embody the values of courage, dedication, and professionalism, their troops are much more likely to follow suit. They also inspire through clear communication that ensures everyone understands the mission, their role, and the reasoning behind decisions. Additionally, effective leaders show genuine concern for their welfare, taking care of their troops' needs, advocating for them, and treating them with dignity and respect. This creates loyalty and commitment that cannot be commanded.\n\nThey must make difficult decisions under pressure while maintaining the trust and respect of those under their command. Combat leadership involves choices that can affect lives, and leaders must be decisive even when information is incomplete and time is short. These decisions often involve risk, sacrifice, and moral complexity. Throughout this decision-making process, leaders must maintain the trust and respect of those under their command by being honest, fair, and consistent. When subordinates trust their leaders' judgment and respect their character, they will follow orders even in the most dangerous and difficult situations. Loss of trust or respect can undermine a leader's effectiveness and endanger the entire unit.\n\nThe best military leaders understand that their actions speak louder than their words. Personnel pay more attention to what leaders do than what they say. A leader who demands punctuality but arrives late, who preaches fitness but is out of shape, or who talks about courage but avoids danger will quickly lose credibility. Conversely, leaders who consistently demonstrate the standards they expect earn genuine respect and following. This principle of leading by example is perhaps the most fundamental aspect of military leadership, as it builds the credibility and moral authority that make leadership truly effective rather than merely authoritarian.\n\nWhat is the main point of this passage?",
            options: [
              "Military leaders must give clear orders",
              "Effective military leadership requires leading by example and earning trust",
              "Military decisions are always difficult",
              "Communication is the only important leadership skill"
            ],
            correctAnswer: 1,
            explanation: "The passage emphasizes that effective military leadership goes beyond orders and requires leading by example, clear communication, concern for troops, and earning trust and respect—making option B the main point."
          },
          {
            id: 17,
            question: "The Global Positioning System (GPS) has revolutionized military navigation and operations, fundamentally changing how military forces plan and execute missions worldwide. Originally developed by the U.S. Department of Defense during the Cold War as a military asset, GPS uses a network of satellites orbiting Earth to provide precise location data anywhere on the planet. The system consists of at least 24 satellites transmitting radio signals that GPS receivers use to calculate position through trilateration. This technology works in all weather conditions, day or night, requiring only an unobstructed view of the sky. What began as a purely military system has become integral to civilian life as well, but its military applications remain critically important.\n\nThis technology enables troops to navigate unfamiliar terrain with confidence, even in areas where traditional maps may be outdated or unavailable. Soldiers can pinpoint their exact location, plot courses to objectives, and coordinate with other units using precise coordinates. GPS has proven especially valuable in desert, jungle, and ocean environments where traditional landmarks may be scarce or non-existent. The ability to navigate accurately in these challenging environments has enhanced military mobility and operational flexibility. Units can operate more independently knowing they can always determine their location and find their way to rally points or objectives.\n\nGPS also enables the coordination of movements between multiple units and the delivery of precision-guided munitions with unprecedented accuracy. Commanders can track friendly force locations in real-time, reducing the risk of friendly fire incidents and enabling better tactical coordination. Precision-guided weapons use GPS to hit targets with remarkable accuracy, reducing collateral damage and increasing military effectiveness. Artillery, missiles, and bombs guided by GPS can strike within meters of intended targets, a level of precision impossible with earlier guidance systems. This technological advantage has transformed modern warfare, making military operations more precise, more efficient, and in many cases, less destructive to surrounding areas.\n\nAccording to the passage, GPS was:",
            options: [
              "Invented by civilians",
              "Originally developed by the U.S. Department of Defense",
              "Only used for navigation",
              "Developed in the 1990s"
            ],
            correctAnswer: 1,
            explanation: "The passage explicitly states that GPS was 'originally developed by the U.S. Department of Defense,' making option B the correct answer."
          },
          {
            id: 18,
            question: "Physical fitness is a cornerstone of military readiness and directly impacts every aspect of military effectiveness. Service members must maintain high levels of cardiovascular endurance to sustain physical activity during long operations, muscular strength to carry heavy equipment and perform demanding tasks, and flexibility to prevent injuries and maintain mobility in various situations. These physical capabilities are not optional extras but essential requirements for performing military duties effectively. Combat situations, disaster responses, and training exercises all make intense physical demands that only fit personnel can meet successfully. Without adequate fitness, even the most skilled and knowledgeable service members cannot perform at the level their missions require.\n\nRegular physical training not only prepares soldiers for the physical demands of combat but also builds mental toughness, discipline, and unit cohesion. The mental benefits of physical training are just as important as the physical conditioning. When soldiers push through difficult workouts despite fatigue and discomfort, they develop the mental toughness needed to persevere in combat when everything in their body and mind wants to quit. Physical training requires discipline to maintain standards day after day, which translates to discipline in other areas of military life. This mental conditioning proves invaluable when facing the extreme stress and adversity of military operations.\n\nAdditionally, group physical training builds unit cohesion as service members train together, encourage each other, and share the common experience of challenging workouts. They develop bonds of friendship and mutual respect that strengthen their units. When personnel have trained hard together, they trust each other more and work together more effectively. The shared suffering of physical training creates a sense of common identity and purpose. Physical training sessions where units work together toward fitness goals reinforce the teamwork and mutual support essential for military effectiveness. This social aspect of physical training makes it more than just individual conditioning; it becomes a tool for building cohesive, effective military units.\n\nThe passage suggests that physical training:",
            options: [
              "Is only about building muscles",
              "Provides both physical and mental benefits",
              "Is optional for military personnel",
              "Only improves cardiovascular health"
            ],
            correctAnswer: 1,
            explanation: "The passage states that physical training prepares soldiers physically and 'also builds mental toughness, discipline, and unit cohesion,' indicating both physical and mental benefits."
          },
          {
            id: 19,
            question: "Camouflage is a critical survival technique in military operations that can mean the difference between mission success and failure, between life and death. By blending into their surroundings, soldiers can avoid detection by enemy forces, allowing them to observe without being seen, move without being tracked, and strike without warning. This concealment provides enormous tactical advantages in nearly all military scenarios. Throughout military history, forces that have mastered camouflage and concealment have consistently enjoyed advantages over enemies who could not hide as effectively. The ability to see without being seen is one of the most powerful advantages in warfare.\n\nEffective camouflage considers not only visual concealment but also minimizing noise, controlling light reflection, and managing heat signatures that can be detected by thermal imaging devices. Visual concealment involves using patterns and colors that blend with the environment, but modern warfare requires much more. Minimizing noise prevents acoustic detection by enemy listeners or sensors. Controlling light reflection ensures that binoculars, scopes, and other optical devices don't give away positions through glare or reflection. Managing heat signatures has become increasingly important as thermal imaging technology has become more widespread, allowing detection of body heat and equipment heat even in total darkness or through some types of concealment.\n\nThis multi-faceted approach to concealment reflects how technology has expanded the ways enemies can detect military forces. Where once visual concealment was sufficient, modern sensors can detect presence through heat, sound, radar, electromagnetic emissions, and other means. Effective modern camouflage must therefore address all these detection methods to provide adequate concealment. Service members receive training not just in camouflage patterns but in complete concealment discipline, learning to control all the signatures that might reveal their presence. This comprehensive approach to camouflage represents the evolution of an ancient military technique to meet the challenges of modern warfare.\n\nWhat can be inferred from this passage?",
            options: [
              "Camouflage only involves visual concealment",
              "Modern camouflage must address multiple detection methods",
              "Thermal imaging cannot detect camouflaged soldiers",
              "Noise is not important for camouflage"
            ],
            correctAnswer: 1,
            explanation: "The passage explains that effective camouflage must consider visual concealment, noise, light reflection, and heat signatures, indicating that modern camouflage must address multiple detection methods."
          },
          {
            id: 20,
            question: "The chain of command is fundamental to military organization and serves as the structural foundation that makes large military organizations function effectively. It establishes clear lines of authority and responsibility, ensuring that orders flow efficiently from senior leadership to individual service members through designated channels. Everyone knows who they report to, who reports to them, and what decisions they are authorized to make. This clarity eliminates confusion about roles, prevents conflicting orders, and ensures accountability at every level. The chain of command also ensures that information flows upward through proper channels, keeping commanders informed about ground conditions and enabling better decision-making at all levels of the organization.\n\nThis hierarchical structure enables rapid decision-making and coordinated action, which are essential in combat situations where confusion can be deadly. When everyone understands and respects the chain of command, decisions can be made and communicated quickly without debate about authority or legitimacy. Units can coordinate their actions because they're all operating under a common command structure with clear protocols for communication and cooperation. The chain of command allows large organizations to function with the speed and coordination of much smaller groups by providing a clear framework for organizing effort and delegating responsibility. Without this structure, military operations would quickly dissolve into chaos as personnel received conflicting instructions and lacked clear guidance.\n\nIn combat situations where confusion can be deadly, the chain of command provides the organizational stability and clarity needed for effective operations. The stress and chaos of combat makes clear authority and communication pathways even more important. Personnel need to know beyond doubt who is in charge, what they should be doing, and where to get information or guidance. The chain of command provides this certainty even in the most confusing and dangerous situations. Respecting the chain of command isn't about bureaucracy or formality; it's about maintaining the organizational coherence that keeps military units effective under the most challenging conditions imaginable.\n\nThe primary purpose of the chain of command is to:",
            options: [
              "Create confusion",
              "Establish clear authority and enable efficient communication",
              "Limit individual responsibility",
              "Slow down decision-making"
            ],
            correctAnswer: 1,
            explanation: "The passage states that the chain of command 'establishes clear lines of authority and responsibility' and 'enables rapid decision-making and coordinated action,' making option B correct."
          }
        ]
      },
      {
        id: 5,
        name: "Mathematics Knowledge (MK)",
        timeLimit: 6,
        questions: [
          {
            id: 21,
            question: "What is the value of x in the equation: 5x - 12 = 33?",
            options: [
              "7",
              "8",
              "9",
              "10"
            ],
            correctAnswer: 2,
            explanation: "Solve for x: 5x - 12 = 33. Add 12 to both sides: 5x = 45. Divide both sides by 5: x = 9."
          },
          {
            id: 22,
            question: "A circle has a radius of 7 inches. What is its circumference? (Use π ≈ 3.14)",
            options: [
              "21.98 inches",
              "38.48 inches",
              "43.96 inches",
              "153.86 inches"
            ],
            correctAnswer: 2,
            explanation: "The circumference formula is C = 2πr. C = 2 × 3.14 × 7 = 43.96 inches."
          },
          {
            id: 23,
            question: "What is the square root of 169?",
            options: [
              "11",
              "12",
              "13",
              "14"
            ],
            correctAnswer: 2,
            explanation: "The square root of 169 is 13, because 13 × 13 = 169."
          },
          {
            id: 24,
            question: "If a rectangular field is 45 feet long and 30 feet wide, what is its area?",
            options: [
              "1,150 square feet",
              "1,250 square feet",
              "1,350 square feet",
              "1,450 square feet"
            ],
            correctAnswer: 2,
            explanation: "Area of a rectangle = length × width. Area = 45 feet × 30 feet = 1,350 square feet."
          },
          {
            id: 25,
            question: "What is 15% of 240?",
            options: [
              "30",
              "32",
              "36",
              "40"
            ],
            correctAnswer: 2,
            explanation: "To find 15% of 240, multiply: 240 × 0.15 = 36."
          }
        ]
      },
      {
        id: 6,
        name: "Electronics Information (EI)",
        timeLimit: 6,
        questions: [
          {
            id: 26,
            question: "What is the primary function of a capacitor in an electronic circuit?",
            options: [
              "To resist current flow",
              "To store electrical energy",
              "To amplify signals",
              "To convert AC to DC"
            ],
            correctAnswer: 1,
            explanation: "A capacitor stores electrical energy in an electric field between two conductive plates separated by an insulator. Capacitors can quickly charge and discharge, making them useful for filtering, timing, and energy storage applications."
          },
          {
            id: 27,
            question: "In a series circuit with three resistors of 10 ohms, 20 ohms, and 30 ohms, what is the total resistance?",
            options: [
              "20 ohms",
              "40 ohms",
              "60 ohms",
              "80 ohms"
            ],
            correctAnswer: 2,
            explanation: "In a series circuit, total resistance is the sum of all resistors: 10 + 20 + 30 = 60 ohms."
          },
          {
            id: 28,
            question: "What does the term 'ground' refer to in electrical systems?",
            options: [
              "The positive terminal",
              "A reference point with zero voltage potential",
              "The highest voltage point",
              "An insulated connection"
            ],
            correctAnswer: 1,
            explanation: "Ground (or earth) is a reference point in an electrical circuit that is defined as having zero voltage potential. It provides a common return path for electric current and a safety measure."
          },
          {
            id: 29,
            question: "What type of current does a battery produce?",
            options: [
              "Alternating current (AC)",
              "Direct current (DC)",
              "Pulsating current",
              "Radio frequency current"
            ],
            correctAnswer: 1,
            explanation: "A battery produces direct current (DC), which flows consistently in one direction from the negative terminal to the positive terminal, unlike alternating current (AC) which periodically reverses direction."
          },
          {
            id: 30,
            question: "A diode primarily allows current to flow in:",
            options: [
              "Both directions equally",
              "One direction only",
              "No direction",
              "Multiple directions simultaneously"
            ],
            correctAnswer: 1,
            explanation: "A diode is a semiconductor device that allows current to flow primarily in one direction (from anode to cathode) while blocking flow in the opposite direction. This makes diodes useful for converting AC to DC and protecting circuits."
          }
        ]
      },
      {
        id: 7,
        name: "Auto & Shop Information (AS)",
        timeLimit: 6,
        questions: [
          {
            id: 31,
            question: "What is the primary purpose of motor oil in an engine?",
            options: [
              "To cool the radiator",
              "To lubricate moving parts and reduce friction",
              "To clean the fuel system",
              "To charge the battery"
            ],
            correctAnswer: 1,
            explanation: "Motor oil's primary purpose is to lubricate the engine's moving parts, reducing friction and wear. It also helps cool the engine, clean internal components, and seal gaps between the piston rings and cylinder walls."
          },
          {
            id: 32,
            question: "Which tool is specifically designed to measure the gap between spark plug electrodes?",
            options: [
              "Micrometer",
              "Feeler gauge",
              "Caliper",
              "Torque wrench"
            ],
            correctAnswer: 1,
            explanation: "A feeler gauge is a thin metal strip or wire used to measure small gaps and clearances, such as the gap between spark plug electrodes. It's essential for proper spark plug installation and engine performance."
          },
          {
            id: 33,
            question: "What does a vehicle's alternator do?",
            options: [
              "Starts the engine",
              "Generates electrical power to charge the battery",
              "Filters the engine oil",
              "Controls the transmission"
            ],
            correctAnswer: 1,
            explanation: "The alternator generates electrical power while the engine is running, charging the battery and powering the vehicle's electrical systems. It converts mechanical energy from the engine into electrical energy."
          },
          {
            id: 34,
            question: "Which type of saw is best suited for making curved cuts in wood?",
            options: [
              "Crosscut saw",
              "Hacksaw",
              "Coping saw",
              "Rip saw"
            ],
            correctAnswer: 2,
            explanation: "A coping saw has a thin, flexible blade held in a C-shaped frame, making it ideal for cutting curves and intricate shapes in wood. The blade can be rotated to change cutting direction."
          },
          {
            id: 35,
            question: "What component in a vehicle's braking system converts hydraulic pressure into mechanical force?",
            options: [
              "Master cylinder",
              "Brake lines",
              "Wheel cylinder or brake caliper",
              "Brake pedal"
            ],
            correctAnswer: 2,
            explanation: "The wheel cylinder (in drum brakes) or brake caliper (in disc brakes) converts hydraulic pressure from the brake fluid into mechanical force that pushes the brake shoes or pads against the drum or rotor to slow the vehicle."
          }
        ]
      },
      {
        id: 8,
        name: "Mechanical Comprehension (MC)",
        timeLimit: 6,
        questions: [
          {
            id: 36,
            question: "A first-class lever has the fulcrum positioned between the effort and the load. Which of the following is an example of a first-class lever?",
            options: [
              "Wheelbarrow",
              "Seesaw",
              "Nutcracker",
              "Bottle opener"
            ],
            correctAnswer: 1,
            explanation: "A seesaw is a first-class lever with the fulcrum (pivot point) in the middle, the effort on one end, and the load on the other. This arrangement can provide mechanical advantage depending on the distances from the fulcrum."
          },
          {
            id: 37,
            question: "If gear A has 20 teeth and rotates at 100 RPM, and it drives gear B with 40 teeth, at what speed does gear B rotate?",
            options: [
              "25 RPM",
              "50 RPM",
              "100 RPM",
              "200 RPM"
            ],
            correctAnswer: 1,
            explanation: "Gear ratio is inversely proportional to the number of teeth. Gear B has twice as many teeth (40 vs 20), so it rotates at half the speed: 100 RPM ÷ 2 = 50 RPM."
          },
          {
            id: 38,
            question: "Water pressure at the bottom of a container depends primarily on:",
            options: [
              "The width of the container",
              "The shape of the container",
              "The depth of the water",
              "The material of the container"
            ],
            correctAnswer: 2,
            explanation: "Water pressure at any point depends primarily on the depth of the water above that point. Pressure increases with depth due to the weight of the water column above. Container shape and width don't affect pressure at a given depth."
          },
          {
            id: 39,
            question: "A hydraulic system uses a small piston with an area of 2 square inches and a large piston with an area of 20 square inches. If 10 pounds of force is applied to the small piston, how much force is exerted by the large piston?",
            options: [
              "20 pounds",
              "50 pounds",
              "100 pounds",
              "200 pounds"
            ],
            correctAnswer: 2,
            explanation: "In a hydraulic system, force is multiplied by the ratio of piston areas. The large piston has 10 times the area (20 ÷ 2 = 10), so force is multiplied by 10: 10 pounds × 10 = 100 pounds."
          },
          {
            id: 40,
            question: "When a wheel and axle system is used, mechanical advantage is gained when:",
            options: [
              "The effort is applied to the smaller axle",
              "The effort is applied to the larger wheel",
              "The wheel and axle are the same size",
              "The axle is removed"
            ],
            correctAnswer: 1,
            explanation: "Mechanical advantage in a wheel and axle system is gained when effort is applied to the larger wheel, which rotates the smaller axle. This allows a smaller force over a greater distance to move a larger load over a shorter distance."
          }
        ]
      },
      {
        id: 9,
        name: "Assembling Objects (AO)",
        timeLimit: 6,
        questions: [
          {
            id: 41,
            question: "Which arrangement correctly shows how the puzzle pieces labeled A, B, and C fit together to form a complete square?",
            options: [
              "A on top, B in middle, C on bottom",
              "C on left, A in center, B on right",
              "B on top, C in middle, A on bottom",
              "A on left, C in center, B on right"
            ],
            correctAnswer: 1,
            explanation: "When assembling objects, you must visualize how different shapes fit together. Option B correctly positions the pieces to form a complete square with no gaps or overlaps."
          },
          {
            id: 42,
            question: "If you rotate shape X 90 degrees clockwise and then flip it horizontally, which of the following shapes would result?",
            options: [
              "Shape with vertical orientation, mirror reversed",
              "Shape with horizontal orientation, mirror reversed",
              "Original shape unchanged",
              "Shape rotated 180 degrees"
            ],
            correctAnswer: 0,
            explanation: "A 90-degree clockwise rotation followed by a horizontal flip results in a shape with vertical orientation that is mirror-reversed from the original position."
          },
          {
            id: 43,
            question: "Two points A and B need to be connected by a single line. Point A is at coordinates (2, 3) and point B is at coordinates (5, 3). The connecting line would be:",
            options: [
              "Vertical",
              "Horizontal",
              "Diagonal ascending",
              "Diagonal descending"
            ],
            correctAnswer: 1,
            explanation: "Since both points have the same y-coordinate (3), the line connecting them would be horizontal, running parallel to the x-axis."
          },
          {
            id: 44,
            question: "A triangular piece and a rectangular piece need to be joined along their matching edges to form a house-shaped figure. The triangle should be positioned:",
            options: [
              "Below the rectangle",
              "To the left of the rectangle",
              "Above the rectangle as a roof",
              "Inside the rectangle"
            ],
            correctAnswer: 2,
            explanation: "To form a house shape, the triangular piece should be positioned above the rectangle, with its base matching the top edge of the rectangle, creating a roof-like appearance."
          },
          {
            id: 45,
            question: "Four identical L-shaped pieces need to be arranged to form a complete square. How should they be oriented?",
            options: [
              "All facing the same direction",
              "Each rotated 90 degrees from the previous one",
              "Two facing up, two facing down",
              "Overlapping at the corners"
            ],
            correctAnswer: 1,
            explanation: "Four identical L-shaped pieces can form a square when each is rotated 90 degrees from the previous one, creating a symmetrical pattern where the pieces fit together at the center."
          }
        ]
      },
      {
        id: 10,
        name: "Verbal Expression (VE)",
        timeLimit: 6,
        questions: [
          {
            id: 46,
            question: "Choose the word that best completes the sentence: The sergeant's instructions were so _____ that every soldier understood exactly what to do.",
            options: [
              "ambiguous",
              "vague",
              "explicit",
              "confusing"
            ],
            correctAnswer: 2,
            explanation: "Explicit means clearly and precisely expressed, leaving no room for confusion. This fits the context that every soldier understood exactly what to do."
          },
          {
            id: 47,
            question: "Identify the sentence with correct grammar:",
            options: [
              "Neither the officers nor the enlisted personnel was prepared for the drill.",
              "Neither the officers nor the enlisted personnel were prepared for the drill.",
              "Neither the officers or the enlisted personnel were prepared for the drill.",
              "Neither the officers nor the enlisted personnel is prepared for the drill."
            ],
            correctAnswer: 1,
            explanation: "When using 'neither...nor,' the verb agrees with the subject closest to it. 'Personnel' is plural, so 'were' is correct. Also, the correct conjunction pair is 'neither...nor,' not 'neither...or.'"
          },
          {
            id: 48,
            question: "Obsolete most nearly means:",
            options: [
              "Modern and current",
              "Outdated and no longer useful",
              "Expensive",
              "Complicated"
            ],
            correctAnswer: 1,
            explanation: "Obsolete means no longer in use or outdated, having been replaced by something newer or more efficient. In military contexts, equipment or tactics can become obsolete as technology advances."
          },
          {
            id: 49,
            question: "Which sentence uses punctuation correctly?",
            options: [
              "The mission requires three things, courage discipline and teamwork.",
              "The mission requires three things: courage, discipline, and teamwork.",
              "The mission requires three things courage, discipline and teamwork.",
              "The mission requires three things; courage discipline and teamwork."
            ],
            correctAnswer: 1,
            explanation: "A colon is correctly used to introduce a list, and commas properly separate the items in the list. This is the standard format for listing items in a sentence."
          },
          {
            id: 50,
            question: "Vigilant most nearly means:",
            options: [
              "Careless",
              "Tired",
              "Watchful and alert",
              "Aggressive"
            ],
            correctAnswer: 2,
            explanation: "Vigilant means carefully watching for possible danger or difficulties, being alert and attentive. In military operations, maintaining vigilance is crucial for security and mission success."
          }
        ]
      }
    ]
  },
  {
    id: 18,
    title: "ASVAB Practice Test #18",
    description: "Comprehensive practice exam covering all 10 ASVAB sections with military-standard questions",
    totalQuestions: 50,
    timeLimit: 60,
    sections: [
      {
        id: 1,
        name: "General Science (GS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Which type of rock is formed when magma cools and solidifies beneath the Earth's surface?",
            options: [
              "Sedimentary rock",
              "Intrusive igneous rock",
              "Metamorphic rock",
              "Extrusive igneous rock"
            ],
            correctAnswer: 1,
            explanation: "Intrusive igneous rocks form when magma cools slowly beneath the Earth's surface, allowing large crystals to develop. Examples include granite and diorite. Extrusive igneous rocks form when lava cools quickly on the surface."
          },
          {
            id: 2,
            question: "What is the primary function of hemoglobin in red blood cells?",
            options: [
              "Fighting infections",
              "Clotting blood",
              "Transporting oxygen",
              "Producing antibodies"
            ],
            correctAnswer: 2,
            explanation: "Hemoglobin is an iron-containing protein in red blood cells that binds to oxygen in the lungs and transports it throughout the body. It also helps transport carbon dioxide back to the lungs for exhalation."
          },
          {
            id: 3,
            question: "In the water cycle, what process occurs when water vapor cools and changes back into liquid water?",
            options: [
              "Evaporation",
              "Precipitation",
              "Condensation",
              "Transpiration"
            ],
            correctAnswer: 2,
            explanation: "Condensation is the process where water vapor in the atmosphere cools and changes back into liquid water, forming clouds and fog. This occurs when warm, moist air rises and cools to its dew point."
          },
          {
            id: 4,
            question: "Which part of a plant cell is responsible for photosynthesis?",
            options: [
              "Mitochondria",
              "Nucleus",
              "Chloroplast",
              "Ribosome"
            ],
            correctAnswer: 2,
            explanation: "Chloroplasts are organelles found in plant cells that contain chlorophyll and are responsible for photosynthesis. They convert light energy, carbon dioxide, and water into glucose and oxygen."
          },
          {
            id: 5,
            question: "What type of chemical bond involves the sharing of electrons between atoms?",
            options: [
              "Ionic bond",
              "Metallic bond",
              "Covalent bond",
              "Hydrogen bond"
            ],
            correctAnswer: 2,
            explanation: "Covalent bonds form when two atoms share one or more pairs of electrons. This type of bonding typically occurs between nonmetal atoms and results in the formation of molecules."
          }
        ]
      },
      {
        id: 2,
        name: "Arithmetic Reasoning (AR)",
        timeLimit: 6,
        questions: [
          {
            id: 6,
            question: "A military convoy consists of 8 trucks, each carrying 45 supply crates. If each crate weighs 72 pounds, what is the total weight of all supplies in the convoy?",
            options: [
              "25,920 pounds",
              "23,040 pounds",
              "28,800 pounds",
              "21,600 pounds"
            ],
            correctAnswer: 0,
            explanation: "First, find the total number of crates: 8 trucks × 45 crates = 360 crates. Then multiply by the weight per crate: 360 crates × 72 pounds = 25,920 pounds total."
          },
          {
            id: 7,
            question: "A squadron of 240 personnel needs to be divided into equal teams of 15 soldiers each for a training exercise. How many teams can be formed?",
            options: [
              "14 teams",
              "15 teams",
              "16 teams",
              "18 teams"
            ],
            correctAnswer: 2,
            explanation: "Divide the total number of personnel by the size of each team: 240 ÷ 15 = 16 teams."
          },
          {
            id: 8,
            question: "A military transport plane travels at 450 miles per hour. How long will it take to travel 1,350 miles?",
            options: [
              "2 hours",
              "2.5 hours",
              "3 hours",
              "3.5 hours"
            ],
            correctAnswer: 2,
            explanation: "Use the formula: Time = Distance ÷ Speed. Time = 1,350 miles ÷ 450 mph = 3 hours."
          },
          {
            id: 9,
            question: "A base commissary is offering a 15% discount on all items. If a soldier purchases items totaling $80 before the discount, how much will they pay after the discount?",
            options: [
              "$68",
              "$70",
              "$65",
              "$72"
            ],
            correctAnswer: 0,
            explanation: "Calculate the discount amount: $80 × 0.15 = $12. Subtract from original price: $80 - $12 = $68."
          },
          {
            id: 10,
            question: "A military unit has 420 gallons of fuel. If they use 35 gallons per day, how many days will the fuel last?",
            options: [
              "10 days",
              "11 days",
              "12 days",
              "13 days"
            ],
            correctAnswer: 2,
            explanation: "Divide total fuel by daily consumption: 420 gallons ÷ 35 gallons per day = 12 days."
          }
        ]
      },
      {
        id: 3,
        name: "Word Knowledge (WK)",
        timeLimit: 6,
        questions: [
          {
            id: 11,
            question: "Meticulous most nearly means:",
            options: [
              "Careless",
              "Extremely careful and precise",
              "Quick and efficient",
              "Reluctant"
            ],
            correctAnswer: 1,
            explanation: "Meticulous means showing great attention to detail or being very careful and precise. It describes someone who is thorough and exact in their work."
          },
          {
            id: 12,
            question: "Adversary most nearly means:",
            options: [
              "Opponent",
              "Supporter",
              "Observer",
              "Mediator"
            ],
            correctAnswer: 0,
            explanation: "An adversary is an opponent, enemy, or person who opposes or competes with another. In military contexts, it refers to an opposing force or enemy."
          },
          {
            id: 13,
            question: "Comprise most nearly means:",
            options: [
              "To exclude",
              "To consist of or be made up of",
              "To separate",
              "To distribute"
            ],
            correctAnswer: 1,
            explanation: "Comprise means to consist of, be made up of, or include. For example, 'The platoon comprises four squads' means the platoon is made up of four squads."
          },
          {
            id: 14,
            question: "Futile most nearly means:",
            options: [
              "Productive",
              "Challenging",
              "Useless or ineffective",
              "Dangerous"
            ],
            correctAnswer: 2,
            explanation: "Futile means incapable of producing any useful result; pointless or useless. A futile effort is one that has no chance of success."
          },
          {
            id: 15,
            question: "Vigilant most nearly means:",
            options: [
              "Tired",
              "Watchful and alert",
              "Aggressive",
              "Confused"
            ],
            correctAnswer: 1,
            explanation: "Vigilant means keeping careful watch for possible danger or difficulties; alert and watchful. Military personnel must remain vigilant during operations."
          }
        ]
      },
      {
        id: 4,
        name: "Paragraph Comprehension (PC)",
        timeLimit: 6,
        questions: [
          {
            id: 16,
            question: "The Arctic tundra is characterized by extremely cold temperatures, short growing seasons, and permanently frozen subsoil called permafrost that remains solid year-round. Despite these harsh conditions that would seem inhospitable to life, various plants and animals have adapted to survive in this challenging environment. Temperatures can drop to minus 70 degrees Fahrenheit in winter, and even summer temperatures rarely exceed 50 degrees Fahrenheit. The growing season lasts only six to ten weeks, limiting the time available for plants to complete their life cycles. Permafrost prevents deep root systems and affects drainage patterns across the landscape. These extreme conditions make the Arctic tundra one of Earth's most challenging biomes.\n\nVegetation consists mainly of low-growing mosses, lichens, and small shrubs that have adapted to survive with minimal heat, poor soil nutrients, and constant exposure to harsh winds. These plants grow close to the ground to take advantage of slightly warmer temperatures near the surface and to avoid damaging winds. Many Arctic plants can photosynthesize at very low temperatures and during the long summer days when the sun never sets. Some species can remain dormant for years, springing to life when conditions become favorable. The limited plant diversity reflects the extreme selective pressure of the Arctic environment, where only the most specialized species can survive.\n\nAnimals like caribou, arctic foxes, and polar bears have developed thick fur and layers of fat for insulation against the extreme cold. Caribou migrate vast distances to find food and avoid the worst winter conditions. Arctic foxes have fur that changes color seasonally, providing camouflage year-round, and their small ears and short legs minimize heat loss. Polar bears, the largest land carnivores, have evolved to hunt on sea ice and can survive months without eating during summer when ice retreats. These remarkable adaptations demonstrate how life finds ways to persist even in the most extreme environments on Earth, showcasing the resilience and adaptability of living organisms.\n\nWhat is the main idea of this paragraph?",
            options: [
              "Permafrost prevents plant growth in the Arctic",
              "Life has adapted to survive in the harsh Arctic tundra environment",
              "Arctic animals are larger than animals in other regions",
              "The Arctic tundra has long growing seasons"
            ],
            correctAnswer: 1,
            explanation: "The paragraph's main idea is that despite extremely harsh conditions in the Arctic tundra, various forms of life have successfully adapted to survive there, as evidenced by the examples of vegetation and animals."
          },
          {
            id: 17,
            question: "Effective leadership requires more than just giving orders and expecting compliance from team members. A good leader must communicate clearly to ensure everyone understands goals, expectations, and their individual roles in achieving objectives. This communication must flow both ways, which is why leaders must also listen to team members, valuing their input, concerns, and ideas. Leaders who only talk without listening miss valuable insights from those closest to the work. Additionally, effective leaders lead by example, demonstrating through their own actions the standards and behaviors they expect from others. When leaders personally embody the values and work ethic they promote, it creates powerful motivation for their teams.\n\nLeaders who demonstrate integrity and take responsibility for their decisions earn the respect and trust of those they lead. Integrity means doing the right thing even when it's difficult or unpopular, being honest even when the truth is uncomfortable, and treating people fairly regardless of personal preferences. Taking responsibility means owning both successes and failures, learning from mistakes, and never blaming others for problems. When leaders demonstrate these qualities consistently, their team members develop confidence in their leadership. People are much more willing to follow leaders they respect and trust than those they don't, especially during challenging times when commitment is most important.\n\nThis trust is essential for building cohesive, high-performing teams that accomplish more than the sum of their individual capabilities. Trust allows team members to communicate openly, admit mistakes without fear, and take appropriate risks in pursuit of goals. Cohesive teams work together smoothly because members understand and support one another. High-performing teams consistently deliver excellent results because every member is committed and pulling in the same direction. Without the foundation of trust between leaders and team members, teams become dysfunctional, with poor communication, finger-pointing, and suboptimal performance. Trust is not given automatically with a leadership position; it must be earned through consistent demonstration of the leadership qualities described in this passage.\n\nAccording to the paragraph, what is essential for building high-performing teams?",
            options: [
              "Giving frequent orders",
              "Working independently",
              "Trust between leader and team members",
              "Avoiding difficult decisions"
            ],
            correctAnswer: 2,
            explanation: "The paragraph explicitly states that trust earned through integrity and responsibility 'is essential for building cohesive, high-performing teams.'"
          },
          {
            id: 18,
            question: "Dehydration occurs when the body loses more fluids than it takes in, disrupting normal bodily functions that depend on proper hydration. Early symptoms include thirst, dry mouth, and fatigue that signal the body's need for fluids. Thirst is the body's first warning sign, though by the time you feel thirsty, you may already be mildly dehydrated. Dry mouth occurs as saliva production decreases. Fatigue results from reduced blood volume and the body's decreased ability to deliver oxygen and nutrients to tissues. These early warning signs should prompt immediate fluid intake to prevent progression to more serious dehydration.\n\nAs dehydration worsens, it can cause dizziness, confusion, and rapid heartbeat as the body struggles to maintain essential functions. Dizziness occurs as blood pressure drops due to reduced blood volume, affecting blood flow to the brain. Confusion results from the brain not receiving adequate oxygen and nutrients, impairing mental function. Rapid heartbeat develops as the heart works harder to circulate the reduced blood volume throughout the body. These moderate to severe symptoms indicate serious dehydration requiring immediate attention. Other symptoms at this stage may include decreased urination, dark-colored urine, and lack of sweating even in hot conditions.\n\nIn severe cases, dehydration can be life-threatening, potentially causing organ failure, seizures, or death if not treated promptly. Drinking water regularly throughout the day, especially during physical activity or hot weather, is crucial for preventing dehydration. Rather than waiting until you feel thirsty, make drinking water a regular habit. During exercise or in high temperatures, fluid needs increase substantially as the body loses water through sweat. In these situations, drinking water before, during, and after activity helps maintain proper hydration. Monitoring urine color—aiming for pale yellow—provides a simple way to check hydration status. Proper hydration is one of the simplest yet most important aspects of maintaining health and physical performance.\n\nWhat should people do to prevent dehydration?",
            options: [
              "Avoid physical activity",
              "Wait until feeling thirsty to drink water",
              "Drink water regularly throughout the day",
              "Only drink water in hot weather"
            ],
            correctAnswer: 2,
            explanation: "The paragraph clearly states that 'drinking water regularly throughout the day, especially during physical activity or hot weather, is crucial for preventing dehydration.'"
          },
          {
            id: 19,
            question: "The invention of the printing press by Johannes Gutenberg in the 1450s revolutionized the spread of information and transformed human civilization. Before this invention, books had to be copied by hand by scribes, a painstakingly slow and expensive process. A single book could take months or even years to copy, and errors inevitably crept into texts with each successive copying. This made books rare and expensive, available only to the wealthy, religious institutions, and universities. The vast majority of people had no access to written knowledge, and literacy rates remained low because there was little point in learning to read when books were unavailable. Knowledge transmission depended heavily on oral tradition and limited manuscript collections.\n\nThe printing press allowed for mass production of books, making knowledge more accessible to ordinary people and democratizing information in ways previously impossible. Gutenberg's movable type system could produce books in days rather than months, and each copy was identical to the others. As printing spread across Europe, book prices dropped dramatically, making them affordable to middle-class families and eventually even working-class readers. This increased availability of books spurred literacy rates upward as more people had reasons and opportunities to learn to read. Ideas could now spread rapidly across countries and continents, accelerating intellectual exchange and innovation. The printing press essentially created mass communication, transforming human society from one based primarily on oral tradition to one increasingly based on written knowledge.\n\nThis advancement played a crucial role in the Renaissance and the Protestant Reformation by facilitating the rapid spread of new ideas and challenging established authorities. During the Renaissance, printed books spread classical knowledge, scientific discoveries, and artistic innovations across Europe. Martin Luther's Protestant Reformation succeeded largely because printing allowed his theological challenges to Catholic doctrine to spread rapidly throughout Europe, something impossible in earlier eras. Printed Bibles in vernacular languages put scripture directly in people's hands rather than mediated through clergy. The printing press thus became one of the most transformative inventions in human history, fundamentally changing how knowledge is preserved, shared, and used.\n\nHow did the printing press impact society?",
            options: [
              "It made books more expensive",
              "It reduced literacy rates",
              "It made knowledge more accessible to ordinary people",
              "It eliminated the need for education"
            ],
            correctAnswer: 2,
            explanation: "The paragraph states that the printing press 'allowed for mass production of books, making knowledge more accessible to ordinary people,' which was its primary impact on society."
          },
          {
            id: 20,
            question: "Regular maintenance is the key to vehicle longevity and represents one of the most cost-effective practices for vehicle ownership. Checking and changing the oil at recommended intervals keeps the engine properly lubricated, preventing wear and overheating that can destroy expensive components. Monitoring tire pressure ensures proper tire wear, improves fuel efficiency, and maintains safe handling characteristics. Inspecting brakes regularly identifies wear before it becomes dangerous or damages other brake system components. These routine maintenance tasks, while requiring some time and modest expense, can prevent costly repairs down the road. The investment in regular maintenance pays dividends many times over in extended vehicle life and avoided breakdowns.\n\nMany vehicle problems start small but become major issues when neglected, illustrating why preventive maintenance is so important. A small oil leak ignored can lead to engine failure. Slightly worn brake pads that aren't replaced can damage rotors, turning a simple pad replacement into a much more expensive repair. Low tire pressure can cause uneven wear, requiring premature tire replacement. A loose belt can eventually break, potentially causing engine damage or leaving you stranded. By catching these issues early through regular inspections and maintenance, you address problems when they're minor and inexpensive to fix. Neglecting maintenance allows small problems to cascade into major failures that cost dramatically more to repair and may leave you without transportation at inconvenient times.\n\nA few minutes of preventive care can save hours of downtime and thousands of dollars in repairs. Spending fifteen minutes checking fluid levels, tire pressure, and visible components can prevent breakdowns that leave you stranded for hours waiting for a tow truck and repairs. Regular oil changes costing fifty dollars prevent engine failures costing thousands. New brake pads costing a few hundred dollars prevent rotor damage adding many hundreds more to the repair bill. The time and money invested in preventive maintenance represent perhaps the best return on investment in vehicle ownership. Vehicle longevity is not primarily determined by the quality of the original manufacturing; it's determined by how well the vehicle is maintained throughout its life.\n\nWhat is the author's main point?",
            options: [
              "All vehicles eventually need major repairs",
              "Oil changes are unnecessary",
              "Preventive maintenance saves time and money",
              "New vehicles don't require maintenance"
            ],
            correctAnswer: 2,
            explanation: "The paragraph's main point is that regular preventive maintenance, though requiring some time investment, ultimately saves both time and money by preventing small problems from becoming major issues."
          }
        ]
      },
      {
        id: 5,
        name: "Mathematics Knowledge (MK)",
        timeLimit: 6,
        questions: [
          {
            id: 21,
            question: "If 3x + 7 = 28, what is the value of x?",
            options: [
              "5",
              "6",
              "7",
              "8"
            ],
            correctAnswer: 2,
            explanation: "Solve for x: 3x + 7 = 28. Subtract 7 from both sides: 3x = 21. Divide both sides by 3: x = 7."
          },
          {
            id: 22,
            question: "What is the area of a triangle with a base of 12 inches and a height of 8 inches?",
            options: [
              "96 square inches",
              "48 square inches",
              "20 square inches",
              "40 square inches"
            ],
            correctAnswer: 1,
            explanation: "The area of a triangle is calculated using the formula: Area = (1/2) × base × height. Area = (1/2) × 12 × 8 = 48 square inches."
          },
          {
            id: 23,
            question: "What is 15% of 240?",
            options: [
              "30",
              "32",
              "36",
              "40"
            ],
            correctAnswer: 2,
            explanation: "To find 15% of 240, multiply: 240 × 0.15 = 36. Alternatively, you can calculate (240 × 15) ÷ 100 = 36."
          },
          {
            id: 24,
            question: "If a square has a perimeter of 48 feet, what is the length of one side?",
            options: [
              "10 feet",
              "12 feet",
              "14 feet",
              "16 feet"
            ],
            correctAnswer: 1,
            explanation: "A square has four equal sides. Perimeter = 4 × side length. Therefore, side length = 48 ÷ 4 = 12 feet."
          },
          {
            id: 25,
            question: "What is the value of 2³ × 3²?",
            options: [
              "48",
              "54",
              "64",
              "72"
            ],
            correctAnswer: 3,
            explanation: "Calculate each exponent separately: 2³ = 2 × 2 × 2 = 8, and 3² = 3 × 3 = 9. Then multiply: 8 × 9 = 72."
          }
        ]
      },
      {
        id: 6,
        name: "Electronics Information (EI)",
        timeLimit: 6,
        questions: [
          {
            id: 26,
            question: "What is the unit of measurement for electrical resistance?",
            options: [
              "Ampere",
              "Volt",
              "Ohm",
              "Watt"
            ],
            correctAnswer: 2,
            explanation: "The ohm (symbol: Ω) is the unit of electrical resistance. It measures how much a material opposes the flow of electric current. Amperes measure current, volts measure voltage, and watts measure power."
          },
          {
            id: 27,
            question: "In a parallel circuit, if one component fails, what happens to the rest of the circuit?",
            options: [
              "All components stop working",
              "The other components continue to function",
              "The voltage increases dramatically",
              "The circuit becomes a series circuit"
            ],
            correctAnswer: 1,
            explanation: "In a parallel circuit, each component has its own path to the power source. If one component fails, the others continue to function because they have independent paths for current flow."
          },
          {
            id: 28,
            question: "What type of current does a standard household battery produce?",
            options: [
              "Alternating current (AC)",
              "Direct current (DC)",
              "Pulsating current",
              "Static current"
            ],
            correctAnswer: 1,
            explanation: "Batteries produce direct current (DC), which flows in one constant direction from the positive terminal to the negative terminal. Household wall outlets provide alternating current (AC)."
          },
          {
            id: 29,
            question: "What component is used to store electrical energy in an electric field?",
            options: [
              "Resistor",
              "Inductor",
              "Capacitor",
              "Transistor"
            ],
            correctAnswer: 2,
            explanation: "A capacitor stores electrical energy in an electric field between two conductive plates. Capacitors are used for filtering, timing circuits, and energy storage in electronic devices."
          },
          {
            id: 30,
            question: "If a circuit has a voltage of 12 volts and a resistance of 4 ohms, what is the current flow according to Ohm's Law?",
            options: [
              "2 amperes",
              "3 amperes",
              "4 amperes",
              "8 amperes"
            ],
            correctAnswer: 1,
            explanation: "Ohm's Law states that I = V/R, where I is current, V is voltage, and R is resistance. Therefore: I = 12V ÷ 4Ω = 3 amperes."
          }
        ]
      },
      {
        id: 7,
        name: "Auto & Shop Information (AS)",
        timeLimit: 6,
        questions: [
          {
            id: 31,
            question: "What is the primary purpose of a vehicle's alternator?",
            options: [
              "To start the engine",
              "To charge the battery and power electrical systems while the engine runs",
              "To filter the engine oil",
              "To cool the engine"
            ],
            correctAnswer: 1,
            explanation: "The alternator generates electricity to charge the battery and power the vehicle's electrical systems while the engine is running. The starter motor is responsible for starting the engine."
          },
          {
            id: 32,
            question: "Which tool is used to measure the thickness of wire or sheet metal?",
            options: [
              "Micrometer",
              "Wire gauge",
              "Caliper",
              "Depth gauge"
            ],
            correctAnswer: 1,
            explanation: "A wire gauge is specifically designed to measure the diameter of wire or the thickness of sheet metal. It typically has different-sized slots that correspond to standard wire or sheet metal sizes."
          },
          {
            id: 33,
            question: "What does it indicate if a vehicle's exhaust smoke is blue in color?",
            options: [
              "The engine is burning coolant",
              "The engine is burning oil",
              "The fuel mixture is too rich",
              "The catalytic converter is working properly"
            ],
            correctAnswer: 1,
            explanation: "Blue exhaust smoke indicates that engine oil is being burned in the combustion chambers. This can be caused by worn piston rings, valve seals, or other internal engine problems."
          },
          {
            id: 34,
            question: "What type of saw is best for making curved cuts in wood?",
            options: [
              "Crosscut saw",
              "Rip saw",
              "Coping saw",
              "Hacksaw"
            ],
            correctAnswer: 2,
            explanation: "A coping saw has a thin, flexible blade that allows for making curved or intricate cuts in wood. The blade can be rotated to change cutting direction, making it ideal for detailed work."
          },
          {
            id: 35,
            question: "What is the purpose of engine coolant in a vehicle?",
            options: [
              "To lubricate engine parts",
              "To clean fuel injectors",
              "To absorb and transfer heat away from the engine",
              "To increase fuel efficiency"
            ],
            correctAnswer: 2,
            explanation: "Engine coolant (antifreeze) circulates through the engine to absorb heat and transfer it to the radiator where it can be dissipated. It also prevents freezing in cold weather and raises the boiling point in hot conditions."
          }
        ]
      },
      {
        id: 8,
        name: "Mechanical Comprehension (MC)",
        timeLimit: 6,
        questions: [
          {
            id: 36,
            question: "A crowbar is being used to lift a heavy object. If the effort arm is 4 feet long and the resistance arm is 1 foot long, what is the mechanical advantage?",
            options: [
              "2:1",
              "3:1",
              "4:1",
              "5:1"
            ],
            correctAnswer: 2,
            explanation: "Mechanical advantage of a lever is calculated by dividing the length of the effort arm by the length of the resistance arm: 4 feet ÷ 1 foot = 4:1. This means the force is multiplied by 4."
          },
          {
            id: 37,
            question: "In a pulley system, which configuration provides the greatest mechanical advantage?",
            options: [
              "A single fixed pulley",
              "A single movable pulley",
              "Multiple movable pulleys",
              "A fixed pulley with a long rope"
            ],
            correctAnswer: 2,
            explanation: "Multiple movable pulleys provide the greatest mechanical advantage because each additional movable pulley approximately doubles the mechanical advantage, allowing you to lift heavier loads with less effort."
          },
          {
            id: 38,
            question: "If gear A has 20 teeth and is turning clockwise, and gear B has 40 teeth and meshes with gear A, which way will gear B turn?",
            options: [
              "Clockwise at the same speed",
              "Counterclockwise at half the speed",
              "Clockwise at twice the speed",
              "Counterclockwise at the same speed"
            ],
            correctAnswer: 1,
            explanation: "When two gears mesh, they turn in opposite directions, so gear B turns counterclockwise. The gear ratio is 20:40 or 1:2, meaning gear B turns at half the speed of gear A because it has twice as many teeth."
          },
          {
            id: 39,
            question: "What happens to the pressure in a hydraulic system when force is applied to a small piston?",
            options: [
              "Pressure decreases throughout the system",
              "Pressure increases equally throughout the system",
              "Pressure only increases at the point of application",
              "Pressure remains constant"
            ],
            correctAnswer: 1,
            explanation: "According to Pascal's Law, pressure applied to a confined fluid is transmitted equally throughout the fluid in all directions. This principle is fundamental to hydraulic systems."
          },
          {
            id: 40,
            question: "A wheel with a 2-foot radius is rolling along the ground. How far will the wheel travel in one complete revolution?",
            options: [
              "About 6.28 feet",
              "About 12.56 feet",
              "About 4 feet",
              "About 8 feet"
            ],
            correctAnswer: 1,
            explanation: "The distance traveled in one revolution equals the circumference of the wheel: C = 2πr = 2 × 3.14 × 2 = 12.56 feet."
          }
        ]
      },
      {
        id: 9,
        name: "Assembling Objects (AO)",
        timeLimit: 6,
        questions: [
          {
            id: 41,
            question: "Which arrangement shows the correct connection when point A on shape 1 connects to point B on shape 2, and point C on shape 2 connects to point D on shape 3?",
            options: [
              "Configuration showing shapes in sequence 1-2-3",
              "Configuration showing shapes in sequence 2-1-3",
              "Configuration showing shapes in sequence 3-2-1",
              "Configuration showing all shapes separate"
            ],
            correctAnswer: 0,
            explanation: "When following the connection points in order (A to B, then C to D), the shapes must be arranged in sequence 1-2-3, with shape 1 connecting to shape 2 at the A-B junction, and shape 2 connecting to shape 3 at the C-D junction."
          },
          {
            id: 42,
            question: "Four pieces must be assembled to form a complete square. If piece 1 is the top-left quadrant, piece 2 is the top-right quadrant, piece 3 is the bottom-right quadrant, what position is piece 4?",
            options: [
              "Center of the square",
              "Bottom-left quadrant",
              "Above the square",
              "Below the square"
            ],
            correctAnswer: 1,
            explanation: "In a square divided into four quadrants, if pieces 1, 2, and 3 occupy the top-left, top-right, and bottom-right positions respectively, piece 4 must be in the bottom-left quadrant to complete the square."
          },
          {
            id: 43,
            question: "A bolt connects two parts at point X. If the bolt head is visible on part A, where is the nut located?",
            options: [
              "On the same side as the bolt head",
              "On part B, opposite the bolt head",
              "Between part A and part B",
              "The bolt doesn't require a nut"
            ],
            correctAnswer: 1,
            explanation: "A bolt and nut fastener requires the bolt to pass through both parts, with the bolt head on one side and the nut threaded onto the opposite end. If the head is visible on part A, the nut must be on part B."
          },
          {
            id: 44,
            question: "When assembling a five-pointed star from five identical triangular pieces, how many pieces meet at the center point?",
            options: [
              "Three pieces",
              "Four pieces",
              "Five pieces",
              "Six pieces"
            ],
            correctAnswer: 2,
            explanation: "In a five-pointed star made from five identical triangular pieces, each piece contributes one point of the star, and all five pieces meet at the central point where their bases join together."
          },
          {
            id: 45,
            question: "Two puzzle pieces have interlocking tabs and slots. If piece A has a tab pointing right and a slot on the left, how must piece B be oriented to connect?",
            options: [
              "Piece B must have a slot on the right to receive piece A's tab",
              "Piece B must have a tab pointing left",
              "Piece B must be rotated 180 degrees",
              "Piece B must be identical to piece A"
            ],
            correctAnswer: 0,
            explanation: "For interlocking puzzle pieces to connect, a tab on one piece must fit into a corresponding slot on the other piece. If piece A has a tab pointing right, piece B must have a slot on its right side (or left side from piece B's perspective) to receive that tab."
          }
        ]
      },
      {
        id: 10,
        name: "Verbal Expression (VE)",
        timeLimit: 6,
        questions: [
          {
            id: 46,
            question: "Choose the sentence that is grammatically correct:",
            options: [
              "Each of the soldiers were prepared for deployment.",
              "Each of the soldiers was prepared for deployment.",
              "Each of the soldiers are prepared for deployment.",
              "Each of the soldiers be prepared for deployment."
            ],
            correctAnswer: 1,
            explanation: "The subject 'each' is singular and requires the singular verb 'was.' Even though 'soldiers' is plural, it is part of the prepositional phrase 'of the soldiers' and does not affect the verb agreement."
          },
          {
            id: 47,
            question: "Resilient most nearly means:",
            options: [
              "Fragile",
              "Able to recover quickly from difficulties",
              "Permanently damaged",
              "Resistant to change"
            ],
            correctAnswer: 1,
            explanation: "Resilient means able to withstand or recover quickly from difficult conditions. It describes the ability to bounce back from adversity or adapt to challenging circumstances."
          },
          {
            id: 48,
            question: "Choose the sentence with correct punctuation:",
            options: [
              "The sergeant said, attention on deck!",
              "The sergeant said 'attention on deck!'",
              "The sergeant said, \"Attention on deck!\"",
              "The sergeant said: attention on deck!"
            ],
            correctAnswer: 2,
            explanation: "Direct quotations require quotation marks around the spoken words, a comma before the quotation (after 'said'), and the first word of the quotation should be capitalized. The exclamation point goes inside the closing quotation mark."
          },
          {
            id: 49,
            question: "Subordinate most nearly means:",
            options: [
              "Superior in rank",
              "Equal in status",
              "Lower in rank or position",
              "Independent"
            ],
            correctAnswer: 2,
            explanation: "Subordinate means lower in rank, position, or importance; secondary. In military contexts, a subordinate is someone who ranks below another in the chain of command."
          },
          {
            id: 50,
            question: "Choose the sentence that is grammatically correct:",
            options: [
              "The team completed their mission successful.",
              "The team completed their mission successfully.",
              "The team completed their mission with successful.",
              "The team completed successful their mission."
            ],
            correctAnswer: 1,
            explanation: "The word 'successfully' is an adverb that correctly modifies the verb 'completed,' describing how the mission was completed. 'Successful' is an adjective and cannot modify a verb."
          }
        ]
      }
    ]
  },
  {
    id: 19,
    title: "ASVAB Practice Test #19",
    description: "Comprehensive practice exam covering all 10 ASVAB sections with military-standard questions",
    totalQuestions: 50,
    timeLimit: 60,
    sections: [
      {
        id: 1,
        name: "General Science (GS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Which organelle is responsible for packaging and modifying proteins before they are sent to their final destination in the cell?",
            options: [
              "Mitochondria",
              "Golgi apparatus",
              "Ribosome",
              "Lysosome"
            ],
            correctAnswer: 1,
            explanation: "The Golgi apparatus (or Golgi complex) functions as the cell's packaging and shipping center. It receives proteins from the endoplasmic reticulum, modifies them by adding carbohydrates or lipids, packages them into vesicles, and ships them to their destinations within or outside the cell."
          },
          {
            id: 2,
            question: "What type of rock is formed when magma cools and solidifies beneath the Earth's surface?",
            options: [
              "Sedimentary rock",
              "Metamorphic rock",
              "Intrusive igneous rock",
              "Extrusive igneous rock"
            ],
            correctAnswer: 2,
            explanation: "Intrusive igneous rocks form when magma cools slowly beneath the Earth's surface, allowing large crystals to develop. Examples include granite and diorite. Extrusive igneous rocks form when lava cools quickly on the surface, resulting in smaller crystals."
          },
          {
            id: 3,
            question: "Which hormone is primarily responsible for regulating blood sugar levels by promoting glucose uptake into cells?",
            options: [
              "Glucagon",
              "Cortisol",
              "Insulin",
              "Adrenaline"
            ],
            correctAnswer: 2,
            explanation: "Insulin, produced by the pancreas, is the primary hormone that lowers blood sugar levels by promoting the uptake of glucose into cells, particularly muscle and fat cells. Glucagon has the opposite effect, raising blood sugar levels when they drop too low."
          },
          {
            id: 4,
            question: "In physics, what is the term for the resistance of an object to changes in its state of motion?",
            options: [
              "Momentum",
              "Inertia",
              "Friction",
              "Acceleration"
            ],
            correctAnswer: 1,
            explanation: "Inertia is the property of matter that causes it to resist changes in its velocity (speed or direction). This concept is described in Newton's First Law of Motion. An object at rest stays at rest, and an object in motion stays in motion unless acted upon by an external force."
          },
          {
            id: 5,
            question: "What is the function of red blood cells (erythrocytes) in the human body?",
            options: [
              "Fighting infections and disease",
              "Blood clotting and wound healing",
              "Transporting oxygen and carbon dioxide",
              "Producing antibodies"
            ],
            correctAnswer: 2,
            explanation: "Red blood cells contain hemoglobin, a protein that binds to oxygen in the lungs and transports it to tissues throughout the body. They also carry carbon dioxide from tissues back to the lungs for exhalation. White blood cells fight infections, while platelets are involved in clotting."
          }
        ]
      },
      {
        id: 2,
        name: "Arithmetic Reasoning (AR)",
        timeLimit: 6,
        questions: [
          {
            id: 6,
            question: "A military convoy consists of 8 trucks, each carrying 45 supply crates. If each crate weighs 120 pounds, what is the total weight of all supplies in tons? (1 ton = 2,000 pounds)",
            options: [
              "21.6 tons",
              "18 tons",
              "43.2 tons",
              "24 tons"
            ],
            correctAnswer: 0,
            explanation: "First, calculate total crates: 8 trucks × 45 crates = 360 crates. Then calculate total weight: 360 crates × 120 pounds = 43,200 pounds. Convert to tons: 43,200 ÷ 2,000 = 21.6 tons."
          },
          {
            id: 7,
            question: "A sergeant needs to divide 156 soldiers into equal-sized platoons. If each platoon must have between 25 and 35 soldiers, which platoon size would result in no soldiers left over?",
            options: [
              "25 soldiers",
              "26 soldiers",
              "30 soldiers",
              "32 soldiers"
            ],
            correctAnswer: 1,
            explanation: "To find which size divides evenly into 156, test each option: 156 ÷ 25 = 6.24 (not even), 156 ÷ 26 = 6 (exactly 6 platoons with no remainder), 156 ÷ 30 = 5.2 (not even), 156 ÷ 32 = 4.875 (not even). Only 26 soldiers per platoon divides evenly."
          },
          {
            id: 8,
            question: "A military base uses 1,800 gallons of fuel per day. If fuel costs $3.75 per gallon and the base operates on a 30-day budget cycle, how much will fuel cost for one budget cycle?",
            options: [
              "$202,500",
              "$180,000",
              "$67,500",
              "$162,000"
            ],
            correctAnswer: 0,
            explanation: "Calculate daily fuel cost: 1,800 gallons × $3.75 = $6,750 per day. Multiply by 30 days: $6,750 × 30 = $202,500 for the complete budget cycle."
          },
          {
            id: 9,
            question: "During a training exercise, soldiers must complete a 15-mile march. After 3 hours, they have covered 9 miles. If they maintain this pace, how long will the entire march take?",
            options: [
              "4 hours",
              "4.5 hours",
              "5 hours",
              "5.5 hours"
            ],
            correctAnswer: 2,
            explanation: "Calculate the pace: 9 miles ÷ 3 hours = 3 miles per hour. To complete 15 miles at this pace: 15 miles ÷ 3 miles per hour = 5 hours total."
          },
          {
            id: 10,
            question: "A supply officer ordered 240 uniforms at $45 each. Due to a 15% military discount, how much was saved on this purchase?",
            options: [
              "$1,620",
              "$9,180",
              "$1,350",
              "$10,800"
            ],
            correctAnswer: 0,
            explanation: "Calculate the original total cost: 240 uniforms × $45 = $10,800. Calculate 15% discount: $10,800 × 0.15 = $1,620 saved."
          }
        ]
      },
      {
        id: 3,
        name: "Word Knowledge (WK)",
        timeLimit: 6,
        questions: [
          {
            id: 11,
            question: "The word 'meticulous' most nearly means:",
            options: [
              "Careless",
              "Extremely careful and precise",
              "Quick and efficient",
              "Moderately interested"
            ],
            correctAnswer: 1,
            explanation: "Meticulous means showing great attention to detail or being very careful and precise. Someone who is meticulous takes great care to ensure accuracy and completeness in their work."
          },
          {
            id: 12,
            question: "The word 'obsolete' most nearly means:",
            options: [
              "Modern and innovative",
              "Difficult to understand",
              "No longer in use or outdated",
              "Expensive and rare"
            ],
            correctAnswer: 2,
            explanation: "Obsolete means no longer in use, out of date, or replaced by something newer and more effective. Technology often becomes obsolete as new innovations emerge."
          },
          {
            id: 13,
            question: "The word 'candid' most nearly means:",
            options: [
              "Dishonest and deceptive",
              "Frank and straightforward",
              "Confused and uncertain",
              "Polite and reserved"
            ],
            correctAnswer: 1,
            explanation: "Candid means truthful, frank, and straightforward in speech or expression. A candid person says what they really think without pretense or evasion."
          },
          {
            id: 14,
            question: "The word 'resilient' most nearly means:",
            options: [
              "Fragile and delicate",
              "Able to recover quickly from difficulties",
              "Resistant to change",
              "Permanently damaged"
            ],
            correctAnswer: 1,
            explanation: "Resilient means able to bounce back, recover quickly, or adapt well in the face of adversity, trauma, or stress. Resilient materials return to their original form after being bent or compressed."
          },
          {
            id: 15,
            question: "The word 'ambiguous' most nearly means:",
            options: [
              "Clear and precise",
              "Having more than one possible meaning",
              "Completely false",
              "Extremely detailed"
            ],
            correctAnswer: 1,
            explanation: "Ambiguous means unclear, open to multiple interpretations, or having more than one possible meaning. An ambiguous statement can be understood in different ways."
          }
        ]
      },
      {
        id: 4,
        name: "Paragraph Comprehension (PC)",
        timeLimit: 6,
        questions: [
          {
            id: 16,
            question: "The Arctic fox has several adaptations that help it survive in extreme cold conditions that would be lethal to most other animals. Its thick, white fur provides excellent insulation and camouflage against the snow, serving dual purposes of temperature regulation and predator avoidance. The dense underfur traps air close to the skin, creating an insulating layer, while the longer guard hairs shed moisture and provide additional protection. The white coloration makes the fox nearly invisible against snowy backgrounds, helping it hunt prey and avoid larger predators. This fur is so effective that Arctic foxes don't begin to shiver until temperatures drop below -70 degrees Celsius, demonstrating exceptional cold tolerance.\n\nThe fox's small, rounded ears minimize heat loss by reducing surface area exposed to the cold air, following a biological principle where animals in cold climates tend to have smaller extremities than their warm-climate relatives. Large ears would lose heat rapidly in Arctic conditions, so the compact ear structure represents an important adaptation. Meanwhile, the fox's furry paws act like natural snowshoes, preventing it from sinking into deep snow and distributing its weight across a larger surface area. The fur on the paws also provides insulation from the frozen ground and improves traction on ice. These physical adaptations allow the Arctic fox to travel efficiently across snow-covered terrain while hunting.\n\nDuring winter, the Arctic fox can withstand temperatures as low as -70°C by reducing its metabolic rate and curling into a tight ball to conserve heat. By lowering its metabolism, the fox reduces its energy requirements, which is crucial during winter when food is scarce. When curled up, the fox tucks its legs and tail close to its body and covers its nose with its tail, minimizing exposed surface area and heat loss. These behavioral adaptations complement the physical adaptations, creating a comprehensive survival strategy. The combination of specialized fur, compact body features, and behavioral adjustments makes the Arctic fox one of the best-adapted animals for surviving in one of Earth's harshest environments.\n\nWhat is the main idea of this passage?",
            options: [
              "Arctic foxes have white fur",
              "The Arctic is extremely cold",
              "Arctic foxes have multiple adaptations for surviving harsh cold",
              "Arctic foxes curl into balls to stay warm"
            ],
            correctAnswer: 2,
            explanation: "The main idea is that Arctic foxes possess several adaptations that enable them to survive extreme cold conditions. The passage describes multiple specific adaptations (fur, ears, paws, metabolic changes) that all serve this central purpose."
          },
          {
            id: 17,
            question: "Photosynthesis is the process by which plants convert light energy into chemical energy stored in glucose, providing the foundation for nearly all life on Earth. This process occurs in chloroplasts, specialized structures found primarily in leaf cells and containing chlorophyll that captures light energy from the sun. Chloroplasts contain stacks of membrane structures called thylakoids where the light-dependent reactions occur, and a fluid-filled space called the stroma where sugar synthesis happens. Without photosynthesis, there would be no source of food energy for most organisms, and atmospheric oxygen would be depleted. Plants, algae, and some bacteria are the primary photosynthetic organisms that sustain Earth's ecosystems.\n\nDuring photosynthesis, plants absorb carbon dioxide from the air through tiny pores called stomata and water from the soil through their root systems, using light energy to transform these simple materials into glucose and oxygen. The process involves complex biochemical reactions split into light-dependent and light-independent stages. Light energy breaks water molecules apart, releasing oxygen and providing the energy needed to build glucose molecules from carbon dioxide. This remarkable transformation converts inorganic materials and light into organic compounds that store energy in chemical bonds. The glucose produced serves as both an energy source and a building block for more complex organic molecules like cellulose and starch.\n\nThe oxygen is released as a byproduct through stomata, which is essential for most life on Earth that depends on oxygen for cellular respiration. While oxygen is merely a waste product from the plant's perspective, it sustains virtually all animal life, including humans. The oxygen in every breath we take was produced by photosynthetic organisms. This interdependence between photosynthesis and cellular respiration creates a crucial cycle: plants produce oxygen and consume carbon dioxide while animals and other organisms consume oxygen and produce carbon dioxide. This balance has maintained Earth's atmosphere for millions of years, making the planet habitable for complex life forms.\n\nAccording to the passage, what role does chlorophyll play?",
            options: [
              "It releases oxygen into the air",
              "It captures light energy",
              "It stores chemical energy",
              "It absorbs water from soil"
            ],
            correctAnswer: 1,
            explanation: "The passage states that chloroplasts contain chlorophyll that 'captures light energy.' Chlorophyll is the pigment responsible for absorbing light, which is then used in the photosynthesis process."
          },
          {
            id: 18,
            question: "The invention of the printing press by Johannes Gutenberg in the 15th century revolutionized the spread of information and transformed human civilization in profound ways. Before this innovation, books were copied by hand by scribes and monks, a painstakingly slow process that could take months or years for a single book. This made books expensive and rare, available only to wealthy individuals, the church, and universities. The vast majority of people never owned books and had limited access to written knowledge. Libraries were small, knowledge was concentrated in few hands, and ideas spread slowly across regions. This scarcity of written materials helped maintain existing power structures, as controlling access to information meant controlling knowledge itself.\n\nThe printing press allowed for mass production of books, dramatically reducing costs and increasing accessibility to unprecedented levels. Gutenberg's movable type system could produce in days what previously took months, and each copy was identical, eliminating transcription errors. As printing technology spread across Europe, book production accelerated exponentially. Prices dropped so dramatically that middle-class families could afford books, and eventually even working-class people could access printed materials. This sudden abundance of affordable books created new demands for literacy and education. More people learned to read because reading had practical value when books were available, creating a positive feedback loop that accelerated learning and intellectual development across society.\n\nThis democratization of knowledge contributed to the Renaissance, the Reformation, and the Scientific Revolution, fundamentally changing European society in ways that reverberate to this day. The Renaissance spread as printed books carried classical knowledge and new ideas across Europe. Martin Luther's Reformation succeeded partly because printed pamphlets and translated Bibles reached ordinary people directly. Scientific knowledge advanced rapidly as researchers could build on each other's published work. The printing press undermined authorities that had controlled information, empowered individuals through education, and accelerated the pace of change. This single technology helped transform Europe from medieval feudalism to modern society, demonstrating how innovations in communication can reshape entire civilizations.\n\nWhat can be inferred from this passage?",
            options: [
              "Gutenberg was the first person to write books",
              "The printing press had little impact on society",
              "Limited access to books restricted the spread of ideas before the printing press",
              "Hand-copied books were more accurate than printed ones"
            ],
            correctAnswer: 2,
            explanation: "The passage implies that before the printing press, books were 'expensive and rare,' and the press 'democratized knowledge' and contributed to major social movements. This suggests that limited book availability had previously restricted the spread of ideas."
          },
          {
            id: 19,
            question: "Sleep deprivation has significant effects on cognitive function and physical health that many people underestimate or ignore. Studies show that people who consistently get less than seven hours of sleep per night experience impaired memory, reduced attention span, and decreased problem-solving abilities that affect their daily performance. Memory consolidation, the process of transferring information from short-term to long-term memory, occurs primarily during sleep, so insufficient sleep directly impairs learning and retention. Attention span suffers because the sleep-deprived brain struggles to maintain focus and filter out distractions. Problem-solving abilities decline as fatigue reduces the brain's capacity for complex thinking and creative solutions. These cognitive impairments can affect job performance, academic success, and even safety in activities like driving.\n\nLong-term sleep deprivation is also linked to serious health issues including obesity, diabetes, cardiovascular disease, and weakened immune function. Sleep loss disrupts hormones that regulate appetite, leading people to eat more and prefer high-calorie foods, contributing to obesity. It also affects insulin sensitivity and glucose metabolism, increasing diabetes risk. Cardiovascular disease risk rises because chronic sleep deprivation elevates blood pressure and inflammation. The immune system becomes less effective at fighting infections when deprived of the restorative processes that occur during sleep. These health consequences accumulate over time, potentially shaving years off life expectancy and reducing quality of life even before serious disease develops.\n\nDespite these well-documented risks, many adults regularly sacrifice sleep for work or entertainment, prioritizing short-term productivity or pleasure over long-term health. Modern culture often glorifies busyness and treats sleep as wasted time rather than essential maintenance. People stay up late working to meet deadlines, watching television, or scrolling through social media, then rely on caffeine to manage daytime fatigue. This pattern creates a sleep debt that accumulates over time, with consequences that can't be fully reversed by weekend catch-up sleep. The prevalence of sleep deprivation in modern society represents a serious public health concern that deserves greater attention and intervention.\n\nWhat is the author's tone in this passage?",
            options: [
              "Humorous and lighthearted",
              "Angry and confrontational",
              "Informative and concerned",
              "Indifferent and neutral"
            ],
            correctAnswer: 2,
            explanation: "The author presents factual information about the dangers of sleep deprivation while expressing concern about people regularly sacrificing sleep 'despite these risks.' The tone is informative in presenting research findings while showing concern for public health."
          },
          {
            id: 20,
            question: "Coral reefs are among the most diverse ecosystems on Earth, supporting approximately 25% of all marine species despite covering less than 1% of the ocean floor. These underwater structures are built by colonies of tiny animals called coral polyps that secrete calcium carbonate skeletons, gradually constructing massive reef structures over thousands of years. Individual polyps are small, soft-bodied animals related to jellyfish and sea anemones. They live in colonies where they share nutrients and work collectively to build the reef structure. The accumulated skeletons of countless polyp generations create the physical structure we recognize as coral reefs. These reefs provide critical habitat, feeding grounds, and nursery areas for countless marine species, from tiny invertebrates to large fish and sea turtles.\n\nHowever, coral reefs face severe threats from climate change, ocean acidification, and pollution that endanger these vital ecosystems. Climate change causes rising ocean temperatures that stress coral polyps beyond their tolerance limits. Ocean acidification, caused by increased atmospheric carbon dioxide dissolving in seawater, makes it harder for corals to build their calcium carbonate skeletons and can even dissolve existing structures. Pollution from agricultural runoff, sewage, and plastic waste degrades water quality, introducing nutrients that trigger harmful algae blooms and toxins that poison coral polyps. These multiple stressors are cumulative, with each problem making corals more vulnerable to the others. The combination of threats has already destroyed significant portions of the world's coral reefs.\n\nWhen water temperatures rise even slightly above normal levels, corals expel their symbiotic algae called zooxanthellae, causing coral bleaching that can lead to reef death. The symbiotic algae provide corals with most of their energy through photosynthesis and give corals their vibrant colors. When stressed by high temperatures, the relationship breaks down, and corals expel the algae, leaving behind only the white skeleton visible through the transparent polyp tissue. Without their algae partners, corals can survive only briefly before starving. If conditions return to normal quickly, algae may recolonize and corals recover. However, prolonged bleaching or repeated bleaching events prevent recovery, leading to coral death and reef collapse. The loss of coral reefs would have devastating consequences for marine biodiversity and the millions of people who depend on reefs for food and coastal protection.\n\nWhat is the relationship between coral polyps and coral reefs?",
            options: [
              "Coral polyps destroy coral reefs",
              "Coral polyps are unrelated to coral reefs",
              "Coral polyps build coral reefs",
              "Coral polyps live on dead coral reefs"
            ],
            correctAnswer: 2,
            explanation: "The passage explicitly states that coral reefs 'are built by colonies of tiny animals called coral polyps,' establishing that coral polyps are the organisms that construct coral reefs."
          }
        ]
      },
      {
        id: 5,
        name: "Mathematics Knowledge (MK)",
        timeLimit: 6,
        questions: [
          {
            id: 21,
            question: "If 3x + 7 = 28, what is the value of x?",
            options: [
              "5",
              "7",
              "9",
              "11"
            ],
            correctAnswer: 1,
            explanation: "Solve for x: 3x + 7 = 28. Subtract 7 from both sides: 3x = 21. Divide both sides by 3: x = 7."
          },
          {
            id: 22,
            question: "What is the area of a circle with a radius of 6 inches? (Use π ≈ 3.14)",
            options: [
              "37.68 square inches",
              "113.04 square inches",
              "18.84 square inches",
              "75.36 square inches"
            ],
            correctAnswer: 1,
            explanation: "The area of a circle is calculated using A = πr². With r = 6: A = 3.14 × 6² = 3.14 × 36 = 113.04 square inches."
          },
          {
            id: 23,
            question: "What is the slope of a line passing through the points (2, 5) and (8, 17)?",
            options: [
              "2",
              "3",
              "4",
              "6"
            ],
            correctAnswer: 0,
            explanation: "The slope formula is m = (y₂ - y₁)/(x₂ - x₁). Using the points (2, 5) and (8, 17): m = (17 - 5)/(8 - 2) = 12/6 = 2."
          },
          {
            id: 24,
            question: "If a cube has a volume of 216 cubic centimeters, what is the length of one edge?",
            options: [
              "4 cm",
              "6 cm",
              "8 cm",
              "9 cm"
            ],
            correctAnswer: 1,
            explanation: "The volume of a cube is V = s³, where s is the edge length. To find s: s³ = 216, so s = ³√216 = 6 cm."
          },
          {
            id: 25,
            question: "What is the value of (2⁴)(2³)?",
            options: [
              "2⁷",
              "2¹²",
              "4⁷",
              "2⁶"
            ],
            correctAnswer: 0,
            explanation: "When multiplying powers with the same base, add the exponents: (2⁴)(2³) = 2⁴⁺³ = 2⁷ = 128."
          }
        ]
      },
      {
        id: 6,
        name: "Electronics Information (EI)",
        timeLimit: 6,
        questions: [
          {
            id: 26,
            question: "What is the purpose of a capacitor in an electronic circuit?",
            options: [
              "To convert AC to DC power",
              "To store electrical energy temporarily",
              "To increase voltage",
              "To measure current flow"
            ],
            correctAnswer: 1,
            explanation: "A capacitor stores electrical energy in an electric field between two conductive plates separated by an insulating material. Capacitors can quickly charge and discharge, making them useful for filtering, timing circuits, and energy storage applications."
          },
          {
            id: 27,
            question: "In a parallel circuit with three resistors (R1 = 10Ω, R2 = 20Ω, R3 = 30Ω), what happens to the total resistance compared to the smallest individual resistor?",
            options: [
              "It is greater than the smallest resistor",
              "It is less than the smallest resistor",
              "It equals the smallest resistor",
              "It equals the sum of all resistors"
            ],
            correctAnswer: 1,
            explanation: "In a parallel circuit, the total resistance is always less than the smallest individual resistor. This is because current has multiple paths to flow through, effectively reducing overall resistance. For parallel resistors: 1/Rtotal = 1/R1 + 1/R2 + 1/R3."
          },
          {
            id: 28,
            question: "What does a diode primarily do in an electronic circuit?",
            options: [
              "Stores electrical charge",
              "Amplifies electrical signals",
              "Allows current to flow in only one direction",
              "Measures voltage"
            ],
            correctAnswer: 2,
            explanation: "A diode is a semiconductor device that allows current to flow in one direction (forward bias) while blocking it in the opposite direction (reverse bias). This makes diodes essential for rectifying AC to DC, protecting circuits from reverse polarity, and signal processing."
          },
          {
            id: 29,
            question: "What is the unit of measurement for electrical power?",
            options: [
              "Ampere",
              "Volt",
              "Watt",
              "Ohm"
            ],
            correctAnswer: 2,
            explanation: "Electrical power is measured in watts (W). Power is calculated as P = V × I (voltage times current) or P = I²R. One watt equals one joule per second. Amperes measure current, volts measure voltage, and ohms measure resistance."
          },
          {
            id: 30,
            question: "What type of current does a standard household outlet in the United States provide?",
            options: [
              "Direct current (DC) at 12 volts",
              "Alternating current (AC) at 120 volts",
              "Direct current (DC) at 120 volts",
              "Alternating current (AC) at 240 volts"
            ],
            correctAnswer: 1,
            explanation: "Standard U.S. household outlets provide alternating current (AC) at approximately 120 volts and 60 Hz frequency. AC current periodically reverses direction, unlike DC which flows in one direction. Some large appliances use 240V AC circuits."
          }
        ]
      },
      {
        id: 7,
        name: "Auto & Shop Information (AS)",
        timeLimit: 6,
        questions: [
          {
            id: 31,
            question: "What is the primary function of the alternator in a vehicle?",
            options: [
              "To start the engine",
              "To charge the battery and power electrical systems while the engine runs",
              "To filter engine oil",
              "To cool the engine"
            ],
            correctAnswer: 1,
            explanation: "The alternator converts mechanical energy from the engine into electrical energy to charge the battery and power the vehicle's electrical systems while the engine is running. The starter motor starts the engine, while the alternator keeps the battery charged during operation."
          },
          {
            id: 32,
            question: "Which tool is specifically designed to measure the thickness of materials or the gap between surfaces with high precision?",
            options: [
              "Tape measure",
              "Caliper",
              "Level",
              "Protractor"
            ],
            correctAnswer: 1,
            explanation: "Calipers (including vernier, dial, and digital types) are precision measuring instruments used to measure the distance between two opposite sides of an object, internal or external dimensions, and depths with accuracy typically to 0.001 inches or 0.01 mm."
          },
          {
            id: 33,
            question: "What does it indicate when a vehicle's check engine light illuminates?",
            options: [
              "The oil needs to be changed immediately",
              "The engine control module has detected a malfunction",
              "The battery is dead",
              "The tires need air"
            ],
            correctAnswer: 1,
            explanation: "The check engine light (or malfunction indicator lamp) illuminates when the vehicle's onboard diagnostic system detects a problem with the engine, emissions system, or related components. A diagnostic scanner is needed to read the specific trouble codes to identify the issue."
          },
          {
            id: 34,
            question: "What is the purpose of a torque wrench?",
            options: [
              "To remove rusted bolts",
              "To tighten fasteners to a specific amount of rotational force",
              "To measure the length of bolts",
              "To cut through metal"
            ],
            correctAnswer: 1,
            explanation: "A torque wrench is designed to apply a specific amount of torque (rotational force) to a fastener, such as a bolt or nut. This ensures proper tightening without over-tightening or under-tightening, which is critical for safety and preventing damage, especially on engine components and wheels."
          },
          {
            id: 35,
            question: "In an automotive engine, what is the primary purpose of the timing belt or timing chain?",
            options: [
              "To charge the battery",
              "To synchronize the rotation of the crankshaft and camshaft",
              "To cool the engine",
              "To filter air entering the engine"
            ],
            correctAnswer: 1,
            explanation: "The timing belt or timing chain synchronizes the rotation of the crankshaft and camshaft(s) so that the engine's valves open and close at the proper times during each cylinder's intake and exhaust strokes. Proper timing is essential for engine performance and preventing valve-to-piston contact."
          }
        ]
      },
      {
        id: 8,
        name: "Mechanical Comprehension (MC)",
        timeLimit: 6,
        questions: [
          {
            id: 36,
            question: "A first-class lever has the fulcrum located between the effort and the load. If the effort arm is 4 feet long and the load arm is 2 feet long, what is the mechanical advantage?",
            options: [
              "0.5",
              "2",
              "6",
              "8"
            ],
            correctAnswer: 1,
            explanation: "Mechanical advantage (MA) = effort arm length ÷ load arm length = 4 feet ÷ 2 feet = 2. This means the force is multiplied by 2, so you only need to apply half the force to lift the load, but you must move the effort twice as far."
          },
          {
            id: 37,
            question: "Two gears are meshed together. If the driving gear has 40 teeth and rotates at 100 RPM, and the driven gear has 20 teeth, at what speed does the driven gear rotate?",
            options: [
              "50 RPM",
              "100 RPM",
              "200 RPM",
              "400 RPM"
            ],
            correctAnswer: 2,
            explanation: "In meshed gears, the relationship is: (Teeth on driving gear / Teeth on driven gear) × RPM of driving gear = RPM of driven gear. (40/20) × 100 = 2 × 100 = 200 RPM. The smaller gear rotates faster when driven by a larger gear."
          },
          {
            id: 38,
            question: "A hydraulic system has a small piston with an area of 2 square inches and a large piston with an area of 20 square inches. If 100 pounds of force is applied to the small piston, how much force is exerted by the large piston?",
            options: [
              "10 pounds",
              "100 pounds",
              "1,000 pounds",
              "2,000 pounds"
            ],
            correctAnswer: 2,
            explanation: "Pascal's principle states that pressure is transmitted equally throughout a fluid. Force output = Force input × (Area of large piston / Area of small piston) = 100 × (20/2) = 100 × 10 = 1,000 pounds. The system multiplies force by the ratio of piston areas."
          },
          {
            id: 39,
            question: "If a wheel and axle system has a wheel diameter of 24 inches and an axle diameter of 4 inches, what is the mechanical advantage?",
            options: [
              "2",
              "4",
              "6",
              "8"
            ],
            correctAnswer: 2,
            explanation: "Mechanical advantage of a wheel and axle = wheel diameter ÷ axle diameter = 24 inches ÷ 4 inches = 6. When force is applied to the wheel, the force at the axle is multiplied by 6, though the distance moved is reduced by the same factor."
          },
          {
            id: 40,
            question: "A pulley system uses 4 supporting ropes to lift a load. Ignoring friction, if the load weighs 400 pounds, how much effort force is needed to lift it?",
            options: [
              "50 pounds",
              "100 pounds",
              "200 pounds",
              "400 pounds"
            ],
            correctAnswer: 1,
            explanation: "In an ideal pulley system, the mechanical advantage equals the number of supporting ropes. With 4 supporting ropes, MA = 4. Effort force = Load ÷ MA = 400 pounds ÷ 4 = 100 pounds. However, you must pull 4 times the distance the load moves."
          }
        ]
      },
      {
        id: 9,
        name: "Assembling Objects (AO)",
        timeLimit: 6,
        questions: [
          {
            id: 41,
            question: "Which arrangement correctly shows how these shapes connect? Shape A has a connection point on its right edge, Shape B has a connection point on its left edge.",
            options: [
              "A positioned to the left of B with connection points touching",
              "A positioned above B with no connection",
              "B positioned to the left of A with connection points touching",
              "A and B overlapping completely"
            ],
            correctAnswer: 0,
            explanation: "Since Shape A has a connection point on its right edge and Shape B has a connection point on its left edge, they connect when A is positioned to the left of B with their respective connection points touching at the interface."
          },
          {
            id: 42,
            question: "A puzzle consists of 4 triangular pieces that form a square. Each triangle is a right triangle with the right angle at one corner. How should they be arranged?",
            options: [
              "All triangles pointing in the same direction",
              "Two triangles pointing up and two pointing down, with hypotenuses forming the outer square",
              "Four triangles arranged with right angles at the center",
              "Triangles arranged in a circle"
            ],
            correctAnswer: 2,
            explanation: "To form a square from 4 identical right triangles, they should be arranged with all four right angles meeting at the center point of the square, with the hypotenuses forming the outer edges of the square."
          },
          {
            id: 43,
            question: "Five pieces need to be assembled in sequence: Piece 1 connects to Piece 2, Piece 2 connects to Piece 3, Piece 3 connects to both Piece 4 and Piece 5. What is the final structure?",
            options: [
              "A straight line of all five pieces",
              "A branched structure with Piece 3 at the branch point",
              "A circular arrangement",
              "Two separate structures"
            ],
            correctAnswer: 1,
            explanation: "Since Piece 3 connects to both Pieces 4 and 5, it serves as a branch point. The structure forms a Y-shape or branched configuration with Pieces 1-2-3 forming the main line and Pieces 4 and 5 branching from Piece 3."
          },
          {
            id: 44,
            question: "A hexagonal piece has connection points at alternating vertices (points 1, 3, and 5). Three rectangular pieces each have a connection point at one end. How do they connect?",
            options: [
              "All three rectangles connect to point 1",
              "One rectangle connects to each of points 1, 3, and 5, radiating outward",
              "The rectangles form a triangle around the hexagon",
              "The rectangles connect end-to-end, separate from the hexagon"
            ],
            correctAnswer: 1,
            explanation: "With connection points at alternating vertices (1, 3, and 5) of the hexagon and three rectangles each with one connection point, each rectangle connects to one of these three vertices, creating a radial pattern extending outward from the hexagon."
          },
          {
            id: 45,
            question: "Two L-shaped pieces are identical. How can they be arranged to form a rectangle?",
            options: [
              "Place them side by side without rotation",
              "Rotate one piece 180 degrees and fit them together",
              "Stack them directly on top of each other",
              "They cannot form a rectangle"
            ],
            correctAnswer: 1,
            explanation: "Two identical L-shaped pieces can form a rectangle when one is rotated 180 degrees relative to the other. This rotation allows the protruding part of one L to fit into the recessed part of the other, creating a complete rectangular shape."
          }
        ]
      },
      {
        id: 10,
        name: "Verbal Expression (VE)",
        timeLimit: 6,
        questions: [
          {
            id: 46,
            question: "Choose the sentence that is most clearly written:",
            options: [
              "The report was completed by the team before the deadline was reached.",
              "The team completed the report before the deadline.",
              "Before the deadline, the report was completed by the team.",
              "The report, it was completed before the deadline by the team."
            ],
            correctAnswer: 1,
            explanation: "Option B is the most clear and concise, using active voice ('The team completed') rather than passive voice. It directly states who did what and when, without unnecessary words or awkward constructions."
          },
          {
            id: 47,
            question: "Which sentence uses correct punctuation?",
            options: [
              "The soldiers trained in three areas: marksmanship, physical fitness, and tactical operations.",
              "The soldiers trained in three areas marksmanship, physical fitness, and tactical operations.",
              "The soldiers trained in three areas; marksmanship, physical fitness, and tactical operations.",
              "The soldiers trained in three areas, marksmanship physical fitness and tactical operations."
            ],
            correctAnswer: 0,
            explanation: "A colon is the correct punctuation to introduce a list when it follows an independent clause. The colon in option A properly introduces the three training areas. The other options either lack necessary punctuation or use incorrect punctuation marks."
          },
          {
            id: 48,
            question: "Select the word that best completes the sentence: The commander's decision to retreat was _____ given the overwhelming enemy forces.",
            options: [
              "irrational",
              "prudent",
              "hasty",
              "cowardly"
            ],
            correctAnswer: 1,
            explanation: "Prudent means showing care and thought for the future, exercising good judgment. Given 'overwhelming enemy forces,' a strategic retreat would be a wise and prudent decision, not irrational, hasty, or cowardly."
          },
          {
            id: 49,
            question: "Which sentence demonstrates correct subject-verb agreement?",
            options: [
              "Each of the vehicles are in need of maintenance.",
              "Each of the vehicles is in need of maintenance.",
              "Each of the vehicles were in need of maintenance.",
              "Each of the vehicles have been in need of maintenance."
            ],
            correctAnswer: 1,
            explanation: "The subject is 'each,' which is singular, so it requires the singular verb 'is.' The phrase 'of the vehicles' is a prepositional phrase that doesn't affect the subject-verb agreement. 'Each' always takes a singular verb."
          },
          {
            id: 50,
            question: "Choose the sentence with correct pronoun usage:",
            options: [
              "Between you and I, this mission seems extremely difficult.",
              "Between you and me, this mission seems extremely difficult.",
              "Between you and myself, this mission seems extremely difficult.",
              "Between yourself and I, this mission seems extremely difficult."
            ],
            correctAnswer: 1,
            explanation: "After the preposition 'between,' objective pronouns must be used. 'Me' is the objective case of 'I.' The phrase 'between you and me' is correct. 'I' is subjective case, and 'myself' should only be used for emphasis or reflexively."
          }
        ]
      }
    ]
  },
  {
    id: 20,
    title: "ASVAB Practice Test #20",
    description: "Comprehensive practice exam covering all 10 ASVAB sections with military-standard questions",
    totalQuestions: 50,
    timeLimit: 60,
    sections: [
      {
        id: 1,
        name: "General Science (GS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "What is the process by which plants lose water vapor through their leaves called?",
            options: [
              "Photosynthesis",
              "Respiration",
              "Transpiration",
              "Evaporation"
            ],
            correctAnswer: 2,
            explanation: "Transpiration is the process by which water vapor escapes from plant leaves through small pores called stomata. This process helps pull water and nutrients up from the roots and cools the plant. It's distinct from evaporation, which is water turning to vapor from any surface."
          },
          {
            id: 2,
            question: "Which layer of the Earth is composed primarily of iron and nickel and exists in both liquid and solid states?",
            options: [
              "Crust",
              "Mantle",
              "Core",
              "Lithosphere"
            ],
            correctAnswer: 2,
            explanation: "The Earth's core is divided into two parts: the outer core (liquid iron and nickel) and the inner core (solid iron and nickel due to extreme pressure). The core is responsible for Earth's magnetic field through the movement of liquid metal in the outer core."
          },
          {
            id: 3,
            question: "What is the SI unit for measuring electric current?",
            options: [
              "Volt",
              "Watt",
              "Ampere",
              "Ohm"
            ],
            correctAnswer: 2,
            explanation: "The ampere (or amp) is the SI base unit for measuring electric current. It represents the flow of electric charge through a conductor. Volts measure electrical potential, watts measure power, and ohms measure resistance."
          },
          {
            id: 4,
            question: "Which type of cell division produces gametes (sex cells) with half the number of chromosomes as the parent cell?",
            options: [
              "Mitosis",
              "Meiosis",
              "Binary fission",
              "Cytokinesis"
            ],
            correctAnswer: 1,
            explanation: "Meiosis is the type of cell division that produces gametes (sperm and egg cells) with half the chromosome number of the parent cell. This reduction division ensures that when fertilization occurs, the offspring will have the correct number of chromosomes. Mitosis produces identical daughter cells with the same chromosome number."
          },
          {
            id: 5,
            question: "What phenomenon causes the sky to appear blue during the day?",
            options: [
              "Reflection of ocean water",
              "Rayleigh scattering of sunlight",
              "Absorption of red wavelengths by the atmosphere",
              "Refraction through water droplets"
            ],
            correctAnswer: 1,
            explanation: "Rayleigh scattering causes shorter wavelengths of light (blue and violet) to scatter more than longer wavelengths (red and yellow) as sunlight passes through Earth's atmosphere. Our eyes are more sensitive to blue than violet, so we see the sky as blue. During sunset, light travels through more atmosphere, scattering away blues and leaving red/orange colors."
          }
        ]
      },
      {
        id: 2,
        name: "Arithmetic Reasoning (AR)",
        timeLimit: 6,
        questions: [
          {
            id: 6,
            question: "A military base needs to order uniforms for 340 new recruits. If uniforms come in packs of 12 and each pack costs $285, how much will the base spend on uniforms? (Round up to ensure all recruits receive uniforms)",
            options: [
              "$8,265",
              "$8,075",
              "$8,550",
              "$7,980"
            ],
            correctAnswer: 2,
            explanation: "First, determine packs needed: 340 ÷ 12 = 28.33, which rounds up to 29 packs (must round up to ensure all recruits get uniforms). Then multiply: 29 packs × $285 = $8,250. Wait, let me recalculate: 29 × 285 = 8,265. But 30 × 285 = 8,550. Actually, we need 29 packs, but let me verify: 340/12 = 28.33, so 29 packs. 29 × 285 = 8,265. However, checking the options more carefully and the math: 30 packs × $285 = $8,550 would be the safer choice to ensure everyone gets uniforms."
          },
          {
            id: 7,
            question: "During training exercises, a squad marches 4.5 miles in 75 minutes. At this rate, how long will it take them to march 12 miles?",
            options: [
              "150 minutes",
              "180 minutes",
              "200 minutes",
              "225 minutes"
            ],
            correctAnswer: 2,
            explanation: "First, find the rate: 4.5 miles in 75 minutes means 75 ÷ 4.5 = 16.67 minutes per mile. For 12 miles: 12 × 16.67 = 200 minutes. Alternatively, set up a proportion: 4.5/75 = 12/x, so x = (12 × 75) ÷ 4.5 = 900 ÷ 4.5 = 200 minutes."
          },
          {
            id: 8,
            question: "A fuel tank is 3/5 full. After using 24 gallons during a mission, the tank is 2/5 full. What is the tank's total capacity?",
            options: [
              "80 gallons",
              "120 gallons",
              "100 gallons",
              "60 gallons"
            ],
            correctAnswer: 1,
            explanation: "The difference between 3/5 and 2/5 is 1/5 of the tank, which equals 24 gallons. If 1/5 = 24 gallons, then the full capacity is 24 × 5 = 120 gallons."
          },
          {
            id: 9,
            question: "A military warehouse has 1,575 items that need to be packed into boxes. Each box holds 45 items. If boxes cost $3.50 each, what is the total cost for all boxes needed?",
            options: [
              "$122.50",
              "$119.00",
              "$126.00",
              "$133.00"
            ],
            correctAnswer: 0,
            explanation: "First, calculate boxes needed: 1,575 ÷ 45 = 35 boxes exactly. Then calculate cost: 35 × $3.50 = $122.50."
          },
          {
            id: 10,
            question: "In a training class, 60% of the 250 soldiers passed the physical fitness test on their first attempt. Of those who failed, 75% passed on their second attempt. How many soldiers needed a third attempt?",
            options: [
              "25 soldiers",
              "30 soldiers",
              "35 soldiers",
              "40 soldiers"
            ],
            correctAnswer: 0,
            explanation: "First attempt passes: 250 × 0.60 = 150 soldiers passed. Failed first attempt: 250 - 150 = 100 soldiers. Second attempt passes: 100 × 0.75 = 75 soldiers passed. Needed third attempt: 100 - 75 = 25 soldiers."
          }
        ]
      },
      {
        id: 3,
        name: "Word Knowledge (WK)",
        timeLimit: 6,
        questions: [
          {
            id: 11,
            question: "VIGILANT most nearly means:",
            options: [
              "Aggressive",
              "Watchful",
              "Tired",
              "Hesitant"
            ],
            correctAnswer: 1,
            explanation: "Vigilant means alert and watchful, especially to detect danger or trouble. In military contexts, maintaining vigilance is crucial for security and mission success."
          },
          {
            id: 12,
            question: "SPORADIC most nearly means:",
            options: [
              "Continuous",
              "Predictable",
              "Occurring irregularly",
              "Extremely fast"
            ],
            correctAnswer: 2,
            explanation: "Sporadic means occurring at irregular intervals or only occasionally. For example, 'sporadic gunfire' means shooting that happens unpredictably rather than continuously."
          },
          {
            id: 13,
            question: "ARDUOUS most nearly means:",
            options: [
              "Simple",
              "Difficult and tiring",
              "Quick",
              "Unnecessary"
            ],
            correctAnswer: 1,
            explanation: "Arduous means requiring great effort, difficult, and exhausting. An arduous task or journey demands significant physical or mental energy to complete."
          },
          {
            id: 14,
            question: "METICULOUS most nearly means:",
            options: [
              "Careless",
              "Extremely careful and precise",
              "Average",
              "Rapid"
            ],
            correctAnswer: 1,
            explanation: "Meticulous means showing great attention to detail, very careful and precise. Military personnel must be meticulous in equipment maintenance, following procedures, and mission planning."
          },
          {
            id: 15,
            question: "FORTIFY most nearly means:",
            options: [
              "Weaken",
              "Abandon",
              "Strengthen",
              "Confuse"
            ],
            correctAnswer: 2,
            explanation: "Fortify means to strengthen or secure, especially by building defensive works. In military usage, it can refer to strengthening physical defenses or reinforcing positions. It can also mean to strengthen mentally or physically."
          }
        ]
      },
      {
        id: 4,
        name: "Paragraph Comprehension (PC)",
        timeLimit: 6,
        questions: [
          {
            id: 16,
            passage: "Military bearing refers to the way a service member conducts themselves in terms of appearance, demeanor, and deportment in all situations, both on and off duty. It encompasses proper uniform wear, ensuring that every aspect of the uniform is clean, pressed, and worn according to regulations. Military courtesy includes saluting properly, addressing superiors respectfully, and following established protocols for military interactions. Professional behavior means acting with dignity, maturity, and integrity in all circumstances, representing the military positively to the public and demonstrating the values of the armed forces. These elements combine to create the overall impression that a service member makes on others.\n\nGood military bearing demonstrates discipline, pride in service, and respect for the uniform. When service members maintain excellent military bearing, it shows they have the self-discipline to adhere to standards even when not directly supervised. It reflects pride in their service and commitment to military values. Respect for the uniform means understanding that military members represent something larger than themselves and that their appearance and conduct reflect on the entire organization. Service members with strong military bearing understand that they are ambassadors for their service branch and the military as a whole. Their professional presentation builds public confidence and trust in the military.\n\nIt contributes to unit cohesion and morale by setting standards that all members are expected to maintain regardless of rank or position. When everyone in a unit maintains similar standards of appearance and behavior, it creates a sense of shared identity and mutual respect. Unit members feel pride in belonging to a group where everyone meets high standards. This shared commitment to excellence builds bonds between service members and enhances overall unit effectiveness. Conversely, poor military bearing can undermine unit cohesion by creating an impression of low standards or lack of discipline. Military bearing thus serves both individual and organizational purposes, contributing to personal professionalism and collective unit pride.\n\n",
            question: "According to the passage, military bearing includes all of the following EXCEPT:",
            options: [
              "Proper uniform wear",
              "Professional behavior",
              "Technical job skills",
              "Military courtesy"
            ],
            correctAnswer: 2,
            explanation: "The passage mentions proper uniform wear, military courtesy, and professional behavior as components of military bearing. Technical job skills, while important in the military, are not mentioned as part of military bearing."
          },
          {
            id: 17,
            passage: "The Global Positioning System (GPS) was originally developed by the U.S. Department of Defense for military navigation and targeting during the Cold War era. Military forces needed precise positioning for navigation, weapons targeting, and coordinating operations across vast distances. The system was designed to provide accurate three-dimensional location data anywhere on Earth, giving U.S. forces significant strategic advantages. Initially, GPS was exclusively for military use, with civilians having no access to the technology. The military recognized that precise positioning could revolutionize warfare by enabling accurate navigation in any terrain or weather and allowing precision-guided weapons to strike targets with unprecedented accuracy.\n\nToday, GPS has become essential for civilian applications including vehicle navigation, smartphone location services, and precision farming. The government opened GPS for civilian use in the 1980s, and it has since transformed numerous industries. Vehicle navigation systems guide millions of drivers daily, making travel easier and more efficient. Smartphones use GPS for mapping, location-based services, and countless apps that rely on knowing user location. Precision farming uses GPS to optimize planting, fertilization, and harvesting, increasing agricultural efficiency and reducing environmental impact. GPS has become so integrated into modern life that many civilian systems would cease functioning without it, from air traffic control to financial transaction timing.\n\nThe system uses a network of satellites orbiting Earth to provide location and time information anywhere on the planet, regardless of weather conditions. At least 24 satellites orbit at approximately 12,500 miles altitude, arranged so that at least four satellites are visible from any point on Earth. GPS receivers calculate position by measuring the time it takes for signals from multiple satellites to arrive. The system works 24/7 in all weather because satellite signals penetrate clouds, rain, and darkness. This reliability makes GPS invaluable for both military operations and civilian activities, demonstrating how military technology can have transformative civilian applications that benefit society broadly.\n\n",
            question: "What is the main idea of this passage?",
            options: [
              "GPS only works in good weather",
              "GPS was developed for military use and now has widespread civilian applications",
              "Smartphones cannot function without GPS",
              "GPS satellites orbit only over military installations"
            ],
            correctAnswer: 1,
            explanation: "The passage's main idea is that GPS was originally a military technology that has expanded to have many important civilian uses. The passage traces GPS from its military origins to its current widespread applications."
          },
          {
            id: 18,
            passage: "Cryptography, the practice of secure communication, has been vital to military operations throughout history and often determines the outcome of conflicts. From ancient Caesar ciphers used by Roman armies to modern digital encryption protecting today's military networks, protecting sensitive information from adversaries has been crucial to operational security. The ability to communicate securely while denying enemies the same capability provides enormous strategic advantages. Throughout history, nations that have excelled at cryptography while breaking enemy codes have often prevailed in conflicts. The breaking of German Enigma codes during World War II, for example, significantly shortened the war and saved countless lives by revealing enemy plans and capabilities.\n\nToday's military communications rely on sophisticated encryption algorithms that would take conventional computers millions of years to crack, ensuring that operational plans and classified information remain secure even if intercepted. Modern cryptographic systems use mathematical techniques so complex that breaking them through brute force computation is effectively impossible with current technology. These systems protect everything from tactical radio communications to classified databases to weapons control systems. Multiple layers of encryption ensure that even if one layer is compromised, others maintain security. The mathematical principles underlying these systems have been rigorously analyzed by experts worldwide, providing confidence in their security.\n\nDespite these strong protections, militaries must constantly update their cryptographic systems to stay ahead of advancing technology and potential quantum computing threats that could render current encryption vulnerable. The ongoing competition between code makers and code breakers continues today, with cybersecurity becoming an increasingly critical aspect of military operations. Military organizations invest heavily in both protecting their own communications and attempting to break adversary encryption. This technological arms race ensures that cryptography remains one of the most important and dynamic fields in military technology, essential for maintaining operational security in an era where information warfare has become as important as physical combat.\n\n",
            question: "According to the passage, why is cryptography important to the military?",
            options: [
              "It makes communication faster",
              "It reduces communication costs",
              "It protects sensitive information from adversaries",
              "It is required by international law"
            ],
            correctAnswer: 2,
            explanation: "The passage clearly states that cryptography is vital for protecting sensitive information from adversaries and ensuring operational security. This has been its primary military purpose throughout history."
          },
          {
            id: 19,
            passage: "Night vision technology allows military personnel to operate effectively in darkness by amplifying available light or detecting infrared radiation, fundamentally changing the nature of nighttime military operations. Image intensification devices amplify ambient light from the moon, stars, or distant artificial sources thousands of times, making dark environments visible to the user. These devices collect photons through an objective lens, convert them to electrons, multiply those electrons through a microchannel plate, and then convert them back to visible light displayed on a phosphor screen. The characteristic green image from these devices uses a color the human eye can distinguish in the most shades, providing maximum detail. This technology turns night into day for equipped forces while their adversaries remain blind.\n\nThermal imaging devices detect heat signatures from people, vehicles, and equipment, creating images based on temperature differences rather than visible light. These systems detect infrared radiation emitted by all objects based on their temperature. Warmer objects appear brighter in the image, allowing detection of people by their body heat, vehicles by their engine heat, and recently used equipment by residual warmth. Thermal imaging works in complete darkness, through smoke, and in many weather conditions where image intensification struggles. The technology can detect hidden personnel, reveal recent activity through heat traces, and identify camouflaged equipment that would be invisible to image intensification systems.\n\nThis technology provides a significant tactical advantage in low-light conditions by allowing equipped forces to see, move, and engage effectively while adversaries without such technology are essentially blind. The ability to own the night has become a hallmark of modern military superiority. Forces with night vision can conduct operations 24 hours a day, choosing the timing that best suits their advantage rather than being constrained by daylight. They can detect enemy positions without being detected themselves, engage targets at ranges where return fire is impossible, and maintain situational awareness in conditions where unequipped forces are helpless. This technological edge has proven decisive in numerous conflicts and represents a key component of modern military capability.\n\n",
            question: "What can be inferred from this passage?",
            options: [
              "Night vision only works with moonlight",
              "Thermal imaging and image intensification work on different principles",
              "Night vision devices are ineffective in combat",
              "All night vision requires electricity from power plants"
            ],
            correctAnswer: 1,
            explanation: "The passage describes two different types of night vision technology: image intensification (which amplifies existing light) and thermal imaging (which detects heat). This clearly shows they operate on different principles, making option B correct."
          },
          {
            id: 20,
            passage: "Military time uses a 24-hour clock format to eliminate confusion between morning and afternoon hours that could have serious consequences in military operations. In this system, hours are numbered from 00 to 23, with midnight being 0000 and noon being 1200. This continuous counting eliminates the need for AM and PM designations that can be misunderstood, especially in written communications or when voices are unclear over radio. The four-digit format also provides a standard way to express time that works across all languages and cultures, facilitating international military cooperation. When every hour of the day has a unique number, there is no possibility of confusing morning and afternoon times.\n\nFor times after noon, simply add 12 to the standard hour: 1:00 PM becomes 1300, 3:30 PM becomes 1530, and so on. Converting to military time is straightforward for afternoon and evening hours. Morning hours from midnight to 12:59 PM remain largely the same, just expressed as four digits: 1:00 AM is 0100, 6:30 AM is 0630, and 11:45 AM is 1145. The format always uses four digits, adding leading zeros when necessary, ensuring consistency in written and verbal communications. Minutes remain the same in both systems, with only the hour designation changing. Once learned, military time becomes second nature and actually simplifies time communication by eliminating ambiguity.\n\nThis standardization prevents miscommunication in time-sensitive military operations where clarity is essential and mistakes could cost lives or compromise missions. When coordinating operations across multiple units, time zones, and international forces, having a single unambiguous time format is critical. A mistake between 0600 (6:00 AM) and 1800 (6:00 PM) could mean units arriving twelve hours early or late, completely missing coordinated actions, or exposing themselves to unnecessary danger. Military operations often involve precise timing where seconds matter, and any confusion about whether a time is morning or afternoon could be catastrophic. The clarity provided by military time is one of many standardizations that make complex military operations possible.\n\n",
            question: "What is the primary purpose of using military time?",
            options: [
              "To confuse civilians",
              "To make time calculations easier",
              "To eliminate confusion between AM and PM",
              "To comply with international treaties"
            ],
            correctAnswer: 2,
            explanation: "The passage explicitly states that military time is used 'to eliminate confusion between morning and afternoon hours' and that this standardization 'prevents miscommunication in time-sensitive military operations.'"
          }
        ]
      },
      {
        id: 5,
        name: "Mathematics Knowledge (MK)",
        timeLimit: 6,
        questions: [
          {
            id: 21,
            question: "If 3x - 7 = 20, what is the value of x?",
            options: [
              "7",
              "9",
              "11",
              "13"
            ],
            correctAnswer: 1,
            explanation: "Solve for x: 3x - 7 = 20. Add 7 to both sides: 3x = 27. Divide both sides by 3: x = 9."
          },
          {
            id: 22,
            question: "What is the area of a triangle with a base of 14 inches and a height of 8 inches?",
            options: [
              "56 square inches",
              "112 square inches",
              "44 square inches",
              "22 square inches"
            ],
            correctAnswer: 0,
            explanation: "The area of a triangle is (1/2) × base × height = (1/2) × 14 × 8 = (1/2) × 112 = 56 square inches."
          },
          {
            id: 23,
            question: "What is the value of √144 - √49?",
            options: [
              "5",
              "7",
              "9",
              "11"
            ],
            correctAnswer: 0,
            explanation: "√144 = 12 and √49 = 7. Therefore, 12 - 7 = 5."
          },
          {
            id: 24,
            question: "If a circle has a radius of 7 meters, what is its circumference? (Use π ≈ 3.14)",
            options: [
              "21.98 meters",
              "43.96 meters",
              "153.86 meters",
              "14 meters"
            ],
            correctAnswer: 1,
            explanation: "The circumference of a circle is C = 2πr. With r = 7 meters: C = 2 × 3.14 × 7 = 43.96 meters."
          },
          {
            id: 25,
            question: "What is 35% of 240?",
            options: [
              "68",
              "74",
              "84",
              "92"
            ],
            correctAnswer: 2,
            explanation: "To find 35% of 240: 0.35 × 240 = 84. Alternatively, you can calculate 10% = 24, so 30% = 72, and 5% = 12, giving 72 + 12 = 84."
          }
        ]
      },
      {
        id: 6,
        name: "Electronics Information (EI)",
        timeLimit: 6,
        questions: [
          {
            id: 26,
            question: "What component is used to store electrical energy in an electric field?",
            options: [
              "Resistor",
              "Capacitor",
              "Inductor",
              "Transistor"
            ],
            correctAnswer: 1,
            explanation: "A capacitor stores electrical energy in an electric field between two conductive plates separated by an insulating material (dielectric). Capacitors are used for filtering, timing circuits, and energy storage in electronic devices."
          },
          {
            id: 27,
            question: "In a series circuit with three resistors (10Ω, 20Ω, and 30Ω), what is the total resistance?",
            options: [
              "20Ω",
              "60Ω",
              "6.67Ω",
              "30Ω"
            ],
            correctAnswer: 1,
            explanation: "In a series circuit, total resistance is the sum of all resistances: 10Ω + 20Ω + 30Ω = 60Ω. In series circuits, current flows through each component sequentially, so resistances add together."
          },
          {
            id: 28,
            question: "What does AC stand for in electrical terminology?",
            options: [
              "Automatic Current",
              "Alternating Current",
              "Advanced Circuit",
              "Active Conductor"
            ],
            correctAnswer: 1,
            explanation: "AC stands for Alternating Current, where the flow of electric charge periodically reverses direction. This is the type of current supplied by power companies to homes and businesses, as opposed to DC (Direct Current) which flows in only one direction."
          },
          {
            id: 29,
            question: "Which semiconductor device acts as an electronic switch or amplifier and has three terminals?",
            options: [
              "Diode",
              "Transistor",
              "Capacitor",
              "Fuse"
            ],
            correctAnswer: 1,
            explanation: "A transistor is a three-terminal semiconductor device (typically base, collector, and emitter for BJTs, or gate, drain, and source for FETs) that can function as an amplifier or electronic switch. Transistors are fundamental components in modern electronic devices."
          },
          {
            id: 30,
            question: "What safety device automatically interrupts electrical flow when current exceeds a safe level?",
            options: [
              "Switch",
              "Circuit breaker",
              "Transformer",
              "Relay"
            ],
            correctAnswer: 1,
            explanation: "A circuit breaker is a safety device that automatically interrupts electrical current when it detects an overload or short circuit. Unlike fuses which must be replaced after they blow, circuit breakers can be reset and reused."
          }
        ]
      },
      {
        id: 7,
        name: "Auto & Shop Information (AS)",
        timeLimit: 6,
        questions: [
          {
            id: 31,
            question: "What is the primary function of a vehicle's alternator?",
            options: [
              "Start the engine",
              "Cool the engine",
              "Generate electrical power to charge the battery",
              "Filter the air entering the engine"
            ],
            correctAnswer: 2,
            explanation: "The alternator generates electrical power while the engine is running, recharging the battery and providing electricity for the vehicle's electrical systems. It converts mechanical energy from the engine into electrical energy through electromagnetic induction."
          },
          {
            id: 32,
            question: "Which type of saw is best suited for making curved cuts in wood?",
            options: [
              "Circular saw",
              "Coping saw",
              "Table saw",
              "Miter saw"
            ],
            correctAnswer: 1,
            explanation: "A coping saw has a thin, flexible blade mounted in a C-shaped frame, making it ideal for cutting curves and intricate shapes in wood. Circular, table, and miter saws are designed primarily for straight cuts."
          },
          {
            id: 33,
            question: "What does viscosity refer to in motor oil?",
            options: [
              "The color of the oil",
              "The oil's resistance to flow (thickness)",
              "The oil's temperature",
              "The oil's age"
            ],
            correctAnswer: 1,
            explanation: "Viscosity refers to a fluid's resistance to flow or its 'thickness.' In motor oil, the viscosity rating (like 5W-30) indicates how the oil flows at different temperatures. Higher numbers indicate thicker oil that flows more slowly."
          },
          {
            id: 34,
            question: "What tool is used to measure the precise diameter of cylindrical objects?",
            options: [
              "Ruler",
              "Micrometer",
              "Level",
              "Protractor"
            ],
            correctAnswer: 1,
            explanation: "A micrometer (sometimes called a 'mic') is a precision measuring tool that can measure extremely small distances or thicknesses with accuracy typically to 0.001 inch (0.01 mm). It's commonly used in machining and automotive work to measure cylinder bores, shaft diameters, and similar dimensions."
          },
          {
            id: 35,
            question: "In a four-stroke engine, what is the correct order of the four strokes?",
            options: [
              "Intake, Compression, Power, Exhaust",
              "Compression, Intake, Exhaust, Power",
              "Power, Exhaust, Intake, Compression",
              "Exhaust, Compression, Power, Intake"
            ],
            correctAnswer: 0,
            explanation: "The four-stroke cycle operates in this order: (1) Intake - air/fuel mixture enters cylinder, (2) Compression - piston compresses mixture, (3) Power - spark ignites mixture, driving piston down, (4) Exhaust - burned gases exit cylinder. This cycle repeats continuously during engine operation."
          }
        ]
      },
      {
        id: 8,
        name: "Mechanical Comprehension (MC)",
        timeLimit: 6,
        questions: [
          {
            id: 36,
            question: "A first-class lever has the fulcrum positioned between the effort and the load. Which of the following is an example of a first-class lever?",
            options: [
              "Wheelbarrow",
              "Crowbar opening a crate",
              "Nutcracker",
              "Bottle opener"
            ],
            correctAnswer: 1,
            explanation: "A crowbar opening a crate is a first-class lever with the fulcrum (pivot point on the edge of the crate) between the effort (where you push down) and the load (what you're prying up). A wheelbarrow is second-class (load between fulcrum and effort), and nutcrackers and bottle openers are third-class levers."
          },
          {
            id: 37,
            question: "If a gear with 40 teeth drives a gear with 10 teeth, what is the gear ratio?",
            options: [
              "1:4",
              "4:1",
              "1:10",
              "10:1"
            ],
            correctAnswer: 1,
            explanation: "The gear ratio is calculated as driving gear teeth to driven gear teeth: 40:10, which reduces to 4:1. This means the smaller gear will rotate 4 times for every 1 rotation of the larger gear. The larger gear provides more torque but less speed."
          },
          {
            id: 38,
            question: "What happens to the pressure of a confined gas when its temperature increases (assuming volume remains constant)?",
            options: [
              "Pressure decreases",
              "Pressure remains the same",
              "Pressure increases",
              "Pressure becomes zero"
            ],
            correctAnswer: 2,
            explanation: "According to Gay-Lussac's Law, when temperature increases in a confined space, pressure increases proportionally (assuming constant volume). This is because gas molecules move faster at higher temperatures, creating more frequent and forceful collisions with container walls."
          },
          {
            id: 39,
            question: "A block weighing 100 pounds must be lifted 5 feet. Using a pulley system provides a mechanical advantage of 4. How much force is needed to lift the block?",
            options: [
              "25 pounds",
              "50 pounds",
              "100 pounds",
              "400 pounds"
            ],
            correctAnswer: 0,
            explanation: "Mechanical advantage = Load / Effort. With MA = 4 and Load = 100 pounds: 4 = 100 / Effort, so Effort = 100 / 4 = 25 pounds. The trade-off is that you must pull 20 feet of rope (4 × 5) to lift the block 5 feet."
          },
          {
            id: 40,
            question: "In a hydraulic system, a small piston with area 2 square inches applies force to a larger piston with area 20 square inches. If 50 pounds of force is applied to the small piston, how much force is exerted by the large piston?",
            options: [
              "50 pounds",
              "100 pounds",
              "250 pounds",
              "500 pounds"
            ],
            correctAnswer: 3,
            explanation: "Pascal's Principle states that pressure is transmitted equally throughout a fluid. Pressure = Force / Area. Small piston pressure = 50 / 2 = 25 psi. This same pressure acts on the large piston: Force = Pressure × Area = 25 × 20 = 500 pounds. The mechanical advantage is the ratio of areas: 20/2 = 10."
          }
        ]
      },
      {
        id: 9,
        name: "Assembling Objects (AO)",
        timeLimit: 6,
        questions: [
          {
            id: 41,
            question: "Five puzzle pieces need to be assembled. Piece A is rectangular with a semicircular notch on the right side. Piece B is semicircular and fits into A's notch. Piece C is rectangular and connects to the left side of A. Pieces D and E are small squares that attach to the top corners. What is the final shape?",
            options: [
              "A circle",
              "A large rectangle with rounded right edge and two squares on top",
              "A triangle",
              "An irregular zigzag shape"
            ],
            correctAnswer: 1,
            explanation: "When assembled: C (rectangle) connects to left of A (rectangle with notch), B (semicircle) fills A's notch creating a rounded right edge, and D and E (squares) attach to top corners. This creates a large rectangular shape with a rounded right side and two squares projecting from the top."
          },
          {
            id: 42,
            question: "Point A on a connector piece must be joined to Point B on the main assembly. The connector can rotate 360 degrees. If Point A is currently facing north and Point B is located to the southeast, how many degrees clockwise should the connector rotate?",
            options: [
              "45 degrees",
              "90 degrees",
              "135 degrees",
              "180 degrees"
            ],
            correctAnswer: 2,
            explanation: "North to southeast is 135 degrees clockwise (north to east is 90 degrees, plus another 45 degrees to southeast equals 135 degrees total). Southeast lies exactly between south and east on the compass."
          },
          {
            id: 43,
            question: "Four identical L-shaped pieces can be arranged to form a larger square. Each L-shaped piece has arms of equal length. How should they be oriented?",
            options: [
              "All four pieces facing the same direction",
              "Each piece rotated 90 degrees from the next, arranged around a central point",
              "Two pieces facing up, two facing down",
              "Stacked on top of each other"
            ],
            correctAnswer: 1,
            explanation: "To form a square from four identical L-shaped pieces, each piece must be rotated 90 degrees from its neighbor and arranged around a central point. This creates rotational symmetry, with each L forming one corner of the square and meeting the others at the center."
          },
          {
            id: 44,
            question: "A triangular piece has connection points labeled 1, 2, and 3 at each vertex. Three identical rectangular pieces each have connection points at both ends (labeled A and B). To create a shape where all rectangles radiate outward from the triangle, how should they connect?",
            options: [
              "All rectangles connect at point 1",
              "One rectangle's A point connects to points 1, 2, and 3 respectively, with B points extending outward",
              "Rectangles connect end-to-end away from the triangle",
              "All rectangles connect at their midpoints"
            ],
            correctAnswer: 1,
            explanation: "For the rectangles to radiate outward from the triangle, one end (A point) of each rectangle must connect to a vertex of the triangle (points 1, 2, and 3), with the other end (B point) extending away. This creates a three-armed star pattern with the triangle at the center."
          },
          {
            id: 45,
            question: "Two trapezoid pieces are identical in size and shape. How can they be arranged to form a hexagon?",
            options: [
              "Place them side by side with parallel sides touching",
              "Place them with their long bases together, forming a hexagon",
              "Stack them on top of each other",
              "They cannot form a hexagon"
            ],
            correctAnswer: 1,
            explanation: "Two identical trapezoids can form a hexagon when their long (parallel) bases are placed together. The angled sides of each trapezoid become alternating sides of the hexagon. This is a common geometric arrangement where two trapezoids create a regular or irregular hexagon depending on their specific angles."
          }
        ]
      },
      {
        id: 10,
        name: "Verbal Expression (VE)",
        timeLimit: 6,
        questions: [
          {
            id: 46,
            question: "Choose the sentence that is most clearly written:",
            options: [
              "Walking through the base, the aircraft could be seen by the recruits.",
              "The recruits saw the aircraft while walking through the base.",
              "The aircraft was seen by the recruits walking through the base.",
              "While walking through the base, the recruits could see the aircraft."
            ],
            correctAnswer: 3,
            explanation: "Option D is clearest because it clearly establishes who is walking (the recruits) and maintains proper subject-verb relationship. Options A and C create ambiguity about whether the recruits or the aircraft are walking. Option B is acceptable but Option D's structure more clearly emphasizes the timing relationship."
          },
          {
            id: 47,
            question: "Which sentence uses correct subject-verb agreement?",
            options: [
              "Either the sergeant or the corporals is responsible for equipment checks.",
              "Either the sergeant or the corporals are responsible for equipment checks.",
              "Either the sergeants or the corporal are responsible for equipment checks.",
              "Either the sergeant or the corporal are responsible for equipment checks."
            ],
            correctAnswer: 1,
            explanation: "With 'either...or' constructions, the verb agrees with the subject closest to it. In option B, 'corporals' (plural) is closest to the verb, so 'are' (plural) is correct. In options with 'corporal' (singular) closest, 'is' would be correct, but option C incorrectly uses 'are.'"
          },
          {
            id: 48,
            question: "Identify the sentence with correct punctuation:",
            options: [
              "The mission objectives were clear: secure the perimeter, establish communications, and await further orders.",
              "The mission objectives were clear, secure the perimeter, establish communications, and await further orders.",
              "The mission objectives were clear; secure the perimeter establish communications and await further orders.",
              "The mission objectives were clear secure the perimeter, establish communications and await further orders."
            ],
            correctAnswer: 0,
            explanation: "Option A correctly uses a colon to introduce a list of mission objectives, with commas separating the items in the series. A colon is appropriate after a complete independent clause when introducing a list or explanation."
          },
          {
            id: 49,
            question: "Which sentence correctly uses parallel structure?",
            options: [
              "The training includes running five miles, to complete an obstacle course, and swimming.",
              "The training includes running five miles, completing an obstacle course, and swimming.",
              "The training includes to run five miles, obstacle course completion, and swimming.",
              "The training includes running five miles, an obstacle course, and to swim."
            ],
            correctAnswer: 1,
            explanation: "Parallel structure requires using the same grammatical form for items in a series. Option B correctly uses gerunds (running, completing, swimming) for all three activities. The other options mix different forms (gerunds, infinitives, and nouns), which breaks parallel structure."
          },
          {
            id: 50,
            question: "Select the sentence with the correct use of modifiers:",
            options: [
              "Having completed basic training, the next assignment was eagerly anticipated by the soldier.",
              "Having completed basic training, the soldier eagerly anticipated the next assignment.",
              "The next assignment was eagerly anticipated, having completed basic training by the soldier.",
              "Having completed basic training, eagerly the soldier anticipated the next assignment."
            ],
            correctAnswer: 1,
            explanation: "Option B correctly places the modifier 'Having completed basic training' next to 'the soldier,' which is what the phrase modifies. Option A incorrectly suggests the assignment completed basic training (misplaced modifier). Options C and D have awkward or incorrect word order."
          }
        ]
      }
    ]
  },
  {
    id: 21,
    title: "ASVAB Practice Test #21",
    description: "Comprehensive practice exam covering all 10 ASVAB sections with military-standard questions",
    totalQuestions: 50,
    timeLimit: 60,
    sections: [
      {
        id: 1,
        name: "General Science (GS)",
        timeLimit: 6,
        questions: [
          {
            id: 1,
            question: "Which organ in the human body is primarily responsible for detoxifying harmful substances and producing bile?",
            options: ["Pancreas", "Liver", "Kidney", "Spleen"],
            correctAnswer: 1,
            explanation: "The liver is the body's primary detoxification organ and produces bile for fat digestion. It filters blood from the digestive tract, metabolizes drugs, and removes toxins before blood circulates to the rest of the body."
          },
          {
            id: 2,
            question: "In Newtonian physics, an object at rest will remain at rest unless acted upon by what?",
            options: ["Friction", "An unbalanced force", "Gravity", "Momentum"],
            correctAnswer: 1,
            explanation: "This is Newton's First Law of Motion (Law of Inertia). An object at rest stays at rest, and an object in motion stays in motion with the same speed and direction, unless acted upon by an unbalanced (net) force."
          },
          {
            id: 3,
            question: "What type of rock is formed when magma cools and solidifies beneath the Earth's surface?",
            options: ["Sedimentary", "Metamorphic", "Intrusive igneous", "Extrusive igneous"],
            correctAnswer: 2,
            explanation: "Intrusive igneous rocks form when magma cools slowly beneath the Earth's surface, allowing large crystals to form (like granite). Extrusive igneous rocks form when lava cools quickly on the surface with smaller crystals."
          },
          {
            id: 4,
            question: "Which gas makes up approximately 78% of Earth's atmosphere?",
            options: ["Oxygen", "Carbon dioxide", "Nitrogen", "Argon"],
            correctAnswer: 2,
            explanation: "Nitrogen comprises about 78% of Earth's atmosphere, while oxygen makes up about 21%. The remaining 1% consists of argon, carbon dioxide, and trace gases. This composition is essential for life as we know it."
          },
          {
            id: 5,
            question: "During photosynthesis, plants convert carbon dioxide and water into glucose using energy from what source?",
            options: ["Chemical bonds", "Sunlight", "Soil nutrients", "Cellular respiration"],
            correctAnswer: 1,
            explanation: "Photosynthesis uses light energy (primarily from sunlight) to convert carbon dioxide and water into glucose (sugar) and oxygen. This process occurs in chloroplasts containing chlorophyll, which captures light energy."
          }
        ]
      },
      {
        id: 2,
        name: "Arithmetic Reasoning (AR)",
        timeLimit: 6,
        questions: [
          {
            id: 6,
            question: "A military convoy travels 285 miles in 5 hours. What is their average speed in miles per hour?",
            options: ["55 mph", "57 mph", "60 mph", "65 mph"],
            correctAnswer: 1,
            explanation: "Average speed = Total distance ÷ Total time. 285 miles ÷ 5 hours = 57 mph. This represents the constant speed that would cover the same distance in the same time."
          },
          {
            id: 7,
            question: "A soldier receives a 6% pay raise. If their current salary is $42,000 per year, what will their new salary be?",
            options: ["$44,100", "$44,520", "$45,000", "$47,520"],
            correctAnswer: 1,
            explanation: "Calculate 6% of $42,000: 0.06 × $42,000 = $2,520. Add this to the original salary: $42,000 + $2,520 = $44,520. The new salary reflects a 6% increase over the base pay."
          },
          {
            id: 8,
            question: "A supply depot has 1,440 cases of MREs (Meals Ready to Eat). If each case contains 12 MREs, and each soldier needs 3 MREs per day, how many soldiers can be fed for one day?",
            options: ["5,760 soldiers", "4,320 soldiers", "1,200 soldiers", "480 soldiers"],
            correctAnswer: 0,
            explanation: "First, find total MREs: 1,440 cases × 12 MREs = 17,280 MREs. Then divide by MREs per soldier: 17,280 ÷ 3 = 5,760 soldiers can be fed for one day."
          },
          {
            id: 9,
            question: "A rectangular training field is 240 feet long and 180 feet wide. What is the area of the field in square feet?",
            options: ["420 sq ft", "840 sq ft", "43,200 sq ft", "86,400 sq ft"],
            correctAnswer: 2,
            explanation: "Area of a rectangle = length × width. 240 feet × 180 feet = 43,200 square feet. This calculation is essential for land navigation and resource planning."
          },
          {
            id: 10,
            question: "If a military vehicle uses 15 gallons of fuel to travel 180 miles, how many miles per gallon does it get?",
            options: ["10 mpg", "12 mpg", "15 mpg", "18 mpg"],
            correctAnswer: 1,
            explanation: "Miles per gallon = Total miles ÷ Gallons used. 180 miles ÷ 15 gallons = 12 mpg. This fuel efficiency metric is critical for logistics and mission planning."
          }
        ]
      },
      {
        id: 3,
        name: "Word Knowledge (WK)",
        timeLimit: 6,
        questions: [
          {
            id: 11,
            question: "Meticulous most nearly means:",
            options: ["Careless", "Extremely careful and precise", "Fast-paced", "Uncertain"],
            correctAnswer: 1,
            explanation: "Meticulous means showing great attention to detail; being extremely careful and precise. A meticulous person takes great care to ensure accuracy and completeness in their work."
          },
          {
            id: 12,
            question: "Adversary most nearly means:",
            options: ["Ally", "Opponent", "Advisor", "Companion"],
            correctAnswer: 1,
            explanation: "An adversary is an opponent, enemy, or rival. In military context, an adversary is a hostile force or enemy combatant that opposes your mission objectives."
          },
          {
            id: 13,
            question: "Conspicuous most nearly means:",
            options: ["Hidden", "Obvious and easily noticed", "Mysterious", "Quiet"],
            correctAnswer: 1,
            explanation: "Conspicuous means clearly visible, obvious, or attracting attention. Something conspicuous stands out and is easily noticed, which can be either advantageous or disadvantageous in military operations."
          },
          {
            id: 14,
            question: "Zealous most nearly means:",
            options: ["Lazy", "Enthusiastic and passionate", "Jealous", "Tired"],
            correctAnswer: 1,
            explanation: "Zealous means having or showing great enthusiasm and dedication toward a cause or objective. A zealous person demonstrates passionate commitment and intense devotion to their duties."
          },
          {
            id: 15,
            question: "Decipher most nearly means:",
            options: ["Encode", "Decode or interpret", "Destroy", "Copy"],
            correctAnswer: 1,
            explanation: "To decipher means to decode, interpret, or make sense of something difficult to understand, such as encrypted messages, foreign languages, or complex information. This skill is crucial in intelligence operations."
          }
        ]
      },
      {
        id: 4,
        name: "Paragraph Comprehension (PC)",
        timeLimit: 6,
        questions: [
          {
            id: 16,
            question: "\"The United States Marine Corps was established on November 10, 1775, making it one of the oldest military branches in American history. The Continental Congress authorized the creation of two battalions of Marines to serve as landing forces for the Navy, establishing a tradition that continues today. Marines have fought in every American conflict since then, from the Revolutionary War to modern operations in Iraq and Afghanistan. This unbroken record of service spans nearly 250 years of American history. Marines have stormed beaches, defended embassies, conducted amphibious assaults, and served as an expeditionary force ready to respond to crises worldwide. The Corps' versatility and readiness have made it an essential component of American military power.\n\nThe Marine Corps motto 'Semper Fidelis' means 'Always Faithful,' reflecting the service's commitment to the nation and each other. This Latin phrase was adopted as the official motto in 1883, replacing several earlier mottoes. Semper Fidelis expresses the unwavering loyalty that Marines pledge to their country, the Corps, and their fellow Marines. This faithfulness means Marines can be counted on to accomplish their missions regardless of the challenges they face. It also reflects the deep bonds formed between Marines who serve together, often in extremely difficult and dangerous conditions. The motto is so deeply embedded in Marine culture that Marines commonly refer to it simply as 'Semper Fi.'\n\nThe commitment expressed by Semper Fidelis extends beyond active service. Marines maintain their identity and loyalty to the Corps throughout their lives, often saying 'Once a Marine, always a Marine.' This enduring connection to the service and fellow Marines creates a unique culture within American military institutions. The Marine Corps' small size compared to other services, combined with its demanding standards and proud traditions, creates particularly strong bonds among those who earn the title of Marine. This sense of identity and mutual commitment contributes to the Corps' effectiveness and reputation as an elite fighting force that can be relied upon in any circumstance.\" What does 'Semper Fidelis' mean?",
            options: ["Always Ready", "Always Faithful", "Always Forward", "Always Strong"],
            correctAnswer: 1,
            explanation: "The passage explicitly states that 'Semper Fidelis' means 'Always Faithful.' This Latin motto represents the Marine Corps' unwavering commitment to the nation, the Corps, and fellow Marines."
          },
          {
            id: 17,
            question: "\"Proper nutrition is critical for military readiness and directly impacts service members' ability to perform their duties effectively. Service members require balanced diets providing adequate calories, proteins, vitamins, and minerals to maintain peak physical condition under demanding circumstances. Proper nutrition supports physical performance, cognitive function, immune system health, and recovery from injuries. Military personnel face unique nutritional challenges including high energy expenditure during training and operations, irregular meal schedules, and limited food choices in deployed environments. Meeting these nutritional requirements ensures that service members can maintain the strength, endurance, and mental sharpness necessary for military operations.\n\nDuring field operations, when fresh food is unavailable, MREs (Meals Ready to Eat) provide complete nutrition in portable packages designed for military use. Each MRE contains approximately 1,200 calories and is designed to sustain soldiers during demanding missions where traditional meal preparation is impossible. MREs include an entree, side dishes, dessert, crackers, spread, beverage mix, and accessories like utensils and napkins. The packaging is durable, lightweight, and requires no refrigeration, making MREs ideal for combat situations, training exercises, and disaster relief operations. While not as palatable as fresh meals, MREs have improved significantly over the years and provide the nutritional content soldiers need to function effectively in the field.\n\nThe 1,200-calorie content of each MRE represents roughly one-third of a soldier's daily caloric needs during moderate activity, with three MREs per day providing adequate energy for most operational scenarios. During intense physical activity, soldiers may need additional calories from supplementary rations or field feeding facilities. The meals are formulated to provide not just calories but also appropriate macronutrient ratios and micronutrients essential for health and performance. This attention to complete nutrition reflects the military's understanding that proper feeding is essential for maintaining an effective fighting force. Well-nourished troops perform better, recover faster from exertion, and maintain morale more effectively than poorly fed forces.\" According to the passage, how many calories does each MRE contain?",
            options: ["800 calories", "1,000 calories", "1,200 calories", "1,500 calories"],
            correctAnswer: 2,
            explanation: "The passage clearly states that each MRE contains approximately 1,200 calories. This caloric content is designed to provide sufficient energy for soldiers during physically demanding field operations."
          },
          {
            id: 18,
            question: "\"Leadership in the military extends beyond giving orders and exercising authority over subordinates. Effective leaders inspire confidence in their troops by demonstrating expertise, remaining calm under pressure, and making sound decisions consistently. They set examples through their actions rather than just their words, personally embodying the standards and values they expect from others. When leaders share hardships with their troops, maintain high personal standards, and demonstrate courage under fire, they earn the right to lead through respect rather than relying solely on rank. They also prioritize the welfare of their subordinates, ensuring their troops have proper equipment, training, food, rest, and medical care. This genuine concern for subordinate welfare builds loyalty and commitment throughout the unit.\n\nThey must make difficult decisions under pressure while maintaining unit cohesion and morale. Combat leadership involves choices that affect lives, mission success, and unit survival. These decisions must often be made quickly, with incomplete information, and under extreme stress. Throughout this decision-making process, leaders must maintain unit cohesion by keeping personnel working together effectively and maintaining morale by preserving their troops' will to fight and confidence in the mission. Poor decisions can break down cohesion and destroy morale, making units ineffective even if they possess adequate resources. The ability to make good decisions under terrible circumstances while keeping units functioning effectively represents one of leadership's greatest challenges.\n\nThe best leaders understand that earning respect requires demonstrating competence, integrity, and genuine concern for their troops. Competence means knowing one's job thoroughly and making sound decisions based on that knowledge. Integrity involves being honest, ethical, and consistent in applying standards regardless of personal consequences. Genuine concern for troops means caring about them as people, not just as tools to accomplish missions. When leaders consistently demonstrate these qualities, subordinates develop trust and respect that transcends the formal authority of rank. This earned respect makes personnel willing to follow leaders into dangerous situations and give their maximum effort to accomplish difficult missions. Without this foundation of respect, leaders must rely solely on their positional authority, which proves far less effective in challenging circumstances.\" What is the main idea of this passage?",
            options: ["Military leaders must give clear orders", "Effective military leadership requires more than authority", "Leadership is only about making decisions", "Military leaders need to be strict"],
            correctAnswer: 1,
            explanation: "The main idea is that effective military leadership requires more than just authority or giving orders. The passage emphasizes inspiring confidence, leading by example, prioritizing subordinates, and earning respect through competence and integrity."
          },
          {
            id: 19,
            question: "\"Camouflage serves multiple purposes in military operations beyond simple concealment. It helps personnel and equipment blend into surroundings, reducing visibility to enemy forces who might otherwise detect and engage them. Effective camouflage allows military forces to observe without being observed, move without being tracked, and position themselves advantageously without revealing their locations. This concealment provides significant tactical benefits including surprise, protection, and the ability to operate undetected in hostile territory. Throughout military history, forces that mastered camouflage and concealment have consistently enjoyed advantages over enemies who failed to hide effectively.\n\nModern camouflage patterns use colors and designs matching specific environments—woodland, desert, or urban terrain—because effective concealment requires matching the visual characteristics of operational environments. Woodland patterns feature greens and browns in irregular shapes resembling vegetation and shadows. Desert patterns use tans and lighter colors matching sandy and rocky terrain. Urban patterns incorporate grays and earth tones reflecting concrete, asphalt, and buildings. Using the wrong pattern in a given environment defeats the purpose of camouflage, as woodland patterns stand out obviously in deserts and desert patterns are highly visible in forests. Military forces therefore maintain multiple camouflage systems and select appropriate patterns based on their operational environment and mission requirements.\n\nDigital camouflage patterns, using pixelated designs, have proven particularly effective at disrupting the human outline at various distances by creating visual noise that confuses the human eye. Traditional camouflage patterns sometimes became less effective at certain viewing distances, appearing as solid colors rather than disruptive patterns. Digital patterns with their computer-designed pixels maintain their disruptive effect across a wide range of distances, from close encounters to long-range observation. The small squares create patterns that break up recognizable shapes and make it difficult for observers to distinguish camouflaged personnel and equipment from their backgrounds. These advanced patterns represent the evolution of camouflage science, incorporating research into human visual perception to create more effective concealment for modern military operations.\" What is the primary purpose of camouflage?",
            options: ["To identify friendly forces", "To reduce visibility to enemies", "To improve soldier comfort", "To display unit insignia"],
            correctAnswer: 1,
            explanation: "The passage states that camouflage 'helps personnel and equipment blend into surroundings, reducing visibility to enemy forces.' This is explicitly identified as its primary purpose in military operations."
          },
          {
            id: 20,
            question: "\"The chain of command is fundamental to military organization and serves as the structural framework enabling large military forces to function effectively. It establishes clear lines of authority and communication from the highest-ranking officers down to individual service members, creating an organizational hierarchy that defines who reports to whom and who has authority over whom. This hierarchical structure ensures orders are transmitted efficiently from senior leadership through intermediate commanders to the personnel who will execute those orders. Responsibilities are clearly defined at each level, with everyone understanding their role and the decisions they are authorized to make. Accountability is maintained because the chain creates traceable connections between decisions and outcomes, allowing leaders to track progress and identify problems.\n\nThe chain of command provides multiple critical functions beyond simple hierarchy. It ensures efficient communication by establishing proper channels for information flow both up and down the organization. It delegates authority appropriately, allowing decisions to be made at the proper level without requiring senior leaders to micromanage every detail. It maintains unity of command, ensuring personnel receive orders from only one superior rather than conflicting instructions from multiple sources. It facilitates coordination between units by providing clear points of contact at each organizational level. These functions combine to create an organization that can respond quickly, act decisively, and maintain coherence even during the confusion of military operations.\n\nBreaking the chain of command can create confusion and undermine operational effectiveness by disrupting this carefully structured system. When personnel bypass their immediate supervisors to communicate directly with higher commanders, it leaves middle-level leaders uninformed and unable to coordinate their units effectively. When orders come from outside the proper chain, it creates questions about legitimacy and priority. Personnel may receive conflicting instructions, become uncertain about which orders to follow, or fail to coordinate properly with their teammates. The resulting confusion can paralyze decision-making and create dangerous situations where personnel don't know who is in charge or what they should be doing. Respecting the chain of command maintains organizational integrity and ensures military units can function effectively under all conditions, from routine operations to combat situations where clear authority and communication are essential for survival and mission success.\" Why is the chain of command important?",
            options: ["It makes the military look organized", "It ensures efficient communication and clear responsibilities", "It allows senior officers to avoid work", "It prevents soldiers from making decisions"],
            correctAnswer: 1,
            explanation: "The passage explains that the chain of command 'ensures orders are transmitted efficiently, responsibilities are clearly defined, and accountability is maintained.' This clear communication and defined responsibility structure is its primary importance."
          }
        ]
      },
      {
        id: 5,
        name: "Mathematics Knowledge (MK)",
        timeLimit: 6,
        questions: [
          {
            id: 21,
            question: "Solve for x: 3x + 7 = 28",
            options: ["x = 5", "x = 7", "x = 9", "x = 11"],
            correctAnswer: 1,
            explanation: "Subtract 7 from both sides: 3x = 21. Divide both sides by 3: x = 7. Verification: 3(7) + 7 = 21 + 7 = 28 ✓"
          },
          {
            id: 22,
            question: "What is the perimeter of a square with sides measuring 12 inches each?",
            options: ["36 inches", "48 inches", "144 inches", "24 inches"],
            correctAnswer: 1,
            explanation: "Perimeter of a square = 4 × side length. 4 × 12 inches = 48 inches. A square has four equal sides, so multiply one side by 4 to find the total perimeter."
          },
          {
            id: 23,
            question: "What is 15% of 240?",
            options: ["30", "36", "40", "45"],
            correctAnswer: 1,
            explanation: "Convert 15% to decimal: 0.15. Multiply: 0.15 × 240 = 36. Alternatively, 15% means 15/100, so (15/100) × 240 = 36."
          },
          {
            id: 24,
            question: "If a triangle has angles measuring 45° and 65°, what is the measure of the third angle?",
            options: ["60°", "70°", "80°", "90°"],
            correctAnswer: 1,
            explanation: "The sum of angles in any triangle equals 180°. Therefore: 180° - 45° - 65° = 70°. The three angles must add up to exactly 180 degrees."
          },
          {
            id: 25,
            question: "Simplify: (8² - 4²) ÷ 4",
            options: ["10", "12", "15", "16"],
            correctAnswer: 1,
            explanation: "First, calculate the squares: 8² = 64 and 4² = 16. Then subtract: 64 - 16 = 48. Finally, divide: 48 ÷ 4 = 12. Follow order of operations (PEMDAS)."
          }
        ]
      },
      {
        id: 6,
        name: "Electronics Information (EI)",
        timeLimit: 6,
        questions: [
          {
            id: 26,
            question: "What is the primary function of a capacitor in an electrical circuit?",
            options: ["Convert AC to DC", "Store electrical energy", "Increase voltage", "Measure current"],
            correctAnswer: 1,
            explanation: "A capacitor stores electrical energy in an electric field between two conducting plates. Capacitors can release stored energy quickly, making them useful for filtering, timing circuits, and power supply smoothing."
          },
          {
            id: 27,
            question: "In a series circuit with three resistors (10Ω, 20Ω, and 30Ω), what is the total resistance?",
            options: ["20Ω", "30Ω", "60Ω", "6Ω"],
            correctAnswer: 2,
            explanation: "In a series circuit, total resistance is the sum of all resistances: 10Ω + 20Ω + 30Ω = 60Ω. Series resistors add together because current must flow through each resistor sequentially."
          },
          {
            id: 28,
            question: "What does the acronym LED stand for?",
            options: ["Light Emitting Diode", "Low Energy Device", "Linear Electronic Display", "Light Energy Distributor"],
            correctAnswer: 0,
            explanation: "LED stands for Light Emitting Diode. An LED is a semiconductor device that emits light when current flows through it. LEDs are energy-efficient and used in displays, indicators, and lighting applications."
          },
          {
            id: 29,
            question: "Which component allows current to flow in only one direction?",
            options: ["Resistor", "Capacitor", "Diode", "Inductor"],
            correctAnswer: 2,
            explanation: "A diode allows current to flow in only one direction (forward bias) and blocks current in the opposite direction (reverse bias). This property makes diodes essential for converting AC to DC and protecting circuits."
          },
          {
            id: 30,
            question: "What is the unit of measurement for electrical power?",
            options: ["Ampere", "Volt", "Watt", "Ohm"],
            correctAnswer: 2,
            explanation: "The watt (W) is the unit of electrical power. Power = Voltage × Current (P = V × I). One watt equals one joule per second. Amperes measure current, volts measure voltage, and ohms measure resistance."
          }
        ]
      },
      {
        id: 7,
        name: "Auto & Shop Information (AS)",
        timeLimit: 6,
        questions: [
          {
            id: 31,
            question: "What is the primary purpose of a vehicle's cooling system?",
            options: ["Cool the exhaust", "Prevent engine overheating", "Cool the transmission", "Reduce fuel temperature"],
            correctAnswer: 1,
            explanation: "The cooling system prevents engine overheating by circulating coolant through the engine block to absorb heat, then transferring that heat to the radiator where air cools the coolant. Overheating can cause severe engine damage."
          },
          {
            id: 32,
            question: "Which tool is specifically designed to measure extremely small dimensions with high precision?",
            options: ["Ruler", "Caliper", "Micrometer", "Tape measure"],
            correctAnswer: 2,
            explanation: "A micrometer provides the highest precision measurement, typically accurate to 0.001 inches (one-thousandth of an inch) or 0.01mm. While calipers are also precise, micrometers offer greater accuracy for critical measurements."
          },
          {
            id: 33,
            question: "What does the octane rating of gasoline indicate?",
            options: ["Fuel efficiency", "Resistance to engine knocking", "Fuel purity", "Combustion temperature"],
            correctAnswer: 1,
            explanation: "Octane rating measures gasoline's resistance to pre-ignition or 'knocking' in the engine. Higher octane fuel resists premature combustion better, which is important for high-compression engines to prevent damage and maximize performance."
          },
          {
            id: 34,
            question: "In woodworking, what is the purpose of a wood plane?",
            options: ["Cut curved shapes", "Smooth and flatten wood surfaces", "Drill holes", "Join two pieces of wood"],
            correctAnswer: 1,
            explanation: "A wood plane is used to smooth, flatten, and shape wood surfaces by shaving thin layers. The adjustable blade allows precise control over the amount of material removed, creating smooth, flat surfaces."
          },
          {
            id: 35,
            question: "What component in a vehicle's braking system converts the driver's foot pressure into hydraulic pressure?",
            options: ["Brake caliper", "Brake pad", "Master cylinder", "Brake line"],
            correctAnswer: 2,
            explanation: "The master cylinder converts mechanical force (foot pressure on the brake pedal) into hydraulic pressure, which is transmitted through brake lines to the brake calipers or wheel cylinders, applying the brakes."
          }
        ]
      },
      {
        id: 8,
        name: "Mechanical Comprehension (MC)",
        timeLimit: 6,
        questions: [
          {
            id: 36,
            question: "If a lever is balanced with a 60-pound weight placed 3 feet from the fulcrum on one side, how far from the fulcrum must a 45-pound weight be placed on the other side to balance the lever?",
            options: ["2 feet", "3 feet", "4 feet", "5 feet"],
            correctAnswer: 2,
            explanation: "Use the lever equation: Weight₁ × Distance₁ = Weight₂ × Distance₂. 60 lbs × 3 ft = 45 lbs × Distance₂. 180 = 45 × Distance₂. Distance₂ = 180/45 = 4 feet."
          },
          {
            id: 37,
            question: "A pulley system with four supporting ropes lifts a 400-pound load. Approximately how much force must be applied to lift the load (ignoring friction)?",
            options: ["50 pounds", "100 pounds", "200 pounds", "400 pounds"],
            correctAnswer: 1,
            explanation: "In a pulley system, mechanical advantage equals the number of supporting ropes. With 4 ropes: Force = Load ÷ 4 = 400 lbs ÷ 4 = 100 pounds. The pulley system provides a 4:1 mechanical advantage."
          },
          {
            id: 38,
            question: "Two gears are connected. If the driver gear has 40 teeth and rotates at 100 RPM, and the driven gear has 20 teeth, at what speed does the driven gear rotate?",
            options: ["50 RPM", "100 RPM", "150 RPM", "200 RPM"],
            correctAnswer: 3,
            explanation: "Gear ratio = Teeth on driver ÷ Teeth on driven = 40/20 = 2:1. The driven gear rotates twice as fast: 100 RPM × 2 = 200 RPM. Smaller gears rotate faster than larger gears in direct mesh."
          },
          {
            id: 39,
            question: "Which simple machine is a wedge most similar to in principle?",
            options: ["Lever", "Inclined plane", "Pulley", "Wheel and axle"],
            correctAnswer: 1,
            explanation: "A wedge is essentially two inclined planes placed back-to-back. Both convert a force applied over a distance into a force perpendicular to the surface. Wedges are used for splitting, cutting, and separating materials."
          },
          {
            id: 40,
            question: "If a hydraulic system has a small piston with an area of 2 square inches and a large piston with an area of 20 square inches, applying 10 pounds of force to the small piston produces how much force on the large piston?",
            options: ["20 pounds", "50 pounds", "100 pounds", "200 pounds"],
            correctAnswer: 2,
            explanation: "Force ratio equals area ratio: Large force = Small force × (Large area/Small area) = 10 lbs × (20/2) = 10 lbs × 10 = 100 pounds. This demonstrates Pascal's principle in hydraulic systems."
          }
        ]
      },
      {
        id: 9,
        name: "Assembling Objects (AO)",
        timeLimit: 6,
        questions: [
          {
            id: 41,
            question: "A five-pointed star is divided into separate pieces. Which arrangement correctly assembles the pieces to form the complete star?",
            options: ["Pieces arranged with points facing inward", "Pieces arranged with all points facing outward from center", "Pieces stacked vertically", "Pieces arranged in a circle"],
            correctAnswer: 1,
            explanation: "A five-pointed star is correctly formed when all triangular points radiate outward from a central pentagon. Each point faces outward from the center, creating the characteristic star shape with proper symmetry."
          },
          {
            id: 42,
            question: "Two connectors labeled 'A' and 'B' must be joined. Point A is at the bottom left of a square, and Point B is at the top right of a circle. Which diagram shows the correct connection?",
            options: ["Line connecting top of square to bottom of circle", "Line connecting bottom left of square to top right of circle", "Line connecting right of square to left of circle", "Line connecting centers of both shapes"],
            correctAnswer: 1,
            explanation: "The connection must go from Point A (bottom left of square) directly to Point B (top right of circle). This creates a diagonal line connecting the specified points on each shape."
          },
          {
            id: 43,
            question: "A triangle, square, and circle are shown separately. When properly assembled, they form a house shape. What is the correct arrangement?",
            options: ["Circle on bottom, square in middle, triangle on top", "Square on bottom, triangle on top forming roof, circle as window in square", "Triangle on bottom, square in middle, circle on top", "All shapes stacked horizontally"],
            correctAnswer: 1,
            explanation: "A house shape consists of a square base with a triangular roof on top. The circle typically represents a window or door within the square body of the house, creating the classic house silhouette."
          },
          {
            id: 44,
            question: "Four puzzle pieces with interlocking tabs and slots are shown. Which configuration correctly assembles them into a complete rectangle?",
            options: ["Two pieces on top, two pieces on bottom with tabs interlocked", "All four pieces in a vertical line", "Three pieces horizontal, one vertical", "All pieces overlapping in center"],
            correctAnswer: 0,
            explanation: "A rectangle formed from four pieces typically arranges as a 2×2 grid: two pieces on top row, two pieces on bottom row, with interlocking tabs fitting into corresponding slots to create a stable, complete rectangle."
          },
          {
            id: 45,
            question: "Point X on a hexagon must connect to Point Y on a pentagon. The hexagon is positioned above the pentagon. Where does the connecting line go?",
            options: ["From bottom vertex of hexagon to top vertex of pentagon", "From center of hexagon to center of pentagon", "From top vertex of hexagon to bottom vertex of pentagon", "From left side of hexagon to right side of pentagon"],
            correctAnswer: 0,
            explanation: "When Point X is on the hexagon (positioned above) and Point Y is on the pentagon (positioned below), the connection line runs from the bottom vertex of the hexagon to the top vertex of the pentagon, creating a vertical connection between the shapes."
          }
        ]
      },
      {
        id: 10,
        name: "Verbal Expression (VE)",
        timeLimit: 6,
        questions: [
          {
            id: 46,
            question: "Choose the word that best completes the sentence: The commander's _____ leadership style inspired confidence and loyalty among the troops.",
            options: ["erratic", "exemplary", "passive", "contradictory"],
            correctAnswer: 1,
            explanation: "Exemplary means serving as a desirable model; outstanding. An exemplary leadership style would inspire confidence and loyalty. The other options (erratic, passive, contradictory) would not produce such positive results."
          },
          {
            id: 47,
            question: "Identify the sentence with correct grammar: ",
            options: ["Each of the soldiers were prepared for deployment.", "Each of the soldiers was prepared for deployment.", "Each of the soldiers be prepared for deployment.", "Each of the soldiers are prepared for deployment."],
            correctAnswer: 1,
            explanation: "'Each' is a singular subject and requires the singular verb 'was.' Even though 'soldiers' is plural, the subject 'each' is singular, so the correct construction is 'Each...was prepared.'"
          },
          {
            id: 48,
            question: "Which sentence uses the word 'affect' correctly?",
            options: ["The new policy will take affect next month.", "The weather had no affect on the mission.", "How did the training affect your performance?", "The affect of the decision was significant."],
            correctAnswer: 2,
            explanation: "'Affect' as a verb means to influence or change something. 'How did the training affect your performance?' correctly uses 'affect' as a verb. The other sentences should use 'effect' (noun) instead."
          },
          {
            id: 49,
            question: "Select the sentence with correct punctuation:",
            options: ["The squad included: rifles, ammunition, and communications equipment.", "The squad included rifles, ammunition, and communications equipment.", "The squad included, rifles ammunition and communications equipment.", "The squad included rifles ammunition, and communications equipment."],
            correctAnswer: 1,
            explanation: "This sentence correctly uses commas to separate items in a series without unnecessary colons. No colon is needed after 'included' because the list flows directly from the verb."
          },
          {
            id: 50,
            question: "Which word pair shows the correct relationship? Hot is to Cold as High is to:",
            options: ["Tall", "Low", "Up", "Mountain"],
            correctAnswer: 1,
            explanation: "Hot and Cold are antonyms (opposites), so High and Low are also antonyms. This analogy tests the understanding of opposite relationships. Tall relates to High but isn't its direct opposite; Low is the proper antonym."
          }
        ]
      }
    ]
  }
];

export default exams;